/* THIS IS A GENERATED FILE */
/* eslint-disable */
import { ChartData } from '../types';
import { RecordAdherenceHistoryPerDay } from '../types';
import { ReportsStatistics } from '../types';
import { gql } from '@apollo/client';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ChartData: ChartData;
  RecordAdherenceHistoryPerDay: RecordAdherenceHistoryPerDay;
  ReportsStatistics: ReportsStatistics;
};

export type AcdQueue = {
  __typename?: 'AcdQueue';
  acdId: Scalars['String'];
  acdSourceQueueId: Scalars['String'];
  id: Scalars['ID'];
  importType: AcdQueueImportType;
  queueName: Scalars['String'];
};

export enum AcdQueueImportType {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

export type AdherenceEvent = CommonAdherenceEvent & {
  __typename?: 'AdherenceEvent';
  agent: AgentInfo;
  currentActivity: Scalars['String'];
  expectedActivity: Scalars['String'];
  expectedActivityTypeId: Scalars['String'];
  from: Scalars['String'];
  id: Scalars['ID'];
  state: RealTimeAdherenceState;
  to?: Maybe<Scalars['String']>;
};

export type AdherenceEventType = {
  __typename?: 'AdherenceEventType';
  acdType: Scalars['String'];
  eventId: Scalars['ID'];
  eventName: Scalars['String'];
  eventType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  reasonCodeRequired: Scalars['Boolean'];
};

export type AdherenceEvents = {
  __typename?: 'AdherenceEvents';
  adherenceEvents: Array<AdherenceEvent>;
};

export type AdherenceHistory = {
  __typename?: 'AdherenceHistory';
  adherenceHistoryList: Array<AdherenceHistoryItem>;
  totalCount: Scalars['Int'];
};

export type AdherenceHistoryAgentActivityItem = {
  __typename?: 'AdherenceHistoryAgentActivityItem';
  agentId: Scalars['ID'];
  dateTimeRange: DateTimeRange;
  eleveoStatusName: Scalars['String'];
  mappedToActivity: Scalars['Boolean'];
};

export type AdherenceHistoryBarChart = {
  __typename?: 'AdherenceHistoryBarChart';
  adherence: Array<Scalars['ChartData']>;
  conformance: Array<Scalars['ChartData']>;
  dataPerDay: Scalars['RecordAdherenceHistoryPerDay'];
  maxChartValue: Scalars['Int'];
};

export type AdherenceHistoryGanttChart = {
  __typename?: 'AdherenceHistoryGanttChart';
  agentActivityItems: Array<AdherenceHistoryAgentActivityItem>;
  outOfAdherenceItems: Array<AdherenceHistoryOutOfAdherenceItem>;
  scheduleItems: Array<AdherenceHistoryScheduleItem>;
};

export type AdherenceHistoryItem = {
  __typename?: 'AdherenceHistoryItem';
  adherenceRawDataAvailable: Scalars['Boolean'];
  agentId: Scalars['ID'];
  agentName: Scalars['String'];
  agentSurname: Scalars['String'];
  conformancePercentage: Scalars['Float'];
  earlyLeavesCount: Scalars['Int'];
  inAdherencePercentage: Scalars['Float'];
  lateArrivalsCount: Scalars['Int'];
  outOfAdhEventsCount: Scalars['Int'];
  outOfAdhTimeTotal: Scalars['Int'];
  scheduledTime: Scalars['Int'];
  scheduledWorkingTime: Scalars['Int'];
  teamIds: Array<Scalars['ID']>;
  timezone: Scalars['String'];
};

export type AdherenceHistoryOutOfAdherenceItem = {
  __typename?: 'AdherenceHistoryOutOfAdherenceItem';
  dateTimeRange: DateTimeRange;
  eleveoStatusName: Scalars['String'];
  scheduleElementId: Scalars['ID'];
};

export type AdherenceHistoryScheduleItem = {
  __typename?: 'AdherenceHistoryScheduleItem';
  agentId: Scalars['ID'];
  dateTimeRange: DateTimeRange;
  scheduleElementId: Scalars['ID'];
};

export type AdherenceHistorySearchCriteriaInput = {
  agentName?: InputMaybe<Scalars['String']>;
  dateRange: DateTimeRangeInput;
  filter?: InputMaybe<AdherenceHistorySidebarFilterCriteria>;
  first: Scalars['Int'];
  max: Scalars['Int'];
  teamIds: Array<InputMaybe<Scalars['ID']>>;
  timezone: Scalars['String'];
};

export type AdherenceHistorySidebarFilterCriteria = {
  adherenceEventsRange?: InputMaybe<MinMaxRangeFilterInput>;
  conformanceRange?: InputMaybe<MinMaxRangeFilterInput>;
  earlyLeaves?: InputMaybe<Scalars['Boolean']>;
  inAdherenceRange?: InputMaybe<MinMaxRangeFilterInput>;
  includeInactiveAgents?: InputMaybe<Scalars['Boolean']>;
  lateArrivals?: InputMaybe<Scalars['Boolean']>;
};

export type AdherenceHistoryStartDate = {
  __typename?: 'AdherenceHistoryStartDate';
  dateTime?: Maybe<Scalars['String']>;
};

export type AdherenceLastImport = {
  __typename?: 'AdherenceLastImport';
  dateTime?: Maybe<Scalars['String']>;
};

export type AdherenceNotificationInput = {
  threshold: Scalars['Int'];
};

export type AdherenceNotificationType = {
  __typename?: 'AdherenceNotificationType';
  threshold: Scalars['Int'];
};

export type AdherenceReasonCode = {
  __typename?: 'AdherenceReasonCode';
  code: Scalars['Int'];
  eventType: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
  sourceId: Scalars['String'];
};

export type AdherenceSetting = {
  __typename?: 'AdherenceSetting';
  acdStatuses: Array<AdherenceSettingAcdStatus>;
  historyScheduleActivityIds: Array<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  realTimeScheduleActivityIds: Array<Scalars['ID']>;
};

export type AdherenceSettingAcdStatus = {
  __typename?: 'AdherenceSettingACDStatus';
  agentEventReasonCodeId?: Maybe<Scalars['ID']>;
  agentEventTypeId: Scalars['ID'];
};

export type AdherenceSettingAcdStatusInput = {
  agentEventReasonCodeId?: InputMaybe<Scalars['ID']>;
  agentEventTypeId: Scalars['ID'];
};

export type AdherenceSettingInput = {
  acdStatuses: Array<AdherenceSettingAcdStatusInput>;
  historyScheduleActivityIds: Array<Scalars['ID']>;
  name: Scalars['String'];
  realTimeScheduleActivityIds: Array<Scalars['ID']>;
};

export type AdherenceSettings = {
  __typename?: 'AdherenceSettings';
  adherenceSettings: Array<AdherenceSetting>;
  totalCount: Scalars['Int'];
};

export type AdherenceSettingsSearchCriteria = {
  first: Scalars['Int'];
  max: Scalars['Int'];
};

export type Adjustment = {
  __typename?: 'Adjustment';
  averageHandlingTime: Scalars['Int'];
  concurrentChatsCount?: Maybe<Scalars['Int']>;
  contactVolume: Scalars['Int'];
  dateTimeRange: DateTimeRange;
  id: Scalars['ID'];
  name: Scalars['String'];
  shrinkagePercentage: Scalars['Int'];
};

export type AdjustmentInput = {
  averageHandlingTime: Scalars['Int'];
  concurrentChatsCount?: InputMaybe<Scalars['Int']>;
  contactVolume: Scalars['Int'];
  dateTimeRange: DateTimeRangeInput;
  id: Scalars['ID'];
  name: Scalars['String'];
  shrinkagePercentage: Scalars['Int'];
};

export type Agent = {
  __typename?: 'Agent';
  active: Scalars['Boolean'];
  deleted: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  queueIds?: Maybe<Array<Scalars['ID']>>;
  shiftTemplateIds?: Maybe<Array<Scalars['ID']>>;
  skillIds?: Maybe<Array<Scalars['ID']>>;
  surname: Scalars['String'];
  teamIds: Array<Scalars['ID']>;
  timezone: Scalars['String'];
};

export type AgentEvent = CommonEvent & {
  __typename?: 'AgentEvent';
  activityName: Scalars['String'];
  agent: AgentInfo;
  from: Scalars['String'];
  id: Scalars['ID'];
  mappedToActivity: Scalars['Boolean'];
  to?: Maybe<Scalars['String']>;
};

export type AgentEvents = {
  __typename?: 'AgentEvents';
  agentEvents: Array<AgentEvent>;
};

export type AgentInRequest = {
  __typename?: 'AgentInRequest';
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
};

export type AgentInRequestWithQueues = {
  __typename?: 'AgentInRequestWithQueues';
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  queueIds: Array<Scalars['ID']>;
};

export type AgentInfo = {
  __typename?: 'AgentInfo';
  agentId: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type AgentInfoWithTeams = {
  __typename?: 'AgentInfoWithTeams';
  agentId: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  teamIds: Array<Scalars['ID']>;
};

export type AgentInput = {
  name: Scalars['String'];
  queueId: Scalars['ID'];
  shiftTemplateIds?: InputMaybe<Scalars['ID']>;
  surname: Scalars['String'];
};

export type AgentOverview = {
  __typename?: 'AgentOverview';
  agent: AgentInfo;
  currentActivity: Scalars['String'];
  expectedActivity: Scalars['String'];
  inStateSince: Scalars['String'];
  state: RealTimeAdherenceState;
};

export type AgentOverviewWithTeams = {
  __typename?: 'AgentOverviewWithTeams';
  agent: AgentInfoWithTeams;
  currentActivity: Scalars['String'];
  expectedActivity: Scalars['String'];
  inStateSince: Scalars['String'];
  state: RealTimeAdherenceState;
};

export type AgentProductionOverviewSchedule = {
  __typename?: 'AgentProductionOverviewSchedule';
  agentId: Scalars['ID'];
  scheduleDailyOverview: Array<ScheduleDailyOverview>;
  stats?: Maybe<AgentScheduleStats>;
};

export type AgentProductionSchedule = {
  __typename?: 'AgentProductionSchedule';
  agentId: Scalars['ID'];
  dailyShifts?: Maybe<Array<AgentScheduleDailyShift>>;
  scheduleItems?: Maybe<Array<ScheduleItem>>;
  stats?: Maybe<AgentScheduleStats>;
};

export type AgentProductionScheduleWithoutStats = {
  __typename?: 'AgentProductionScheduleWithoutStats';
  scheduleItems?: Maybe<Array<ScheduleItem>>;
};

export type AgentProductionScheduleWithoutStatsInput = {
  agentIds: Array<Scalars['ID']>;
  dateTimeRange: DateTimeRangeInput;
};

export type AgentScheduleDailyShift = {
  __typename?: 'AgentScheduleDailyShift';
  date: Scalars['String'];
  settings?: Maybe<ScheduleDailyAgentSettings>;
  shift?: Maybe<ScheduleDailyShift>;
};

export type AgentScheduleStats = {
  __typename?: 'AgentScheduleStats';
  vacationDays: Scalars['Int'];
  workDays: Scalars['Int'];
  workHours: Scalars['Int'];
};

export type AgentShift = {
  __typename?: 'AgentShift';
  agent: AgentInRequest;
  dateRange: DateRange;
  queueIds: Array<Scalars['ID']>;
  scheduleItems: Array<ShiftScheduleItem>;
};

export type AgentShiftOverviews = {
  __typename?: 'AgentShiftOverviews';
  agent: AgentInRequest;
  shiftOverview: Array<ShiftOverview>;
};

export type AgentShiftWithoutItems = {
  __typename?: 'AgentShiftWithoutItems';
  agent: AgentInRequestWithQueues;
  dateRange: DateRange;
};

export type Agents = {
  __typename?: 'Agents';
  agents: Array<Agent>;
  totalCount: Scalars['Int'];
};

export type AgentsProductionSchedulesData = {
  __typename?: 'AgentsProductionSchedulesData';
  agent: Agent;
  productionSchedules: Array<ScheduleInfo>;
};

export type AgentsProductionSchedulesInput = {
  agentIds: Array<Scalars['String']>;
  queueIds: Array<Scalars['String']>;
  startDateTime: Scalars['String'];
};

export type AgentsReportsResult = {
  __typename?: 'AgentsReportsResult';
  metadata: ReportsMetadata;
  result: UserStatisticsResult;
};

export type AutoScheduleJobInput = {
  forecastType: ForecastType;
  scheduleId: Scalars['ID'];
  scheduleOptions: ScheduleOptionsInput;
  selectedAgentIds: Array<InputMaybe<Scalars['ID']>>;
  selectedRange: DateTimeRangeInput;
  strictSelectedRange: Scalars['Boolean'];
};

export type BaseDataSeries = {
  trend: Array<Scalars['ChartData']>;
};

export type BulkAssignSupervisedAgentsInput = {
  agentsIds: Array<Scalars['String']>;
  queueId: Scalars['String'];
};

export type BulkAssignSupervisedAgentsToShiftTemplateInput = {
  agentsIds: Array<Scalars['String']>;
  shiftTemplateId: Scalars['String'];
};

export type CalculateForecastInput = {
  adjustments?: InputMaybe<Array<AdjustmentInput>>;
  info?: InputMaybe<ForecastInfoInput>;
};

export type CalculateWorkContributionInput = {
  agentIds: Array<Scalars['String']>;
  dateTimeRange: DateTimeRangeInput;
  queueIds: Array<Scalars['String']>;
  timezone: Scalars['String'];
};

export type CalculatedForecastData = {
  __typename?: 'CalculatedForecastData';
  averageHandlingTime: CalculatedSeriesData;
  contactVolume: CalculatedSeriesData;
  staffingRequirements: CalculatedSeriesData;
  workloadRequirements: CalculatedSeriesData;
};

export type CalculatedForecastValuesData = {
  __typename?: 'CalculatedForecastValuesData';
  adjustmentId?: Maybe<Scalars['ID']>;
  data: Array<Scalars['ChartData']>;
};

export type CalculatedSeriesData = {
  __typename?: 'CalculatedSeriesData';
  forecastValues: Array<CalculatedForecastValuesData>;
  gaps: Array<Scalars['ChartData']>;
};

export type CalculatedWorkContributionData = {
  __typename?: 'CalculatedWorkContributionData';
  queueId: Scalars['String'];
  workContributions: Array<WorkContribution>;
};

export type ChartDataInfo = {
  __typename?: 'ChartDataInfo';
  forecastAccuracy?: Maybe<Scalars['Float']>;
  lastHourAverageDifference?: Maybe<Scalars['Float']>;
};

export type ChartDataSeries = BaseDataSeries & {
  __typename?: 'ChartDataSeries';
  current: Array<Scalars['ChartData']>;
  forecasted: Array<Scalars['ChartData']>;
  trend: Array<Scalars['ChartData']>;
};

export type CommonAdherenceEvent = {
  currentActivity: Scalars['String'];
  expectedActivity: Scalars['String'];
  expectedActivityTypeId: Scalars['String'];
  from: Scalars['String'];
  id: Scalars['ID'];
  state: RealTimeAdherenceState;
  to?: Maybe<Scalars['String']>;
};

export type CommonEvent = {
  activityName: Scalars['String'];
  from: Scalars['String'];
  id: Scalars['ID'];
  mappedToActivity: Scalars['Boolean'];
  to?: Maybe<Scalars['String']>;
};

export type CommonIntradayChart = {
  info: ChartDataInfo;
};

export type CommonScheduleItem = {
  agentId?: Maybe<Scalars['ID']>;
  dateTimeRange: DateTimeRange;
  pinned: Scalars['Boolean'];
  scheduleElementId: Scalars['ID'];
};

export type DailyStatistics = {
  __typename?: 'DailyStatistics';
  date: Scalars['String'];
  statistics: Scalars['ReportsStatistics'];
};

export type DataImportHistory = {
  __typename?: 'DataImportHistory';
  dataImportHistoryRecords: Array<DataImportHistoryRecord>;
  totalCount: Scalars['Int'];
};

export type DataImportHistoryRecord = {
  __typename?: 'DataImportHistoryRecord';
  dateOfImport: Scalars['String'];
  id: Scalars['String'];
  importType: ImportTypeEnum;
  source: Scalars['String'];
  status: Scalars['Int'];
};

export type DateRange = {
  __typename?: 'DateRange';
  from: Scalars['String'];
  to: Scalars['String'];
};

export type DateTimeRange = {
  __typename?: 'DateTimeRange';
  endDateTime: Scalars['String'];
  startDateTime: Scalars['String'];
};

export type DateTimeRangeInput = {
  endDateTime: Scalars['String'];
  startDateTime: Scalars['String'];
};

export type DayTemplate = {
  __typename?: 'DayTemplate';
  breaks: Array<ShiftBreak>;
  breaksMinGap: Scalars['Int'];
  dayIndex: Scalars['Int'];
  id: Scalars['ID'];
  scheduleActivitySettings: Array<ScheduleActivitySettings>;
  shiftDuration: Scalars['Int'];
  shiftRange: TimeRange;
  shiftsMinGap: Scalars['Int'];
};

export type DayTemplateInput = {
  breaks: Array<ShiftBreakInput>;
  breaksMinGap: Scalars['Int'];
  dayIndex: Scalars['Int'];
  scheduleActivitySettings: Array<ScheduleActivitySettingsInput>;
  shiftDuration: Scalars['Int'];
  shiftRange: TimeRangeInput;
  shiftsMinGap: Scalars['Int'];
};

export enum DocTypeEnum {
  Csv = 'CSV',
  Pdf = 'PDF'
}

export type EslStaffingPerIntervalInput = {
  staffing: Scalars['Float'];
  startDateTime: Scalars['String'];
};

export type EslStaffingPerQueueInput = {
  queueId: Scalars['ID'];
  scheduledStaffing: Array<EslStaffingPerIntervalInput>;
};

export type EmptyInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type EstimatedServiceLevelPerQueue = {
  __typename?: 'EstimatedServiceLevelPerQueue';
  averageEsl?: Maybe<Scalars['Float']>;
  queueId: Scalars['ID'];
  series: EstimatedServiceLevelPerQueueSeriesData;
};

export type EstimatedServiceLevelPerQueueResponse = {
  __typename?: 'EstimatedServiceLevelPerQueueResponse';
  eslQueues: Array<EstimatedServiceLevelPerQueue>;
};

export type EstimatedServiceLevelPerQueueSeriesData = {
  __typename?: 'EstimatedServiceLevelPerQueueSeriesData';
  benchmark: Array<Scalars['ChartData']>;
  current: Array<Scalars['ChartData']>;
};

export type Forecast = {
  __typename?: 'Forecast';
  author: Scalars['String'];
  concurrentChatsCount?: Maybe<Scalars['Int']>;
  creationDate: Scalars['String'];
  forecastRange: DateTimeRange;
  historyRange: DateTimeRange;
  id: Scalars['ID'];
  modificationDate?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notes: Scalars['String'];
  queueId: Scalars['ID'];
  state: StateEnum;
  timezone: Scalars['String'];
};

export type ForecastInfoInput = {
  author: Scalars['String'];
  concurrentChatsCount?: InputMaybe<Scalars['Int']>;
  forecastRange: DateTimeRangeInput;
  historyRange: DateTimeRangeInput;
  name: Scalars['String'];
  notes: Scalars['String'];
  queueId: Scalars['ID'];
};

export type ForecastProduction = {
  __typename?: 'ForecastProduction';
  forecastValues: Array<ForecastValue>;
  queueId: Scalars['String'];
};

export enum ForecastType {
  Intraday = 'INTRADAY',
  Production = 'PRODUCTION'
}

export type ForecastValue = {
  __typename?: 'ForecastValue';
  dateTimeRange: DateTimeRange;
  value: ForecastValuesValue;
};

export type ForecastValuesValue = {
  __typename?: 'ForecastValuesValue';
  sourceForecastId: Scalars['String'];
  staffingRequirements: Scalars['Int'];
};

export type GetCalendarExportUrl = {
  __typename?: 'GetCalendarExportURL';
  url: Scalars['String'];
};

export type GetForecast = {
  __typename?: 'GetForecast';
  adjustments: Array<Adjustment>;
  info: Forecast;
  values: CalculatedForecastData;
};

export type GetQueuesStaffingFromOtherProductionSchedulesInput = {
  endDateTime: Scalars['String'];
  queueIds: Array<Scalars['String']>;
  scheduleToExclude?: InputMaybe<Scalars['ID']>;
  startDateTime: Scalars['String'];
};

export type IdOrEmptyResponse = {
  __typename?: 'IdOrEmptyResponse';
  id: Scalars['ID'];
};

export enum ImportTypeEnum {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

export type IntradayChart = CommonIntradayChart & {
  __typename?: 'IntradayChart';
  info: ChartDataInfo;
  series: ChartDataSeries;
};

export type IntradayChartsData = {
  __typename?: 'IntradayChartsData';
  aht: IntradayChart;
  contactVolume: IntradayChart;
  sla: SlaIntradayChart;
  staffingRequirement: StaffingIntradayChart;
};

export type IntradayInfo = {
  __typename?: 'IntradayInfo';
  actualInterval: Scalars['String'];
  dataAsOf: Scalars['String'];
  timezone: Scalars['String'];
};

export type IntradayPerQueue = {
  __typename?: 'IntradayPerQueue';
  charts: IntradayChartsData;
  info: IntradayInfo;
};

export type IntradayPushNotificationSetting = {
  __typename?: 'IntradayPushNotificationSetting';
  enabled: Scalars['Boolean'];
};

export type IntradayPushNotificationSettingInput = {
  enabled: Scalars['Boolean'];
};

export type IntradayQueue = {
  __typename?: 'IntradayQueue';
  id: Scalars['ID'];
  inAlert: Scalars['Boolean'];
  name: Scalars['String'];
  timezone: Scalars['String'];
};

export type IntradayQueueNotification = {
  __typename?: 'IntradayQueueNotification';
  contactVolumeDeviation?: Maybe<Scalars['Float']>;
  queueId: Scalars['ID'];
  slaOutOfRangeFrom?: Maybe<Scalars['Float']>;
  slaOutOfRangeTo?: Maybe<Scalars['Float']>;
};

export type IntradayQueueNotificationInput = {
  contactVolumeDeviation?: InputMaybe<Scalars['Float']>;
  queueId: Scalars['ID'];
  slaOutOfRangeFrom?: InputMaybe<Scalars['Float']>;
  slaOutOfRangeTo?: InputMaybe<Scalars['Float']>;
};

export type KeycloakApplication = {
  __typename?: 'KeycloakApplication';
  applicationName: Scalars['String'];
};

export enum LockType {
  None = 'NONE',
  Write = 'WRITE'
}

export type MinMaxRangeFilterInput = {
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  bulkAssignSupervisedAgents?: Maybe<IdOrEmptyResponse>;
  bulkAssignSupervisedAgentsToShiftTemplate?: Maybe<IdOrEmptyResponse>;
  cloneSchedule?: Maybe<IdOrEmptyResponse>;
  createAdherenceNotification?: Maybe<AdherenceNotificationType>;
  createAdherenceSetting?: Maybe<IdOrEmptyResponse>;
  createAutoScheduleJob?: Maybe<ScheduleJobType>;
  createForecast?: Maybe<IdOrEmptyResponse>;
  createIntradayPushSubscription?: Maybe<PushSubscription>;
  createIntradayQueueNotification?: Maybe<IdOrEmptyResponse>;
  createPTORequest: PtoRequest;
  createQueue?: Maybe<IdOrEmptyResponse>;
  createRtaPushSubscription?: Maybe<PushSubscription>;
  createSchedule?: Maybe<IdOrEmptyResponse>;
  createScheduleElement?: Maybe<IdOrEmptyResponse>;
  createShiftSwapRequest: ShiftSwapRequest;
  createShiftTemplate?: Maybe<IdOrEmptyResponse>;
  createSkill?: Maybe<IdOrEmptyResponse>;
  deleteAdherenceNotification?: Maybe<IdOrEmptyResponse>;
  deleteAdherenceSetting?: Maybe<IdOrEmptyResponse>;
  deleteForecast?: Maybe<IdOrEmptyResponse>;
  deleteForecastFromProduction?: Maybe<IdOrEmptyResponse>;
  deleteIntradayQueueNotification?: Maybe<IdOrEmptyResponse>;
  deleteQueue?: Maybe<IdOrEmptyResponse>;
  deleteSchedule?: Maybe<IdOrEmptyResponse>;
  deleteScheduleElement?: Maybe<IdOrEmptyResponse>;
  deleteShiftTemplate?: Maybe<IdOrEmptyResponse>;
  deleteSkill?: Maybe<IdOrEmptyResponse>;
  putForecastToProduction?: Maybe<IdOrEmptyResponse>;
  putScheduleToProduction?: Maybe<IdOrEmptyResponse>;
  removeScheduleFromProduction?: Maybe<IdOrEmptyResponse>;
  updateAdherenceNotification?: Maybe<AdherenceNotificationType>;
  updateAdherenceSetting?: Maybe<IdOrEmptyResponse>;
  updateDisplayOrderOnScheduleElement?: Maybe<IdOrEmptyResponse>;
  updateForecast?: Maybe<IdOrEmptyResponse>;
  updateForecastName?: Maybe<IdOrEmptyResponse>;
  updateIntradayPushNotificationOnOffSetting?: Maybe<IdOrEmptyResponse>;
  updateIntradayQueueNotification?: Maybe<IdOrEmptyResponse>;
  updateQueue?: Maybe<IdOrEmptyResponse>;
  updateSchedule?: Maybe<IdOrEmptyResponse>;
  updateScheduleElement?: Maybe<IdOrEmptyResponse>;
  updateScheduleInfo?: Maybe<IdOrEmptyResponse>;
  updateShiftTemplate?: Maybe<ShiftTemplate>;
  updateSkill?: Maybe<IdOrEmptyResponse>;
  updateStateOfNotificationSettings: NotificationSettings;
  updateStateOfPTORequest: PtoRequest;
  updateStateOfShiftSwapRequest: ShiftSwapRequest;
  updateStateOfSupervisorPTORequest: PtoRequest;
  updateSupervisedAgent?: Maybe<IdOrEmptyResponse>;
};


export type MutationBulkAssignSupervisedAgentsArgs = {
  data: BulkAssignSupervisedAgentsInput;
  supervisorId: Scalars['ID'];
};


export type MutationBulkAssignSupervisedAgentsToShiftTemplateArgs = {
  data: BulkAssignSupervisedAgentsToShiftTemplateInput;
  supervisorId: Scalars['ID'];
};


export type MutationCloneScheduleArgs = {
  id: Scalars['ID'];
};


export type MutationCreateAdherenceNotificationArgs = {
  notificationSetup: AdherenceNotificationInput;
};


export type MutationCreateAdherenceSettingArgs = {
  setting: AdherenceSettingInput;
};


export type MutationCreateAutoScheduleJobArgs = {
  autoScheduleJob: AutoScheduleJobInput;
};


export type MutationCreateForecastArgs = {
  forecast: CalculateForecastInput;
};


export type MutationCreateIntradayPushSubscriptionArgs = {
  subscription: PushSubscriptionInput;
};


export type MutationCreateIntradayQueueNotificationArgs = {
  intradayQueueNotification: IntradayQueueNotificationInput;
};


export type MutationCreatePtoRequestArgs = {
  agentId: Scalars['ID'];
  parameters: PtoRequestInput;
};


export type MutationCreateQueueArgs = {
  queue: QueueInput;
};


export type MutationCreateRtaPushSubscriptionArgs = {
  subscription: PushSubscriptionInput;
};


export type MutationCreateScheduleArgs = {
  allowInactiveAgents?: InputMaybe<Scalars['Boolean']>;
  schedule: ScheduleInput;
};


export type MutationCreateScheduleElementArgs = {
  scheduleElement: ScheduleElementInput;
};


export type MutationCreateShiftSwapRequestArgs = {
  parameters: ShiftSwapRequestInput;
  requesterId: Scalars['ID'];
};


export type MutationCreateShiftTemplateArgs = {
  shiftTemplate: ShiftTemplateInput;
};


export type MutationCreateSkillArgs = {
  skill: SkillInput;
};


export type MutationDeleteAdherenceSettingArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteForecastArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteForecastFromProductionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteIntradayQueueNotificationArgs = {
  queueId: Scalars['ID'];
};


export type MutationDeleteQueueArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteScheduleArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteScheduleElementArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteShiftTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSkillArgs = {
  id: Scalars['ID'];
};


export type MutationPutForecastToProductionArgs = {
  id: Scalars['ID'];
  input?: InputMaybe<EmptyInput>;
};


export type MutationPutScheduleToProductionArgs = {
  input?: InputMaybe<EmptyInput>;
  scheduleId: Scalars['ID'];
};


export type MutationRemoveScheduleFromProductionArgs = {
  scheduleId: Scalars['ID'];
};


export type MutationUpdateAdherenceNotificationArgs = {
  notificationSetup: AdherenceNotificationInput;
};


export type MutationUpdateAdherenceSettingArgs = {
  id: Scalars['ID'];
  setting: AdherenceSettingInput;
};


export type MutationUpdateDisplayOrderOnScheduleElementArgs = {
  id: Scalars['ID'];
  scheduleElementDisplayOrder: ScheduleElementDisplayOrderInput;
};


export type MutationUpdateForecastArgs = {
  forecast: CalculateForecastInput;
  id: Scalars['ID'];
};


export type MutationUpdateForecastNameArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationUpdateIntradayPushNotificationOnOffSettingArgs = {
  intradayPushNotificationSetting: IntradayPushNotificationSettingInput;
};


export type MutationUpdateIntradayQueueNotificationArgs = {
  intradayQueueNotification: IntradayQueueNotificationInput;
};


export type MutationUpdateQueueArgs = {
  id: Scalars['ID'];
  queue: QueueInput;
  updateUsedQueue?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateScheduleArgs = {
  allowInactiveAgents?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  schedule: ScheduleInput;
};


export type MutationUpdateScheduleElementArgs = {
  id: Scalars['ID'];
  scheduleElement: ScheduleElementInput;
};


export type MutationUpdateScheduleInfoArgs = {
  availableSeats: Scalars['String'];
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateShiftTemplateArgs = {
  id: Scalars['ID'];
  shiftTemplate: ShiftTemplateInput;
};


export type MutationUpdateSkillArgs = {
  id: Scalars['ID'];
  skill: SkillInput;
};


export type MutationUpdateStateOfNotificationSettingsArgs = {
  notificationSettingsId: Scalars['ID'];
  parameters: NotificationsSettingsUpdateInput;
  userId: Scalars['ID'];
};


export type MutationUpdateStateOfPtoRequestArgs = {
  agentId: Scalars['ID'];
  parameters: PtoRequestUpdateInput;
  ptoRequestId: Scalars['ID'];
};


export type MutationUpdateStateOfShiftSwapRequestArgs = {
  action: ShiftSwapRequestAction;
  agentId: Scalars['ID'];
  controller: ShiftSwapRequestController;
  parameters: ShiftSwapRequestUpdateInput;
  requestId: Scalars['ID'];
};


export type MutationUpdateStateOfSupervisorPtoRequestArgs = {
  fromState: RequestState;
  parameters: PtoRequestUpdateInput;
  ptoRequestId: Scalars['ID'];
  supervisorId: Scalars['ID'];
};


export type MutationUpdateSupervisedAgentArgs = {
  agent: UpdateAgentInput;
  id: Scalars['ID'];
  supervisorId: Scalars['ID'];
};

export enum NotificationFeature {
  SelfService = 'SELF_SERVICE'
}

export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  createdAt: Scalars['String'];
  enabled: Scalars['Boolean'];
  feature: NotificationFeature;
  id: Scalars['ID'];
  type: NotificationType;
  updatedAt: Scalars['String'];
  userId: Scalars['ID'];
};

export enum NotificationType {
  Email = 'EMAIL'
}

export type NotificationsSettingsUpdateInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type PtoRequest = {
  __typename?: 'PTORequest';
  agent: AgentInRequestWithQueues;
  approver?: Maybe<AgentInRequest>;
  audits: Array<RequestAudit>;
  createdAt: Scalars['String'];
  dateRange: DateTimeRange;
  id: Scalars['ID'];
  state: PtoRequestState;
  stateChangedAt: Scalars['String'];
  type: PtoRequestSubtype;
  updatedAt: Scalars['String'];
};

export type PtoRequestInput = {
  dateRange: DateTimeRangeInput;
  message?: InputMaybe<Scalars['String']>;
  type: PtoRequestSubtype;
};

export type PtoRequestUpdateInput = {
  message?: InputMaybe<Scalars['String']>;
  ptoRequestState: RequestState;
};

export type ProductionSchedule = {
  __typename?: 'ProductionSchedule';
  itemsInProgress: Scalars['Boolean'];
  name: Scalars['String'];
  queueIds: Array<Scalars['ID']>;
  scheduleId: Scalars['ID'];
  scheduleRange: DateTimeRange;
};

export type ProductionScheduleElementsFromOtherSchedulesInput = {
  agentIds: Array<Scalars['ID']>;
  dateTimeRange: DateTimeRangeInput;
  scheduleToExclude?: InputMaybe<Scalars['ID']>;
};

export type ProductionScheduleItemsExtended = {
  __typename?: 'ProductionScheduleItemsExtended';
  queueIntervals: Array<ProductionScheduleRangeIntervals>;
  queuesDetails: Array<ProductionScheduleQueuesDetails>;
  scheduleItems: Array<ScheduleItemExtended>;
  scheduleRange: DateTimeRange;
};

export type ProductionScheduleQueuesDetails = {
  __typename?: 'ProductionScheduleQueuesDetails';
  channelType: QueueChannelType;
  queueId: Scalars['ID'];
};

export type ProductionScheduleRangeIntervals = {
  __typename?: 'ProductionScheduleRangeIntervals';
  dateTimeRange: DateTimeRange;
  intervalAgentIds: Array<Scalars['ID']>;
  intervalQueueIds: Array<Scalars['ID']>;
  sourceScheduleId: Scalars['ID'];
};

export enum PtoRequestState {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Declined = 'DECLINED',
  PendingApproval = 'PENDING_APPROVAL'
}

export enum PtoRequestSubtype {
  Sick = 'SICK',
  Vacation = 'VACATION'
}

export type PushSubscription = {
  __typename?: 'PushSubscription';
  auth: Scalars['String'];
  endpoint: Scalars['String'];
  expirationTime?: Maybe<Scalars['String']>;
  p256dh: Scalars['String'];
};

export type PushSubscriptionInput = {
  auth: Scalars['String'];
  endpoint: Scalars['String'];
  expirationTime?: InputMaybe<Scalars['String']>;
  p256dh: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  acdQueues: Array<AcdQueue>;
  adherenceAcdStatuses: Array<AdherenceSettingAcdStatus>;
  adherenceEventTypes: Array<AdherenceEventType>;
  adherenceHistoryBarChartData: AdherenceHistoryBarChart;
  adherenceHistoryGanttChartData: AdherenceHistoryGanttChart;
  adherenceHistoryStartDate: AdherenceHistoryStartDate;
  adherenceLastImport: AdherenceLastImport;
  adherenceNotificationSetup?: Maybe<AdherenceNotificationType>;
  adherenceReasonCodes: Array<AdherenceReasonCode>;
  adherenceSettings: AdherenceSettings;
  agentOverviews: Array<AgentOverviewWithTeams>;
  agentPTORequest: PtoRequest;
  agentProductionOverviewSchedule?: Maybe<AgentProductionOverviewSchedule>;
  agentProductionSchedule?: Maybe<AgentProductionSchedule>;
  agentProductionScheduleWithoutStats?: Maybe<AgentProductionScheduleWithoutStats>;
  agentSchedulesInfo: Array<ScheduleInfo>;
  agents?: Maybe<Agents>;
  agentsByIds?: Maybe<Agents>;
  agentsProductionSchedules: Array<Maybe<AgentsProductionSchedulesData>>;
  agentsReports: AgentsReportsResult;
  availableApplications: Array<KeycloakApplication>;
  calculatedForecast: CalculatedForecastData;
  calculatedIntradayWorkContribution: Array<CalculatedWorkContributionData>;
  calculatedWorkContribution: Array<CalculatedWorkContributionData>;
  dataImportHistory: DataImportHistory;
  estimatedServiceLevelPerQueue: EstimatedServiceLevelPerQueueResponse;
  forecast?: Maybe<GetForecast>;
  forecasts: Array<Forecast>;
  forecastsIntraday: Array<ForecastProduction>;
  forecastsProduction: Array<ForecastProduction>;
  getCalendarExportURL?: Maybe<GetCalendarExportUrl>;
  getScheduleJobsInProgress: Array<ScheduleJobType>;
  getScheduleJobsState: Array<ScheduleJobType>;
  intradayNotifications: Array<IntradayQueueNotification>;
  intradayPerQueueData?: Maybe<IntradayPerQueue>;
  intradayPushNotificationOnOffSetting: IntradayPushNotificationSetting;
  intradayQueuesList: Array<IntradayQueue>;
  notificationSettings: Array<NotificationSettings>;
  productionScheduleElementsFromOtherSchedules: ProductionScheduleItemsExtended;
  productionScheduleReport?: Maybe<Scalars['String']>;
  productionSchedulesPerQueues: Array<ProductionSchedule>;
  publicVapidKey: VapidKeys;
  queue?: Maybe<Queue>;
  queueHistoryRange?: Maybe<DateTimeRange>;
  queues: Array<Queue>;
  queuesStaffingFromOtherProductionSchedules: Array<StaffingPerQueue>;
  queuesTags: Array<ScheduleElementTag>;
  queuesTimezones: Array<Timezone>;
  realTimeAdherenceGanttChartInitialData: RealTimeAdherenceGanttChartInitial;
  recipientShiftSwapRequest: ShiftSwapRequest;
  requesterShiftSwapRequest: ShiftSwapRequest;
  schedule?: Maybe<Schedule>;
  scheduleElement?: Maybe<ScheduleElement>;
  scheduleElements: Array<ScheduleElement>;
  schedules?: Maybe<Array<ScheduleInfo>>;
  schedulesInfo: Array<ScheduleInfo>;
  shiftOverviewForShiftFromShiftSwapRequest: AgentShift;
  shiftOverviewsForRequester: AgentShiftOverviews;
  shiftTemplate?: Maybe<ShiftTemplate>;
  shiftTemplates?: Maybe<ShiftTemplates>;
  skills: Array<Skill>;
  skillsWithUsed: Array<SkillWithUsed>;
  suitableRecipients: Array<AgentInRequestWithQueues>;
  suitableShiftsForSwap: Array<AgentShift>;
  supervisedAdherenceHistory: AdherenceHistory;
  supervisedAgents?: Maybe<Agents>;
  supervisedTeams: Array<Team>;
  supervisorPtoRequest: PtoRequest;
  supervisorRequests: SupervisorRequests;
  supervisorShiftOverviewForShiftSwapRequest: AgentShift;
  supervisorShiftSwapRequest: ShiftSwapRequest;
  teams: Array<Team>;
  teamsReports: TeamsReportsResult;
  timezones: Array<Timezone>;
  userRequests: Array<RequestPreview>;
};


export type QueryAdherenceHistoryBarChartDataArgs = {
  agentId: Scalars['ID'];
  endDateTime: Scalars['String'];
  startDateTime: Scalars['String'];
  timezone: Scalars['String'];
};


export type QueryAdherenceHistoryGanttChartDataArgs = {
  agentId: Scalars['ID'];
  endDateTime: Scalars['String'];
  startDateTime: Scalars['String'];
  timezone: Scalars['String'];
};


export type QueryAdherenceLastImportArgs = {
  status?: InputMaybe<Scalars['Int']>;
};


export type QueryAdherenceSettingsArgs = {
  searchCriteria: AdherenceSettingsSearchCriteria;
};


export type QueryAgentOverviewsArgs = {
  teamIds?: InputMaybe<Scalars['String']>;
};


export type QueryAgentPtoRequestArgs = {
  agentId: Scalars['ID'];
  ptoRequestId: Scalars['ID'];
};


export type QueryAgentProductionOverviewScheduleArgs = {
  agentId: Scalars['ID'];
  endDateTime: Scalars['String'];
  endDateTimeStats?: InputMaybe<Scalars['String']>;
  startDateTime: Scalars['String'];
  startDateTimeStats?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
};


export type QueryAgentProductionScheduleArgs = {
  agentId: Scalars['ID'];
  endDateTime: Scalars['String'];
  startDateTime: Scalars['String'];
  timezone: Scalars['String'];
};


export type QueryAgentProductionScheduleWithoutStatsArgs = {
  parameters: AgentProductionScheduleWithoutStatsInput;
};


export type QueryAgentSchedulesInfoArgs = {
  agentId: Scalars['ID'];
  endDate?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['String']>;
};


export type QueryAgentsArgs = {
  agentName?: InputMaybe<Scalars['String']>;
  agentSurname?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  max?: InputMaybe<Scalars['Int']>;
  queueIds?: InputMaybe<Scalars['ID']>;
  shiftTemplateIds?: InputMaybe<Scalars['ID']>;
  skillIds?: InputMaybe<Scalars['ID']>;
};


export type QueryAgentsByIdsArgs = {
  agentIds: Array<Scalars['String']>;
};


export type QueryAgentsProductionSchedulesArgs = {
  parameters: AgentsProductionSchedulesInput;
};


export type QueryAgentsReportsArgs = {
  agentIds?: InputMaybe<Scalars['String']>;
  from: Scalars['String'];
  page: Scalars['Int'];
  pageSize?: InputMaybe<Scalars['Int']>;
  teamIds?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
};


export type QueryCalculatedForecastArgs = {
  parameters: CalculateForecastInput;
};


export type QueryCalculatedIntradayWorkContributionArgs = {
  parameters: CalculateWorkContributionInput;
};


export type QueryCalculatedWorkContributionArgs = {
  parameters: CalculateWorkContributionInput;
};


export type QueryDataImportHistoryArgs = {
  first?: InputMaybe<Scalars['Int']>;
  max?: InputMaybe<Scalars['Int']>;
};


export type QueryEstimatedServiceLevelPerQueueArgs = {
  endDateTime: Scalars['String'];
  scheduledStaffingPerQueue: Array<EslStaffingPerQueueInput>;
  startDateTime: Scalars['String'];
};


export type QueryForecastArgs = {
  id: Scalars['ID'];
};


export type QueryForecastsArgs = {
  forecastEndDateTime: Scalars['String'];
  forecastName?: InputMaybe<Scalars['String']>;
  forecastStartDateTime: Scalars['String'];
  queueId?: InputMaybe<Scalars['ID']>;
};


export type QueryForecastsIntradayArgs = {
  endDateTime: Scalars['String'];
  queueIds: Scalars['ID'];
  startDateTime: Scalars['String'];
};


export type QueryForecastsProductionArgs = {
  endDateTime: Scalars['String'];
  queueIds: Scalars['ID'];
  startDateTime: Scalars['String'];
};


export type QueryGetCalendarExportUrlArgs = {
  agentId: Scalars['ID'];
};


export type QueryGetScheduleJobsStateArgs = {
  correlationId?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryIntradayPerQueueDataArgs = {
  queueId: Scalars['ID'];
};


export type QueryNotificationSettingsArgs = {
  features?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type QueryProductionScheduleElementsFromOtherSchedulesArgs = {
  parameters: ProductionScheduleElementsFromOtherSchedulesInput;
};


export type QueryProductionScheduleReportArgs = {
  docType: DocTypeEnum;
  endDateTime: Scalars['String'];
  queueId: Scalars['ID'];
  startDateTime: Scalars['String'];
};


export type QueryProductionSchedulesPerQueuesArgs = {
  endDateTime: Scalars['String'];
  queueIds: Array<Scalars['ID']>;
  startDateTime: Scalars['String'];
};


export type QueryQueueArgs = {
  id: Scalars['ID'];
};


export type QueryQueueHistoryRangeArgs = {
  queueId?: InputMaybe<Scalars['ID']>;
};


export type QueryQueuesArgs = {
  acdQueueIds?: InputMaybe<Scalars['ID']>;
  channelTypes?: InputMaybe<Scalars['String']>;
  historicalDataIntervals?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  skillIds?: InputMaybe<Scalars['ID']>;
  timezones?: InputMaybe<Scalars['ID']>;
};


export type QueryQueuesStaffingFromOtherProductionSchedulesArgs = {
  parameters: GetQueuesStaffingFromOtherProductionSchedulesInput;
};


export type QueryRealTimeAdherenceGanttChartInitialDataArgs = {
  agentId: Scalars['ID'];
};


export type QueryRecipientShiftSwapRequestArgs = {
  recipientId: Scalars['ID'];
  shiftSwapRequestId: Scalars['ID'];
};


export type QueryRequesterShiftSwapRequestArgs = {
  requesterId: Scalars['ID'];
  shiftSwapRequestId: Scalars['ID'];
};


export type QueryScheduleArgs = {
  id: Scalars['ID'];
};


export type QueryScheduleElementArgs = {
  id: Scalars['ID'];
};


export type QuerySchedulesArgs = {
  queueIds?: InputMaybe<Scalars['ID']>;
  scheduleEndDateTime?: InputMaybe<Scalars['String']>;
  scheduleName?: InputMaybe<Scalars['String']>;
  scheduleStartDateTime?: InputMaybe<Scalars['String']>;
};


export type QuerySchedulesInfoArgs = {
  scheduleIds: Scalars['ID'];
};


export type QueryShiftOverviewForShiftFromShiftSwapRequestArgs = {
  controller: ShiftSwapRequestController;
  shiftSwapRequestId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryShiftOverviewsForRequesterArgs = {
  from: Scalars['String'];
  requesterId: Scalars['ID'];
  to: Scalars['String'];
};


export type QueryShiftTemplateArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryShiftTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QuerySkillsArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QuerySuitableRecipientsArgs = {
  requesterId: Scalars['ID'];
};


export type QuerySuitableShiftsForSwapArgs = {
  recipientGroup: ShiftSwapRecipientGroup;
  recipients?: InputMaybe<Scalars['String']>;
  requesterId: Scalars['ID'];
  shiftDate: Scalars['String'];
  shiftsFrom?: InputMaybe<Scalars['String']>;
  shiftsTo?: InputMaybe<Scalars['String']>;
};


export type QuerySupervisedAdherenceHistoryArgs = {
  adherenceHistorySearchCriteria: AdherenceHistorySearchCriteriaInput;
  supervisorId: Scalars['ID'];
};


export type QuerySupervisedAgentsArgs = {
  filters: SupervisedAgentsFilter;
  supervisorId: Scalars['ID'];
};


export type QuerySupervisedTeamsArgs = {
  supervisorId: Scalars['ID'];
};


export type QuerySupervisorPtoRequestArgs = {
  ptoRequestId: Scalars['ID'];
  supervisorId: Scalars['ID'];
};


export type QuerySupervisorRequestsArgs = {
  agentName?: InputMaybe<Scalars['String']>;
  agentSurname?: InputMaybe<Scalars['String']>;
  createdAtFrom?: InputMaybe<Scalars['String']>;
  createdAtTo?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  max: Scalars['Int'];
  queueIds?: InputMaybe<Scalars['ID']>;
  requestedFrom?: InputMaybe<Scalars['String']>;
  requestedTo?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<Scalars['String']>;
  subtypes?: InputMaybe<Scalars['String']>;
  supervisorId: Scalars['ID'];
  types?: InputMaybe<Scalars['String']>;
};


export type QuerySupervisorShiftOverviewForShiftSwapRequestArgs = {
  controller: ShiftSwapRequestController;
  shiftSwapRequestId: Scalars['ID'];
  supervisorId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QuerySupervisorShiftSwapRequestArgs = {
  shiftSwapRequestId: Scalars['ID'];
  supervisorId: Scalars['ID'];
};


export type QueryTeamsReportsArgs = {
  from: Scalars['String'];
  page: Scalars['Int'];
  pageSize?: InputMaybe<Scalars['Int']>;
  teamIds?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
};


export type QueryUserRequestsArgs = {
  agentId: Scalars['ID'];
  createdAtFrom?: InputMaybe<Scalars['String']>;
  createdAtTo?: InputMaybe<Scalars['String']>;
  requestedFrom?: InputMaybe<Scalars['String']>;
  requestedTo?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<Scalars['String']>;
  subtypes?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Scalars['String']>;
};

export type Queue = {
  __typename?: 'Queue';
  acdQueueIds?: Maybe<Array<Scalars['ID']>>;
  acdQueueIdsEditable: Scalars['Boolean'];
  channelType: QueueChannelType;
  channelTypeEditable: Scalars['Boolean'];
  historicalDataInterval?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  idEditable: Scalars['Boolean'];
  name: Scalars['String'];
  nameEditable: Scalars['Boolean'];
  serviceLevel?: Maybe<ServiceLevel>;
  serviceLevelEditable: Scalars['Boolean'];
  skillId?: Maybe<Scalars['String']>;
  skillIdEditable: Scalars['Boolean'];
  tag?: Maybe<Scalars['String']>;
  tagEditable: Scalars['Boolean'];
  timezone: Scalars['String'];
  timezoneEditable: Scalars['Boolean'];
  used: Scalars['Boolean'];
};

export enum QueueChannelType {
  Chat = 'CHAT',
  Email = 'EMAIL',
  Voice = 'VOICE'
}

export type QueueInput = {
  acdQueueIds?: InputMaybe<Array<Scalars['ID']>>;
  channelType: QueueChannelType;
  name: Scalars['String'];
  serviceLevel?: InputMaybe<ServiceLevelInput>;
  skillId?: InputMaybe<Scalars['String']>;
  tag: Scalars['String'];
  timezone: Scalars['String'];
  used: Scalars['Boolean'];
};

export type RealTimeActivityEvent = CommonEvent & {
  __typename?: 'RealTimeActivityEvent';
  activityName: Scalars['String'];
  from: Scalars['String'];
  id: Scalars['ID'];
  mappedToActivity: Scalars['Boolean'];
  to?: Maybe<Scalars['String']>;
};

export type RealTimeAdherenceEvent = CommonAdherenceEvent & {
  __typename?: 'RealTimeAdherenceEvent';
  currentActivity: Scalars['String'];
  expectedActivity: Scalars['String'];
  expectedActivityTypeId: Scalars['String'];
  from: Scalars['String'];
  id: Scalars['ID'];
  state: RealTimeAdherenceState;
  to?: Maybe<Scalars['String']>;
};

export type RealTimeAdherenceGanttChartInitial = {
  __typename?: 'RealTimeAdherenceGanttChartInitial';
  adherenceEvents: Array<RealTimeAdherenceEvent>;
  agentEvents: Array<RealTimeActivityEvent>;
};

export enum RealTimeAdherenceState {
  In = 'IN',
  Out = 'OUT'
}

export type RecipientShiftForSwapInput = {
  from: Scalars['String'];
  recipientId: Scalars['ID'];
};

export type ReportsMetadata = {
  __typename?: 'ReportsMetadata';
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalPages: Scalars['Int'];
  totalRecords: Scalars['Int'];
};

export type RequestAudit = {
  __typename?: 'RequestAudit';
  message?: Maybe<Scalars['String']>;
  toState: RequestState;
  when: Scalars['String'];
  who: AgentInRequest;
};

export type RequestPreview = {
  __typename?: 'RequestPreview';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  state: RequestState;
  subtype: RequestSubtype;
  type: RequestType;
};

export enum RequestState {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Declined = 'DECLINED',
  PendingAcceptance = 'PENDING_ACCEPTANCE',
  PendingApproval = 'PENDING_APPROVAL'
}

export enum RequestSubtype {
  Approver = 'APPROVER',
  Recipient = 'RECIPIENT',
  Requester = 'REQUESTER',
  Sick = 'SICK',
  Vacation = 'VACATION'
}

export enum RequestType {
  Pto = 'PTO',
  ShiftSwap = 'SHIFT_SWAP'
}

export type RequesterShiftForSwapInput = {
  from: Scalars['String'];
  requesterId: Scalars['ID'];
};

export type Schedule = {
  __typename?: 'Schedule';
  daysSettings: Array<ScheduleDaySettings>;
  info: ScheduleInfo;
  scheduleItems?: Maybe<Array<ScheduleItem>>;
  scheduleQueues: Array<StaffingPerQueue>;
  scheduledAgents: Array<ScheduledAgent>;
};

export type ScheduleActivitySettings = {
  __typename?: 'ScheduleActivitySettings';
  id: Scalars['ID'];
  maximumPerDay: Scalars['Int'];
  minimumPerDay: Scalars['Int'];
  type: QueueChannelType;
};

export type ScheduleActivitySettingsInput = {
  maximumPerDay: Scalars['Int'];
  minimumPerDay: Scalars['Int'];
  type: QueueChannelType;
};

export type ScheduleAgentDaySettings = {
  __typename?: 'ScheduleAgentDaySettings';
  agentId: Scalars['ID'];
  remote: Scalars['Boolean'];
};

export type ScheduleAgentDaySettingsInput = {
  agentId: Scalars['ID'];
  remote: Scalars['Boolean'];
};

export type ScheduleChange = {
  __typename?: 'ScheduleChange';
  agentId: Scalars['String'];
  from: Scalars['String'];
  to: Scalars['String'];
};

export type ScheduleDailyAgentSettings = {
  __typename?: 'ScheduleDailyAgentSettings';
  remote: Scalars['Boolean'];
};

export type ScheduleDailyOverview = {
  __typename?: 'ScheduleDailyOverview';
  afterShiftScheduleElementIds: Array<Scalars['String']>;
  beforeShiftScheduleElementIds: Array<Scalars['String']>;
  date: Scalars['String'];
  overviewScheduleElementIds: Array<Scalars['String']>;
  settings?: Maybe<ScheduleDailyAgentSettings>;
  shift?: Maybe<ScheduleDailyShift>;
};

export type ScheduleDailyShift = {
  __typename?: 'ScheduleDailyShift';
  dateTimeRange: DateTimeRange;
  durationPaidHours: Scalars['Int'];
  durationShiftHours: Scalars['Int'];
  swappable: Scalars['Boolean'];
};

export type ScheduleDaySettings = {
  __typename?: 'ScheduleDaySettings';
  agents: Array<ScheduleAgentDaySettings>;
  dayIndex: Scalars['Int'];
};

export type ScheduleDaySettingsInput = {
  agents: Array<ScheduleAgentDaySettingsInput>;
  dayIndex: Scalars['Int'];
};

export type ScheduleElement = {
  __typename?: 'ScheduleElement';
  color: ScheduleElementColor;
  defaultDuration: Scalars['Int'];
  displayOrder: Scalars['Int'];
  editable?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  paid: Scalars['Boolean'];
  paidTimeOff: Scalars['Boolean'];
  pinnable: Scalars['Boolean'];
  productive: Scalars['Boolean'];
  shift: Scalars['Boolean'];
  showInOverview: Scalars['Boolean'];
  showInOverviewBig: Scalars['Boolean'];
  sick: Scalars['Boolean'];
  tags: Array<ScheduleElementTag>;
  vacation: Scalars['Boolean'];
  zoomLevel: Scalars['Int'];
};

export type ScheduleElementColor = {
  __typename?: 'ScheduleElementColor';
  blue: Scalars['Int'];
  green: Scalars['Int'];
  red: Scalars['Int'];
};

export type ScheduleElementColorInput = {
  blue: Scalars['Int'];
  green: Scalars['Int'];
  red: Scalars['Int'];
};

export type ScheduleElementDisplayOrderInput = {
  displayOrder: Scalars['Int'];
};

export type ScheduleElementInput = {
  color: ScheduleElementColorInput;
  defaultDuration: Scalars['Int'];
  name: Scalars['String'];
  paid: Scalars['Boolean'];
  pinnable: Scalars['Boolean'];
  productive: Scalars['Boolean'];
  tags: Array<Scalars['ID']>;
  zoomLevel: Scalars['Int'];
};

export type ScheduleElementTag = {
  __typename?: 'ScheduleElementTag';
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type ScheduleInfo = {
  __typename?: 'ScheduleInfo';
  author: Scalars['String'];
  availableSeats?: Maybe<Scalars['Int']>;
  creationDate: Scalars['String'];
  id: Scalars['ID'];
  lockType: LockType;
  modificationDate: Scalars['String'];
  name: Scalars['String'];
  notes: Scalars['String'];
  queueIds: Array<Scalars['ID']>;
  scheduleRange: DateTimeRange;
  state: StateEnum;
  timezone: Scalars['String'];
};

export type ScheduleInfoInput = {
  author: Scalars['String'];
  availableSeats?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  notes: Scalars['String'];
  queueIds: Array<Scalars['ID']>;
  scheduleRange: DateTimeRangeInput;
  timezone: Scalars['String'];
};

export type ScheduleInput = {
  daysSettings?: InputMaybe<Array<ScheduleDaySettingsInput>>;
  info: ScheduleInfoInput;
  scheduleItems?: InputMaybe<Array<ScheduleItemInput>>;
  scheduledAgents: Array<ScheduledAgentInput>;
};

export type ScheduleItem = CommonScheduleItem & {
  __typename?: 'ScheduleItem';
  agentId?: Maybe<Scalars['ID']>;
  dateTimeRange: DateTimeRange;
  pinned: Scalars['Boolean'];
  scheduleElementId: Scalars['ID'];
};

export type ScheduleItemExtended = CommonScheduleItem & {
  __typename?: 'ScheduleItemExtended';
  agentId?: Maybe<Scalars['ID']>;
  dateTimeRange: DateTimeRange;
  pinned: Scalars['Boolean'];
  ptoRequestId?: Maybe<Scalars['ID']>;
  scheduleElementId: Scalars['ID'];
  sourceSchedule?: Maybe<SourceSchedule>;
};

export type ScheduleItemInput = {
  agentId: Scalars['ID'];
  dateTimeRange: DateTimeRangeInput;
  pinned: Scalars['Boolean'];
  scheduleElementId: Scalars['ID'];
};

export enum ScheduleJobStateType {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  InQueue = 'IN_QUEUE',
  UnlockFailed = 'UNLOCK_FAILED'
}

export type ScheduleJobType = {
  __typename?: 'ScheduleJobType';
  code: Scalars['String'];
  correlationId: Scalars['ID'];
  jobId: Scalars['ID'];
  message: Scalars['String'];
  scheduleId: Scalars['ID'];
  state: ScheduleJobStateType;
};

export type ScheduleOptionsInput = {
  weightBreakSpread: Scalars['Int'];
  weightChannelSpread: Scalars['Int'];
  weightMaxUnderStaff: Scalars['Int'];
};

export type ScheduledAgent = {
  __typename?: 'ScheduledAgent';
  agentId: Scalars['ID'];
  displayOrder: Scalars['Int'];
};

export type ScheduledAgentInput = {
  agentId: Scalars['ID'];
  displayOrder: Scalars['Int'];
};

export type ServiceLevel = {
  __typename?: 'ServiceLevel';
  interval?: Maybe<Scalars['Int']>;
  percentage?: Maybe<Scalars['Int']>;
};

export type ServiceLevelInput = {
  interval?: InputMaybe<Scalars['Int']>;
  percentage?: InputMaybe<Scalars['Int']>;
};

export type ShiftBreak = {
  __typename?: 'ShiftBreak';
  duration: Scalars['Int'];
  entitlementAfter: Scalars['Int'];
  id: Scalars['ID'];
  type: ShiftBreakType;
};

export type ShiftBreakInput = {
  duration: Scalars['Int'];
  entitlementAfter: Scalars['Int'];
  type: ShiftBreakType;
};

export enum ShiftBreakType {
  Break = 'BREAK',
  Lunch = 'LUNCH'
}

export type ShiftOverview = {
  __typename?: 'ShiftOverview';
  dateRange?: Maybe<DateRange>;
  shiftDay: Scalars['String'];
  swappable: Scalars['Boolean'];
};

export type ShiftScheduleItem = {
  __typename?: 'ShiftScheduleItem';
  dateRange: DateRange;
  scheduleElementId: Scalars['ID'];
};

export enum ShiftStateType {
  Assigned = 'ASSIGNED',
  Unassigned = 'UNASSIGNED'
}

export enum ShiftSwapRecipientGroup {
  All = 'ALL',
  Specific = 'SPECIFIC',
  Team = 'TEAM'
}

export type ShiftSwapRequest = {
  __typename?: 'ShiftSwapRequest';
  approver?: Maybe<AgentInRequest>;
  audits: Array<RequestAudit>;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  recipientShift: AgentShiftWithoutItems;
  requesterShift: AgentShiftWithoutItems;
  state: ShiftSwapRequestState;
  type?: Maybe<ShiftSwapRequestSubtype>;
  updatedAt: Scalars['String'];
};

export enum ShiftSwapRequestAction {
  Accept = 'accept',
  Approve = 'approve',
  Cancel = 'cancel',
  Decline = 'decline'
}

export enum ShiftSwapRequestController {
  Recipients = 'recipients',
  Requesters = 'requesters',
  Supervisors = 'supervisors'
}

export type ShiftSwapRequestInput = {
  message?: InputMaybe<Scalars['String']>;
  recipientShift: RecipientShiftForSwapInput;
  requesterShift: RequesterShiftForSwapInput;
};

export enum ShiftSwapRequestState {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Declined = 'DECLINED',
  PendingAcceptance = 'PENDING_ACCEPTANCE',
  PendingApproval = 'PENDING_APPROVAL'
}

export enum ShiftSwapRequestSubtype {
  Approver = 'APPROVER',
  Recipient = 'RECIPIENT',
  Requester = 'REQUESTER'
}

export type ShiftSwapRequestUpdateInput = {
  fromState: RequestState;
  message?: InputMaybe<Scalars['String']>;
};

export type ShiftTemplate = {
  __typename?: 'ShiftTemplate';
  dayTemplates: Array<DayTemplate>;
  effectiveDate: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  state: ShiftStateType;
  type: ShiftTemplateType;
};

export type ShiftTemplateInput = {
  dayTemplates: Array<DayTemplateInput>;
  effectiveDate: Scalars['String'];
  name: Scalars['String'];
  type: ShiftTemplateType;
};

export enum ShiftTemplateType {
  AllWorkDays = 'ALL_WORK_DAYS',
  EvenOdd = 'EVEN_ODD'
}

export type ShiftTemplates = {
  __typename?: 'ShiftTemplates';
  shiftTemplates: Array<ShiftTemplate>;
  totalCount: Scalars['Int'];
};

export type Skill = {
  __typename?: 'Skill';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SkillInput = {
  name: Scalars['String'];
};

export type SkillWithUsed = {
  __typename?: 'SkillWithUsed';
  id: Scalars['ID'];
  name: Scalars['String'];
  used: Scalars['Boolean'];
};

export type SlaChartDataInfo = {
  __typename?: 'SlaChartDataInfo';
  averageSla?: Maybe<Scalars['Float']>;
};

export type SlaChartDataSeries = BaseDataSeries & {
  __typename?: 'SlaChartDataSeries';
  benchmark: Array<Scalars['ChartData']>;
  current: Array<Scalars['ChartData']>;
  trend: Array<Scalars['ChartData']>;
};

export type SlaIntradayChart = {
  __typename?: 'SlaIntradayChart';
  info: SlaChartDataInfo;
  series: SlaChartDataSeries;
};

export type SourceSchedule = {
  __typename?: 'SourceSchedule';
  scheduleId: Scalars['ID'];
  scheduleQueuesIds: Array<Scalars['ID']>;
};

export type StaffingChartDataSeries = BaseDataSeries & {
  __typename?: 'StaffingChartDataSeries';
  forecasted: Array<Scalars['ChartData']>;
  required: Array<Scalars['ChartData']>;
  scheduled: Array<Scalars['ChartData']>;
  trend: Array<Scalars['ChartData']>;
};

export type StaffingIntradayChart = CommonIntradayChart & {
  __typename?: 'StaffingIntradayChart';
  info: ChartDataInfo;
  series: StaffingChartDataSeries;
};

export type StaffingPerInterval = {
  __typename?: 'StaffingPerInterval';
  dateRange: DateTimeRange;
  staffing: Scalars['Float'];
};

export type StaffingPerQueue = {
  __typename?: 'StaffingPerQueue';
  queueId: Scalars['ID'];
  scheduleQueuesStaffing: Array<StaffingPerInterval>;
};

export enum StateEnum {
  NonProduction = 'NON_PRODUCTION',
  Production = 'PRODUCTION'
}

export type Subscription = {
  __typename?: 'Subscription';
  intradayMeasurementsChanged?: Maybe<IdOrEmptyResponse>;
  realTimeAdherenceChanged?: Maybe<AgentOverview>;
  realTimeAdherenceEventsChanged?: Maybe<AdherenceEvents>;
  realTimeAgentEventsChanged?: Maybe<AgentEvents>;
  realTimeScheduleChanged?: Maybe<ScheduleChange>;
  webSocketState?: Maybe<WebSocketState>;
};


export type SubscriptionRealTimeAdherenceEventsChangedArgs = {
  agentId: Scalars['ID'];
};


export type SubscriptionRealTimeAgentEventsChangedArgs = {
  agentId: Scalars['ID'];
};


export type SubscriptionRealTimeScheduleChangedArgs = {
  agentId: Scalars['ID'];
};

export type SupervisedAgentsFilter = {
  agentName?: InputMaybe<Scalars['String']>;
  agentSurname?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  max?: InputMaybe<Scalars['Int']>;
  queueIds?: InputMaybe<Scalars['ID']>;
  shiftTemplateIds?: InputMaybe<Scalars['ID']>;
  skillIds?: InputMaybe<Scalars['ID']>;
  teamIds?: InputMaybe<Scalars['ID']>;
};

export type SupervisorRequestPreview = {
  __typename?: 'SupervisorRequestPreview';
  approver?: Maybe<AgentInRequest>;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  offered?: Maybe<AgentShiftWithoutItems>;
  requested: AgentShiftWithoutItems;
  state: RequestState;
  subtype: RequestSubtype;
  type: RequestType;
};

export type SupervisorRequests = {
  __typename?: 'SupervisorRequests';
  requests: Array<SupervisorRequestPreview>;
  totalCount: Scalars['Int'];
};

export type Team = {
  __typename?: 'Team';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type TeamInStatistics = {
  __typename?: 'TeamInStatistics';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type TeamStatistics = {
  __typename?: 'TeamStatistics';
  dailyStatistics: Array<DailyStatistics>;
  statistics: Scalars['ReportsStatistics'];
  team: TeamInStatistics;
};

export type TeamsReportsResult = {
  __typename?: 'TeamsReportsResult';
  metadata: ReportsMetadata;
  result: TeamsStatisticsResult;
};

export type TeamsStatisticsResult = {
  __typename?: 'TeamsStatisticsResult';
  dailyStatistics: Array<DailyStatistics>;
  statistics: Scalars['ReportsStatistics'];
  teamStatistics: Array<TeamStatistics>;
};

export type TimeRange = {
  __typename?: 'TimeRange';
  endTime: Scalars['String'];
  startTime: Scalars['String'];
};

export type TimeRangeInput = {
  endTime: Scalars['String'];
  startTime: Scalars['String'];
};

export type Timezone = {
  __typename?: 'Timezone';
  zoneId: Scalars['String'];
};

export type UpdateAgentInput = {
  queueIds?: InputMaybe<Array<Scalars['ID']>>;
  shiftTemplateIds?: InputMaybe<Array<Scalars['ID']>>;
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type UserInStatistics = {
  __typename?: 'UserInStatistics';
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
};

export type UserStatistics = {
  __typename?: 'UserStatistics';
  dailyStatistics: Array<DailyStatistics>;
  statistics: Scalars['ReportsStatistics'];
  teams: Array<TeamInStatistics>;
  user: UserInStatistics;
};

export type UserStatisticsResult = {
  __typename?: 'UserStatisticsResult';
  dailyStatistics: Array<DailyStatistics>;
  statistics: Scalars['ReportsStatistics'];
  usersStatistics: Array<UserStatistics>;
};

export type VapidKeys = {
  __typename?: 'VapidKeys';
  publicKey: Scalars['String'];
};

export type WebSocketError = {
  __typename?: 'WebSocketError';
  message: Scalars['String'];
};

export type WebSocketState = {
  __typename?: 'WebSocketState';
  error?: Maybe<WebSocketError>;
  state: Scalars['String'];
};

export type WorkContribution = {
  __typename?: 'WorkContribution';
  dateTimeRange: DateTimeRange;
  value: WorkContributionPerQueue;
};

export type WorkContributionPerAgent = {
  __typename?: 'WorkContributionPerAgent';
  agentId: Scalars['String'];
  value: Scalars['Int'];
};

export type WorkContributionPerQueue = {
  __typename?: 'WorkContributionPerQueue';
  agentWorkContributions: Array<WorkContributionPerAgent>;
  queueTraffic: Scalars['Int'];
};

export type GetAcdQueuesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAcdQueuesQuery = { __typename?: 'Query', acdQueues: Array<{ __typename?: 'AcdQueue', acdId: string, acdSourceQueueId: string, id: string, importType: AcdQueueImportType, queueName: string }> };

export type AcdQueueFieldsFragment = { __typename?: 'AcdQueue', acdId: string, acdSourceQueueId: string, id: string, importType: AcdQueueImportType, queueName: string };

export type GetAgentsAllQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgentsAllQuery = { __typename?: 'Query', agents?: { __typename?: 'Agents', totalCount: number, agents: Array<{ __typename?: 'Agent', active: boolean, deleted: boolean, id: string, name: string, surname: string, queueIds?: Array<string> | null, shiftTemplateIds?: Array<string> | null, skillIds?: Array<string> | null, timezone: string, teamIds: Array<string> }> } | null };

export type GetAgentsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
  queueIds?: InputMaybe<Scalars['ID']>;
  shiftTemplateIds?: InputMaybe<Scalars['ID']>;
  skillIds?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetAgentsQuery = { __typename?: 'Query', agents?: { __typename?: 'Agents', totalCount: number, agents: Array<{ __typename?: 'Agent', active: boolean, deleted: boolean, id: string, name: string, surname: string, queueIds?: Array<string> | null, shiftTemplateIds?: Array<string> | null, skillIds?: Array<string> | null, timezone: string, teamIds: Array<string> }> } | null };

export type GetAgentsByIdsQueryVariables = Exact<{
  agentIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetAgentsByIdsQuery = { __typename?: 'Query', agentsByIds?: { __typename?: 'Agents', totalCount: number, agents: Array<{ __typename?: 'Agent', active: boolean, deleted: boolean, id: string, name: string, surname: string, queueIds?: Array<string> | null, shiftTemplateIds?: Array<string> | null, skillIds?: Array<string> | null, timezone: string, teamIds: Array<string> }> } | null };

export type AgentFieldsFragment = { __typename?: 'Agent', active: boolean, deleted: boolean, id: string, name: string, surname: string, queueIds?: Array<string> | null, shiftTemplateIds?: Array<string> | null, skillIds?: Array<string> | null, timezone: string, teamIds: Array<string> };

export type GetAvailableApplicationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableApplicationsQuery = { __typename?: 'Query', availableApplications: Array<{ __typename?: 'KeycloakApplication', applicationName: string }> };

export type KeycloakApplicationFieldsFragment = { __typename?: 'KeycloakApplication', applicationName: string };

export type GetScheduleJobsInProgressQueryVariables = Exact<{ [key: string]: never; }>;


export type GetScheduleJobsInProgressQuery = { __typename?: 'Query', getScheduleJobsInProgress: Array<{ __typename?: 'ScheduleJobType', code: string, correlationId: string, jobId: string, message: string, scheduleId: string, state: ScheduleJobStateType }> };

export type GetScheduleJobsStateQueryVariables = Exact<{
  correlationId?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type GetScheduleJobsStateQuery = { __typename?: 'Query', getScheduleJobsState: Array<{ __typename?: 'ScheduleJobType', code: string, correlationId: string, jobId: string, message: string, scheduleId: string, state: ScheduleJobStateType }> };

export type CreateAutoScheduleJobMutationVariables = Exact<{
  autoScheduleJob: AutoScheduleJobInput;
}>;


export type CreateAutoScheduleJobMutation = { __typename?: 'Mutation', createAutoScheduleJob?: { __typename?: 'ScheduleJobType', code: string, correlationId: string, jobId: string, message: string, scheduleId: string, state: ScheduleJobStateType } | null };

export type ScheduleJobTypeFieldsFragment = { __typename?: 'ScheduleJobType', code: string, correlationId: string, jobId: string, message: string, scheduleId: string, state: ScheduleJobStateType };

export type CalculateForecastQueryVariables = Exact<{
  parameters: CalculateForecastInput;
}>;


export type CalculateForecastQuery = { __typename?: 'Query', calculatedForecast: { __typename?: 'CalculatedForecastData', averageHandlingTime: { __typename?: 'CalculatedSeriesData', gaps: Array<ChartData>, forecastValues: Array<{ __typename?: 'CalculatedForecastValuesData', adjustmentId?: string | null, data: Array<ChartData> }> }, contactVolume: { __typename?: 'CalculatedSeriesData', gaps: Array<ChartData>, forecastValues: Array<{ __typename?: 'CalculatedForecastValuesData', adjustmentId?: string | null, data: Array<ChartData> }> }, staffingRequirements: { __typename?: 'CalculatedSeriesData', gaps: Array<ChartData>, forecastValues: Array<{ __typename?: 'CalculatedForecastValuesData', adjustmentId?: string | null, data: Array<ChartData> }> }, workloadRequirements: { __typename?: 'CalculatedSeriesData', gaps: Array<ChartData>, forecastValues: Array<{ __typename?: 'CalculatedForecastValuesData', adjustmentId?: string | null, data: Array<ChartData> }> } } };

export type CreateForecastMutationVariables = Exact<{
  forecast: CalculateForecastInput;
}>;


export type CreateForecastMutation = { __typename?: 'Mutation', createForecast?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type DeleteForecastMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteForecastMutation = { __typename?: 'Mutation', deleteForecast?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type DeleteForecastFromProductionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteForecastFromProductionMutation = { __typename?: 'Mutation', deleteForecastFromProduction?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type ForecastFieldsFragment = { __typename?: 'Forecast', id: string, author: string, name: string, notes: string, state: StateEnum, queueId: string, creationDate: string, modificationDate?: string | null, concurrentChatsCount?: number | null, timezone: string, forecastRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string }, historyRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } };

export type ForecastProductionFieldsFragment = { __typename?: 'ForecastProduction', queueId: string, forecastValues: Array<{ __typename?: 'ForecastValue', dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string }, value: { __typename?: 'ForecastValuesValue', sourceForecastId: string, staffingRequirements: number } }> };

export type GetForecastFieldsFragment = { __typename?: 'GetForecast', adjustments: Array<{ __typename?: 'Adjustment', averageHandlingTime: number, contactVolume: number, id: string, name: string, shrinkagePercentage: number, concurrentChatsCount?: number | null, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } }>, values: { __typename?: 'CalculatedForecastData', averageHandlingTime: { __typename?: 'CalculatedSeriesData', gaps: Array<ChartData>, forecastValues: Array<{ __typename?: 'CalculatedForecastValuesData', adjustmentId?: string | null, data: Array<ChartData> }> }, contactVolume: { __typename?: 'CalculatedSeriesData', gaps: Array<ChartData>, forecastValues: Array<{ __typename?: 'CalculatedForecastValuesData', adjustmentId?: string | null, data: Array<ChartData> }> }, staffingRequirements: { __typename?: 'CalculatedSeriesData', gaps: Array<ChartData>, forecastValues: Array<{ __typename?: 'CalculatedForecastValuesData', adjustmentId?: string | null, data: Array<ChartData> }> }, workloadRequirements: { __typename?: 'CalculatedSeriesData', gaps: Array<ChartData>, forecastValues: Array<{ __typename?: 'CalculatedForecastValuesData', adjustmentId?: string | null, data: Array<ChartData> }> } }, info: { __typename?: 'Forecast', id: string, author: string, name: string, notes: string, state: StateEnum, queueId: string, creationDate: string, modificationDate?: string | null, concurrentChatsCount?: number | null, timezone: string, forecastRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string }, historyRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } } };

export type ForecastValueFieldsFragment = { __typename?: 'ForecastValue', dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string }, value: { __typename?: 'ForecastValuesValue', sourceForecastId: string, staffingRequirements: number } };

export type ForecastValuesValueFieldsFragment = { __typename?: 'ForecastValuesValue', sourceForecastId: string, staffingRequirements: number };

export type DateTimeRangeFieldsFragment = { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string };

export type DataImportHistoryRecordFieldsFragment = { __typename?: 'DataImportHistoryRecord', id: string, dateOfImport: string, importType: ImportTypeEnum, source: string, status: number };

export type AdjustmentFieldsFragment = { __typename?: 'Adjustment', averageHandlingTime: number, contactVolume: number, id: string, name: string, shrinkagePercentage: number, concurrentChatsCount?: number | null, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } };

export type CalculatedSeriesFieldsFragment = { __typename?: 'CalculatedSeriesData', gaps: Array<ChartData>, forecastValues: Array<{ __typename?: 'CalculatedForecastValuesData', adjustmentId?: string | null, data: Array<ChartData> }> };

export type CalculatedForecastValuesFieldsFragment = { __typename?: 'CalculatedForecastValuesData', adjustmentId?: string | null, data: Array<ChartData> };

export type CalculateForecastFieldsFragment = { __typename?: 'CalculatedForecastData', averageHandlingTime: { __typename?: 'CalculatedSeriesData', gaps: Array<ChartData>, forecastValues: Array<{ __typename?: 'CalculatedForecastValuesData', adjustmentId?: string | null, data: Array<ChartData> }> }, contactVolume: { __typename?: 'CalculatedSeriesData', gaps: Array<ChartData>, forecastValues: Array<{ __typename?: 'CalculatedForecastValuesData', adjustmentId?: string | null, data: Array<ChartData> }> }, staffingRequirements: { __typename?: 'CalculatedSeriesData', gaps: Array<ChartData>, forecastValues: Array<{ __typename?: 'CalculatedForecastValuesData', adjustmentId?: string | null, data: Array<ChartData> }> }, workloadRequirements: { __typename?: 'CalculatedSeriesData', gaps: Array<ChartData>, forecastValues: Array<{ __typename?: 'CalculatedForecastValuesData', adjustmentId?: string | null, data: Array<ChartData> }> } };

export type GetDataImportHistoryQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetDataImportHistoryQuery = { __typename?: 'Query', dataImportHistory: { __typename?: 'DataImportHistory', totalCount: number, dataImportHistoryRecords: Array<{ __typename?: 'DataImportHistoryRecord', id: string, dateOfImport: string, importType: ImportTypeEnum, source: string, status: number }> } };

export type GetForecastQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetForecastQuery = { __typename?: 'Query', forecast?: { __typename?: 'GetForecast', adjustments: Array<{ __typename?: 'Adjustment', averageHandlingTime: number, contactVolume: number, id: string, name: string, shrinkagePercentage: number, concurrentChatsCount?: number | null, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } }>, values: { __typename?: 'CalculatedForecastData', averageHandlingTime: { __typename?: 'CalculatedSeriesData', gaps: Array<ChartData>, forecastValues: Array<{ __typename?: 'CalculatedForecastValuesData', adjustmentId?: string | null, data: Array<ChartData> }> }, contactVolume: { __typename?: 'CalculatedSeriesData', gaps: Array<ChartData>, forecastValues: Array<{ __typename?: 'CalculatedForecastValuesData', adjustmentId?: string | null, data: Array<ChartData> }> }, staffingRequirements: { __typename?: 'CalculatedSeriesData', gaps: Array<ChartData>, forecastValues: Array<{ __typename?: 'CalculatedForecastValuesData', adjustmentId?: string | null, data: Array<ChartData> }> }, workloadRequirements: { __typename?: 'CalculatedSeriesData', gaps: Array<ChartData>, forecastValues: Array<{ __typename?: 'CalculatedForecastValuesData', adjustmentId?: string | null, data: Array<ChartData> }> } }, info: { __typename?: 'Forecast', id: string, author: string, name: string, notes: string, state: StateEnum, queueId: string, creationDate: string, modificationDate?: string | null, concurrentChatsCount?: number | null, timezone: string, forecastRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string }, historyRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } } } | null };

export type GetForecastsQueryVariables = Exact<{
  forecastStartDateTime: Scalars['String'];
  forecastEndDateTime: Scalars['String'];
  forecastName?: InputMaybe<Scalars['String']>;
  queueId?: InputMaybe<Scalars['ID']>;
}>;


export type GetForecastsQuery = { __typename?: 'Query', forecasts: Array<{ __typename?: 'Forecast', id: string, author: string, name: string, notes: string, state: StateEnum, queueId: string, creationDate: string, modificationDate?: string | null, concurrentChatsCount?: number | null, timezone: string, forecastRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string }, historyRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } }>, queues: Array<{ __typename?: 'Queue', acdQueueIds?: Array<string> | null, acdQueueIdsEditable: boolean, channelType: QueueChannelType, channelTypeEditable: boolean, historicalDataInterval?: number | null, id: string, idEditable: boolean, name: string, nameEditable: boolean, serviceLevelEditable: boolean, skillId?: string | null, skillIdEditable: boolean, tag?: string | null, tagEditable: boolean, timezone: string, timezoneEditable: boolean, used: boolean, serviceLevel?: { __typename?: 'ServiceLevel', interval?: number | null, percentage?: number | null } | null }> };

export type GetForecastsProductionQueryVariables = Exact<{
  startDateTime: Scalars['String'];
  endDateTime: Scalars['String'];
  queueIds: Scalars['ID'];
}>;


export type GetForecastsProductionQuery = { __typename?: 'Query', forecastsProduction: Array<{ __typename?: 'ForecastProduction', queueId: string, forecastValues: Array<{ __typename?: 'ForecastValue', dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string }, value: { __typename?: 'ForecastValuesValue', sourceForecastId: string, staffingRequirements: number } }> }> };

export type GetForecastsIntradayQueryVariables = Exact<{
  startDateTime: Scalars['String'];
  endDateTime: Scalars['String'];
  queueIds: Scalars['ID'];
}>;


export type GetForecastsIntradayQuery = { __typename?: 'Query', forecastsIntraday: Array<{ __typename?: 'ForecastProduction', queueId: string, forecastValues: Array<{ __typename?: 'ForecastValue', dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string }, value: { __typename?: 'ForecastValuesValue', sourceForecastId: string, staffingRequirements: number } }> }> };

export type PutForecastToProductionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PutForecastToProductionMutation = { __typename?: 'Mutation', putForecastToProduction?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type QueueHistoryRangeQueryVariables = Exact<{
  queueId: Scalars['ID'];
}>;


export type QueueHistoryRangeQuery = { __typename?: 'Query', queueHistoryRange?: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } | null };

export type UpdateForecastMutationVariables = Exact<{
  id: Scalars['ID'];
  forecast: CalculateForecastInput;
}>;


export type UpdateForecastMutation = { __typename?: 'Mutation', updateForecast?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type UpdateForecastNameMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
}>;


export type UpdateForecastNameMutation = { __typename?: 'Mutation', updateForecastName?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type GetIntradayQueuesListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIntradayQueuesListQuery = { __typename?: 'Query', intradayQueuesList: Array<{ __typename?: 'IntradayQueue', id: string, inAlert: boolean, name: string, timezone: string }> };

export type GetIntradayNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIntradayNotificationsQuery = { __typename?: 'Query', intradayNotifications: Array<{ __typename?: 'IntradayQueueNotification', queueId: string, contactVolumeDeviation?: number | null, slaOutOfRangeFrom?: number | null, slaOutOfRangeTo?: number | null }> };

export type CreateIntradayNotificationMutationVariables = Exact<{
  intradayQueueNotification: IntradayQueueNotificationInput;
}>;


export type CreateIntradayNotificationMutation = { __typename?: 'Mutation', createIntradayQueueNotification?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type UpdateIntradayNotificationMutationVariables = Exact<{
  intradayQueueNotification: IntradayQueueNotificationInput;
}>;


export type UpdateIntradayNotificationMutation = { __typename?: 'Mutation', updateIntradayQueueNotification?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type DeleteIntradayNotificationMutationVariables = Exact<{
  queueId: Scalars['ID'];
}>;


export type DeleteIntradayNotificationMutation = { __typename?: 'Mutation', deleteIntradayQueueNotification?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type GetIntradayPushNotificationOnOffSettingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIntradayPushNotificationOnOffSettingQuery = { __typename?: 'Query', intradayPushNotificationOnOffSetting: { __typename?: 'IntradayPushNotificationSetting', enabled: boolean } };

export type UpdateIntradayPushNotificationOnOffSettingMutationVariables = Exact<{
  intradayPushNotificationSetting: IntradayPushNotificationSettingInput;
}>;


export type UpdateIntradayPushNotificationOnOffSettingMutation = { __typename?: 'Mutation', updateIntradayPushNotificationOnOffSetting?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type IntradayPerQueueFieldsFragment = { __typename?: 'IntradayPerQueue', charts: { __typename?: 'IntradayChartsData', contactVolume: { __typename?: 'IntradayChart', info: { __typename?: 'ChartDataInfo', forecastAccuracy?: number | null, lastHourAverageDifference?: number | null }, series: { __typename?: 'ChartDataSeries', current: Array<ChartData>, forecasted: Array<ChartData>, trend: Array<ChartData> } }, aht: { __typename?: 'IntradayChart', info: { __typename?: 'ChartDataInfo', forecastAccuracy?: number | null, lastHourAverageDifference?: number | null }, series: { __typename?: 'ChartDataSeries', current: Array<ChartData>, forecasted: Array<ChartData>, trend: Array<ChartData> } }, staffingRequirement: { __typename?: 'StaffingIntradayChart', info: { __typename?: 'ChartDataInfo', forecastAccuracy?: number | null, lastHourAverageDifference?: number | null }, series: { __typename?: 'StaffingChartDataSeries', forecasted: Array<ChartData>, required: Array<ChartData>, scheduled: Array<ChartData>, trend: Array<ChartData> } }, sla: { __typename?: 'SlaIntradayChart', info: { __typename?: 'SlaChartDataInfo', averageSla?: number | null }, series: { __typename?: 'SlaChartDataSeries', benchmark: Array<ChartData>, current: Array<ChartData>, trend: Array<ChartData> } } }, info: { __typename?: 'IntradayInfo', actualInterval: string, dataAsOf: string, timezone: string } };

export type IntradayChartsDataFieldsFragment = { __typename?: 'IntradayChartsData', contactVolume: { __typename?: 'IntradayChart', info: { __typename?: 'ChartDataInfo', forecastAccuracy?: number | null, lastHourAverageDifference?: number | null }, series: { __typename?: 'ChartDataSeries', current: Array<ChartData>, forecasted: Array<ChartData>, trend: Array<ChartData> } }, aht: { __typename?: 'IntradayChart', info: { __typename?: 'ChartDataInfo', forecastAccuracy?: number | null, lastHourAverageDifference?: number | null }, series: { __typename?: 'ChartDataSeries', current: Array<ChartData>, forecasted: Array<ChartData>, trend: Array<ChartData> } }, staffingRequirement: { __typename?: 'StaffingIntradayChart', info: { __typename?: 'ChartDataInfo', forecastAccuracy?: number | null, lastHourAverageDifference?: number | null }, series: { __typename?: 'StaffingChartDataSeries', forecasted: Array<ChartData>, required: Array<ChartData>, scheduled: Array<ChartData>, trend: Array<ChartData> } }, sla: { __typename?: 'SlaIntradayChart', info: { __typename?: 'SlaChartDataInfo', averageSla?: number | null }, series: { __typename?: 'SlaChartDataSeries', benchmark: Array<ChartData>, current: Array<ChartData>, trend: Array<ChartData> } } };

export type IntradayInfoFieldsFragment = { __typename?: 'IntradayInfo', actualInterval: string, dataAsOf: string, timezone: string };

export type IntradayChartFieldsFragment = { __typename?: 'IntradayChart', info: { __typename?: 'ChartDataInfo', forecastAccuracy?: number | null, lastHourAverageDifference?: number | null }, series: { __typename?: 'ChartDataSeries', current: Array<ChartData>, forecasted: Array<ChartData>, trend: Array<ChartData> } };

export type StaffingIntradayChartFieldsFragment = { __typename?: 'StaffingIntradayChart', info: { __typename?: 'ChartDataInfo', forecastAccuracy?: number | null, lastHourAverageDifference?: number | null }, series: { __typename?: 'StaffingChartDataSeries', forecasted: Array<ChartData>, required: Array<ChartData>, scheduled: Array<ChartData>, trend: Array<ChartData> } };

export type SlaIntradayChartFieldsFragment = { __typename?: 'SlaIntradayChart', info: { __typename?: 'SlaChartDataInfo', averageSla?: number | null }, series: { __typename?: 'SlaChartDataSeries', benchmark: Array<ChartData>, current: Array<ChartData>, trend: Array<ChartData> } };

export type ChartDataInfoFieldsFragment = { __typename?: 'ChartDataInfo', forecastAccuracy?: number | null, lastHourAverageDifference?: number | null };

export type SlaChartDataInfoFieldsFragment = { __typename?: 'SlaChartDataInfo', averageSla?: number | null };

export type ChartDataSeriesFieldsFragment = { __typename?: 'ChartDataSeries', current: Array<ChartData>, forecasted: Array<ChartData>, trend: Array<ChartData> };

export type StaffingChartDataSeriesFieldsFragment = { __typename?: 'StaffingChartDataSeries', forecasted: Array<ChartData>, required: Array<ChartData>, scheduled: Array<ChartData>, trend: Array<ChartData> };

export type SlaChartDataSeriesFieldsFragment = { __typename?: 'SlaChartDataSeries', benchmark: Array<ChartData>, current: Array<ChartData>, trend: Array<ChartData> };

export type IntradayQueueFieldsFragment = { __typename?: 'IntradayQueue', id: string, inAlert: boolean, name: string, timezone: string };

export type IntradayQueueNotificationFieldsFragment = { __typename?: 'IntradayQueueNotification', queueId: string, contactVolumeDeviation?: number | null, slaOutOfRangeFrom?: number | null, slaOutOfRangeTo?: number | null };

export type IntradayPushNotificationSettingFieldsFragment = { __typename?: 'IntradayPushNotificationSetting', enabled: boolean };

export type GetIntradayPerQueueDataQueryVariables = Exact<{
  queueId: Scalars['ID'];
}>;


export type GetIntradayPerQueueDataQuery = { __typename?: 'Query', intradayPerQueueData?: { __typename?: 'IntradayPerQueue', charts: { __typename?: 'IntradayChartsData', contactVolume: { __typename?: 'IntradayChart', info: { __typename?: 'ChartDataInfo', forecastAccuracy?: number | null, lastHourAverageDifference?: number | null }, series: { __typename?: 'ChartDataSeries', current: Array<ChartData>, forecasted: Array<ChartData>, trend: Array<ChartData> } }, aht: { __typename?: 'IntradayChart', info: { __typename?: 'ChartDataInfo', forecastAccuracy?: number | null, lastHourAverageDifference?: number | null }, series: { __typename?: 'ChartDataSeries', current: Array<ChartData>, forecasted: Array<ChartData>, trend: Array<ChartData> } }, staffingRequirement: { __typename?: 'StaffingIntradayChart', info: { __typename?: 'ChartDataInfo', forecastAccuracy?: number | null, lastHourAverageDifference?: number | null }, series: { __typename?: 'StaffingChartDataSeries', forecasted: Array<ChartData>, required: Array<ChartData>, scheduled: Array<ChartData>, trend: Array<ChartData> } }, sla: { __typename?: 'SlaIntradayChart', info: { __typename?: 'SlaChartDataInfo', averageSla?: number | null }, series: { __typename?: 'SlaChartDataSeries', benchmark: Array<ChartData>, current: Array<ChartData>, trend: Array<ChartData> } } }, info: { __typename?: 'IntradayInfo', actualInterval: string, dataAsOf: string, timezone: string } } | null };

export type NotificationSettingsFieldsFragment = { __typename?: 'NotificationSettings', createdAt: string, enabled: boolean, feature: NotificationFeature, id: string, type: NotificationType, updatedAt: string, userId: string };

export type GetNotificationSettingsQueryVariables = Exact<{
  userId: Scalars['ID'];
  types?: InputMaybe<Scalars['String']>;
  features?: InputMaybe<Scalars['String']>;
}>;


export type GetNotificationSettingsQuery = { __typename?: 'Query', notificationSettings: Array<{ __typename?: 'NotificationSettings', createdAt: string, enabled: boolean, feature: NotificationFeature, id: string, type: NotificationType, updatedAt: string, userId: string }> };

export type UpdateStateOfNotificationSettingsMutationVariables = Exact<{
  userId: Scalars['ID'];
  notificationSettingsId: Scalars['ID'];
  parameters: NotificationsSettingsUpdateInput;
}>;


export type UpdateStateOfNotificationSettingsMutation = { __typename?: 'Mutation', updateStateOfNotificationSettings: { __typename?: 'NotificationSettings', createdAt: string, enabled: boolean, feature: NotificationFeature, id: string, type: NotificationType, updatedAt: string, userId: string } };

export type GetPublicVapidKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPublicVapidKeyQuery = { __typename?: 'Query', publicVapidKey: { __typename?: 'VapidKeys', publicKey: string } };

export type CreateRtaPushSubscriptionMutationVariables = Exact<{
  subscription: PushSubscriptionInput;
}>;


export type CreateRtaPushSubscriptionMutation = { __typename?: 'Mutation', createRtaPushSubscription?: { __typename?: 'PushSubscription', endpoint: string, p256dh: string, auth: string, expirationTime?: string | null } | null };

export type CreateIntradayPushSubscriptionMutationVariables = Exact<{
  subscription: PushSubscriptionInput;
}>;


export type CreateIntradayPushSubscriptionMutation = { __typename?: 'Mutation', createIntradayPushSubscription?: { __typename?: 'PushSubscription', endpoint: string, p256dh: string, auth: string, expirationTime?: string | null } | null };

export type CreateQueueMutationVariables = Exact<{
  queue: QueueInput;
}>;


export type CreateQueueMutation = { __typename?: 'Mutation', createQueue?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type GetQueuesQueryVariables = Exact<{
  acdQueueIds?: InputMaybe<Scalars['ID']>;
  channelTypes?: InputMaybe<Scalars['String']>;
  historicalDataIntervals?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  skillIds?: InputMaybe<Scalars['ID']>;
  timezones?: InputMaybe<Scalars['ID']>;
}>;


export type GetQueuesQuery = { __typename?: 'Query', queues: Array<{ __typename?: 'Queue', acdQueueIds?: Array<string> | null, acdQueueIdsEditable: boolean, channelType: QueueChannelType, channelTypeEditable: boolean, historicalDataInterval?: number | null, id: string, idEditable: boolean, name: string, nameEditable: boolean, serviceLevelEditable: boolean, skillId?: string | null, skillIdEditable: boolean, tag?: string | null, tagEditable: boolean, timezone: string, timezoneEditable: boolean, used: boolean, serviceLevel?: { __typename?: 'ServiceLevel', interval?: number | null, percentage?: number | null } | null }> };

export type GetQueueQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetQueueQuery = { __typename?: 'Query', queue?: { __typename?: 'Queue', acdQueueIds?: Array<string> | null, acdQueueIdsEditable: boolean, channelType: QueueChannelType, channelTypeEditable: boolean, historicalDataInterval?: number | null, id: string, idEditable: boolean, name: string, nameEditable: boolean, serviceLevelEditable: boolean, skillId?: string | null, skillIdEditable: boolean, tag?: string | null, tagEditable: boolean, timezone: string, timezoneEditable: boolean, used: boolean, serviceLevel?: { __typename?: 'ServiceLevel', interval?: number | null, percentage?: number | null } | null } | null };

export type GetQueuesTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQueuesTagsQuery = { __typename?: 'Query', queuesTags: Array<{ __typename?: 'ScheduleElementTag', id: string, value: string }> };

export type UpdateQueueMutationVariables = Exact<{
  id: Scalars['ID'];
  queue: QueueInput;
  updateUsedQueue?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateQueueMutation = { __typename?: 'Mutation', updateQueue?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type DeleteQueueMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteQueueMutation = { __typename?: 'Mutation', deleteQueue?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type QueueFieldsFragment = { __typename?: 'Queue', acdQueueIds?: Array<string> | null, acdQueueIdsEditable: boolean, channelType: QueueChannelType, channelTypeEditable: boolean, historicalDataInterval?: number | null, id: string, idEditable: boolean, name: string, nameEditable: boolean, serviceLevelEditable: boolean, skillId?: string | null, skillIdEditable: boolean, tag?: string | null, tagEditable: boolean, timezone: string, timezoneEditable: boolean, used: boolean, serviceLevel?: { __typename?: 'ServiceLevel', interval?: number | null, percentage?: number | null } | null };

export type ServiceLevelFieldsFragment = { __typename?: 'ServiceLevel', interval?: number | null, percentage?: number | null };

export type GetAgentsReportsQueryVariables = Exact<{
  from: Scalars['String'];
  to: Scalars['String'];
  page: Scalars['Int'];
  pageSize?: InputMaybe<Scalars['Int']>;
  teamIds?: InputMaybe<Scalars['String']>;
  agentIds?: InputMaybe<Scalars['String']>;
}>;


export type GetAgentsReportsQuery = { __typename?: 'Query', agentsReports: { __typename?: 'AgentsReportsResult', metadata: { __typename?: 'ReportsMetadata', page: number, pageSize: number, totalRecords: number, totalPages: number }, result: { __typename?: 'UserStatisticsResult', statistics: ReportsStatistics, dailyStatistics: Array<{ __typename?: 'DailyStatistics', date: string, statistics: ReportsStatistics }>, usersStatistics: Array<{ __typename?: 'UserStatistics', statistics: ReportsStatistics, dailyStatistics: Array<{ __typename?: 'DailyStatistics', date: string, statistics: ReportsStatistics }>, teams: Array<{ __typename?: 'TeamInStatistics', id: string, name: string }>, user: { __typename?: 'UserInStatistics', id: string, firstName: string, lastName: string } }> } } };

export type GetTeamsReportsQueryVariables = Exact<{
  from: Scalars['String'];
  to: Scalars['String'];
  page: Scalars['Int'];
  pageSize?: InputMaybe<Scalars['Int']>;
  teamIds?: InputMaybe<Scalars['String']>;
}>;


export type GetTeamsReportsQuery = { __typename?: 'Query', teamsReports: { __typename?: 'TeamsReportsResult', metadata: { __typename?: 'ReportsMetadata', page: number, pageSize: number, totalRecords: number, totalPages: number }, result: { __typename?: 'TeamsStatisticsResult', statistics: ReportsStatistics, dailyStatistics: Array<{ __typename?: 'DailyStatistics', date: string, statistics: ReportsStatistics }>, teamStatistics: Array<{ __typename?: 'TeamStatistics', statistics: ReportsStatistics, dailyStatistics: Array<{ __typename?: 'DailyStatistics', date: string, statistics: ReportsStatistics }>, team: { __typename?: 'TeamInStatistics', id: string, name: string } }> } } };

export type DailyStatisticsFieldsFragment = { __typename?: 'DailyStatistics', date: string, statistics: ReportsStatistics };

export type UserInStatisticsFieldsFragment = { __typename?: 'UserInStatistics', id: string, firstName: string, lastName: string };

export type TeamInStatisticsFieldsFragment = { __typename?: 'TeamInStatistics', id: string, name: string };

export type UserStatisticsFieldsFragment = { __typename?: 'UserStatistics', statistics: ReportsStatistics, dailyStatistics: Array<{ __typename?: 'DailyStatistics', date: string, statistics: ReportsStatistics }>, teams: Array<{ __typename?: 'TeamInStatistics', id: string, name: string }>, user: { __typename?: 'UserInStatistics', id: string, firstName: string, lastName: string } };

export type UserStatisticsResultFieldsFragment = { __typename?: 'UserStatisticsResult', statistics: ReportsStatistics, dailyStatistics: Array<{ __typename?: 'DailyStatistics', date: string, statistics: ReportsStatistics }>, usersStatistics: Array<{ __typename?: 'UserStatistics', statistics: ReportsStatistics, dailyStatistics: Array<{ __typename?: 'DailyStatistics', date: string, statistics: ReportsStatistics }>, teams: Array<{ __typename?: 'TeamInStatistics', id: string, name: string }>, user: { __typename?: 'UserInStatistics', id: string, firstName: string, lastName: string } }> };

export type ReportsMetadataFieldsFragment = { __typename?: 'ReportsMetadata', page: number, pageSize: number, totalRecords: number, totalPages: number };

export type AgentsReportsResultFieldsFragment = { __typename?: 'AgentsReportsResult', metadata: { __typename?: 'ReportsMetadata', page: number, pageSize: number, totalRecords: number, totalPages: number }, result: { __typename?: 'UserStatisticsResult', statistics: ReportsStatistics, dailyStatistics: Array<{ __typename?: 'DailyStatistics', date: string, statistics: ReportsStatistics }>, usersStatistics: Array<{ __typename?: 'UserStatistics', statistics: ReportsStatistics, dailyStatistics: Array<{ __typename?: 'DailyStatistics', date: string, statistics: ReportsStatistics }>, teams: Array<{ __typename?: 'TeamInStatistics', id: string, name: string }>, user: { __typename?: 'UserInStatistics', id: string, firstName: string, lastName: string } }> } };

export type TeamStatisticsFieldsFragment = { __typename?: 'TeamStatistics', statistics: ReportsStatistics, dailyStatistics: Array<{ __typename?: 'DailyStatistics', date: string, statistics: ReportsStatistics }>, team: { __typename?: 'TeamInStatistics', id: string, name: string } };

export type TeamsStatisticsResultFieldsFragment = { __typename?: 'TeamsStatisticsResult', statistics: ReportsStatistics, dailyStatistics: Array<{ __typename?: 'DailyStatistics', date: string, statistics: ReportsStatistics }>, teamStatistics: Array<{ __typename?: 'TeamStatistics', statistics: ReportsStatistics, dailyStatistics: Array<{ __typename?: 'DailyStatistics', date: string, statistics: ReportsStatistics }>, team: { __typename?: 'TeamInStatistics', id: string, name: string } }> };

export type TeamsReportsResultFieldsFragment = { __typename?: 'TeamsReportsResult', metadata: { __typename?: 'ReportsMetadata', page: number, pageSize: number, totalRecords: number, totalPages: number }, result: { __typename?: 'TeamsStatisticsResult', statistics: ReportsStatistics, dailyStatistics: Array<{ __typename?: 'DailyStatistics', date: string, statistics: ReportsStatistics }>, teamStatistics: Array<{ __typename?: 'TeamStatistics', statistics: ReportsStatistics, dailyStatistics: Array<{ __typename?: 'DailyStatistics', date: string, statistics: ReportsStatistics }>, team: { __typename?: 'TeamInStatistics', id: string, name: string } }> } };

export type GetAdherenceHistoryBarChartDataQueryVariables = Exact<{
  agentId: Scalars['ID'];
  startDateTime: Scalars['String'];
  endDateTime: Scalars['String'];
  timezone: Scalars['String'];
}>;


export type GetAdherenceHistoryBarChartDataQuery = { __typename?: 'Query', adherenceHistoryBarChartData: { __typename?: 'AdherenceHistoryBarChart', adherence: Array<ChartData>, conformance: Array<ChartData>, dataPerDay: RecordAdherenceHistoryPerDay, maxChartValue: number } };

export type GetAdherenceHistoryGanttChartDataQueryVariables = Exact<{
  agentId: Scalars['ID'];
  endDateTime: Scalars['String'];
  startDateTime: Scalars['String'];
  timezone: Scalars['String'];
}>;


export type GetAdherenceHistoryGanttChartDataQuery = { __typename?: 'Query', adherenceHistoryGanttChartData: { __typename?: 'AdherenceHistoryGanttChart', agentActivityItems: Array<{ __typename?: 'AdherenceHistoryAgentActivityItem', agentId: string, mappedToActivity: boolean, eleveoStatusName: string, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } }>, outOfAdherenceItems: Array<{ __typename?: 'AdherenceHistoryOutOfAdherenceItem', eleveoStatusName: string, scheduleElementId: string, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } }>, scheduleItems: Array<{ __typename?: 'AdherenceHistoryScheduleItem', agentId: string, scheduleElementId: string, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } }> } };

export type GetAdherenceLastImportQueryVariables = Exact<{
  status?: InputMaybe<Scalars['Int']>;
}>;


export type GetAdherenceLastImportQuery = { __typename?: 'Query', adherenceLastImport: { __typename?: 'AdherenceLastImport', dateTime?: string | null } };

export type GetAdherenceNotificationSetupQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdherenceNotificationSetupQuery = { __typename?: 'Query', adherenceNotificationSetup?: { __typename?: 'AdherenceNotificationType', threshold: number } | null };

export type CreateAdherenceNotificationMutationVariables = Exact<{
  notificationSetup: AdherenceNotificationInput;
}>;


export type CreateAdherenceNotificationMutation = { __typename?: 'Mutation', createAdherenceNotification?: { __typename?: 'AdherenceNotificationType', threshold: number } | null };

export type UpdateAdherenceNotificationMutationVariables = Exact<{
  notificationSetup: AdherenceNotificationInput;
}>;


export type UpdateAdherenceNotificationMutation = { __typename?: 'Mutation', updateAdherenceNotification?: { __typename?: 'AdherenceNotificationType', threshold: number } | null };

export type DeleteAdherenceNotificationMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAdherenceNotificationMutation = { __typename?: 'Mutation', deleteAdherenceNotification?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type GetAdherenceSettingsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdherenceSettingsDataQuery = { __typename?: 'Query', scheduleElements: Array<{ __typename?: 'ScheduleElement', defaultDuration: number, displayOrder: number, editable?: boolean | null, id: string, name: string, paid: boolean, paidTimeOff: boolean, pinnable: boolean, productive: boolean, shift: boolean, showInOverview: boolean, showInOverviewBig: boolean, sick: boolean, vacation: boolean, zoomLevel: number, color: { __typename?: 'ScheduleElementColor', red: number, green: number, blue: number }, tags: Array<{ __typename?: 'ScheduleElementTag', id: string, value: string }> }>, adherenceEventTypes: Array<{ __typename?: 'AdherenceEventType', acdType: string, eventId: string, eventName: string, eventType?: string | null, id: string, reasonCodeRequired: boolean }>, adherenceReasonCodes: Array<{ __typename?: 'AdherenceReasonCode', code: number, eventType: string, id: string, label: string, sourceId: string }> };

export type GetAdherenceSettingsQueryVariables = Exact<{
  searchCriteria: AdherenceSettingsSearchCriteria;
}>;


export type GetAdherenceSettingsQuery = { __typename?: 'Query', adherenceSettings: { __typename?: 'AdherenceSettings', totalCount: number, adherenceSettings: Array<{ __typename?: 'AdherenceSetting', id: string, name: string, historyScheduleActivityIds: Array<string>, realTimeScheduleActivityIds: Array<string>, acdStatuses: Array<{ __typename?: 'AdherenceSettingACDStatus', agentEventReasonCodeId?: string | null, agentEventTypeId: string }> }> } };

export type CreateAdherenceSettingMutationVariables = Exact<{
  setting: AdherenceSettingInput;
}>;


export type CreateAdherenceSettingMutation = { __typename?: 'Mutation', createAdherenceSetting?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type UpdateAdherenceSettingMutationVariables = Exact<{
  id: Scalars['ID'];
  setting: AdherenceSettingInput;
}>;


export type UpdateAdherenceSettingMutation = { __typename?: 'Mutation', updateAdherenceSetting?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type DeleteAdherenceSettingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAdherenceSettingMutation = { __typename?: 'Mutation', deleteAdherenceSetting?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type GetAdherenceEventTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdherenceEventTypesQuery = { __typename?: 'Query', adherenceEventTypes: Array<{ __typename?: 'AdherenceEventType', acdType: string, eventId: string, eventName: string, eventType?: string | null, id: string, reasonCodeRequired: boolean }> };

export type GetAdherenceReasonCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdherenceReasonCodesQuery = { __typename?: 'Query', adherenceReasonCodes: Array<{ __typename?: 'AdherenceReasonCode', code: number, eventType: string, id: string, label: string, sourceId: string }> };

export type GetUsedAdherenceAcdStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsedAdherenceAcdStatusesQuery = { __typename?: 'Query', adherenceAcdStatuses: Array<{ __typename?: 'AdherenceSettingACDStatus', agentEventReasonCodeId?: string | null, agentEventTypeId: string }> };

export type GetUserRequestsQueryVariables = Exact<{
  agentId: Scalars['ID'];
  createdAtFrom?: InputMaybe<Scalars['String']>;
  createdAtTo?: InputMaybe<Scalars['String']>;
  requestedFrom?: InputMaybe<Scalars['String']>;
  requestedTo?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<Scalars['String']>;
  subtypes?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Scalars['String']>;
}>;


export type GetUserRequestsQuery = { __typename?: 'Query', userRequests: Array<{ __typename?: 'RequestPreview', createdAt: string, id: string, state: RequestState, subtype: RequestSubtype, type: RequestType }> };

export type GetAgentPtoRequestQueryVariables = Exact<{
  agentId: Scalars['ID'];
  ptoRequestId: Scalars['ID'];
}>;


export type GetAgentPtoRequestQuery = { __typename?: 'Query', agentPTORequest: { __typename?: 'PTORequest', createdAt: string, id: string, state: PtoRequestState, type: PtoRequestSubtype, agent: { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }, approver?: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } | null, audits: Array<{ __typename?: 'RequestAudit', message?: string | null, toState: RequestState, when: string, who: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } }>, dateRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } } };

export type CreatePtoRequestMutationVariables = Exact<{
  agentId: Scalars['ID'];
  parameters: PtoRequestInput;
}>;


export type CreatePtoRequestMutation = { __typename?: 'Mutation', createPTORequest: { __typename?: 'PTORequest', createdAt: string, id: string, state: PtoRequestState, type: PtoRequestSubtype, agent: { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }, approver?: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } | null, audits: Array<{ __typename?: 'RequestAudit', message?: string | null, toState: RequestState, when: string, who: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } }>, dateRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } } };

export type UpdateStateOfPtoRequestMutationVariables = Exact<{
  agentId: Scalars['ID'];
  ptoRequestId: Scalars['ID'];
  parameters: PtoRequestUpdateInput;
}>;


export type UpdateStateOfPtoRequestMutation = { __typename?: 'Mutation', updateStateOfPTORequest: { __typename?: 'PTORequest', createdAt: string, id: string, state: PtoRequestState, type: PtoRequestSubtype, agent: { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }, approver?: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } | null, audits: Array<{ __typename?: 'RequestAudit', message?: string | null, toState: RequestState, when: string, who: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } }>, dateRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } } };

export type GetSuitableShiftsForSwapQueryVariables = Exact<{
  requesterId: Scalars['ID'];
  shiftDate: Scalars['String'];
  recipientGroup: ShiftSwapRecipientGroup;
  recipients?: InputMaybe<Scalars['String']>;
  shiftsFrom?: InputMaybe<Scalars['String']>;
  shiftsTo?: InputMaybe<Scalars['String']>;
}>;


export type GetSuitableShiftsForSwapQuery = { __typename?: 'Query', suitableShiftsForSwap: Array<{ __typename?: 'AgentShift', queueIds: Array<string>, agent: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string }, dateRange: { __typename?: 'DateRange', from: string, to: string }, scheduleItems: Array<{ __typename?: 'ShiftScheduleItem', scheduleElementId: string, dateRange: { __typename?: 'DateRange', from: string, to: string } }> }> };

export type GetShiftOverviewsForRequesterQueryVariables = Exact<{
  requesterId: Scalars['ID'];
  from: Scalars['String'];
  to: Scalars['String'];
}>;


export type GetShiftOverviewsForRequesterQuery = { __typename?: 'Query', shiftOverviewsForRequester: { __typename?: 'AgentShiftOverviews', agent: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string }, shiftOverview: Array<{ __typename?: 'ShiftOverview', shiftDay: string, swappable: boolean, dateRange?: { __typename?: 'DateRange', from: string, to: string } | null }> } };

export type GetSuitableRecipientsQueryVariables = Exact<{
  requesterId: Scalars['ID'];
}>;


export type GetSuitableRecipientsQuery = { __typename?: 'Query', suitableRecipients: Array<{ __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }> };

export type CreateShiftSwapRequestMutationVariables = Exact<{
  requesterId: Scalars['ID'];
  parameters: ShiftSwapRequestInput;
}>;


export type CreateShiftSwapRequestMutation = { __typename?: 'Mutation', createShiftSwapRequest: { __typename?: 'ShiftSwapRequest', createdAt: string, updatedAt: string, id: string, state: ShiftSwapRequestState, type?: ShiftSwapRequestSubtype | null, recipientShift: { __typename?: 'AgentShiftWithoutItems', agent: { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }, dateRange: { __typename?: 'DateRange', from: string, to: string } }, requesterShift: { __typename?: 'AgentShiftWithoutItems', agent: { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }, dateRange: { __typename?: 'DateRange', from: string, to: string } }, approver?: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } | null, audits: Array<{ __typename?: 'RequestAudit', message?: string | null, toState: RequestState, when: string, who: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } }> } };

export type GetRecipientShiftSwapRequestQueryVariables = Exact<{
  recipientId: Scalars['ID'];
  shiftSwapRequestId: Scalars['ID'];
}>;


export type GetRecipientShiftSwapRequestQuery = { __typename?: 'Query', recipientShiftSwapRequest: { __typename?: 'ShiftSwapRequest', createdAt: string, updatedAt: string, id: string, state: ShiftSwapRequestState, type?: ShiftSwapRequestSubtype | null, recipientShift: { __typename?: 'AgentShiftWithoutItems', agent: { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }, dateRange: { __typename?: 'DateRange', from: string, to: string } }, requesterShift: { __typename?: 'AgentShiftWithoutItems', agent: { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }, dateRange: { __typename?: 'DateRange', from: string, to: string } }, approver?: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } | null, audits: Array<{ __typename?: 'RequestAudit', message?: string | null, toState: RequestState, when: string, who: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } }> } };

export type GetRequesterShiftSwapRequestQueryVariables = Exact<{
  requesterId: Scalars['ID'];
  shiftSwapRequestId: Scalars['ID'];
}>;


export type GetRequesterShiftSwapRequestQuery = { __typename?: 'Query', requesterShiftSwapRequest: { __typename?: 'ShiftSwapRequest', createdAt: string, updatedAt: string, id: string, state: ShiftSwapRequestState, type?: ShiftSwapRequestSubtype | null, recipientShift: { __typename?: 'AgentShiftWithoutItems', agent: { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }, dateRange: { __typename?: 'DateRange', from: string, to: string } }, requesterShift: { __typename?: 'AgentShiftWithoutItems', agent: { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }, dateRange: { __typename?: 'DateRange', from: string, to: string } }, approver?: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } | null, audits: Array<{ __typename?: 'RequestAudit', message?: string | null, toState: RequestState, when: string, who: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } }> } };

export type GetShiftOverviewForShiftOfShiftSwapRequestQueryVariables = Exact<{
  controller: ShiftSwapRequestController;
  shiftSwapRequestId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type GetShiftOverviewForShiftOfShiftSwapRequestQuery = { __typename?: 'Query', shiftOverviewForShiftFromShiftSwapRequest: { __typename?: 'AgentShift', queueIds: Array<string>, agent: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string }, dateRange: { __typename?: 'DateRange', from: string, to: string }, scheduleItems: Array<{ __typename?: 'ShiftScheduleItem', scheduleElementId: string, dateRange: { __typename?: 'DateRange', from: string, to: string } }> } };

export type UpdateStateOfShiftSwapRequestMutationVariables = Exact<{
  agentId: Scalars['ID'];
  requestId: Scalars['ID'];
  action: ShiftSwapRequestAction;
  controller: ShiftSwapRequestController;
  parameters: ShiftSwapRequestUpdateInput;
}>;


export type UpdateStateOfShiftSwapRequestMutation = { __typename?: 'Mutation', updateStateOfShiftSwapRequest: { __typename?: 'ShiftSwapRequest', createdAt: string, updatedAt: string, id: string, state: ShiftSwapRequestState, type?: ShiftSwapRequestSubtype | null, recipientShift: { __typename?: 'AgentShiftWithoutItems', agent: { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }, dateRange: { __typename?: 'DateRange', from: string, to: string } }, requesterShift: { __typename?: 'AgentShiftWithoutItems', agent: { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }, dateRange: { __typename?: 'DateRange', from: string, to: string } }, approver?: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } | null, audits: Array<{ __typename?: 'RequestAudit', message?: string | null, toState: RequestState, when: string, who: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } }> } };

export type CalculateWorkContributionQueryVariables = Exact<{
  parameters: CalculateWorkContributionInput;
}>;


export type CalculateWorkContributionQuery = { __typename?: 'Query', calculatedWorkContribution: Array<{ __typename?: 'CalculatedWorkContributionData', queueId: string, workContributions: Array<{ __typename?: 'WorkContribution', dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string }, value: { __typename?: 'WorkContributionPerQueue', queueTraffic: number, agentWorkContributions: Array<{ __typename?: 'WorkContributionPerAgent', agentId: string, value: number }> } }> }> };

export type CalculateIntradayWorkContributionQueryVariables = Exact<{
  parameters: CalculateWorkContributionInput;
}>;


export type CalculateIntradayWorkContributionQuery = { __typename?: 'Query', calculatedIntradayWorkContribution: Array<{ __typename?: 'CalculatedWorkContributionData', queueId: string, workContributions: Array<{ __typename?: 'WorkContribution', dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string }, value: { __typename?: 'WorkContributionPerQueue', queueTraffic: number, agentWorkContributions: Array<{ __typename?: 'WorkContributionPerAgent', agentId: string, value: number }> } }> }> };

export type CloneScheduleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CloneScheduleMutation = { __typename?: 'Mutation', cloneSchedule?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type CreateScheduleMutationVariables = Exact<{
  schedule: ScheduleInput;
  allowInactiveAgents?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateScheduleMutation = { __typename?: 'Mutation', createSchedule?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type CreateScheduleElementMutationVariables = Exact<{
  scheduleElement: ScheduleElementInput;
}>;


export type CreateScheduleElementMutation = { __typename?: 'Mutation', createScheduleElement?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type DeleteScheduleMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteScheduleMutation = { __typename?: 'Mutation', deleteSchedule?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type DeleteScheduleElementMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteScheduleElementMutation = { __typename?: 'Mutation', deleteScheduleElement?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type CalculateEstimatedServiceLevelPerQueueQueryVariables = Exact<{
  startDateTime: Scalars['String'];
  endDateTime: Scalars['String'];
  scheduledStaffingPerQueue: Array<EslStaffingPerQueueInput> | EslStaffingPerQueueInput;
}>;


export type CalculateEstimatedServiceLevelPerQueueQuery = { __typename?: 'Query', estimatedServiceLevelPerQueue: { __typename?: 'EstimatedServiceLevelPerQueueResponse', eslQueues: Array<{ __typename?: 'EstimatedServiceLevelPerQueue', queueId: string, averageEsl?: number | null, series: { __typename?: 'EstimatedServiceLevelPerQueueSeriesData', benchmark: Array<ChartData>, current: Array<ChartData> } }> } };

export type DateRangeFieldsFragment = { __typename?: 'DateRange', from: string, to: string };

export type ScheduleInfoFieldsFragment = { __typename?: 'ScheduleInfo', author: string, availableSeats?: number | null, creationDate: string, id: string, lockType: LockType, modificationDate: string, name: string, notes: string, queueIds: Array<string>, state: StateEnum, timezone: string, scheduleRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } };

export type StaffingPerIntervalFieldsFragment = { __typename?: 'StaffingPerInterval', staffing: number, dateRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } };

export type StaffingPerQueueFieldsFragment = { __typename?: 'StaffingPerQueue', queueId: string, scheduleQueuesStaffing: Array<{ __typename?: 'StaffingPerInterval', staffing: number, dateRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } }> };

export type EstimatedServiceLevelPerQueueSeriesDataFieldsFragment = { __typename?: 'EstimatedServiceLevelPerQueueSeriesData', benchmark: Array<ChartData>, current: Array<ChartData> };

export type EstimatedServiceLevelPerQueueFieldsFragment = { __typename?: 'EstimatedServiceLevelPerQueue', queueId: string, averageEsl?: number | null, series: { __typename?: 'EstimatedServiceLevelPerQueueSeriesData', benchmark: Array<ChartData>, current: Array<ChartData> } };

export type AgentScheduleStatsFieldsFragment = { __typename?: 'AgentScheduleStats', vacationDays: number, workDays: number, workHours: number };

export type ScheduleItemFieldsFragment = { __typename?: 'ScheduleItem', agentId?: string | null, pinned: boolean, scheduleElementId: string, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } };

export type SourceScheduleFieldsFragment = { __typename?: 'SourceSchedule', scheduleId: string, scheduleQueuesIds: Array<string> };

export type ScheduleItemExtendedFieldsFragment = { __typename?: 'ScheduleItemExtended', agentId?: string | null, pinned: boolean, ptoRequestId?: string | null, scheduleElementId: string, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string }, sourceSchedule?: { __typename?: 'SourceSchedule', scheduleId: string, scheduleQueuesIds: Array<string> } | null };

export type ProductionScheduleRangeIntervalsFieldsFragment = { __typename?: 'ProductionScheduleRangeIntervals', intervalAgentIds: Array<string>, intervalQueueIds: Array<string>, sourceScheduleId: string, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } };

export type ProductionScheduleQueuesDetailsFieldsFragment = { __typename?: 'ProductionScheduleQueuesDetails', channelType: QueueChannelType, queueId: string };

export type AgentScheduleDailyShiftFieldsFragment = { __typename?: 'AgentScheduleDailyShift', date: string, shift?: { __typename?: 'ScheduleDailyShift', durationPaidHours: number, durationShiftHours: number, swappable: boolean, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } } | null, settings?: { __typename?: 'ScheduleDailyAgentSettings', remote: boolean } | null };

export type AgentScheduleItemFieldsFragment = { __typename?: 'ScheduleItem', scheduleElementId: string, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } };

export type ScheduleDailyShiftFieldsFragment = { __typename?: 'ScheduleDailyShift', durationPaidHours: number, durationShiftHours: number, swappable: boolean, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } };

export type ScheduleDailyAgentSettingsFieldsFragment = { __typename?: 'ScheduleDailyAgentSettings', remote: boolean };

export type AgentScheduleOverviewFieldsFragment = { __typename?: 'ScheduleDailyOverview', date: string, overviewScheduleElementIds: Array<string>, beforeShiftScheduleElementIds: Array<string>, afterShiftScheduleElementIds: Array<string>, shift?: { __typename?: 'ScheduleDailyShift', durationPaidHours: number, durationShiftHours: number, swappable: boolean, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } } | null, settings?: { __typename?: 'ScheduleDailyAgentSettings', remote: boolean } | null };

export type ScheduledAgentFieldsFragment = { __typename?: 'ScheduledAgent', agentId: string, displayOrder: number };

export type ScheduleAgentDaySettingsFieldsFragment = { __typename?: 'ScheduleAgentDaySettings', agentId: string, remote: boolean };

export type ScheduleDaySettingsFieldsFragment = { __typename?: 'ScheduleDaySettings', dayIndex: number, agents: Array<{ __typename?: 'ScheduleAgentDaySettings', agentId: string, remote: boolean }> };

export type WorkContributionFieldsFragment = { __typename?: 'WorkContribution', dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string }, value: { __typename?: 'WorkContributionPerQueue', queueTraffic: number, agentWorkContributions: Array<{ __typename?: 'WorkContributionPerAgent', agentId: string, value: number }> } };

export type CalculatedWorkContributionFieldsFragment = { __typename?: 'CalculatedWorkContributionData', queueId: string, workContributions: Array<{ __typename?: 'WorkContribution', dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string }, value: { __typename?: 'WorkContributionPerQueue', queueTraffic: number, agentWorkContributions: Array<{ __typename?: 'WorkContributionPerAgent', agentId: string, value: number }> } }> };

export type ScheduleElementFieldsFragment = { __typename?: 'ScheduleElement', defaultDuration: number, displayOrder: number, editable?: boolean | null, id: string, name: string, paid: boolean, paidTimeOff: boolean, pinnable: boolean, productive: boolean, shift: boolean, showInOverview: boolean, showInOverviewBig: boolean, sick: boolean, vacation: boolean, zoomLevel: number, color: { __typename?: 'ScheduleElementColor', red: number, green: number, blue: number }, tags: Array<{ __typename?: 'ScheduleElementTag', id: string, value: string }> };

export type AdherenceHistoryItemFieldsFragment = { __typename?: 'AdherenceHistoryItem', adherenceRawDataAvailable: boolean, agentId: string, agentName: string, agentSurname: string, conformancePercentage: number, earlyLeavesCount: number, inAdherencePercentage: number, lateArrivalsCount: number, outOfAdhEventsCount: number, outOfAdhTimeTotal: number, scheduledTime: number, scheduledWorkingTime: number, timezone: string, teamIds: Array<string> };

export type GetAdherenceHistoryBarChartFieldsFragment = { __typename?: 'AdherenceHistoryBarChart', adherence: Array<ChartData>, conformance: Array<ChartData>, dataPerDay: RecordAdherenceHistoryPerDay, maxChartValue: number };

export type AdherenceHistoryStartDateFieldsFragment = { __typename?: 'AdherenceHistoryStartDate', dateTime?: string | null };

export type GetAdherenceHistoryGanttChartFieldsFragment = { __typename?: 'AdherenceHistoryGanttChart', agentActivityItems: Array<{ __typename?: 'AdherenceHistoryAgentActivityItem', agentId: string, mappedToActivity: boolean, eleveoStatusName: string, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } }>, outOfAdherenceItems: Array<{ __typename?: 'AdherenceHistoryOutOfAdherenceItem', eleveoStatusName: string, scheduleElementId: string, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } }>, scheduleItems: Array<{ __typename?: 'AdherenceHistoryScheduleItem', agentId: string, scheduleElementId: string, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } }> };

export type AdherenceHistoryAgentActivityItemFieldsFragment = { __typename?: 'AdherenceHistoryAgentActivityItem', agentId: string, mappedToActivity: boolean, eleveoStatusName: string, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } };

export type AdherenceHistoryOutOfAdherenceItemFieldsFragment = { __typename?: 'AdherenceHistoryOutOfAdherenceItem', eleveoStatusName: string, scheduleElementId: string, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } };

export type AdherenceHistoryScheduleItemFieldsFragment = { __typename?: 'AdherenceHistoryScheduleItem', agentId: string, scheduleElementId: string, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } };

export type AdherenceSettingAcdStatusFieldsFragment = { __typename?: 'AdherenceSettingACDStatus', agentEventReasonCodeId?: string | null, agentEventTypeId: string };

export type AdherenceSettingFieldsFragment = { __typename?: 'AdherenceSetting', id: string, name: string, historyScheduleActivityIds: Array<string>, realTimeScheduleActivityIds: Array<string>, acdStatuses: Array<{ __typename?: 'AdherenceSettingACDStatus', agentEventReasonCodeId?: string | null, agentEventTypeId: string }> };

export type AdherenceEventTypeFieldsFragment = { __typename?: 'AdherenceEventType', acdType: string, eventId: string, eventName: string, eventType?: string | null, id: string, reasonCodeRequired: boolean };

export type AdherenceReasonCodeFieldsFragment = { __typename?: 'AdherenceReasonCode', code: number, eventType: string, id: string, label: string, sourceId: string };

export type AdherenceNotificationFieldsFragment = { __typename?: 'AdherenceNotificationType', threshold: number };

type CommonEventFields_AgentEvent_Fragment = { __typename?: 'AgentEvent', activityName: string, from: string, id: string, mappedToActivity: boolean, to?: string | null };

type CommonEventFields_RealTimeActivityEvent_Fragment = { __typename?: 'RealTimeActivityEvent', activityName: string, from: string, id: string, mappedToActivity: boolean, to?: string | null };

export type CommonEventFieldsFragment = CommonEventFields_AgentEvent_Fragment | CommonEventFields_RealTimeActivityEvent_Fragment;

export type ScheduleChangeFieldsFragment = { __typename?: 'ScheduleChange', agentId: string, from: string, to: string };

export type AgentOverviewFieldsFragment = { __typename?: 'AgentOverview', currentActivity: string, expectedActivity: string, inStateSince: string, state: RealTimeAdherenceState, agent: { __typename?: 'AgentInfo', agentId: string, firstName: string, lastName: string } };

export type AgentOverviewWithTeamsFieldsFragment = { __typename?: 'AgentOverviewWithTeams', currentActivity: string, expectedActivity: string, inStateSince: string, state: RealTimeAdherenceState, agent: { __typename?: 'AgentInfoWithTeams', agentId: string, firstName: string, lastName: string, teamIds: Array<string> } };

export type AgentInfoFieldsFragment = { __typename?: 'AgentInfo', agentId: string, firstName: string, lastName: string };

export type AgentInfoWithTeamsFieldsFragment = { __typename?: 'AgentInfoWithTeams', agentId: string, firstName: string, lastName: string, teamIds: Array<string> };

export type AgentEventFieldsFragment = { __typename?: 'AgentEvent', activityName: string, from: string, id: string, mappedToActivity: boolean, to?: string | null, agent: { __typename?: 'AgentInfo', agentId: string, firstName: string, lastName: string } };

export type AdherenceEventFieldsFragment = { __typename?: 'AdherenceEvent', currentActivity: string, expectedActivityTypeId: string, state: RealTimeAdherenceState, id: string, from: string, to?: string | null, agent: { __typename?: 'AgentInfo', agentId: string, firstName: string, lastName: string } };

export type GetRealTimeAdherenceGanttChartInitialDataFieldsFragment = { __typename?: 'RealTimeAdherenceGanttChartInitial', adherenceEvents: Array<{ __typename?: 'RealTimeAdherenceEvent', currentActivity: string, expectedActivity: string, expectedActivityTypeId: string, from: string, id: string, state: RealTimeAdherenceState, to?: string | null }>, agentEvents: Array<{ __typename?: 'RealTimeActivityEvent', activityName: string, from: string, id: string, mappedToActivity: boolean, to?: string | null }> };

export type RealTimeAdherenceEventFieldsFragment = { __typename?: 'RealTimeAdherenceEvent', currentActivity: string, expectedActivity: string, expectedActivityTypeId: string, from: string, id: string, state: RealTimeAdherenceState, to?: string | null };

export type RealTimeActivityEventFieldsFragment = { __typename?: 'RealTimeActivityEvent', activityName: string, from: string, id: string, mappedToActivity: boolean, to?: string | null };

export type ProductionScheduleFieldsFragment = { __typename?: 'ProductionSchedule', itemsInProgress: boolean, name: string, queueIds: Array<string>, scheduleId: string, scheduleRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } };

export type AgentInRequestFieldsFragment = { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string };

export type AgentInRequestWithQueuesFieldsFragment = { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> };

export type RequestAuditFieldsFragment = { __typename?: 'RequestAudit', message?: string | null, toState: RequestState, when: string, who: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } };

export type PtoRequestFieldsFragment = { __typename?: 'PTORequest', createdAt: string, id: string, state: PtoRequestState, type: PtoRequestSubtype, agent: { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }, approver?: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } | null, audits: Array<{ __typename?: 'RequestAudit', message?: string | null, toState: RequestState, when: string, who: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } }>, dateRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } };

export type RequestPreviewFieldsFragment = { __typename?: 'RequestPreview', createdAt: string, id: string, state: RequestState, subtype: RequestSubtype, type: RequestType };

export type SupervisorRequestPreviewFieldsFragment = { __typename?: 'SupervisorRequestPreview', createdAt: string, id: string, state: RequestState, subtype: RequestSubtype, type: RequestType, approver?: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } | null, offered?: { __typename?: 'AgentShiftWithoutItems', agent: { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }, dateRange: { __typename?: 'DateRange', from: string, to: string } } | null, requested: { __typename?: 'AgentShiftWithoutItems', agent: { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }, dateRange: { __typename?: 'DateRange', from: string, to: string } } };

export type ShiftScheduleItemFieldsFragment = { __typename?: 'ShiftScheduleItem', scheduleElementId: string, dateRange: { __typename?: 'DateRange', from: string, to: string } };

export type AgentShiftFieldsFragment = { __typename?: 'AgentShift', queueIds: Array<string>, agent: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string }, dateRange: { __typename?: 'DateRange', from: string, to: string }, scheduleItems: Array<{ __typename?: 'ShiftScheduleItem', scheduleElementId: string, dateRange: { __typename?: 'DateRange', from: string, to: string } }> };

export type AgentShiftWithoutItemsFieldsFragment = { __typename?: 'AgentShiftWithoutItems', agent: { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }, dateRange: { __typename?: 'DateRange', from: string, to: string } };

export type ShiftSwapRequestFieldsFragment = { __typename?: 'ShiftSwapRequest', createdAt: string, updatedAt: string, id: string, state: ShiftSwapRequestState, type?: ShiftSwapRequestSubtype | null, recipientShift: { __typename?: 'AgentShiftWithoutItems', agent: { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }, dateRange: { __typename?: 'DateRange', from: string, to: string } }, requesterShift: { __typename?: 'AgentShiftWithoutItems', agent: { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }, dateRange: { __typename?: 'DateRange', from: string, to: string } }, approver?: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } | null, audits: Array<{ __typename?: 'RequestAudit', message?: string | null, toState: RequestState, when: string, who: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } }> };

export type AgentShiftOverviewsFieldsFragment = { __typename?: 'AgentShiftOverviews', agent: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string }, shiftOverview: Array<{ __typename?: 'ShiftOverview', shiftDay: string, swappable: boolean, dateRange?: { __typename?: 'DateRange', from: string, to: string } | null }> };

export type ShiftOverviewFieldsFragment = { __typename?: 'ShiftOverview', shiftDay: string, swappable: boolean, dateRange?: { __typename?: 'DateRange', from: string, to: string } | null };

export type GetAdherenceHistoryStartDateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdherenceHistoryStartDateQuery = { __typename?: 'Query', adherenceHistoryStartDate: { __typename?: 'AdherenceHistoryStartDate', dateTime?: string | null } };

export type GetAgentProductionOverviewScheduleQueryVariables = Exact<{
  agentId: Scalars['ID'];
  startDateTime: Scalars['String'];
  endDateTime: Scalars['String'];
  startDateTimeStats?: InputMaybe<Scalars['String']>;
  endDateTimeStats?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
}>;


export type GetAgentProductionOverviewScheduleQuery = { __typename?: 'Query', agentProductionOverviewSchedule?: { __typename?: 'AgentProductionOverviewSchedule', agentId: string, scheduleDailyOverview: Array<{ __typename?: 'ScheduleDailyOverview', date: string, overviewScheduleElementIds: Array<string>, beforeShiftScheduleElementIds: Array<string>, afterShiftScheduleElementIds: Array<string>, shift?: { __typename?: 'ScheduleDailyShift', durationPaidHours: number, durationShiftHours: number, swappable: boolean, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } } | null, settings?: { __typename?: 'ScheduleDailyAgentSettings', remote: boolean } | null }>, stats?: { __typename?: 'AgentScheduleStats', vacationDays: number, workDays: number, workHours: number } | null } | null };

export type GetAgentProductionScheduleQueryVariables = Exact<{
  agentId: Scalars['ID'];
  startDateTime: Scalars['String'];
  endDateTime: Scalars['String'];
  timezone: Scalars['String'];
}>;


export type GetAgentProductionScheduleQuery = { __typename?: 'Query', agentProductionSchedule?: { __typename?: 'AgentProductionSchedule', agentId: string, dailyShifts?: Array<{ __typename?: 'AgentScheduleDailyShift', date: string, shift?: { __typename?: 'ScheduleDailyShift', durationPaidHours: number, durationShiftHours: number, swappable: boolean, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } } | null, settings?: { __typename?: 'ScheduleDailyAgentSettings', remote: boolean } | null }> | null, scheduleItems?: Array<{ __typename?: 'ScheduleItem', scheduleElementId: string, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } }> | null, stats?: { __typename?: 'AgentScheduleStats', vacationDays: number, workDays: number, workHours: number } | null } | null };

export type GetAgentProductionScheduleWithoutStatsQueryVariables = Exact<{
  parameters: AgentProductionScheduleWithoutStatsInput;
}>;


export type GetAgentProductionScheduleWithoutStatsQuery = { __typename?: 'Query', agentProductionScheduleWithoutStats?: { __typename?: 'AgentProductionScheduleWithoutStats', scheduleItems?: Array<{ __typename?: 'ScheduleItem', scheduleElementId: string, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } }> | null } | null };

export type GetAgentsProductionSchedulesQueryVariables = Exact<{
  parameters: AgentsProductionSchedulesInput;
}>;


export type GetAgentsProductionSchedulesQuery = { __typename?: 'Query', agentsProductionSchedules: Array<{ __typename?: 'AgentsProductionSchedulesData', agent: { __typename?: 'Agent', active: boolean, deleted: boolean, id: string, name: string, surname: string, queueIds?: Array<string> | null, shiftTemplateIds?: Array<string> | null, skillIds?: Array<string> | null, timezone: string, teamIds: Array<string> }, productionSchedules: Array<{ __typename?: 'ScheduleInfo', author: string, availableSeats?: number | null, creationDate: string, id: string, lockType: LockType, modificationDate: string, name: string, notes: string, queueIds: Array<string>, state: StateEnum, timezone: string, scheduleRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } }> } | null> };

export type GetCalendarExportUrlQueryVariables = Exact<{
  agentId: Scalars['ID'];
}>;


export type GetCalendarExportUrlQuery = { __typename?: 'Query', getCalendarExportURL?: { __typename?: 'GetCalendarExportURL', url: string } | null };

export type GetProductionScheduleElementsFromOtherSchedulesQueryVariables = Exact<{
  parameters: ProductionScheduleElementsFromOtherSchedulesInput;
}>;


export type GetProductionScheduleElementsFromOtherSchedulesQuery = { __typename?: 'Query', productionScheduleElementsFromOtherSchedules: { __typename?: 'ProductionScheduleItemsExtended', queueIntervals: Array<{ __typename?: 'ProductionScheduleRangeIntervals', intervalAgentIds: Array<string>, intervalQueueIds: Array<string>, sourceScheduleId: string, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } }>, queuesDetails: Array<{ __typename?: 'ProductionScheduleQueuesDetails', channelType: QueueChannelType, queueId: string }>, scheduleItems: Array<{ __typename?: 'ScheduleItemExtended', agentId?: string | null, pinned: boolean, ptoRequestId?: string | null, scheduleElementId: string, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string }, sourceSchedule?: { __typename?: 'SourceSchedule', scheduleId: string, scheduleQueuesIds: Array<string> } | null }> } };

export type GetProductionScheduleReportQueryVariables = Exact<{
  docType: DocTypeEnum;
  queueId: Scalars['ID'];
  startDateTime: Scalars['String'];
  endDateTime: Scalars['String'];
}>;


export type GetProductionScheduleReportQuery = { __typename?: 'Query', productionScheduleReport?: string | null };

export type GetProductionSchedulesPerQueuesQueryVariables = Exact<{
  queueIds: Array<Scalars['ID']> | Scalars['ID'];
  startDateTime: Scalars['String'];
  endDateTime: Scalars['String'];
}>;


export type GetProductionSchedulesPerQueuesQuery = { __typename?: 'Query', productionSchedulesPerQueues: Array<{ __typename?: 'ProductionSchedule', itemsInProgress: boolean, name: string, queueIds: Array<string>, scheduleId: string, scheduleRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } }> };

export type GetQueuesStaffingFromOtherProductionSchedulesQueryVariables = Exact<{
  parameters: GetQueuesStaffingFromOtherProductionSchedulesInput;
}>;


export type GetQueuesStaffingFromOtherProductionSchedulesQuery = { __typename?: 'Query', queuesStaffingFromOtherProductionSchedules: Array<{ __typename?: 'StaffingPerQueue', queueId: string, scheduleQueuesStaffing: Array<{ __typename?: 'StaffingPerInterval', staffing: number, dateRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } }> }> };

export type GetScheduleQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetScheduleQuery = { __typename?: 'Query', schedule?: { __typename?: 'Schedule', info: { __typename?: 'ScheduleInfo', author: string, availableSeats?: number | null, creationDate: string, id: string, lockType: LockType, modificationDate: string, name: string, notes: string, queueIds: Array<string>, state: StateEnum, timezone: string, scheduleRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } }, scheduleItems?: Array<{ __typename?: 'ScheduleItem', agentId?: string | null, pinned: boolean, scheduleElementId: string, dateTimeRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } }> | null, scheduledAgents: Array<{ __typename?: 'ScheduledAgent', agentId: string, displayOrder: number }>, scheduleQueues: Array<{ __typename?: 'StaffingPerQueue', queueId: string, scheduleQueuesStaffing: Array<{ __typename?: 'StaffingPerInterval', staffing: number, dateRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } }> }>, daysSettings: Array<{ __typename?: 'ScheduleDaySettings', dayIndex: number, agents: Array<{ __typename?: 'ScheduleAgentDaySettings', agentId: string, remote: boolean }> }> } | null };

export type GetScheduleElementQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetScheduleElementQuery = { __typename?: 'Query', scheduleElement?: { __typename?: 'ScheduleElement', defaultDuration: number, displayOrder: number, editable?: boolean | null, id: string, name: string, paid: boolean, paidTimeOff: boolean, pinnable: boolean, productive: boolean, shift: boolean, showInOverview: boolean, showInOverviewBig: boolean, sick: boolean, vacation: boolean, zoomLevel: number, color: { __typename?: 'ScheduleElementColor', red: number, green: number, blue: number }, tags: Array<{ __typename?: 'ScheduleElementTag', id: string, value: string }> } | null };

export type GetScheduleElementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetScheduleElementsQuery = { __typename?: 'Query', scheduleElements: Array<{ __typename?: 'ScheduleElement', defaultDuration: number, displayOrder: number, editable?: boolean | null, id: string, name: string, paid: boolean, paidTimeOff: boolean, pinnable: boolean, productive: boolean, shift: boolean, showInOverview: boolean, showInOverviewBig: boolean, sick: boolean, vacation: boolean, zoomLevel: number, color: { __typename?: 'ScheduleElementColor', red: number, green: number, blue: number }, tags: Array<{ __typename?: 'ScheduleElementTag', id: string, value: string }> }> };

export type GetSchedulesQueryVariables = Exact<{
  queueIds?: InputMaybe<Scalars['ID']>;
  scheduleName?: InputMaybe<Scalars['String']>;
  scheduleStartDateTime?: InputMaybe<Scalars['String']>;
  scheduleEndDateTime?: InputMaybe<Scalars['String']>;
}>;


export type GetSchedulesQuery = { __typename?: 'Query', schedules?: Array<{ __typename?: 'ScheduleInfo', author: string, availableSeats?: number | null, creationDate: string, id: string, lockType: LockType, modificationDate: string, name: string, notes: string, queueIds: Array<string>, state: StateEnum, timezone: string, scheduleRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } }> | null, queues: Array<{ __typename?: 'Queue', id: string, name: string }> };

export type GetSchedulesInfoQueryVariables = Exact<{
  scheduleIds: Scalars['ID'];
}>;


export type GetSchedulesInfoQuery = { __typename?: 'Query', schedulesInfo: Array<{ __typename?: 'ScheduleInfo', author: string, availableSeats?: number | null, creationDate: string, id: string, lockType: LockType, modificationDate: string, name: string, notes: string, queueIds: Array<string>, state: StateEnum, timezone: string, scheduleRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } }> };

export type GetAgentSchedulesInfoQueryVariables = Exact<{
  agentId: Scalars['ID'];
  startDateTime?: InputMaybe<Scalars['String']>;
  endDateTime?: InputMaybe<Scalars['String']>;
}>;


export type GetAgentSchedulesInfoQuery = { __typename?: 'Query', agentSchedulesInfo: Array<{ __typename?: 'ScheduleInfo', author: string, availableSeats?: number | null, creationDate: string, id: string, lockType: LockType, modificationDate: string, name: string, notes: string, queueIds: Array<string>, state: StateEnum, timezone: string, scheduleRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } }> };

export type GetSupervisedAdherenceHistoryQueryVariables = Exact<{
  supervisorId: Scalars['ID'];
  adherenceHistorySearchCriteria: AdherenceHistorySearchCriteriaInput;
}>;


export type GetSupervisedAdherenceHistoryQuery = { __typename?: 'Query', supervisedAdherenceHistory: { __typename?: 'AdherenceHistory', totalCount: number, adherenceHistoryList: Array<{ __typename?: 'AdherenceHistoryItem', adherenceRawDataAvailable: boolean, agentId: string, agentName: string, agentSurname: string, conformancePercentage: number, earlyLeavesCount: number, inAdherencePercentage: number, lateArrivalsCount: number, outOfAdhEventsCount: number, outOfAdhTimeTotal: number, scheduledTime: number, scheduledWorkingTime: number, timezone: string, teamIds: Array<string> }> } };

export type GetSupervisorRequestsQueryVariables = Exact<{
  agentName?: InputMaybe<Scalars['String']>;
  agentSurname?: InputMaybe<Scalars['String']>;
  createdAtFrom?: InputMaybe<Scalars['String']>;
  createdAtTo?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  max: Scalars['Int'];
  requestedFrom?: InputMaybe<Scalars['String']>;
  requestedTo?: InputMaybe<Scalars['String']>;
  queueIds?: InputMaybe<Scalars['ID']>;
  states?: InputMaybe<Scalars['String']>;
  subtypes?: InputMaybe<Scalars['String']>;
  supervisorId: Scalars['ID'];
  types?: InputMaybe<Scalars['String']>;
}>;


export type GetSupervisorRequestsQuery = { __typename?: 'Query', supervisorRequests: { __typename?: 'SupervisorRequests', totalCount: number, requests: Array<{ __typename?: 'SupervisorRequestPreview', createdAt: string, id: string, state: RequestState, subtype: RequestSubtype, type: RequestType, approver?: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } | null, offered?: { __typename?: 'AgentShiftWithoutItems', agent: { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }, dateRange: { __typename?: 'DateRange', from: string, to: string } } | null, requested: { __typename?: 'AgentShiftWithoutItems', agent: { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }, dateRange: { __typename?: 'DateRange', from: string, to: string } } }> } };

export type GetSupervisorPtoRequestQueryVariables = Exact<{
  supervisorId: Scalars['ID'];
  ptoRequestId: Scalars['ID'];
}>;


export type GetSupervisorPtoRequestQuery = { __typename?: 'Query', supervisorPtoRequest: { __typename?: 'PTORequest', createdAt: string, id: string, state: PtoRequestState, type: PtoRequestSubtype, agent: { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }, approver?: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } | null, audits: Array<{ __typename?: 'RequestAudit', message?: string | null, toState: RequestState, when: string, who: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } }>, dateRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } } };

export type GetSupervisorShiftSwapRequestQueryVariables = Exact<{
  supervisorId: Scalars['ID'];
  shiftSwapRequestId: Scalars['ID'];
}>;


export type GetSupervisorShiftSwapRequestQuery = { __typename?: 'Query', supervisorShiftSwapRequest: { __typename?: 'ShiftSwapRequest', createdAt: string, updatedAt: string, id: string, state: ShiftSwapRequestState, type?: ShiftSwapRequestSubtype | null, recipientShift: { __typename?: 'AgentShiftWithoutItems', agent: { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }, dateRange: { __typename?: 'DateRange', from: string, to: string } }, requesterShift: { __typename?: 'AgentShiftWithoutItems', agent: { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }, dateRange: { __typename?: 'DateRange', from: string, to: string } }, approver?: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } | null, audits: Array<{ __typename?: 'RequestAudit', message?: string | null, toState: RequestState, when: string, who: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } }> } };

export type GetSupervisorShiftOverviewForShiftSwapRequestQueryVariables = Exact<{
  controller: ShiftSwapRequestController;
  shiftSwapRequestId: Scalars['ID'];
  supervisorId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type GetSupervisorShiftOverviewForShiftSwapRequestQuery = { __typename?: 'Query', supervisorShiftOverviewForShiftSwapRequest: { __typename?: 'AgentShift', queueIds: Array<string>, agent: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string }, dateRange: { __typename?: 'DateRange', from: string, to: string }, scheduleItems: Array<{ __typename?: 'ShiftScheduleItem', scheduleElementId: string, dateRange: { __typename?: 'DateRange', from: string, to: string } }> } };

export type UpdateStateOfSupervisorPtoRequestMutationVariables = Exact<{
  supervisorId: Scalars['ID'];
  ptoRequestId: Scalars['ID'];
  fromState: RequestState;
  parameters: PtoRequestUpdateInput;
}>;


export type UpdateStateOfSupervisorPtoRequestMutation = { __typename?: 'Mutation', updateStateOfSupervisorPTORequest: { __typename?: 'PTORequest', createdAt: string, id: string, state: PtoRequestState, type: PtoRequestSubtype, agent: { __typename?: 'AgentInRequestWithQueues', firstName: string, id: string, lastName: string, queueIds: Array<string> }, approver?: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } | null, audits: Array<{ __typename?: 'RequestAudit', message?: string | null, toState: RequestState, when: string, who: { __typename?: 'AgentInRequest', firstName: string, id: string, lastName: string } }>, dateRange: { __typename?: 'DateTimeRange', endDateTime: string, startDateTime: string } } };

export type PutScheduleToProductionMutationVariables = Exact<{
  scheduleId: Scalars['ID'];
}>;


export type PutScheduleToProductionMutation = { __typename?: 'Mutation', putScheduleToProduction?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type GetRealTimeAdherenceAgentOverviewsQueryVariables = Exact<{
  teamIds?: InputMaybe<Scalars['String']>;
}>;


export type GetRealTimeAdherenceAgentOverviewsQuery = { __typename?: 'Query', agentOverviews: Array<{ __typename?: 'AgentOverviewWithTeams', currentActivity: string, expectedActivity: string, inStateSince: string, state: RealTimeAdherenceState, agent: { __typename?: 'AgentInfoWithTeams', agentId: string, firstName: string, lastName: string, teamIds: Array<string> } }> };

export type GetRealTimeAdherenceGanttChartInitialDataQueryVariables = Exact<{
  agentId: Scalars['ID'];
}>;


export type GetRealTimeAdherenceGanttChartInitialDataQuery = { __typename?: 'Query', realTimeAdherenceGanttChartInitialData: { __typename?: 'RealTimeAdherenceGanttChartInitial', adherenceEvents: Array<{ __typename?: 'RealTimeAdherenceEvent', currentActivity: string, expectedActivity: string, expectedActivityTypeId: string, from: string, id: string, state: RealTimeAdherenceState, to?: string | null }>, agentEvents: Array<{ __typename?: 'RealTimeActivityEvent', activityName: string, from: string, id: string, mappedToActivity: boolean, to?: string | null }> } };

export type RemoveScheduleFromProductionMutationVariables = Exact<{
  scheduleId: Scalars['ID'];
}>;


export type RemoveScheduleFromProductionMutation = { __typename?: 'Mutation', removeScheduleFromProduction?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type UpdateScheduleMutationVariables = Exact<{
  id: Scalars['ID'];
  schedule: ScheduleInput;
  allowInactiveAgents?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateScheduleMutation = { __typename?: 'Mutation', updateSchedule?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type UpdateScheduleElementMutationVariables = Exact<{
  id: Scalars['ID'];
  scheduleElement: ScheduleElementInput;
}>;


export type UpdateScheduleElementMutation = { __typename?: 'Mutation', updateScheduleElement?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type UpdateDisplayOrderOnScheduleElementMutationVariables = Exact<{
  id: Scalars['ID'];
  scheduleElementDisplayOrder: ScheduleElementDisplayOrderInput;
}>;


export type UpdateDisplayOrderOnScheduleElementMutation = { __typename?: 'Mutation', updateDisplayOrderOnScheduleElement?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type UpdateScheduleInfoMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  availableSeats: Scalars['String'];
}>;


export type UpdateScheduleInfoMutation = { __typename?: 'Mutation', updateScheduleInfo?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type PushSubscriptionFieldsFragment = { __typename?: 'PushSubscription', endpoint: string, p256dh: string, auth: string, expirationTime?: string | null };

export type VapidKeysFieldsFragment = { __typename?: 'VapidKeys', publicKey: string };

export type GetShiftTemplatesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetShiftTemplatesQuery = { __typename?: 'Query', shiftTemplates?: { __typename?: 'ShiftTemplates', totalCount: number, shiftTemplates: Array<{ __typename?: 'ShiftTemplate', effectiveDate: string, id: string, name: string, type: ShiftTemplateType, state: ShiftStateType, dayTemplates: Array<{ __typename?: 'DayTemplate', id: string, dayIndex: number, breaksMinGap: number, shiftsMinGap: number, shiftDuration: number, shiftRange: { __typename?: 'TimeRange', endTime: string, startTime: string }, breaks: Array<{ __typename?: 'ShiftBreak', id: string, type: ShiftBreakType, duration: number, entitlementAfter: number }>, scheduleActivitySettings: Array<{ __typename?: 'ScheduleActivitySettings', id: string, type: QueueChannelType, minimumPerDay: number, maximumPerDay: number }> }> }> } | null };

export type GetShiftTemplateQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type GetShiftTemplateQuery = { __typename?: 'Query', shiftTemplate?: { __typename?: 'ShiftTemplate', effectiveDate: string, id: string, name: string, type: ShiftTemplateType, state: ShiftStateType, dayTemplates: Array<{ __typename?: 'DayTemplate', id: string, dayIndex: number, breaksMinGap: number, shiftsMinGap: number, shiftDuration: number, shiftRange: { __typename?: 'TimeRange', endTime: string, startTime: string }, breaks: Array<{ __typename?: 'ShiftBreak', id: string, type: ShiftBreakType, duration: number, entitlementAfter: number }>, scheduleActivitySettings: Array<{ __typename?: 'ScheduleActivitySettings', id: string, type: QueueChannelType, minimumPerDay: number, maximumPerDay: number }> }> } | null };

export type CreateShiftTemplateMutationVariables = Exact<{
  shiftTemplate: ShiftTemplateInput;
}>;


export type CreateShiftTemplateMutation = { __typename?: 'Mutation', createShiftTemplate?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type DeleteShiftTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteShiftTemplateMutation = { __typename?: 'Mutation', deleteShiftTemplate?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type UpdateShiftTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
  shiftTemplate: ShiftTemplateInput;
}>;


export type UpdateShiftTemplateMutation = { __typename?: 'Mutation', updateShiftTemplate?: { __typename?: 'ShiftTemplate', effectiveDate: string, id: string, name: string, type: ShiftTemplateType, state: ShiftStateType, dayTemplates: Array<{ __typename?: 'DayTemplate', id: string, dayIndex: number, breaksMinGap: number, shiftsMinGap: number, shiftDuration: number, shiftRange: { __typename?: 'TimeRange', endTime: string, startTime: string }, breaks: Array<{ __typename?: 'ShiftBreak', id: string, type: ShiftBreakType, duration: number, entitlementAfter: number }>, scheduleActivitySettings: Array<{ __typename?: 'ScheduleActivitySettings', id: string, type: QueueChannelType, minimumPerDay: number, maximumPerDay: number }> }> } | null };

export type TimeRangeFieldsFragment = { __typename?: 'TimeRange', endTime: string, startTime: string };

export type ScheduleActivitySettingsFieldsFragment = { __typename?: 'ScheduleActivitySettings', id: string, type: QueueChannelType, minimumPerDay: number, maximumPerDay: number };

export type ShiftBreakFieldsFragment = { __typename?: 'ShiftBreak', id: string, type: ShiftBreakType, duration: number, entitlementAfter: number };

export type DayTemplateFieldsFragment = { __typename?: 'DayTemplate', id: string, dayIndex: number, breaksMinGap: number, shiftsMinGap: number, shiftDuration: number, shiftRange: { __typename?: 'TimeRange', endTime: string, startTime: string }, breaks: Array<{ __typename?: 'ShiftBreak', id: string, type: ShiftBreakType, duration: number, entitlementAfter: number }>, scheduleActivitySettings: Array<{ __typename?: 'ScheduleActivitySettings', id: string, type: QueueChannelType, minimumPerDay: number, maximumPerDay: number }> };

export type ShiftTemplateFieldsFragment = { __typename?: 'ShiftTemplate', effectiveDate: string, id: string, name: string, type: ShiftTemplateType, state: ShiftStateType, dayTemplates: Array<{ __typename?: 'DayTemplate', id: string, dayIndex: number, breaksMinGap: number, shiftsMinGap: number, shiftDuration: number, shiftRange: { __typename?: 'TimeRange', endTime: string, startTime: string }, breaks: Array<{ __typename?: 'ShiftBreak', id: string, type: ShiftBreakType, duration: number, entitlementAfter: number }>, scheduleActivitySettings: Array<{ __typename?: 'ScheduleActivitySettings', id: string, type: QueueChannelType, minimumPerDay: number, maximumPerDay: number }> }> };

export type CreateSkillMutationVariables = Exact<{
  skill: SkillInput;
}>;


export type CreateSkillMutation = { __typename?: 'Mutation', createSkill?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type GetSkillsAllQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSkillsAllQuery = { __typename?: 'Query', skills: Array<{ __typename?: 'Skill', id: string, name: string }> };

export type GetSkillsAllWithUsedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSkillsAllWithUsedQuery = { __typename?: 'Query', skillsWithUsed: Array<{ __typename?: 'SkillWithUsed', id: string, name: string, used: boolean }> };

export type GetSkillsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetSkillsQuery = { __typename?: 'Query', skills: Array<{ __typename?: 'Skill', id: string, name: string }> };

export type UpdateSkillMutationVariables = Exact<{
  id: Scalars['ID'];
  skill: SkillInput;
}>;


export type UpdateSkillMutation = { __typename?: 'Mutation', updateSkill?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type DeleteSkillMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteSkillMutation = { __typename?: 'Mutation', deleteSkill?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type SkillFieldsFragment = { __typename?: 'Skill', id: string, name: string };

export type SkillWithUsedFieldsFragment = { __typename?: 'SkillWithUsed', id: string, name: string, used: boolean };

export type IntradayMeasurementsChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type IntradayMeasurementsChangedSubscription = { __typename?: 'Subscription', intradayMeasurementsChanged?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type RealTimeScheduleChangedSubscriptionVariables = Exact<{
  agentId: Scalars['ID'];
}>;


export type RealTimeScheduleChangedSubscription = { __typename?: 'Subscription', realTimeScheduleChanged?: { __typename?: 'ScheduleChange', agentId: string, from: string, to: string } | null };

export type RealTimeAgentEventsChangedSubscriptionVariables = Exact<{
  agentId: Scalars['ID'];
}>;


export type RealTimeAgentEventsChangedSubscription = { __typename?: 'Subscription', realTimeAgentEventsChanged?: { __typename?: 'AgentEvents', agentEvents: Array<{ __typename?: 'AgentEvent', activityName: string, from: string, id: string, mappedToActivity: boolean, to?: string | null, agent: { __typename?: 'AgentInfo', agentId: string, firstName: string, lastName: string } }> } | null };

export type RealTimeAdherenceChangedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type RealTimeAdherenceChangedSubscription = { __typename?: 'Subscription', realTimeAdherenceChanged?: { __typename?: 'AgentOverview', currentActivity: string, expectedActivity: string, inStateSince: string, state: RealTimeAdherenceState, agent: { __typename?: 'AgentInfo', agentId: string, firstName: string, lastName: string } } | null };

export type RealTimeAdherenceEventsChangedSubscriptionVariables = Exact<{
  agentId: Scalars['ID'];
}>;


export type RealTimeAdherenceEventsChangedSubscription = { __typename?: 'Subscription', realTimeAdherenceEventsChanged?: { __typename?: 'AdherenceEvents', adherenceEvents: Array<{ __typename?: 'AdherenceEvent', currentActivity: string, expectedActivityTypeId: string, state: RealTimeAdherenceState, id: string, from: string, to?: string | null, agent: { __typename?: 'AgentInfo', agentId: string, firstName: string, lastName: string } }> } | null };

export type WebSocketStateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type WebSocketStateSubscription = { __typename?: 'Subscription', webSocketState?: { __typename?: 'WebSocketState', state: string, error?: { __typename?: 'WebSocketError', message: string } | null } | null };

export type GetSupervisedAgentsAllQueryVariables = Exact<{
  supervisorId: Scalars['ID'];
}>;


export type GetSupervisedAgentsAllQuery = { __typename?: 'Query', supervisedAgents?: { __typename?: 'Agents', totalCount: number, agents: Array<{ __typename?: 'Agent', active: boolean, deleted: boolean, id: string, name: string, surname: string, queueIds?: Array<string> | null, shiftTemplateIds?: Array<string> | null, skillIds?: Array<string> | null, timezone: string, teamIds: Array<string> }> } | null };

export type GetSupervisedAgentsQueryVariables = Exact<{
  supervisorId: Scalars['ID'];
  filters: SupervisedAgentsFilter;
}>;


export type GetSupervisedAgentsQuery = { __typename?: 'Query', supervisedAgents?: { __typename?: 'Agents', totalCount: number, agents: Array<{ __typename?: 'Agent', active: boolean, deleted: boolean, id: string, name: string, surname: string, queueIds?: Array<string> | null, shiftTemplateIds?: Array<string> | null, skillIds?: Array<string> | null, timezone: string, teamIds: Array<string> }> } | null };

export type UpdateSupervisedAgentMutationVariables = Exact<{
  id: Scalars['ID'];
  supervisorId: Scalars['ID'];
  agent: UpdateAgentInput;
}>;


export type UpdateSupervisedAgentMutation = { __typename?: 'Mutation', updateSupervisedAgent?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type BulkAssignSupervisedAgentsToShiftTemplateMutationVariables = Exact<{
  supervisorId: Scalars['ID'];
  data: BulkAssignSupervisedAgentsToShiftTemplateInput;
}>;


export type BulkAssignSupervisedAgentsToShiftTemplateMutation = { __typename?: 'Mutation', bulkAssignSupervisedAgentsToShiftTemplate?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type BulkAssignSupervisedAgentsMutationVariables = Exact<{
  supervisorId: Scalars['ID'];
  data: BulkAssignSupervisedAgentsInput;
}>;


export type BulkAssignSupervisedAgentsMutation = { __typename?: 'Mutation', bulkAssignSupervisedAgents?: { __typename?: 'IdOrEmptyResponse', id: string } | null };

export type GetTeamsAllQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTeamsAllQuery = { __typename?: 'Query', teams: Array<{ __typename?: 'Team', name: string, id: string }> };

export type GetSupervisedTeamsQueryVariables = Exact<{
  supervisorId: Scalars['ID'];
}>;


export type GetSupervisedTeamsQuery = { __typename?: 'Query', supervisedTeams: Array<{ __typename?: 'Team', name: string, id: string }> };

export type TeamFieldsFragment = { __typename?: 'Team', name: string, id: string };

export type GetTimezonesAllQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTimezonesAllQuery = { __typename?: 'Query', timezones: Array<{ __typename?: 'Timezone', zoneId: string }> };

export type GetTimezonesUsedInQueuesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTimezonesUsedInQueuesQuery = { __typename?: 'Query', queuesTimezones: Array<{ __typename?: 'Timezone', zoneId: string }> };

export type TimezoneFieldsFragment = { __typename?: 'Timezone', zoneId: string };

export const AcdQueueFieldsFragmentDoc = gql`
    fragment AcdQueueFields on AcdQueue {
  acdId
  acdSourceQueueId
  id
  importType
  queueName
}
    `;
export const AgentFieldsFragmentDoc = gql`
    fragment AgentFields on Agent {
  active
  deleted
  id
  name
  surname
  queueIds
  shiftTemplateIds
  skillIds
  timezone
  teamIds
}
    `;
export const KeycloakApplicationFieldsFragmentDoc = gql`
    fragment KeycloakApplicationFields on KeycloakApplication {
  applicationName
}
    `;
export const ScheduleJobTypeFieldsFragmentDoc = gql`
    fragment ScheduleJobTypeFields on ScheduleJobType {
  code
  correlationId
  jobId
  message
  scheduleId
  state
}
    `;
export const DateTimeRangeFieldsFragmentDoc = gql`
    fragment DateTimeRangeFields on DateTimeRange {
  endDateTime
  startDateTime
}
    `;
export const ForecastValuesValueFieldsFragmentDoc = gql`
    fragment ForecastValuesValueFields on ForecastValuesValue {
  sourceForecastId
  staffingRequirements
}
    `;
export const ForecastValueFieldsFragmentDoc = gql`
    fragment ForecastValueFields on ForecastValue {
  dateTimeRange @type(name: DateTimeRange) {
    ...DateTimeRangeFields
  }
  value @type(name: ForecastValuesValue) {
    ...ForecastValuesValueFields
  }
}
    ${DateTimeRangeFieldsFragmentDoc}
${ForecastValuesValueFieldsFragmentDoc}`;
export const ForecastProductionFieldsFragmentDoc = gql`
    fragment ForecastProductionFields on ForecastProduction {
  queueId
  forecastValues @type(name: ForecastValue) {
    ...ForecastValueFields
  }
}
    ${ForecastValueFieldsFragmentDoc}`;
export const AdjustmentFieldsFragmentDoc = gql`
    fragment AdjustmentFields on Adjustment {
  averageHandlingTime
  contactVolume
  dateTimeRange @type(name: DateTimeRange) {
    ...DateTimeRangeFields
  }
  id
  name
  shrinkagePercentage
  concurrentChatsCount
}
    ${DateTimeRangeFieldsFragmentDoc}`;
export const CalculatedForecastValuesFieldsFragmentDoc = gql`
    fragment CalculatedForecastValuesFields on CalculatedForecastValuesData {
  adjustmentId
  data
}
    `;
export const CalculatedSeriesFieldsFragmentDoc = gql`
    fragment CalculatedSeriesFields on CalculatedSeriesData {
  gaps
  forecastValues @type(name: CalculatedForecastValuesData) {
    ...CalculatedForecastValuesFields
  }
}
    ${CalculatedForecastValuesFieldsFragmentDoc}`;
export const CalculateForecastFieldsFragmentDoc = gql`
    fragment CalculateForecastFields on CalculatedForecastData {
  averageHandlingTime @type(name: CalculatedSeriesData) {
    ...CalculatedSeriesFields
  }
  contactVolume @type(name: CalculatedSeriesData) {
    ...CalculatedSeriesFields
  }
  staffingRequirements @type(name: CalculatedSeriesData) {
    ...CalculatedSeriesFields
  }
  workloadRequirements @type(name: CalculatedSeriesData) {
    ...CalculatedSeriesFields
  }
}
    ${CalculatedSeriesFieldsFragmentDoc}`;
export const ForecastFieldsFragmentDoc = gql`
    fragment ForecastFields on Forecast {
  id
  author
  name
  notes
  state
  queueId
  creationDate
  modificationDate
  concurrentChatsCount
  timezone
  forecastRange @type(name: DateTimeRange) {
    ...DateTimeRangeFields
  }
  historyRange @type(name: DateTimeRange) {
    ...DateTimeRangeFields
  }
}
    ${DateTimeRangeFieldsFragmentDoc}`;
export const GetForecastFieldsFragmentDoc = gql`
    fragment GetForecastFields on GetForecast {
  adjustments @type(name: Adjustment) {
    ...AdjustmentFields
  }
  values @type(name: CalculatedForecastData) {
    ...CalculateForecastFields
  }
  info @type(name: Forecast) {
    ...ForecastFields
  }
}
    ${AdjustmentFieldsFragmentDoc}
${CalculateForecastFieldsFragmentDoc}
${ForecastFieldsFragmentDoc}`;
export const DataImportHistoryRecordFieldsFragmentDoc = gql`
    fragment DataImportHistoryRecordFields on DataImportHistoryRecord {
  id
  dateOfImport
  importType
  source
  status
}
    `;
export const ChartDataInfoFieldsFragmentDoc = gql`
    fragment ChartDataInfoFields on ChartDataInfo {
  forecastAccuracy
  lastHourAverageDifference
}
    `;
export const ChartDataSeriesFieldsFragmentDoc = gql`
    fragment ChartDataSeriesFields on ChartDataSeries {
  current
  forecasted
  trend
}
    `;
export const IntradayChartFieldsFragmentDoc = gql`
    fragment IntradayChartFields on IntradayChart {
  info @type(name: ChartDataInfo) {
    ...ChartDataInfoFields
  }
  series @type(name: ChartDataSeries) {
    ...ChartDataSeriesFields
  }
}
    ${ChartDataInfoFieldsFragmentDoc}
${ChartDataSeriesFieldsFragmentDoc}`;
export const StaffingChartDataSeriesFieldsFragmentDoc = gql`
    fragment StaffingChartDataSeriesFields on StaffingChartDataSeries {
  forecasted
  required
  scheduled
  trend
}
    `;
export const StaffingIntradayChartFieldsFragmentDoc = gql`
    fragment StaffingIntradayChartFields on StaffingIntradayChart {
  info @type(name: ChartDataInfo) {
    ...ChartDataInfoFields
  }
  series @type(name: StaffingChartDataSeries) {
    ...StaffingChartDataSeriesFields
  }
}
    ${ChartDataInfoFieldsFragmentDoc}
${StaffingChartDataSeriesFieldsFragmentDoc}`;
export const SlaChartDataInfoFieldsFragmentDoc = gql`
    fragment SlaChartDataInfoFields on SlaChartDataInfo {
  averageSla
}
    `;
export const SlaChartDataSeriesFieldsFragmentDoc = gql`
    fragment SlaChartDataSeriesFields on SlaChartDataSeries {
  benchmark
  current
  trend
}
    `;
export const SlaIntradayChartFieldsFragmentDoc = gql`
    fragment SlaIntradayChartFields on SlaIntradayChart {
  info @type(name: SlaChartDataInfo) {
    ...SlaChartDataInfoFields
  }
  series @type(name: SlaChartDataSeries) {
    ...SlaChartDataSeriesFields
  }
}
    ${SlaChartDataInfoFieldsFragmentDoc}
${SlaChartDataSeriesFieldsFragmentDoc}`;
export const IntradayChartsDataFieldsFragmentDoc = gql`
    fragment IntradayChartsDataFields on IntradayChartsData {
  contactVolume @type(name: IntradayChart) {
    ...IntradayChartFields
  }
  aht @type(name: IntradayChart) {
    ...IntradayChartFields
  }
  staffingRequirement @type(name: StaffingIntradayChart) {
    ...StaffingIntradayChartFields
  }
  sla @type(name: SlaIntradayChart) {
    ...SlaIntradayChartFields
  }
}
    ${IntradayChartFieldsFragmentDoc}
${StaffingIntradayChartFieldsFragmentDoc}
${SlaIntradayChartFieldsFragmentDoc}`;
export const IntradayInfoFieldsFragmentDoc = gql`
    fragment IntradayInfoFields on IntradayInfo {
  actualInterval
  dataAsOf
  timezone
}
    `;
export const IntradayPerQueueFieldsFragmentDoc = gql`
    fragment IntradayPerQueueFields on IntradayPerQueue {
  charts @type(name: IntradayChartsData) {
    ...IntradayChartsDataFields
  }
  info @type(name: IntradayInfo) {
    ...IntradayInfoFields
  }
}
    ${IntradayChartsDataFieldsFragmentDoc}
${IntradayInfoFieldsFragmentDoc}`;
export const IntradayQueueFieldsFragmentDoc = gql`
    fragment IntradayQueueFields on IntradayQueue {
  id
  inAlert
  name
  timezone
}
    `;
export const IntradayQueueNotificationFieldsFragmentDoc = gql`
    fragment IntradayQueueNotificationFields on IntradayQueueNotification {
  queueId
  contactVolumeDeviation
  slaOutOfRangeFrom
  slaOutOfRangeTo
}
    `;
export const IntradayPushNotificationSettingFieldsFragmentDoc = gql`
    fragment IntradayPushNotificationSettingFields on IntradayPushNotificationSetting {
  enabled
}
    `;
export const NotificationSettingsFieldsFragmentDoc = gql`
    fragment NotificationSettingsFields on NotificationSettings {
  createdAt
  enabled
  feature
  id
  type
  updatedAt
  userId
}
    `;
export const ServiceLevelFieldsFragmentDoc = gql`
    fragment ServiceLevelFields on ServiceLevel {
  interval
  percentage
}
    `;
export const QueueFieldsFragmentDoc = gql`
    fragment QueueFields on Queue {
  acdQueueIds
  acdQueueIdsEditable
  channelType
  channelTypeEditable
  historicalDataInterval
  id
  idEditable
  name
  nameEditable
  serviceLevel @type(name: ServiceLevel) {
    ...ServiceLevelFields
  }
  serviceLevelEditable
  skillId
  skillIdEditable
  tag
  tagEditable
  timezone
  timezoneEditable
  used
}
    ${ServiceLevelFieldsFragmentDoc}`;
export const ReportsMetadataFieldsFragmentDoc = gql`
    fragment ReportsMetadataFields on ReportsMetadata {
  page
  pageSize
  totalRecords
  totalPages
}
    `;
export const DailyStatisticsFieldsFragmentDoc = gql`
    fragment DailyStatisticsFields on DailyStatistics {
  date
  statistics
}
    `;
export const TeamInStatisticsFieldsFragmentDoc = gql`
    fragment TeamInStatisticsFields on TeamInStatistics {
  id
  name
}
    `;
export const UserInStatisticsFieldsFragmentDoc = gql`
    fragment UserInStatisticsFields on UserInStatistics {
  id
  firstName
  lastName
}
    `;
export const UserStatisticsFieldsFragmentDoc = gql`
    fragment UserStatisticsFields on UserStatistics {
  dailyStatistics @type(name: DailyStatistics) {
    ...DailyStatisticsFields
  }
  statistics
  teams @type(name: TeamInStatistics) {
    ...TeamInStatisticsFields
  }
  user @type(name: UserInStatistics) {
    ...UserInStatisticsFields
  }
}
    ${DailyStatisticsFieldsFragmentDoc}
${TeamInStatisticsFieldsFragmentDoc}
${UserInStatisticsFieldsFragmentDoc}`;
export const UserStatisticsResultFieldsFragmentDoc = gql`
    fragment UserStatisticsResultFields on UserStatisticsResult {
  dailyStatistics @type(name: DailyStatistics) {
    ...DailyStatisticsFields
  }
  statistics
  usersStatistics @type(name: UserStatistics) {
    ...UserStatisticsFields
  }
}
    ${DailyStatisticsFieldsFragmentDoc}
${UserStatisticsFieldsFragmentDoc}`;
export const AgentsReportsResultFieldsFragmentDoc = gql`
    fragment AgentsReportsResultFields on AgentsReportsResult {
  metadata @type(name: ReportsMetadata) {
    ...ReportsMetadataFields
  }
  result @type(name: UserStatisticsResult) {
    ...UserStatisticsResultFields
  }
}
    ${ReportsMetadataFieldsFragmentDoc}
${UserStatisticsResultFieldsFragmentDoc}`;
export const TeamStatisticsFieldsFragmentDoc = gql`
    fragment TeamStatisticsFields on TeamStatistics {
  dailyStatistics @type(name: DailyStatistics) {
    ...DailyStatisticsFields
  }
  statistics
  team @type(name: TeamInStatistics) {
    ...TeamInStatisticsFields
  }
}
    ${DailyStatisticsFieldsFragmentDoc}
${TeamInStatisticsFieldsFragmentDoc}`;
export const TeamsStatisticsResultFieldsFragmentDoc = gql`
    fragment TeamsStatisticsResultFields on TeamsStatisticsResult {
  dailyStatistics @type(name: DailyStatistics) {
    ...DailyStatisticsFields
  }
  statistics
  teamStatistics @type(name: TeamStatistics) {
    ...TeamStatisticsFields
  }
}
    ${DailyStatisticsFieldsFragmentDoc}
${TeamStatisticsFieldsFragmentDoc}`;
export const TeamsReportsResultFieldsFragmentDoc = gql`
    fragment TeamsReportsResultFields on TeamsReportsResult {
  metadata @type(name: ReportsMetadata) {
    ...ReportsMetadataFields
  }
  result @type(name: TeamsStatisticsResult) {
    ...TeamsStatisticsResultFields
  }
}
    ${ReportsMetadataFieldsFragmentDoc}
${TeamsStatisticsResultFieldsFragmentDoc}`;
export const ScheduleInfoFieldsFragmentDoc = gql`
    fragment ScheduleInfoFields on ScheduleInfo {
  author
  availableSeats
  creationDate
  id
  lockType
  modificationDate
  name
  notes
  queueIds
  scheduleRange @type(name: DateTimeRange) {
    ...DateTimeRangeFields
  }
  state
  timezone
}
    ${DateTimeRangeFieldsFragmentDoc}`;
export const StaffingPerIntervalFieldsFragmentDoc = gql`
    fragment StaffingPerIntervalFields on StaffingPerInterval {
  dateRange @type(name: DateTimeRange) {
    ...DateTimeRangeFields
  }
  staffing
}
    ${DateTimeRangeFieldsFragmentDoc}`;
export const StaffingPerQueueFieldsFragmentDoc = gql`
    fragment StaffingPerQueueFields on StaffingPerQueue {
  queueId
  scheduleQueuesStaffing @type(name: StaffingPerInterval) {
    ...StaffingPerIntervalFields
  }
}
    ${StaffingPerIntervalFieldsFragmentDoc}`;
export const EstimatedServiceLevelPerQueueSeriesDataFieldsFragmentDoc = gql`
    fragment EstimatedServiceLevelPerQueueSeriesDataFields on EstimatedServiceLevelPerQueueSeriesData {
  benchmark
  current
}
    `;
export const EstimatedServiceLevelPerQueueFieldsFragmentDoc = gql`
    fragment EstimatedServiceLevelPerQueueFields on EstimatedServiceLevelPerQueue {
  queueId
  averageEsl
  series @type(name: EstimatedServiceLevelPerQueueSeriesData) {
    ...EstimatedServiceLevelPerQueueSeriesDataFields
  }
}
    ${EstimatedServiceLevelPerQueueSeriesDataFieldsFragmentDoc}`;
export const AgentScheduleStatsFieldsFragmentDoc = gql`
    fragment AgentScheduleStatsFields on AgentScheduleStats {
  vacationDays
  workDays
  workHours
}
    `;
export const ScheduleItemFieldsFragmentDoc = gql`
    fragment ScheduleItemFields on ScheduleItem {
  agentId
  dateTimeRange @type(name: DateTimeRange) {
    ...DateTimeRangeFields
  }
  pinned
  scheduleElementId
}
    ${DateTimeRangeFieldsFragmentDoc}`;
export const SourceScheduleFieldsFragmentDoc = gql`
    fragment SourceScheduleFields on SourceSchedule {
  scheduleId
  scheduleQueuesIds
}
    `;
export const ScheduleItemExtendedFieldsFragmentDoc = gql`
    fragment ScheduleItemExtendedFields on ScheduleItemExtended {
  agentId
  dateTimeRange @type(name: DateTimeRange) {
    ...DateTimeRangeFields
  }
  pinned
  ptoRequestId
  scheduleElementId
  sourceSchedule @type(name: SourceSchedule) {
    ...SourceScheduleFields
  }
}
    ${DateTimeRangeFieldsFragmentDoc}
${SourceScheduleFieldsFragmentDoc}`;
export const ProductionScheduleRangeIntervalsFieldsFragmentDoc = gql`
    fragment ProductionScheduleRangeIntervalsFields on ProductionScheduleRangeIntervals {
  dateTimeRange @type(name: DateTimeRange) {
    ...DateTimeRangeFields
  }
  intervalAgentIds
  intervalQueueIds
  sourceScheduleId
}
    ${DateTimeRangeFieldsFragmentDoc}`;
export const ProductionScheduleQueuesDetailsFieldsFragmentDoc = gql`
    fragment ProductionScheduleQueuesDetailsFields on ProductionScheduleQueuesDetails {
  channelType
  queueId
}
    `;
export const ScheduleDailyShiftFieldsFragmentDoc = gql`
    fragment ScheduleDailyShiftFields on ScheduleDailyShift {
  dateTimeRange @type(name: DateTimeRange) {
    ...DateTimeRangeFields
  }
  durationPaidHours
  durationShiftHours
  swappable
}
    ${DateTimeRangeFieldsFragmentDoc}`;
export const ScheduleDailyAgentSettingsFieldsFragmentDoc = gql`
    fragment ScheduleDailyAgentSettingsFields on ScheduleDailyAgentSettings {
  remote
}
    `;
export const AgentScheduleDailyShiftFieldsFragmentDoc = gql`
    fragment AgentScheduleDailyShiftFields on AgentScheduleDailyShift {
  date
  shift @type(name: ScheduleDailyShift) {
    ...ScheduleDailyShiftFields
  }
  settings @type(name: ScheduleDailyAgentSettings) {
    ...ScheduleDailyAgentSettingsFields
  }
}
    ${ScheduleDailyShiftFieldsFragmentDoc}
${ScheduleDailyAgentSettingsFieldsFragmentDoc}`;
export const AgentScheduleItemFieldsFragmentDoc = gql`
    fragment AgentScheduleItemFields on ScheduleItem {
  dateTimeRange @type(name: DateTimeRange) {
    ...DateTimeRangeFields
  }
  scheduleElementId
}
    ${DateTimeRangeFieldsFragmentDoc}`;
export const AgentScheduleOverviewFieldsFragmentDoc = gql`
    fragment AgentScheduleOverviewFields on ScheduleDailyOverview {
  date
  overviewScheduleElementIds
  beforeShiftScheduleElementIds
  afterShiftScheduleElementIds
  shift @type(name: ScheduleDailyShift) {
    ...ScheduleDailyShiftFields
  }
  settings @type(name: ScheduleDailyAgentSettings) {
    ...ScheduleDailyAgentSettingsFields
  }
}
    ${ScheduleDailyShiftFieldsFragmentDoc}
${ScheduleDailyAgentSettingsFieldsFragmentDoc}`;
export const ScheduledAgentFieldsFragmentDoc = gql`
    fragment ScheduledAgentFields on ScheduledAgent {
  agentId
  displayOrder
}
    `;
export const ScheduleAgentDaySettingsFieldsFragmentDoc = gql`
    fragment ScheduleAgentDaySettingsFields on ScheduleAgentDaySettings {
  agentId
  remote
}
    `;
export const ScheduleDaySettingsFieldsFragmentDoc = gql`
    fragment ScheduleDaySettingsFields on ScheduleDaySettings {
  agents @type(name: ScheduleAgentDaySettings) {
    ...ScheduleAgentDaySettingsFields
  }
  dayIndex
}
    ${ScheduleAgentDaySettingsFieldsFragmentDoc}`;
export const WorkContributionFieldsFragmentDoc = gql`
    fragment WorkContributionFields on WorkContribution {
  dateTimeRange @type(name: DateTimeRange) {
    ...DateTimeRangeFields
  }
  value @type(name: WorkContributionPerQueue) {
    agentWorkContributions @type(name: WorkContributionPerAgent) {
      agentId
      value
    }
    queueTraffic
  }
}
    ${DateTimeRangeFieldsFragmentDoc}`;
export const CalculatedWorkContributionFieldsFragmentDoc = gql`
    fragment CalculatedWorkContributionFields on CalculatedWorkContributionData {
  queueId
  workContributions @type(name: WorkContribution) {
    ...WorkContributionFields
  }
}
    ${WorkContributionFieldsFragmentDoc}`;
export const ScheduleElementFieldsFragmentDoc = gql`
    fragment ScheduleElementFields on ScheduleElement {
  color @type(name: ScheduleElementColor) {
    red
    green
    blue
  }
  defaultDuration
  displayOrder
  editable
  id
  name
  paid
  paidTimeOff
  pinnable
  productive
  shift
  showInOverview
  showInOverviewBig
  sick
  vacation
  zoomLevel
  tags @type(name: ScheduleElementTag) {
    id
    value
  }
}
    `;
export const AdherenceHistoryItemFieldsFragmentDoc = gql`
    fragment AdherenceHistoryItemFields on AdherenceHistoryItem {
  adherenceRawDataAvailable
  agentId
  agentName
  agentSurname
  conformancePercentage
  earlyLeavesCount
  inAdherencePercentage
  lateArrivalsCount
  outOfAdhEventsCount
  outOfAdhTimeTotal
  scheduledTime
  scheduledWorkingTime
  timezone
  teamIds
}
    `;
export const GetAdherenceHistoryBarChartFieldsFragmentDoc = gql`
    fragment GetAdherenceHistoryBarChartFields on AdherenceHistoryBarChart {
  adherence
  conformance
  dataPerDay
  maxChartValue
}
    `;
export const AdherenceHistoryStartDateFieldsFragmentDoc = gql`
    fragment AdherenceHistoryStartDateFields on AdherenceHistoryStartDate {
  dateTime
}
    `;
export const AdherenceHistoryAgentActivityItemFieldsFragmentDoc = gql`
    fragment AdherenceHistoryAgentActivityItemFields on AdherenceHistoryAgentActivityItem {
  agentId
  dateTimeRange @type(name: DateTimeRange) {
    ...DateTimeRangeFields
  }
  mappedToActivity
  eleveoStatusName
}
    ${DateTimeRangeFieldsFragmentDoc}`;
export const AdherenceHistoryOutOfAdherenceItemFieldsFragmentDoc = gql`
    fragment AdherenceHistoryOutOfAdherenceItemFields on AdherenceHistoryOutOfAdherenceItem {
  dateTimeRange @type(name: DateTimeRange) {
    ...DateTimeRangeFields
  }
  eleveoStatusName
  scheduleElementId
}
    ${DateTimeRangeFieldsFragmentDoc}`;
export const AdherenceHistoryScheduleItemFieldsFragmentDoc = gql`
    fragment AdherenceHistoryScheduleItemFields on AdherenceHistoryScheduleItem {
  agentId
  dateTimeRange @type(name: DateTimeRange) {
    ...DateTimeRangeFields
  }
  scheduleElementId
}
    ${DateTimeRangeFieldsFragmentDoc}`;
export const GetAdherenceHistoryGanttChartFieldsFragmentDoc = gql`
    fragment GetAdherenceHistoryGanttChartFields on AdherenceHistoryGanttChart {
  agentActivityItems @type(name: AdherenceHistoryAgentActivityItem) {
    ...AdherenceHistoryAgentActivityItemFields
  }
  outOfAdherenceItems @type(name: AdherenceHistoryOutOfAdherenceItem) {
    ...AdherenceHistoryOutOfAdherenceItemFields
  }
  scheduleItems @type(name: AdherenceHistoryScheduleItem) {
    ...AdherenceHistoryScheduleItemFields
  }
}
    ${AdherenceHistoryAgentActivityItemFieldsFragmentDoc}
${AdherenceHistoryOutOfAdherenceItemFieldsFragmentDoc}
${AdherenceHistoryScheduleItemFieldsFragmentDoc}`;
export const AdherenceSettingAcdStatusFieldsFragmentDoc = gql`
    fragment AdherenceSettingACDStatusFields on AdherenceSettingACDStatus {
  agentEventReasonCodeId
  agentEventTypeId
}
    `;
export const AdherenceSettingFieldsFragmentDoc = gql`
    fragment AdherenceSettingFields on AdherenceSetting {
  acdStatuses @type(name: AdherenceSettingACDStatus) {
    ...AdherenceSettingACDStatusFields
  }
  id
  name
  historyScheduleActivityIds
  realTimeScheduleActivityIds
}
    ${AdherenceSettingAcdStatusFieldsFragmentDoc}`;
export const AdherenceEventTypeFieldsFragmentDoc = gql`
    fragment AdherenceEventTypeFields on AdherenceEventType {
  acdType
  eventId
  eventName
  eventType
  id
  reasonCodeRequired
}
    `;
export const AdherenceReasonCodeFieldsFragmentDoc = gql`
    fragment AdherenceReasonCodeFields on AdherenceReasonCode {
  code
  eventType
  id
  label
  sourceId
}
    `;
export const AdherenceNotificationFieldsFragmentDoc = gql`
    fragment AdherenceNotificationFields on AdherenceNotificationType {
  threshold
}
    `;
export const CommonEventFieldsFragmentDoc = gql`
    fragment CommonEventFields on CommonEvent {
  activityName
  from
  id
  mappedToActivity
  to
}
    `;
export const ScheduleChangeFieldsFragmentDoc = gql`
    fragment ScheduleChangeFields on ScheduleChange {
  agentId
  from
  to
}
    `;
export const AgentInfoFieldsFragmentDoc = gql`
    fragment AgentInfoFields on AgentInfo {
  agentId
  firstName
  lastName
}
    `;
export const AgentOverviewFieldsFragmentDoc = gql`
    fragment AgentOverviewFields on AgentOverview {
  agent @type(name: AgentInfo) {
    ...AgentInfoFields
  }
  currentActivity
  expectedActivity
  inStateSince
  state
}
    ${AgentInfoFieldsFragmentDoc}`;
export const AgentInfoWithTeamsFieldsFragmentDoc = gql`
    fragment AgentInfoWithTeamsFields on AgentInfoWithTeams {
  agentId
  firstName
  lastName
  teamIds
}
    `;
export const AgentOverviewWithTeamsFieldsFragmentDoc = gql`
    fragment AgentOverviewWithTeamsFields on AgentOverviewWithTeams {
  agent @type(name: AgentInfoWithTeams) {
    ...AgentInfoWithTeamsFields
  }
  currentActivity
  expectedActivity
  inStateSince
  state
}
    ${AgentInfoWithTeamsFieldsFragmentDoc}`;
export const AgentEventFieldsFragmentDoc = gql`
    fragment AgentEventFields on AgentEvent {
  agent @type(name: AgentInfo) {
    ...AgentInfoFields
  }
  activityName
  from
  id
  mappedToActivity
  to
}
    ${AgentInfoFieldsFragmentDoc}`;
export const AdherenceEventFieldsFragmentDoc = gql`
    fragment AdherenceEventFields on AdherenceEvent {
  agent @type(name: AgentInfo) {
    ...AgentInfoFields
  }
  currentActivity
  expectedActivityTypeId
  state
  id
  from
  to
}
    ${AgentInfoFieldsFragmentDoc}`;
export const RealTimeAdherenceEventFieldsFragmentDoc = gql`
    fragment RealTimeAdherenceEventFields on RealTimeAdherenceEvent {
  currentActivity
  expectedActivity
  expectedActivityTypeId
  from
  id
  state
  to
}
    `;
export const RealTimeActivityEventFieldsFragmentDoc = gql`
    fragment RealTimeActivityEventFields on RealTimeActivityEvent {
  activityName
  from
  id
  mappedToActivity
  to
}
    `;
export const GetRealTimeAdherenceGanttChartInitialDataFieldsFragmentDoc = gql`
    fragment GetRealTimeAdherenceGanttChartInitialDataFields on RealTimeAdherenceGanttChartInitial {
  adherenceEvents @type(name: RealTimeAdherenceEvent) {
    ...RealTimeAdherenceEventFields
  }
  agentEvents @type(name: RealTimeActivityEvent) {
    ...RealTimeActivityEventFields
  }
}
    ${RealTimeAdherenceEventFieldsFragmentDoc}
${RealTimeActivityEventFieldsFragmentDoc}`;
export const ProductionScheduleFieldsFragmentDoc = gql`
    fragment ProductionScheduleFields on ProductionSchedule {
  itemsInProgress
  name
  queueIds
  scheduleId
  scheduleRange @type(name: DateTimeRange) {
    ...DateTimeRangeFields
  }
}
    ${DateTimeRangeFieldsFragmentDoc}`;
export const AgentInRequestWithQueuesFieldsFragmentDoc = gql`
    fragment AgentInRequestWithQueuesFields on AgentInRequestWithQueues {
  firstName
  id
  lastName
  queueIds
}
    `;
export const AgentInRequestFieldsFragmentDoc = gql`
    fragment AgentInRequestFields on AgentInRequest {
  firstName
  id
  lastName
}
    `;
export const RequestAuditFieldsFragmentDoc = gql`
    fragment RequestAuditFields on RequestAudit {
  message
  toState
  who @type(name: AgentInRequest) {
    ...AgentInRequestFields
  }
  when
}
    ${AgentInRequestFieldsFragmentDoc}`;
export const PtoRequestFieldsFragmentDoc = gql`
    fragment PTORequestFields on PTORequest {
  agent @type(name: AgentInRequestWithQueues) {
    ...AgentInRequestWithQueuesFields
  }
  approver @type(name: AgentInRequest) {
    ...AgentInRequestFields
  }
  audits @type(name: RequestAudit) {
    ...RequestAuditFields
  }
  createdAt
  dateRange @type(name: DateTimeRange) {
    ...DateTimeRangeFields
  }
  id
  state
  type
}
    ${AgentInRequestWithQueuesFieldsFragmentDoc}
${AgentInRequestFieldsFragmentDoc}
${RequestAuditFieldsFragmentDoc}
${DateTimeRangeFieldsFragmentDoc}`;
export const RequestPreviewFieldsFragmentDoc = gql`
    fragment RequestPreviewFields on RequestPreview {
  createdAt
  id
  state
  subtype
  type
}
    `;
export const DateRangeFieldsFragmentDoc = gql`
    fragment DateRangeFields on DateRange {
  from
  to
}
    `;
export const AgentShiftWithoutItemsFieldsFragmentDoc = gql`
    fragment AgentShiftWithoutItemsFields on AgentShiftWithoutItems {
  agent @type(name: AgentInRequestWithQueues) {
    ...AgentInRequestWithQueuesFields
  }
  dateRange @type(name: DateRange) {
    ...DateRangeFields
  }
}
    ${AgentInRequestWithQueuesFieldsFragmentDoc}
${DateRangeFieldsFragmentDoc}`;
export const SupervisorRequestPreviewFieldsFragmentDoc = gql`
    fragment SupervisorRequestPreviewFields on SupervisorRequestPreview {
  approver @type(name: AgentInRequest) {
    ...AgentInRequestFields
  }
  createdAt
  id
  offered @type(name: AgentShiftWithoutItems) {
    ...AgentShiftWithoutItemsFields
  }
  requested @type(name: AgentShiftWithoutItems) {
    ...AgentShiftWithoutItemsFields
  }
  state
  subtype
  type
}
    ${AgentInRequestFieldsFragmentDoc}
${AgentShiftWithoutItemsFieldsFragmentDoc}`;
export const ShiftScheduleItemFieldsFragmentDoc = gql`
    fragment ShiftScheduleItemFields on ShiftScheduleItem {
  dateRange @type(name: DateRange) {
    ...DateRangeFields
  }
  scheduleElementId
}
    ${DateRangeFieldsFragmentDoc}`;
export const AgentShiftFieldsFragmentDoc = gql`
    fragment AgentShiftFields on AgentShift {
  agent @type(name: AgentInRequest) {
    ...AgentInRequestFields
  }
  dateRange @type(name: DateRange) {
    ...DateRangeFields
  }
  scheduleItems @type(name: ShiftScheduleItem) {
    ...ShiftScheduleItemFields
  }
  queueIds
}
    ${AgentInRequestFieldsFragmentDoc}
${DateRangeFieldsFragmentDoc}
${ShiftScheduleItemFieldsFragmentDoc}`;
export const ShiftSwapRequestFieldsFragmentDoc = gql`
    fragment ShiftSwapRequestFields on ShiftSwapRequest {
  recipientShift @type(name: AgentShiftWithoutItems) {
    ...AgentShiftWithoutItemsFields
  }
  requesterShift @type(name: AgentShiftWithoutItems) {
    ...AgentShiftWithoutItemsFields
  }
  approver @type(name: AgentInRequest) {
    ...AgentInRequestFields
  }
  audits @type(name: RequestAudit) {
    ...RequestAuditFields
  }
  createdAt
  updatedAt
  id
  state
  type
}
    ${AgentShiftWithoutItemsFieldsFragmentDoc}
${AgentInRequestFieldsFragmentDoc}
${RequestAuditFieldsFragmentDoc}`;
export const ShiftOverviewFieldsFragmentDoc = gql`
    fragment ShiftOverviewFields on ShiftOverview {
  dateRange @type(name: DateRange) {
    ...DateRangeFields
  }
  shiftDay
  swappable
}
    ${DateRangeFieldsFragmentDoc}`;
export const AgentShiftOverviewsFieldsFragmentDoc = gql`
    fragment AgentShiftOverviewsFields on AgentShiftOverviews {
  agent @type(name: AgentInRequest) {
    ...AgentInRequestFields
  }
  shiftOverview @type(name: ShiftOverview) {
    ...ShiftOverviewFields
  }
}
    ${AgentInRequestFieldsFragmentDoc}
${ShiftOverviewFieldsFragmentDoc}`;
export const PushSubscriptionFieldsFragmentDoc = gql`
    fragment PushSubscriptionFields on PushSubscription {
  endpoint
  p256dh
  auth
  expirationTime
}
    `;
export const VapidKeysFieldsFragmentDoc = gql`
    fragment VapidKeysFields on VapidKeys {
  publicKey
}
    `;
export const TimeRangeFieldsFragmentDoc = gql`
    fragment TimeRangeFields on TimeRange {
  endTime
  startTime
}
    `;
export const ShiftBreakFieldsFragmentDoc = gql`
    fragment ShiftBreakFields on ShiftBreak {
  id
  type
  duration
  entitlementAfter
}
    `;
export const ScheduleActivitySettingsFieldsFragmentDoc = gql`
    fragment ScheduleActivitySettingsFields on ScheduleActivitySettings {
  id
  type
  minimumPerDay
  maximumPerDay
}
    `;
export const DayTemplateFieldsFragmentDoc = gql`
    fragment DayTemplateFields on DayTemplate {
  id
  dayIndex
  breaksMinGap
  shiftsMinGap
  shiftDuration
  shiftRange @type(name: TimeRange) {
    ...TimeRangeFields
  }
  breaks @type(name: ShiftBreak) {
    ...ShiftBreakFields
  }
  scheduleActivitySettings @type(name: ScheduleActivitySettings) {
    ...ScheduleActivitySettingsFields
  }
}
    ${TimeRangeFieldsFragmentDoc}
${ShiftBreakFieldsFragmentDoc}
${ScheduleActivitySettingsFieldsFragmentDoc}`;
export const ShiftTemplateFieldsFragmentDoc = gql`
    fragment ShiftTemplateFields on ShiftTemplate {
  effectiveDate
  id
  name
  type
  state
  dayTemplates @type(name: DayTemplate) {
    ...DayTemplateFields
  }
}
    ${DayTemplateFieldsFragmentDoc}`;
export const SkillFieldsFragmentDoc = gql`
    fragment SkillFields on Skill {
  id
  name
}
    `;
export const SkillWithUsedFieldsFragmentDoc = gql`
    fragment SkillWithUsedFields on SkillWithUsed {
  id
  name
  used
}
    `;
export const TeamFieldsFragmentDoc = gql`
    fragment TeamFields on Team {
  name
  id
}
    `;
export const TimezoneFieldsFragmentDoc = gql`
    fragment TimezoneFields on Timezone {
  zoneId
}
    `;
export const GetAcdQueuesDocument = gql`
    query getAcdQueues {
  acdQueues @rest(type: "AcdQueue", path: "queue-management/queues/acd") {
    ...AcdQueueFields
  }
}
    ${AcdQueueFieldsFragmentDoc}`;
export type GetAcdQueuesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAcdQueuesQuery, GetAcdQueuesQueryVariables>, 'query'>;

    export const GetAcdQueuesComponent = (props: GetAcdQueuesComponentProps) => (
      <ApolloReactComponents.Query<GetAcdQueuesQuery, GetAcdQueuesQueryVariables> query={GetAcdQueuesDocument} {...props} />
    );
    

/**
 * __useGetAcdQueuesQuery__
 *
 * To run a query within a React component, call `useGetAcdQueuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcdQueuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcdQueuesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAcdQueuesQuery(baseOptions?: Apollo.QueryHookOptions<GetAcdQueuesQuery, GetAcdQueuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAcdQueuesQuery, GetAcdQueuesQueryVariables>(GetAcdQueuesDocument, options);
      }
export function useGetAcdQueuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAcdQueuesQuery, GetAcdQueuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAcdQueuesQuery, GetAcdQueuesQueryVariables>(GetAcdQueuesDocument, options);
        }
export type GetAcdQueuesQueryHookResult = ReturnType<typeof useGetAcdQueuesQuery>;
export type GetAcdQueuesLazyQueryHookResult = ReturnType<typeof useGetAcdQueuesLazyQuery>;
export type GetAcdQueuesQueryResult = Apollo.QueryResult<GetAcdQueuesQuery, GetAcdQueuesQueryVariables>;
export const GetAgentsAllDocument = gql`
    query getAgentsAll {
  agents @rest(type: "Agents", path: "administration/agents") {
    agents @type(name: Agent) {
      ...AgentFields
    }
    totalCount
  }
}
    ${AgentFieldsFragmentDoc}`;
export type GetAgentsAllComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAgentsAllQuery, GetAgentsAllQueryVariables>, 'query'>;

    export const GetAgentsAllComponent = (props: GetAgentsAllComponentProps) => (
      <ApolloReactComponents.Query<GetAgentsAllQuery, GetAgentsAllQueryVariables> query={GetAgentsAllDocument} {...props} />
    );
    

/**
 * __useGetAgentsAllQuery__
 *
 * To run a query within a React component, call `useGetAgentsAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentsAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentsAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgentsAllQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentsAllQuery, GetAgentsAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentsAllQuery, GetAgentsAllQueryVariables>(GetAgentsAllDocument, options);
      }
export function useGetAgentsAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentsAllQuery, GetAgentsAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentsAllQuery, GetAgentsAllQueryVariables>(GetAgentsAllDocument, options);
        }
export type GetAgentsAllQueryHookResult = ReturnType<typeof useGetAgentsAllQuery>;
export type GetAgentsAllLazyQueryHookResult = ReturnType<typeof useGetAgentsAllLazyQuery>;
export type GetAgentsAllQueryResult = Apollo.QueryResult<GetAgentsAllQuery, GetAgentsAllQueryVariables>;
export const GetAgentsDocument = gql`
    query getAgents($name: String, $surname: String, $queueIds: ID, $shiftTemplateIds: ID, $skillIds: ID, $limit: Int, $offset: Int, $includeInactive: Boolean) {
  agents(
    agentName: $name
    agentSurname: $surname
    queueIds: $queueIds
    shiftTemplateIds: $shiftTemplateIds
    skillIds: $skillIds
    max: $limit
    first: $offset
    includeInactive: $includeInactive
  ) @rest(type: "Agents", path: "administration/agents?{args}") {
    agents @type(name: Agent) {
      ...AgentFields
    }
    totalCount
  }
}
    ${AgentFieldsFragmentDoc}`;
export type GetAgentsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAgentsQuery, GetAgentsQueryVariables>, 'query'>;

    export const GetAgentsComponent = (props: GetAgentsComponentProps) => (
      <ApolloReactComponents.Query<GetAgentsQuery, GetAgentsQueryVariables> query={GetAgentsDocument} {...props} />
    );
    

/**
 * __useGetAgentsQuery__
 *
 * To run a query within a React component, call `useGetAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentsQuery({
 *   variables: {
 *      name: // value for 'name'
 *      surname: // value for 'surname'
 *      queueIds: // value for 'queueIds'
 *      shiftTemplateIds: // value for 'shiftTemplateIds'
 *      skillIds: // value for 'skillIds'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useGetAgentsQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentsQuery, GetAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentsQuery, GetAgentsQueryVariables>(GetAgentsDocument, options);
      }
export function useGetAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentsQuery, GetAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentsQuery, GetAgentsQueryVariables>(GetAgentsDocument, options);
        }
export type GetAgentsQueryHookResult = ReturnType<typeof useGetAgentsQuery>;
export type GetAgentsLazyQueryHookResult = ReturnType<typeof useGetAgentsLazyQuery>;
export type GetAgentsQueryResult = Apollo.QueryResult<GetAgentsQuery, GetAgentsQueryVariables>;
export const GetAgentsByIdsDocument = gql`
    query getAgentsByIds($agentIds: [String!]!) {
  agentsByIds(agentIds: $agentIds) @rest(type: "Agents", path: "administration/agents/mapping", method: "POST", bodyKey: "agentIds") {
    agents @type(name: Agent) {
      ...AgentFields
    }
    totalCount
  }
}
    ${AgentFieldsFragmentDoc}`;
export type GetAgentsByIdsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAgentsByIdsQuery, GetAgentsByIdsQueryVariables>, 'query'> & ({ variables: GetAgentsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAgentsByIdsComponent = (props: GetAgentsByIdsComponentProps) => (
      <ApolloReactComponents.Query<GetAgentsByIdsQuery, GetAgentsByIdsQueryVariables> query={GetAgentsByIdsDocument} {...props} />
    );
    

/**
 * __useGetAgentsByIdsQuery__
 *
 * To run a query within a React component, call `useGetAgentsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentsByIdsQuery({
 *   variables: {
 *      agentIds: // value for 'agentIds'
 *   },
 * });
 */
export function useGetAgentsByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetAgentsByIdsQuery, GetAgentsByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentsByIdsQuery, GetAgentsByIdsQueryVariables>(GetAgentsByIdsDocument, options);
      }
export function useGetAgentsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentsByIdsQuery, GetAgentsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentsByIdsQuery, GetAgentsByIdsQueryVariables>(GetAgentsByIdsDocument, options);
        }
export type GetAgentsByIdsQueryHookResult = ReturnType<typeof useGetAgentsByIdsQuery>;
export type GetAgentsByIdsLazyQueryHookResult = ReturnType<typeof useGetAgentsByIdsLazyQuery>;
export type GetAgentsByIdsQueryResult = Apollo.QueryResult<GetAgentsByIdsQuery, GetAgentsByIdsQueryVariables>;
export const GetAvailableApplicationsDocument = gql`
    query getAvailableApplications {
  availableApplications @rest(type: "KeycloakApplication", path: "administration/app-switcher/application") {
    ...KeycloakApplicationFields
  }
}
    ${KeycloakApplicationFieldsFragmentDoc}`;
export type GetAvailableApplicationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAvailableApplicationsQuery, GetAvailableApplicationsQueryVariables>, 'query'>;

    export const GetAvailableApplicationsComponent = (props: GetAvailableApplicationsComponentProps) => (
      <ApolloReactComponents.Query<GetAvailableApplicationsQuery, GetAvailableApplicationsQueryVariables> query={GetAvailableApplicationsDocument} {...props} />
    );
    

/**
 * __useGetAvailableApplicationsQuery__
 *
 * To run a query within a React component, call `useGetAvailableApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableApplicationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableApplicationsQuery, GetAvailableApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableApplicationsQuery, GetAvailableApplicationsQueryVariables>(GetAvailableApplicationsDocument, options);
      }
export function useGetAvailableApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableApplicationsQuery, GetAvailableApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableApplicationsQuery, GetAvailableApplicationsQueryVariables>(GetAvailableApplicationsDocument, options);
        }
export type GetAvailableApplicationsQueryHookResult = ReturnType<typeof useGetAvailableApplicationsQuery>;
export type GetAvailableApplicationsLazyQueryHookResult = ReturnType<typeof useGetAvailableApplicationsLazyQuery>;
export type GetAvailableApplicationsQueryResult = Apollo.QueryResult<GetAvailableApplicationsQuery, GetAvailableApplicationsQueryVariables>;
export const GetScheduleJobsInProgressDocument = gql`
    query getScheduleJobsInProgress {
  getScheduleJobsInProgress @rest(type: "ScheduleJobType", path: "auto-scheduler/schedule-jobs?state=IN_PROGRESS,IN_QUEUE") {
    ...ScheduleJobTypeFields
  }
}
    ${ScheduleJobTypeFieldsFragmentDoc}`;
export type GetScheduleJobsInProgressComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetScheduleJobsInProgressQuery, GetScheduleJobsInProgressQueryVariables>, 'query'>;

    export const GetScheduleJobsInProgressComponent = (props: GetScheduleJobsInProgressComponentProps) => (
      <ApolloReactComponents.Query<GetScheduleJobsInProgressQuery, GetScheduleJobsInProgressQueryVariables> query={GetScheduleJobsInProgressDocument} {...props} />
    );
    

/**
 * __useGetScheduleJobsInProgressQuery__
 *
 * To run a query within a React component, call `useGetScheduleJobsInProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleJobsInProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleJobsInProgressQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetScheduleJobsInProgressQuery(baseOptions?: Apollo.QueryHookOptions<GetScheduleJobsInProgressQuery, GetScheduleJobsInProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduleJobsInProgressQuery, GetScheduleJobsInProgressQueryVariables>(GetScheduleJobsInProgressDocument, options);
      }
export function useGetScheduleJobsInProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduleJobsInProgressQuery, GetScheduleJobsInProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduleJobsInProgressQuery, GetScheduleJobsInProgressQueryVariables>(GetScheduleJobsInProgressDocument, options);
        }
export type GetScheduleJobsInProgressQueryHookResult = ReturnType<typeof useGetScheduleJobsInProgressQuery>;
export type GetScheduleJobsInProgressLazyQueryHookResult = ReturnType<typeof useGetScheduleJobsInProgressLazyQuery>;
export type GetScheduleJobsInProgressQueryResult = Apollo.QueryResult<GetScheduleJobsInProgressQuery, GetScheduleJobsInProgressQueryVariables>;
export const GetScheduleJobsStateDocument = gql`
    query getScheduleJobsState($correlationId: ID, $state: String, $userId: ID) {
  getScheduleJobsState(
    correlationId: $correlationId
    state: $state
    userId: $userId
  ) @rest(type: "ScheduleJobType", path: "auto-scheduler/schedule-jobs?{args}") {
    ...ScheduleJobTypeFields
  }
}
    ${ScheduleJobTypeFieldsFragmentDoc}`;
export type GetScheduleJobsStateComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetScheduleJobsStateQuery, GetScheduleJobsStateQueryVariables>, 'query'>;

    export const GetScheduleJobsStateComponent = (props: GetScheduleJobsStateComponentProps) => (
      <ApolloReactComponents.Query<GetScheduleJobsStateQuery, GetScheduleJobsStateQueryVariables> query={GetScheduleJobsStateDocument} {...props} />
    );
    

/**
 * __useGetScheduleJobsStateQuery__
 *
 * To run a query within a React component, call `useGetScheduleJobsStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleJobsStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleJobsStateQuery({
 *   variables: {
 *      correlationId: // value for 'correlationId'
 *      state: // value for 'state'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetScheduleJobsStateQuery(baseOptions?: Apollo.QueryHookOptions<GetScheduleJobsStateQuery, GetScheduleJobsStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduleJobsStateQuery, GetScheduleJobsStateQueryVariables>(GetScheduleJobsStateDocument, options);
      }
export function useGetScheduleJobsStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduleJobsStateQuery, GetScheduleJobsStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduleJobsStateQuery, GetScheduleJobsStateQueryVariables>(GetScheduleJobsStateDocument, options);
        }
export type GetScheduleJobsStateQueryHookResult = ReturnType<typeof useGetScheduleJobsStateQuery>;
export type GetScheduleJobsStateLazyQueryHookResult = ReturnType<typeof useGetScheduleJobsStateLazyQuery>;
export type GetScheduleJobsStateQueryResult = Apollo.QueryResult<GetScheduleJobsStateQuery, GetScheduleJobsStateQueryVariables>;
export const CreateAutoScheduleJobDocument = gql`
    mutation createAutoScheduleJob($autoScheduleJob: AutoScheduleJobInput!) {
  createAutoScheduleJob(autoScheduleJob: $autoScheduleJob) @rest(bodyKey: "autoScheduleJob", method: "POST", path: "auto-scheduler/schedule-jobs", type: "CreateAutoScheduleJob") {
    ...ScheduleJobTypeFields
  }
}
    ${ScheduleJobTypeFieldsFragmentDoc}`;
export type CreateAutoScheduleJobMutationFn = Apollo.MutationFunction<CreateAutoScheduleJobMutation, CreateAutoScheduleJobMutationVariables>;
export type CreateAutoScheduleJobComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateAutoScheduleJobMutation, CreateAutoScheduleJobMutationVariables>, 'mutation'>;

    export const CreateAutoScheduleJobComponent = (props: CreateAutoScheduleJobComponentProps) => (
      <ApolloReactComponents.Mutation<CreateAutoScheduleJobMutation, CreateAutoScheduleJobMutationVariables> mutation={CreateAutoScheduleJobDocument} {...props} />
    );
    

/**
 * __useCreateAutoScheduleJobMutation__
 *
 * To run a mutation, you first call `useCreateAutoScheduleJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutoScheduleJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAutoScheduleJobMutation, { data, loading, error }] = useCreateAutoScheduleJobMutation({
 *   variables: {
 *      autoScheduleJob: // value for 'autoScheduleJob'
 *   },
 * });
 */
export function useCreateAutoScheduleJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateAutoScheduleJobMutation, CreateAutoScheduleJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAutoScheduleJobMutation, CreateAutoScheduleJobMutationVariables>(CreateAutoScheduleJobDocument, options);
      }
export type CreateAutoScheduleJobMutationHookResult = ReturnType<typeof useCreateAutoScheduleJobMutation>;
export type CreateAutoScheduleJobMutationResult = Apollo.MutationResult<CreateAutoScheduleJobMutation>;
export type CreateAutoScheduleJobMutationOptions = Apollo.BaseMutationOptions<CreateAutoScheduleJobMutation, CreateAutoScheduleJobMutationVariables>;
export const CalculateForecastDocument = gql`
    query calculateForecast($parameters: CalculateForecastInput!) {
  calculatedForecast(parameters: $parameters) @rest(type: "CalculatedForecastData", path: "forecasting/forecasts/recalculation/highcharts", method: "POST", bodyKey: "parameters") {
    ...CalculateForecastFields
  }
}
    ${CalculateForecastFieldsFragmentDoc}`;
export type CalculateForecastComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CalculateForecastQuery, CalculateForecastQueryVariables>, 'query'> & ({ variables: CalculateForecastQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CalculateForecastComponent = (props: CalculateForecastComponentProps) => (
      <ApolloReactComponents.Query<CalculateForecastQuery, CalculateForecastQueryVariables> query={CalculateForecastDocument} {...props} />
    );
    

/**
 * __useCalculateForecastQuery__
 *
 * To run a query within a React component, call `useCalculateForecastQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateForecastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateForecastQuery({
 *   variables: {
 *      parameters: // value for 'parameters'
 *   },
 * });
 */
export function useCalculateForecastQuery(baseOptions: Apollo.QueryHookOptions<CalculateForecastQuery, CalculateForecastQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateForecastQuery, CalculateForecastQueryVariables>(CalculateForecastDocument, options);
      }
export function useCalculateForecastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateForecastQuery, CalculateForecastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateForecastQuery, CalculateForecastQueryVariables>(CalculateForecastDocument, options);
        }
export type CalculateForecastQueryHookResult = ReturnType<typeof useCalculateForecastQuery>;
export type CalculateForecastLazyQueryHookResult = ReturnType<typeof useCalculateForecastLazyQuery>;
export type CalculateForecastQueryResult = Apollo.QueryResult<CalculateForecastQuery, CalculateForecastQueryVariables>;
export const CreateForecastDocument = gql`
    mutation CreateForecast($forecast: CalculateForecastInput!) {
  createForecast(forecast: $forecast) @rest(type: "CreateForecast", path: "forecasting/forecasts/calculation/highcharts", method: "POST", bodyKey: "forecast") {
    id
  }
}
    `;
export type CreateForecastMutationFn = Apollo.MutationFunction<CreateForecastMutation, CreateForecastMutationVariables>;
export type CreateForecastComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateForecastMutation, CreateForecastMutationVariables>, 'mutation'>;

    export const CreateForecastComponent = (props: CreateForecastComponentProps) => (
      <ApolloReactComponents.Mutation<CreateForecastMutation, CreateForecastMutationVariables> mutation={CreateForecastDocument} {...props} />
    );
    

/**
 * __useCreateForecastMutation__
 *
 * To run a mutation, you first call `useCreateForecastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateForecastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createForecastMutation, { data, loading, error }] = useCreateForecastMutation({
 *   variables: {
 *      forecast: // value for 'forecast'
 *   },
 * });
 */
export function useCreateForecastMutation(baseOptions?: Apollo.MutationHookOptions<CreateForecastMutation, CreateForecastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateForecastMutation, CreateForecastMutationVariables>(CreateForecastDocument, options);
      }
export type CreateForecastMutationHookResult = ReturnType<typeof useCreateForecastMutation>;
export type CreateForecastMutationResult = Apollo.MutationResult<CreateForecastMutation>;
export type CreateForecastMutationOptions = Apollo.BaseMutationOptions<CreateForecastMutation, CreateForecastMutationVariables>;
export const DeleteForecastDocument = gql`
    mutation DeleteForecast($id: ID!) {
  deleteForecast(id: $id) @rest(type: "DeleteForecast", path: "forecasting/forecasts/{args.id}", method: "DELETE") {
    id
  }
}
    `;
export type DeleteForecastMutationFn = Apollo.MutationFunction<DeleteForecastMutation, DeleteForecastMutationVariables>;
export type DeleteForecastComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteForecastMutation, DeleteForecastMutationVariables>, 'mutation'>;

    export const DeleteForecastComponent = (props: DeleteForecastComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteForecastMutation, DeleteForecastMutationVariables> mutation={DeleteForecastDocument} {...props} />
    );
    

/**
 * __useDeleteForecastMutation__
 *
 * To run a mutation, you first call `useDeleteForecastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteForecastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteForecastMutation, { data, loading, error }] = useDeleteForecastMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteForecastMutation(baseOptions?: Apollo.MutationHookOptions<DeleteForecastMutation, DeleteForecastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteForecastMutation, DeleteForecastMutationVariables>(DeleteForecastDocument, options);
      }
export type DeleteForecastMutationHookResult = ReturnType<typeof useDeleteForecastMutation>;
export type DeleteForecastMutationResult = Apollo.MutationResult<DeleteForecastMutation>;
export type DeleteForecastMutationOptions = Apollo.BaseMutationOptions<DeleteForecastMutation, DeleteForecastMutationVariables>;
export const DeleteForecastFromProductionDocument = gql`
    mutation DeleteForecastFromProduction($id: ID!) {
  deleteForecastFromProduction(id: $id) @rest(type: "DeleteForecastFromProduction", path: "forecasting/forecasts/production/{args.id}", method: "DELETE") {
    id
  }
}
    `;
export type DeleteForecastFromProductionMutationFn = Apollo.MutationFunction<DeleteForecastFromProductionMutation, DeleteForecastFromProductionMutationVariables>;
export type DeleteForecastFromProductionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteForecastFromProductionMutation, DeleteForecastFromProductionMutationVariables>, 'mutation'>;

    export const DeleteForecastFromProductionComponent = (props: DeleteForecastFromProductionComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteForecastFromProductionMutation, DeleteForecastFromProductionMutationVariables> mutation={DeleteForecastFromProductionDocument} {...props} />
    );
    

/**
 * __useDeleteForecastFromProductionMutation__
 *
 * To run a mutation, you first call `useDeleteForecastFromProductionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteForecastFromProductionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteForecastFromProductionMutation, { data, loading, error }] = useDeleteForecastFromProductionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteForecastFromProductionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteForecastFromProductionMutation, DeleteForecastFromProductionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteForecastFromProductionMutation, DeleteForecastFromProductionMutationVariables>(DeleteForecastFromProductionDocument, options);
      }
export type DeleteForecastFromProductionMutationHookResult = ReturnType<typeof useDeleteForecastFromProductionMutation>;
export type DeleteForecastFromProductionMutationResult = Apollo.MutationResult<DeleteForecastFromProductionMutation>;
export type DeleteForecastFromProductionMutationOptions = Apollo.BaseMutationOptions<DeleteForecastFromProductionMutation, DeleteForecastFromProductionMutationVariables>;
export const GetDataImportHistoryDocument = gql`
    query getDataImportHistory($limit: Int, $offset: Int) {
  dataImportHistory(max: $limit, first: $offset) @rest(type: "DataImport", path: "forecasting/historical-data/data-import-history?{args}") {
    dataImportHistoryRecords @type(name: DataImportHistoryRecord) {
      ...DataImportHistoryRecordFields
    }
    totalCount
  }
}
    ${DataImportHistoryRecordFieldsFragmentDoc}`;
export type GetDataImportHistoryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetDataImportHistoryQuery, GetDataImportHistoryQueryVariables>, 'query'>;

    export const GetDataImportHistoryComponent = (props: GetDataImportHistoryComponentProps) => (
      <ApolloReactComponents.Query<GetDataImportHistoryQuery, GetDataImportHistoryQueryVariables> query={GetDataImportHistoryDocument} {...props} />
    );
    

/**
 * __useGetDataImportHistoryQuery__
 *
 * To run a query within a React component, call `useGetDataImportHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataImportHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataImportHistoryQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetDataImportHistoryQuery(baseOptions?: Apollo.QueryHookOptions<GetDataImportHistoryQuery, GetDataImportHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataImportHistoryQuery, GetDataImportHistoryQueryVariables>(GetDataImportHistoryDocument, options);
      }
export function useGetDataImportHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataImportHistoryQuery, GetDataImportHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataImportHistoryQuery, GetDataImportHistoryQueryVariables>(GetDataImportHistoryDocument, options);
        }
export type GetDataImportHistoryQueryHookResult = ReturnType<typeof useGetDataImportHistoryQuery>;
export type GetDataImportHistoryLazyQueryHookResult = ReturnType<typeof useGetDataImportHistoryLazyQuery>;
export type GetDataImportHistoryQueryResult = Apollo.QueryResult<GetDataImportHistoryQuery, GetDataImportHistoryQueryVariables>;
export const GetForecastDocument = gql`
    query GetForecast($id: ID!) {
  forecast(id: $id) @rest(type: "GetForecast", path: "forecasting/forecasts/{args.id}/highcharts", method: "GET") {
    ...GetForecastFields
  }
}
    ${GetForecastFieldsFragmentDoc}`;
export type GetForecastComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetForecastQuery, GetForecastQueryVariables>, 'query'> & ({ variables: GetForecastQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetForecastComponent = (props: GetForecastComponentProps) => (
      <ApolloReactComponents.Query<GetForecastQuery, GetForecastQueryVariables> query={GetForecastDocument} {...props} />
    );
    

/**
 * __useGetForecastQuery__
 *
 * To run a query within a React component, call `useGetForecastQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetForecastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetForecastQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetForecastQuery(baseOptions: Apollo.QueryHookOptions<GetForecastQuery, GetForecastQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetForecastQuery, GetForecastQueryVariables>(GetForecastDocument, options);
      }
export function useGetForecastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetForecastQuery, GetForecastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetForecastQuery, GetForecastQueryVariables>(GetForecastDocument, options);
        }
export type GetForecastQueryHookResult = ReturnType<typeof useGetForecastQuery>;
export type GetForecastLazyQueryHookResult = ReturnType<typeof useGetForecastLazyQuery>;
export type GetForecastQueryResult = Apollo.QueryResult<GetForecastQuery, GetForecastQueryVariables>;
export const GetForecastsDocument = gql`
    query getForecasts($forecastStartDateTime: String!, $forecastEndDateTime: String!, $forecastName: String, $queueId: ID) {
  forecasts(
    forecastStartDateTime: $forecastStartDateTime
    forecastEndDateTime: $forecastEndDateTime
    forecastName: $forecastName
    queueId: $queueId
  ) @rest(type: "Forecast", path: "forecasting/forecasts?{args}") {
    ...ForecastFields
  }
  queues @rest(type: "Queue", path: "queue-management/queues") {
    ...QueueFields
  }
}
    ${ForecastFieldsFragmentDoc}
${QueueFieldsFragmentDoc}`;
export type GetForecastsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetForecastsQuery, GetForecastsQueryVariables>, 'query'> & ({ variables: GetForecastsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetForecastsComponent = (props: GetForecastsComponentProps) => (
      <ApolloReactComponents.Query<GetForecastsQuery, GetForecastsQueryVariables> query={GetForecastsDocument} {...props} />
    );
    

/**
 * __useGetForecastsQuery__
 *
 * To run a query within a React component, call `useGetForecastsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetForecastsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetForecastsQuery({
 *   variables: {
 *      forecastStartDateTime: // value for 'forecastStartDateTime'
 *      forecastEndDateTime: // value for 'forecastEndDateTime'
 *      forecastName: // value for 'forecastName'
 *      queueId: // value for 'queueId'
 *   },
 * });
 */
export function useGetForecastsQuery(baseOptions: Apollo.QueryHookOptions<GetForecastsQuery, GetForecastsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetForecastsQuery, GetForecastsQueryVariables>(GetForecastsDocument, options);
      }
export function useGetForecastsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetForecastsQuery, GetForecastsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetForecastsQuery, GetForecastsQueryVariables>(GetForecastsDocument, options);
        }
export type GetForecastsQueryHookResult = ReturnType<typeof useGetForecastsQuery>;
export type GetForecastsLazyQueryHookResult = ReturnType<typeof useGetForecastsLazyQuery>;
export type GetForecastsQueryResult = Apollo.QueryResult<GetForecastsQuery, GetForecastsQueryVariables>;
export const GetForecastsProductionDocument = gql`
    query getForecastsProduction($startDateTime: String!, $endDateTime: String!, $queueIds: ID!) {
  forecastsProduction(
    startDateTime: $startDateTime
    endDateTime: $endDateTime
    queueIds: $queueIds
  ) @rest(type: "ForecastProduction", path: "forecasting/forecasts/production?{args}") {
    ...ForecastProductionFields
  }
}
    ${ForecastProductionFieldsFragmentDoc}`;
export type GetForecastsProductionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetForecastsProductionQuery, GetForecastsProductionQueryVariables>, 'query'> & ({ variables: GetForecastsProductionQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetForecastsProductionComponent = (props: GetForecastsProductionComponentProps) => (
      <ApolloReactComponents.Query<GetForecastsProductionQuery, GetForecastsProductionQueryVariables> query={GetForecastsProductionDocument} {...props} />
    );
    

/**
 * __useGetForecastsProductionQuery__
 *
 * To run a query within a React component, call `useGetForecastsProductionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetForecastsProductionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetForecastsProductionQuery({
 *   variables: {
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      queueIds: // value for 'queueIds'
 *   },
 * });
 */
export function useGetForecastsProductionQuery(baseOptions: Apollo.QueryHookOptions<GetForecastsProductionQuery, GetForecastsProductionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetForecastsProductionQuery, GetForecastsProductionQueryVariables>(GetForecastsProductionDocument, options);
      }
export function useGetForecastsProductionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetForecastsProductionQuery, GetForecastsProductionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetForecastsProductionQuery, GetForecastsProductionQueryVariables>(GetForecastsProductionDocument, options);
        }
export type GetForecastsProductionQueryHookResult = ReturnType<typeof useGetForecastsProductionQuery>;
export type GetForecastsProductionLazyQueryHookResult = ReturnType<typeof useGetForecastsProductionLazyQuery>;
export type GetForecastsProductionQueryResult = Apollo.QueryResult<GetForecastsProductionQuery, GetForecastsProductionQueryVariables>;
export const GetForecastsIntradayDocument = gql`
    query getForecastsIntraday($startDateTime: String!, $endDateTime: String!, $queueIds: ID!) {
  forecastsIntraday(
    startDateTime: $startDateTime
    endDateTime: $endDateTime
    queueIds: $queueIds
  ) @rest(type: "ForecastProduction", path: "forecasting/intraday/v1/forecasts?{args}") {
    ...ForecastProductionFields
  }
}
    ${ForecastProductionFieldsFragmentDoc}`;
export type GetForecastsIntradayComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetForecastsIntradayQuery, GetForecastsIntradayQueryVariables>, 'query'> & ({ variables: GetForecastsIntradayQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetForecastsIntradayComponent = (props: GetForecastsIntradayComponentProps) => (
      <ApolloReactComponents.Query<GetForecastsIntradayQuery, GetForecastsIntradayQueryVariables> query={GetForecastsIntradayDocument} {...props} />
    );
    

/**
 * __useGetForecastsIntradayQuery__
 *
 * To run a query within a React component, call `useGetForecastsIntradayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetForecastsIntradayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetForecastsIntradayQuery({
 *   variables: {
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      queueIds: // value for 'queueIds'
 *   },
 * });
 */
export function useGetForecastsIntradayQuery(baseOptions: Apollo.QueryHookOptions<GetForecastsIntradayQuery, GetForecastsIntradayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetForecastsIntradayQuery, GetForecastsIntradayQueryVariables>(GetForecastsIntradayDocument, options);
      }
export function useGetForecastsIntradayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetForecastsIntradayQuery, GetForecastsIntradayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetForecastsIntradayQuery, GetForecastsIntradayQueryVariables>(GetForecastsIntradayDocument, options);
        }
export type GetForecastsIntradayQueryHookResult = ReturnType<typeof useGetForecastsIntradayQuery>;
export type GetForecastsIntradayLazyQueryHookResult = ReturnType<typeof useGetForecastsIntradayLazyQuery>;
export type GetForecastsIntradayQueryResult = Apollo.QueryResult<GetForecastsIntradayQuery, GetForecastsIntradayQueryVariables>;
export const PutForecastToProductionDocument = gql`
    mutation PutForecastToProduction($id: ID!) {
  putForecastToProduction(id: $id, input: {}) @rest(type: "PutForecastToProduction", path: "forecasting/forecasts/production/{args.id}", method: "PUT") {
    id
  }
}
    `;
export type PutForecastToProductionMutationFn = Apollo.MutationFunction<PutForecastToProductionMutation, PutForecastToProductionMutationVariables>;
export type PutForecastToProductionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<PutForecastToProductionMutation, PutForecastToProductionMutationVariables>, 'mutation'>;

    export const PutForecastToProductionComponent = (props: PutForecastToProductionComponentProps) => (
      <ApolloReactComponents.Mutation<PutForecastToProductionMutation, PutForecastToProductionMutationVariables> mutation={PutForecastToProductionDocument} {...props} />
    );
    

/**
 * __usePutForecastToProductionMutation__
 *
 * To run a mutation, you first call `usePutForecastToProductionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePutForecastToProductionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [putForecastToProductionMutation, { data, loading, error }] = usePutForecastToProductionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePutForecastToProductionMutation(baseOptions?: Apollo.MutationHookOptions<PutForecastToProductionMutation, PutForecastToProductionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PutForecastToProductionMutation, PutForecastToProductionMutationVariables>(PutForecastToProductionDocument, options);
      }
export type PutForecastToProductionMutationHookResult = ReturnType<typeof usePutForecastToProductionMutation>;
export type PutForecastToProductionMutationResult = Apollo.MutationResult<PutForecastToProductionMutation>;
export type PutForecastToProductionMutationOptions = Apollo.BaseMutationOptions<PutForecastToProductionMutation, PutForecastToProductionMutationVariables>;
export const QueueHistoryRangeDocument = gql`
    query QueueHistoryRange($queueId: ID!) {
  queueHistoryRange(queueId: $queueId) @rest(type: "DateTimeRange", path: "forecasting/historical-data/queue-history-range/{args.queueId}", method: "GET") {
    ...DateTimeRangeFields
  }
}
    ${DateTimeRangeFieldsFragmentDoc}`;
export type QueueHistoryRangeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<QueueHistoryRangeQuery, QueueHistoryRangeQueryVariables>, 'query'> & ({ variables: QueueHistoryRangeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const QueueHistoryRangeComponent = (props: QueueHistoryRangeComponentProps) => (
      <ApolloReactComponents.Query<QueueHistoryRangeQuery, QueueHistoryRangeQueryVariables> query={QueueHistoryRangeDocument} {...props} />
    );
    

/**
 * __useQueueHistoryRangeQuery__
 *
 * To run a query within a React component, call `useQueueHistoryRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueueHistoryRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueueHistoryRangeQuery({
 *   variables: {
 *      queueId: // value for 'queueId'
 *   },
 * });
 */
export function useQueueHistoryRangeQuery(baseOptions: Apollo.QueryHookOptions<QueueHistoryRangeQuery, QueueHistoryRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueueHistoryRangeQuery, QueueHistoryRangeQueryVariables>(QueueHistoryRangeDocument, options);
      }
export function useQueueHistoryRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueueHistoryRangeQuery, QueueHistoryRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueueHistoryRangeQuery, QueueHistoryRangeQueryVariables>(QueueHistoryRangeDocument, options);
        }
export type QueueHistoryRangeQueryHookResult = ReturnType<typeof useQueueHistoryRangeQuery>;
export type QueueHistoryRangeLazyQueryHookResult = ReturnType<typeof useQueueHistoryRangeLazyQuery>;
export type QueueHistoryRangeQueryResult = Apollo.QueryResult<QueueHistoryRangeQuery, QueueHistoryRangeQueryVariables>;
export const UpdateForecastDocument = gql`
    mutation UpdateForecast($id: ID!, $forecast: CalculateForecastInput!) {
  updateForecast(id: $id, forecast: $forecast) @rest(type: "UpdateForecast", path: "forecasting/forecasts/calculation/{args.id}/highcharts", method: "PUT", bodyKey: "forecast") {
    id
  }
}
    `;
export type UpdateForecastMutationFn = Apollo.MutationFunction<UpdateForecastMutation, UpdateForecastMutationVariables>;
export type UpdateForecastComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateForecastMutation, UpdateForecastMutationVariables>, 'mutation'>;

    export const UpdateForecastComponent = (props: UpdateForecastComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateForecastMutation, UpdateForecastMutationVariables> mutation={UpdateForecastDocument} {...props} />
    );
    

/**
 * __useUpdateForecastMutation__
 *
 * To run a mutation, you first call `useUpdateForecastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateForecastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateForecastMutation, { data, loading, error }] = useUpdateForecastMutation({
 *   variables: {
 *      id: // value for 'id'
 *      forecast: // value for 'forecast'
 *   },
 * });
 */
export function useUpdateForecastMutation(baseOptions?: Apollo.MutationHookOptions<UpdateForecastMutation, UpdateForecastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateForecastMutation, UpdateForecastMutationVariables>(UpdateForecastDocument, options);
      }
export type UpdateForecastMutationHookResult = ReturnType<typeof useUpdateForecastMutation>;
export type UpdateForecastMutationResult = Apollo.MutationResult<UpdateForecastMutation>;
export type UpdateForecastMutationOptions = Apollo.BaseMutationOptions<UpdateForecastMutation, UpdateForecastMutationVariables>;
export const UpdateForecastNameDocument = gql`
    mutation UpdateForecastName($id: ID!, $name: String!) {
  updateForecastName(id: $id, name: $name) @rest(type: "UpdateForecastName", path: "forecasting/forecasts/name/{args.id}?name={args.name}", method: "PUT", bodyKey: "name") {
    id
  }
}
    `;
export type UpdateForecastNameMutationFn = Apollo.MutationFunction<UpdateForecastNameMutation, UpdateForecastNameMutationVariables>;
export type UpdateForecastNameComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateForecastNameMutation, UpdateForecastNameMutationVariables>, 'mutation'>;

    export const UpdateForecastNameComponent = (props: UpdateForecastNameComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateForecastNameMutation, UpdateForecastNameMutationVariables> mutation={UpdateForecastNameDocument} {...props} />
    );
    

/**
 * __useUpdateForecastNameMutation__
 *
 * To run a mutation, you first call `useUpdateForecastNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateForecastNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateForecastNameMutation, { data, loading, error }] = useUpdateForecastNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateForecastNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateForecastNameMutation, UpdateForecastNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateForecastNameMutation, UpdateForecastNameMutationVariables>(UpdateForecastNameDocument, options);
      }
export type UpdateForecastNameMutationHookResult = ReturnType<typeof useUpdateForecastNameMutation>;
export type UpdateForecastNameMutationResult = Apollo.MutationResult<UpdateForecastNameMutation>;
export type UpdateForecastNameMutationOptions = Apollo.BaseMutationOptions<UpdateForecastNameMutation, UpdateForecastNameMutationVariables>;
export const GetIntradayQueuesListDocument = gql`
    query GetIntradayQueuesList {
  intradayQueuesList @rest(type: "IntradayQueue", path: "forecasting/intraday/v1/measurements/queues") {
    ...IntradayQueueFields
  }
}
    ${IntradayQueueFieldsFragmentDoc}`;
export type GetIntradayQueuesListComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetIntradayQueuesListQuery, GetIntradayQueuesListQueryVariables>, 'query'>;

    export const GetIntradayQueuesListComponent = (props: GetIntradayQueuesListComponentProps) => (
      <ApolloReactComponents.Query<GetIntradayQueuesListQuery, GetIntradayQueuesListQueryVariables> query={GetIntradayQueuesListDocument} {...props} />
    );
    

/**
 * __useGetIntradayQueuesListQuery__
 *
 * To run a query within a React component, call `useGetIntradayQueuesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntradayQueuesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntradayQueuesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntradayQueuesListQuery(baseOptions?: Apollo.QueryHookOptions<GetIntradayQueuesListQuery, GetIntradayQueuesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntradayQueuesListQuery, GetIntradayQueuesListQueryVariables>(GetIntradayQueuesListDocument, options);
      }
export function useGetIntradayQueuesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntradayQueuesListQuery, GetIntradayQueuesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntradayQueuesListQuery, GetIntradayQueuesListQueryVariables>(GetIntradayQueuesListDocument, options);
        }
export type GetIntradayQueuesListQueryHookResult = ReturnType<typeof useGetIntradayQueuesListQuery>;
export type GetIntradayQueuesListLazyQueryHookResult = ReturnType<typeof useGetIntradayQueuesListLazyQuery>;
export type GetIntradayQueuesListQueryResult = Apollo.QueryResult<GetIntradayQueuesListQuery, GetIntradayQueuesListQueryVariables>;
export const GetIntradayNotificationsDocument = gql`
    query GetIntradayNotifications {
  intradayNotifications @rest(type: "IntradayQueueNotification", path: "forecasting/intraday/v1/notification/queues") {
    ...IntradayQueueNotificationFields
  }
}
    ${IntradayQueueNotificationFieldsFragmentDoc}`;
export type GetIntradayNotificationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetIntradayNotificationsQuery, GetIntradayNotificationsQueryVariables>, 'query'>;

    export const GetIntradayNotificationsComponent = (props: GetIntradayNotificationsComponentProps) => (
      <ApolloReactComponents.Query<GetIntradayNotificationsQuery, GetIntradayNotificationsQueryVariables> query={GetIntradayNotificationsDocument} {...props} />
    );
    

/**
 * __useGetIntradayNotificationsQuery__
 *
 * To run a query within a React component, call `useGetIntradayNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntradayNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntradayNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntradayNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetIntradayNotificationsQuery, GetIntradayNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntradayNotificationsQuery, GetIntradayNotificationsQueryVariables>(GetIntradayNotificationsDocument, options);
      }
export function useGetIntradayNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntradayNotificationsQuery, GetIntradayNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntradayNotificationsQuery, GetIntradayNotificationsQueryVariables>(GetIntradayNotificationsDocument, options);
        }
export type GetIntradayNotificationsQueryHookResult = ReturnType<typeof useGetIntradayNotificationsQuery>;
export type GetIntradayNotificationsLazyQueryHookResult = ReturnType<typeof useGetIntradayNotificationsLazyQuery>;
export type GetIntradayNotificationsQueryResult = Apollo.QueryResult<GetIntradayNotificationsQuery, GetIntradayNotificationsQueryVariables>;
export const CreateIntradayNotificationDocument = gql`
    mutation CreateIntradayNotification($intradayQueueNotification: IntradayQueueNotificationInput!) {
  createIntradayQueueNotification(
    intradayQueueNotification: $intradayQueueNotification
  ) @rest(type: "CreateIntradayQueueNotification", path: "forecasting/intraday/v1/notification/queues", method: "POST", bodyKey: "intradayQueueNotification") {
    id
  }
}
    `;
export type CreateIntradayNotificationMutationFn = Apollo.MutationFunction<CreateIntradayNotificationMutation, CreateIntradayNotificationMutationVariables>;
export type CreateIntradayNotificationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateIntradayNotificationMutation, CreateIntradayNotificationMutationVariables>, 'mutation'>;

    export const CreateIntradayNotificationComponent = (props: CreateIntradayNotificationComponentProps) => (
      <ApolloReactComponents.Mutation<CreateIntradayNotificationMutation, CreateIntradayNotificationMutationVariables> mutation={CreateIntradayNotificationDocument} {...props} />
    );
    

/**
 * __useCreateIntradayNotificationMutation__
 *
 * To run a mutation, you first call `useCreateIntradayNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIntradayNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIntradayNotificationMutation, { data, loading, error }] = useCreateIntradayNotificationMutation({
 *   variables: {
 *      intradayQueueNotification: // value for 'intradayQueueNotification'
 *   },
 * });
 */
export function useCreateIntradayNotificationMutation(baseOptions?: Apollo.MutationHookOptions<CreateIntradayNotificationMutation, CreateIntradayNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIntradayNotificationMutation, CreateIntradayNotificationMutationVariables>(CreateIntradayNotificationDocument, options);
      }
export type CreateIntradayNotificationMutationHookResult = ReturnType<typeof useCreateIntradayNotificationMutation>;
export type CreateIntradayNotificationMutationResult = Apollo.MutationResult<CreateIntradayNotificationMutation>;
export type CreateIntradayNotificationMutationOptions = Apollo.BaseMutationOptions<CreateIntradayNotificationMutation, CreateIntradayNotificationMutationVariables>;
export const UpdateIntradayNotificationDocument = gql`
    mutation UpdateIntradayNotification($intradayQueueNotification: IntradayQueueNotificationInput!) {
  updateIntradayQueueNotification(
    intradayQueueNotification: $intradayQueueNotification
  ) @rest(type: "UpdateIntradayQueueNotification", path: "forecasting/intraday/v1/notification/queues", method: "PUT", bodyKey: "intradayQueueNotification") {
    id
  }
}
    `;
export type UpdateIntradayNotificationMutationFn = Apollo.MutationFunction<UpdateIntradayNotificationMutation, UpdateIntradayNotificationMutationVariables>;
export type UpdateIntradayNotificationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateIntradayNotificationMutation, UpdateIntradayNotificationMutationVariables>, 'mutation'>;

    export const UpdateIntradayNotificationComponent = (props: UpdateIntradayNotificationComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateIntradayNotificationMutation, UpdateIntradayNotificationMutationVariables> mutation={UpdateIntradayNotificationDocument} {...props} />
    );
    

/**
 * __useUpdateIntradayNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateIntradayNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntradayNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntradayNotificationMutation, { data, loading, error }] = useUpdateIntradayNotificationMutation({
 *   variables: {
 *      intradayQueueNotification: // value for 'intradayQueueNotification'
 *   },
 * });
 */
export function useUpdateIntradayNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIntradayNotificationMutation, UpdateIntradayNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIntradayNotificationMutation, UpdateIntradayNotificationMutationVariables>(UpdateIntradayNotificationDocument, options);
      }
export type UpdateIntradayNotificationMutationHookResult = ReturnType<typeof useUpdateIntradayNotificationMutation>;
export type UpdateIntradayNotificationMutationResult = Apollo.MutationResult<UpdateIntradayNotificationMutation>;
export type UpdateIntradayNotificationMutationOptions = Apollo.BaseMutationOptions<UpdateIntradayNotificationMutation, UpdateIntradayNotificationMutationVariables>;
export const DeleteIntradayNotificationDocument = gql`
    mutation DeleteIntradayNotification($queueId: ID!) {
  deleteIntradayQueueNotification(queueId: $queueId) @rest(type: "DeleteIntradayQueueNotification", path: "forecasting/intraday/v1/notification/queues/{args.queueId}", method: "DELETE") {
    id
  }
}
    `;
export type DeleteIntradayNotificationMutationFn = Apollo.MutationFunction<DeleteIntradayNotificationMutation, DeleteIntradayNotificationMutationVariables>;
export type DeleteIntradayNotificationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteIntradayNotificationMutation, DeleteIntradayNotificationMutationVariables>, 'mutation'>;

    export const DeleteIntradayNotificationComponent = (props: DeleteIntradayNotificationComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteIntradayNotificationMutation, DeleteIntradayNotificationMutationVariables> mutation={DeleteIntradayNotificationDocument} {...props} />
    );
    

/**
 * __useDeleteIntradayNotificationMutation__
 *
 * To run a mutation, you first call `useDeleteIntradayNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIntradayNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIntradayNotificationMutation, { data, loading, error }] = useDeleteIntradayNotificationMutation({
 *   variables: {
 *      queueId: // value for 'queueId'
 *   },
 * });
 */
export function useDeleteIntradayNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIntradayNotificationMutation, DeleteIntradayNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIntradayNotificationMutation, DeleteIntradayNotificationMutationVariables>(DeleteIntradayNotificationDocument, options);
      }
export type DeleteIntradayNotificationMutationHookResult = ReturnType<typeof useDeleteIntradayNotificationMutation>;
export type DeleteIntradayNotificationMutationResult = Apollo.MutationResult<DeleteIntradayNotificationMutation>;
export type DeleteIntradayNotificationMutationOptions = Apollo.BaseMutationOptions<DeleteIntradayNotificationMutation, DeleteIntradayNotificationMutationVariables>;
export const GetIntradayPushNotificationOnOffSettingDocument = gql`
    query GetIntradayPushNotificationOnOffSetting {
  intradayPushNotificationOnOffSetting @rest(type: "IntradayPushNotificationSetting", path: "forecasting/intraday/v1/notification/settings") {
    ...IntradayPushNotificationSettingFields
  }
}
    ${IntradayPushNotificationSettingFieldsFragmentDoc}`;
export type GetIntradayPushNotificationOnOffSettingComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetIntradayPushNotificationOnOffSettingQuery, GetIntradayPushNotificationOnOffSettingQueryVariables>, 'query'>;

    export const GetIntradayPushNotificationOnOffSettingComponent = (props: GetIntradayPushNotificationOnOffSettingComponentProps) => (
      <ApolloReactComponents.Query<GetIntradayPushNotificationOnOffSettingQuery, GetIntradayPushNotificationOnOffSettingQueryVariables> query={GetIntradayPushNotificationOnOffSettingDocument} {...props} />
    );
    

/**
 * __useGetIntradayPushNotificationOnOffSettingQuery__
 *
 * To run a query within a React component, call `useGetIntradayPushNotificationOnOffSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntradayPushNotificationOnOffSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntradayPushNotificationOnOffSettingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntradayPushNotificationOnOffSettingQuery(baseOptions?: Apollo.QueryHookOptions<GetIntradayPushNotificationOnOffSettingQuery, GetIntradayPushNotificationOnOffSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntradayPushNotificationOnOffSettingQuery, GetIntradayPushNotificationOnOffSettingQueryVariables>(GetIntradayPushNotificationOnOffSettingDocument, options);
      }
export function useGetIntradayPushNotificationOnOffSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntradayPushNotificationOnOffSettingQuery, GetIntradayPushNotificationOnOffSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntradayPushNotificationOnOffSettingQuery, GetIntradayPushNotificationOnOffSettingQueryVariables>(GetIntradayPushNotificationOnOffSettingDocument, options);
        }
export type GetIntradayPushNotificationOnOffSettingQueryHookResult = ReturnType<typeof useGetIntradayPushNotificationOnOffSettingQuery>;
export type GetIntradayPushNotificationOnOffSettingLazyQueryHookResult = ReturnType<typeof useGetIntradayPushNotificationOnOffSettingLazyQuery>;
export type GetIntradayPushNotificationOnOffSettingQueryResult = Apollo.QueryResult<GetIntradayPushNotificationOnOffSettingQuery, GetIntradayPushNotificationOnOffSettingQueryVariables>;
export const UpdateIntradayPushNotificationOnOffSettingDocument = gql`
    mutation UpdateIntradayPushNotificationOnOffSetting($intradayPushNotificationSetting: IntradayPushNotificationSettingInput!) {
  updateIntradayPushNotificationOnOffSetting(
    intradayPushNotificationSetting: $intradayPushNotificationSetting
  ) @rest(type: "IdOrEmptyResponse", path: "forecasting/intraday/v1/notification/settings", method: "PUT", bodyKey: "intradayPushNotificationSetting") {
    id
  }
}
    `;
export type UpdateIntradayPushNotificationOnOffSettingMutationFn = Apollo.MutationFunction<UpdateIntradayPushNotificationOnOffSettingMutation, UpdateIntradayPushNotificationOnOffSettingMutationVariables>;
export type UpdateIntradayPushNotificationOnOffSettingComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateIntradayPushNotificationOnOffSettingMutation, UpdateIntradayPushNotificationOnOffSettingMutationVariables>, 'mutation'>;

    export const UpdateIntradayPushNotificationOnOffSettingComponent = (props: UpdateIntradayPushNotificationOnOffSettingComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateIntradayPushNotificationOnOffSettingMutation, UpdateIntradayPushNotificationOnOffSettingMutationVariables> mutation={UpdateIntradayPushNotificationOnOffSettingDocument} {...props} />
    );
    

/**
 * __useUpdateIntradayPushNotificationOnOffSettingMutation__
 *
 * To run a mutation, you first call `useUpdateIntradayPushNotificationOnOffSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntradayPushNotificationOnOffSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntradayPushNotificationOnOffSettingMutation, { data, loading, error }] = useUpdateIntradayPushNotificationOnOffSettingMutation({
 *   variables: {
 *      intradayPushNotificationSetting: // value for 'intradayPushNotificationSetting'
 *   },
 * });
 */
export function useUpdateIntradayPushNotificationOnOffSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIntradayPushNotificationOnOffSettingMutation, UpdateIntradayPushNotificationOnOffSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIntradayPushNotificationOnOffSettingMutation, UpdateIntradayPushNotificationOnOffSettingMutationVariables>(UpdateIntradayPushNotificationOnOffSettingDocument, options);
      }
export type UpdateIntradayPushNotificationOnOffSettingMutationHookResult = ReturnType<typeof useUpdateIntradayPushNotificationOnOffSettingMutation>;
export type UpdateIntradayPushNotificationOnOffSettingMutationResult = Apollo.MutationResult<UpdateIntradayPushNotificationOnOffSettingMutation>;
export type UpdateIntradayPushNotificationOnOffSettingMutationOptions = Apollo.BaseMutationOptions<UpdateIntradayPushNotificationOnOffSettingMutation, UpdateIntradayPushNotificationOnOffSettingMutationVariables>;
export const GetIntradayPerQueueDataDocument = gql`
    query GetIntradayPerQueueData($queueId: ID!) {
  intradayPerQueueData(queueId: $queueId) @rest(type: "IntradayPerQueue", path: "forecasting/intraday/v1/measurements/queues/{args.queueId}/highcharts") {
    ...IntradayPerQueueFields
  }
}
    ${IntradayPerQueueFieldsFragmentDoc}`;
export type GetIntradayPerQueueDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetIntradayPerQueueDataQuery, GetIntradayPerQueueDataQueryVariables>, 'query'> & ({ variables: GetIntradayPerQueueDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetIntradayPerQueueDataComponent = (props: GetIntradayPerQueueDataComponentProps) => (
      <ApolloReactComponents.Query<GetIntradayPerQueueDataQuery, GetIntradayPerQueueDataQueryVariables> query={GetIntradayPerQueueDataDocument} {...props} />
    );
    

/**
 * __useGetIntradayPerQueueDataQuery__
 *
 * To run a query within a React component, call `useGetIntradayPerQueueDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntradayPerQueueDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntradayPerQueueDataQuery({
 *   variables: {
 *      queueId: // value for 'queueId'
 *   },
 * });
 */
export function useGetIntradayPerQueueDataQuery(baseOptions: Apollo.QueryHookOptions<GetIntradayPerQueueDataQuery, GetIntradayPerQueueDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntradayPerQueueDataQuery, GetIntradayPerQueueDataQueryVariables>(GetIntradayPerQueueDataDocument, options);
      }
export function useGetIntradayPerQueueDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntradayPerQueueDataQuery, GetIntradayPerQueueDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntradayPerQueueDataQuery, GetIntradayPerQueueDataQueryVariables>(GetIntradayPerQueueDataDocument, options);
        }
export type GetIntradayPerQueueDataQueryHookResult = ReturnType<typeof useGetIntradayPerQueueDataQuery>;
export type GetIntradayPerQueueDataLazyQueryHookResult = ReturnType<typeof useGetIntradayPerQueueDataLazyQuery>;
export type GetIntradayPerQueueDataQueryResult = Apollo.QueryResult<GetIntradayPerQueueDataQuery, GetIntradayPerQueueDataQueryVariables>;
export const GetNotificationSettingsDocument = gql`
    query GetNotificationSettings($userId: ID!, $types: String, $features: String) {
  notificationSettings(userId: $userId, types: $types, features: $features) @rest(type: "NotificationSettings", path: "notification/v1/users/{args.userId}/notification-settings?types={args.types}&features={args.features}") {
    ...NotificationSettingsFields
  }
}
    ${NotificationSettingsFieldsFragmentDoc}`;
export type GetNotificationSettingsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>, 'query'> & ({ variables: GetNotificationSettingsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetNotificationSettingsComponent = (props: GetNotificationSettingsComponentProps) => (
      <ApolloReactComponents.Query<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables> query={GetNotificationSettingsDocument} {...props} />
    );
    

/**
 * __useGetNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useGetNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationSettingsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      types: // value for 'types'
 *      features: // value for 'features'
 *   },
 * });
 */
export function useGetNotificationSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>(GetNotificationSettingsDocument, options);
      }
export function useGetNotificationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>(GetNotificationSettingsDocument, options);
        }
export type GetNotificationSettingsQueryHookResult = ReturnType<typeof useGetNotificationSettingsQuery>;
export type GetNotificationSettingsLazyQueryHookResult = ReturnType<typeof useGetNotificationSettingsLazyQuery>;
export type GetNotificationSettingsQueryResult = Apollo.QueryResult<GetNotificationSettingsQuery, GetNotificationSettingsQueryVariables>;
export const UpdateStateOfNotificationSettingsDocument = gql`
    mutation updateStateOfNotificationSettings($userId: ID!, $notificationSettingsId: ID!, $parameters: NotificationsSettingsUpdateInput!) {
  updateStateOfNotificationSettings(
    userId: $userId
    notificationSettingsId: $notificationSettingsId
    parameters: $parameters
  ) @rest(type: "NotificationSettings", path: "notification/v1/users/{args.userId}/notification-settings/{args.notificationSettingsId}", method: "PATCH", bodyKey: "parameters") {
    ...NotificationSettingsFields
  }
}
    ${NotificationSettingsFieldsFragmentDoc}`;
export type UpdateStateOfNotificationSettingsMutationFn = Apollo.MutationFunction<UpdateStateOfNotificationSettingsMutation, UpdateStateOfNotificationSettingsMutationVariables>;
export type UpdateStateOfNotificationSettingsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateStateOfNotificationSettingsMutation, UpdateStateOfNotificationSettingsMutationVariables>, 'mutation'>;

    export const UpdateStateOfNotificationSettingsComponent = (props: UpdateStateOfNotificationSettingsComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateStateOfNotificationSettingsMutation, UpdateStateOfNotificationSettingsMutationVariables> mutation={UpdateStateOfNotificationSettingsDocument} {...props} />
    );
    

/**
 * __useUpdateStateOfNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateStateOfNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStateOfNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStateOfNotificationSettingsMutation, { data, loading, error }] = useUpdateStateOfNotificationSettingsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      notificationSettingsId: // value for 'notificationSettingsId'
 *      parameters: // value for 'parameters'
 *   },
 * });
 */
export function useUpdateStateOfNotificationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStateOfNotificationSettingsMutation, UpdateStateOfNotificationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStateOfNotificationSettingsMutation, UpdateStateOfNotificationSettingsMutationVariables>(UpdateStateOfNotificationSettingsDocument, options);
      }
export type UpdateStateOfNotificationSettingsMutationHookResult = ReturnType<typeof useUpdateStateOfNotificationSettingsMutation>;
export type UpdateStateOfNotificationSettingsMutationResult = Apollo.MutationResult<UpdateStateOfNotificationSettingsMutation>;
export type UpdateStateOfNotificationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateStateOfNotificationSettingsMutation, UpdateStateOfNotificationSettingsMutationVariables>;
export const GetPublicVapidKeyDocument = gql`
    query GetPublicVapidKey {
  publicVapidKey @rest(type: "VapidKeys", path: "notification/v1/push-notifications/vapid-keys") {
    ...VapidKeysFields
  }
}
    ${VapidKeysFieldsFragmentDoc}`;
export type GetPublicVapidKeyComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPublicVapidKeyQuery, GetPublicVapidKeyQueryVariables>, 'query'>;

    export const GetPublicVapidKeyComponent = (props: GetPublicVapidKeyComponentProps) => (
      <ApolloReactComponents.Query<GetPublicVapidKeyQuery, GetPublicVapidKeyQueryVariables> query={GetPublicVapidKeyDocument} {...props} />
    );
    

/**
 * __useGetPublicVapidKeyQuery__
 *
 * To run a query within a React component, call `useGetPublicVapidKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicVapidKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicVapidKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPublicVapidKeyQuery(baseOptions?: Apollo.QueryHookOptions<GetPublicVapidKeyQuery, GetPublicVapidKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicVapidKeyQuery, GetPublicVapidKeyQueryVariables>(GetPublicVapidKeyDocument, options);
      }
export function useGetPublicVapidKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicVapidKeyQuery, GetPublicVapidKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicVapidKeyQuery, GetPublicVapidKeyQueryVariables>(GetPublicVapidKeyDocument, options);
        }
export type GetPublicVapidKeyQueryHookResult = ReturnType<typeof useGetPublicVapidKeyQuery>;
export type GetPublicVapidKeyLazyQueryHookResult = ReturnType<typeof useGetPublicVapidKeyLazyQuery>;
export type GetPublicVapidKeyQueryResult = Apollo.QueryResult<GetPublicVapidKeyQuery, GetPublicVapidKeyQueryVariables>;
export const CreateRtaPushSubscriptionDocument = gql`
    mutation CreateRtaPushSubscription($subscription: PushSubscriptionInput!) {
  createRtaPushSubscription(subscription: $subscription) @rest(type: "CreatePushSubscription", path: "notification/v1/push-notifications/domains/rta/subscribe", method: "PUT", bodyKey: "subscription") {
    ...PushSubscriptionFields
  }
}
    ${PushSubscriptionFieldsFragmentDoc}`;
export type CreateRtaPushSubscriptionMutationFn = Apollo.MutationFunction<CreateRtaPushSubscriptionMutation, CreateRtaPushSubscriptionMutationVariables>;
export type CreateRtaPushSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateRtaPushSubscriptionMutation, CreateRtaPushSubscriptionMutationVariables>, 'mutation'>;

    export const CreateRtaPushSubscriptionComponent = (props: CreateRtaPushSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<CreateRtaPushSubscriptionMutation, CreateRtaPushSubscriptionMutationVariables> mutation={CreateRtaPushSubscriptionDocument} {...props} />
    );
    

/**
 * __useCreateRtaPushSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateRtaPushSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRtaPushSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRtaPushSubscriptionMutation, { data, loading, error }] = useCreateRtaPushSubscriptionMutation({
 *   variables: {
 *      subscription: // value for 'subscription'
 *   },
 * });
 */
export function useCreateRtaPushSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateRtaPushSubscriptionMutation, CreateRtaPushSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRtaPushSubscriptionMutation, CreateRtaPushSubscriptionMutationVariables>(CreateRtaPushSubscriptionDocument, options);
      }
export type CreateRtaPushSubscriptionMutationHookResult = ReturnType<typeof useCreateRtaPushSubscriptionMutation>;
export type CreateRtaPushSubscriptionMutationResult = Apollo.MutationResult<CreateRtaPushSubscriptionMutation>;
export type CreateRtaPushSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateRtaPushSubscriptionMutation, CreateRtaPushSubscriptionMutationVariables>;
export const CreateIntradayPushSubscriptionDocument = gql`
    mutation CreateIntradayPushSubscription($subscription: PushSubscriptionInput!) {
  createIntradayPushSubscription(subscription: $subscription) @rest(type: "CreatePushSubscription", path: "notification/v1/push-notifications/domains/intraday/subscribe", method: "PUT", bodyKey: "subscription") {
    ...PushSubscriptionFields
  }
}
    ${PushSubscriptionFieldsFragmentDoc}`;
export type CreateIntradayPushSubscriptionMutationFn = Apollo.MutationFunction<CreateIntradayPushSubscriptionMutation, CreateIntradayPushSubscriptionMutationVariables>;
export type CreateIntradayPushSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateIntradayPushSubscriptionMutation, CreateIntradayPushSubscriptionMutationVariables>, 'mutation'>;

    export const CreateIntradayPushSubscriptionComponent = (props: CreateIntradayPushSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<CreateIntradayPushSubscriptionMutation, CreateIntradayPushSubscriptionMutationVariables> mutation={CreateIntradayPushSubscriptionDocument} {...props} />
    );
    

/**
 * __useCreateIntradayPushSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateIntradayPushSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIntradayPushSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIntradayPushSubscriptionMutation, { data, loading, error }] = useCreateIntradayPushSubscriptionMutation({
 *   variables: {
 *      subscription: // value for 'subscription'
 *   },
 * });
 */
export function useCreateIntradayPushSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateIntradayPushSubscriptionMutation, CreateIntradayPushSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIntradayPushSubscriptionMutation, CreateIntradayPushSubscriptionMutationVariables>(CreateIntradayPushSubscriptionDocument, options);
      }
export type CreateIntradayPushSubscriptionMutationHookResult = ReturnType<typeof useCreateIntradayPushSubscriptionMutation>;
export type CreateIntradayPushSubscriptionMutationResult = Apollo.MutationResult<CreateIntradayPushSubscriptionMutation>;
export type CreateIntradayPushSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateIntradayPushSubscriptionMutation, CreateIntradayPushSubscriptionMutationVariables>;
export const CreateQueueDocument = gql`
    mutation CreateQueue($queue: QueueInput!) {
  createQueue(queue: $queue) @rest(type: "QueueCreate", bodyKey: "queue", path: "queue-management/queues", method: "POST") {
    id
  }
}
    `;
export type CreateQueueMutationFn = Apollo.MutationFunction<CreateQueueMutation, CreateQueueMutationVariables>;
export type CreateQueueComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateQueueMutation, CreateQueueMutationVariables>, 'mutation'>;

    export const CreateQueueComponent = (props: CreateQueueComponentProps) => (
      <ApolloReactComponents.Mutation<CreateQueueMutation, CreateQueueMutationVariables> mutation={CreateQueueDocument} {...props} />
    );
    

/**
 * __useCreateQueueMutation__
 *
 * To run a mutation, you first call `useCreateQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQueueMutation, { data, loading, error }] = useCreateQueueMutation({
 *   variables: {
 *      queue: // value for 'queue'
 *   },
 * });
 */
export function useCreateQueueMutation(baseOptions?: Apollo.MutationHookOptions<CreateQueueMutation, CreateQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQueueMutation, CreateQueueMutationVariables>(CreateQueueDocument, options);
      }
export type CreateQueueMutationHookResult = ReturnType<typeof useCreateQueueMutation>;
export type CreateQueueMutationResult = Apollo.MutationResult<CreateQueueMutation>;
export type CreateQueueMutationOptions = Apollo.BaseMutationOptions<CreateQueueMutation, CreateQueueMutationVariables>;
export const GetQueuesDocument = gql`
    query getQueues($acdQueueIds: ID, $channelTypes: String, $historicalDataIntervals: String, $name: String, $skillIds: ID, $timezones: ID) {
  queues(
    acdQueueIds: $acdQueueIds
    channelTypes: $channelTypes
    historicalDataIntervals: $historicalDataIntervals
    name: $name
    skillIds: $skillIds
    timezones: $timezones
  ) @rest(type: "Queue", path: "queue-management/queues?{args}") {
    ...QueueFields
  }
}
    ${QueueFieldsFragmentDoc}`;
export type GetQueuesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetQueuesQuery, GetQueuesQueryVariables>, 'query'>;

    export const GetQueuesComponent = (props: GetQueuesComponentProps) => (
      <ApolloReactComponents.Query<GetQueuesQuery, GetQueuesQueryVariables> query={GetQueuesDocument} {...props} />
    );
    

/**
 * __useGetQueuesQuery__
 *
 * To run a query within a React component, call `useGetQueuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueuesQuery({
 *   variables: {
 *      acdQueueIds: // value for 'acdQueueIds'
 *      channelTypes: // value for 'channelTypes'
 *      historicalDataIntervals: // value for 'historicalDataIntervals'
 *      name: // value for 'name'
 *      skillIds: // value for 'skillIds'
 *      timezones: // value for 'timezones'
 *   },
 * });
 */
export function useGetQueuesQuery(baseOptions?: Apollo.QueryHookOptions<GetQueuesQuery, GetQueuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQueuesQuery, GetQueuesQueryVariables>(GetQueuesDocument, options);
      }
export function useGetQueuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQueuesQuery, GetQueuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQueuesQuery, GetQueuesQueryVariables>(GetQueuesDocument, options);
        }
export type GetQueuesQueryHookResult = ReturnType<typeof useGetQueuesQuery>;
export type GetQueuesLazyQueryHookResult = ReturnType<typeof useGetQueuesLazyQuery>;
export type GetQueuesQueryResult = Apollo.QueryResult<GetQueuesQuery, GetQueuesQueryVariables>;
export const GetQueueDocument = gql`
    query getQueue($id: ID!) {
  queue(id: $id) @rest(type: "Queue", path: "queue-management/queues/{args.id}") {
    ...QueueFields
  }
}
    ${QueueFieldsFragmentDoc}`;
export type GetQueueComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetQueueQuery, GetQueueQueryVariables>, 'query'> & ({ variables: GetQueueQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetQueueComponent = (props: GetQueueComponentProps) => (
      <ApolloReactComponents.Query<GetQueueQuery, GetQueueQueryVariables> query={GetQueueDocument} {...props} />
    );
    

/**
 * __useGetQueueQuery__
 *
 * To run a query within a React component, call `useGetQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueueQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetQueueQuery(baseOptions: Apollo.QueryHookOptions<GetQueueQuery, GetQueueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQueueQuery, GetQueueQueryVariables>(GetQueueDocument, options);
      }
export function useGetQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQueueQuery, GetQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQueueQuery, GetQueueQueryVariables>(GetQueueDocument, options);
        }
export type GetQueueQueryHookResult = ReturnType<typeof useGetQueueQuery>;
export type GetQueueLazyQueryHookResult = ReturnType<typeof useGetQueueLazyQuery>;
export type GetQueueQueryResult = Apollo.QueryResult<GetQueueQuery, GetQueueQueryVariables>;
export const GetQueuesTagsDocument = gql`
    query getQueuesTags {
  queuesTags @rest(type: "[ScheduleElementTag]", path: "queue-management/v1/queues/tags") {
    id
    value
  }
}
    `;
export type GetQueuesTagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetQueuesTagsQuery, GetQueuesTagsQueryVariables>, 'query'>;

    export const GetQueuesTagsComponent = (props: GetQueuesTagsComponentProps) => (
      <ApolloReactComponents.Query<GetQueuesTagsQuery, GetQueuesTagsQueryVariables> query={GetQueuesTagsDocument} {...props} />
    );
    

/**
 * __useGetQueuesTagsQuery__
 *
 * To run a query within a React component, call `useGetQueuesTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueuesTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueuesTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQueuesTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetQueuesTagsQuery, GetQueuesTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQueuesTagsQuery, GetQueuesTagsQueryVariables>(GetQueuesTagsDocument, options);
      }
export function useGetQueuesTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQueuesTagsQuery, GetQueuesTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQueuesTagsQuery, GetQueuesTagsQueryVariables>(GetQueuesTagsDocument, options);
        }
export type GetQueuesTagsQueryHookResult = ReturnType<typeof useGetQueuesTagsQuery>;
export type GetQueuesTagsLazyQueryHookResult = ReturnType<typeof useGetQueuesTagsLazyQuery>;
export type GetQueuesTagsQueryResult = Apollo.QueryResult<GetQueuesTagsQuery, GetQueuesTagsQueryVariables>;
export const UpdateQueueDocument = gql`
    mutation UpdateQueue($id: ID!, $queue: QueueInput!, $updateUsedQueue: Boolean = false) {
  updateQueue(id: $id, queue: $queue, updateUsedQueue: $updateUsedQueue) @rest(type: "QueueUpdate", bodyKey: "queue", path: "queue-management/queues/{args.id}?updateUsedQueue={args.updateUsedQueue}", method: "PUT") {
    id
  }
}
    `;
export type UpdateQueueMutationFn = Apollo.MutationFunction<UpdateQueueMutation, UpdateQueueMutationVariables>;
export type UpdateQueueComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateQueueMutation, UpdateQueueMutationVariables>, 'mutation'>;

    export const UpdateQueueComponent = (props: UpdateQueueComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateQueueMutation, UpdateQueueMutationVariables> mutation={UpdateQueueDocument} {...props} />
    );
    

/**
 * __useUpdateQueueMutation__
 *
 * To run a mutation, you first call `useUpdateQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQueueMutation, { data, loading, error }] = useUpdateQueueMutation({
 *   variables: {
 *      id: // value for 'id'
 *      queue: // value for 'queue'
 *      updateUsedQueue: // value for 'updateUsedQueue'
 *   },
 * });
 */
export function useUpdateQueueMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQueueMutation, UpdateQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQueueMutation, UpdateQueueMutationVariables>(UpdateQueueDocument, options);
      }
export type UpdateQueueMutationHookResult = ReturnType<typeof useUpdateQueueMutation>;
export type UpdateQueueMutationResult = Apollo.MutationResult<UpdateQueueMutation>;
export type UpdateQueueMutationOptions = Apollo.BaseMutationOptions<UpdateQueueMutation, UpdateQueueMutationVariables>;
export const DeleteQueueDocument = gql`
    mutation DeleteQueue($id: ID!) {
  deleteQueue(id: $id) @rest(type: "QueueDelete", path: "queue-management/queues/{args.id}", method: "DELETE") {
    id
  }
}
    `;
export type DeleteQueueMutationFn = Apollo.MutationFunction<DeleteQueueMutation, DeleteQueueMutationVariables>;
export type DeleteQueueComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteQueueMutation, DeleteQueueMutationVariables>, 'mutation'>;

    export const DeleteQueueComponent = (props: DeleteQueueComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteQueueMutation, DeleteQueueMutationVariables> mutation={DeleteQueueDocument} {...props} />
    );
    

/**
 * __useDeleteQueueMutation__
 *
 * To run a mutation, you first call `useDeleteQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQueueMutation, { data, loading, error }] = useDeleteQueueMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteQueueMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQueueMutation, DeleteQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQueueMutation, DeleteQueueMutationVariables>(DeleteQueueDocument, options);
      }
export type DeleteQueueMutationHookResult = ReturnType<typeof useDeleteQueueMutation>;
export type DeleteQueueMutationResult = Apollo.MutationResult<DeleteQueueMutation>;
export type DeleteQueueMutationOptions = Apollo.BaseMutationOptions<DeleteQueueMutation, DeleteQueueMutationVariables>;
export const GetAgentsReportsDocument = gql`
    query getAgentsReports($from: String!, $to: String!, $page: Int!, $pageSize: Int, $teamIds: String, $agentIds: String) {
  agentsReports(
    from: $from
    to: $to
    page: $page
    pageSize: $pageSize
    teamIds: $teamIds
    agentIds: $agentIds
  ) @rest(type: "AgentsReportsResult", path: "wfo-analytics-core/wfm/users/statistics?{args}") {
    ...AgentsReportsResultFields
  }
}
    ${AgentsReportsResultFieldsFragmentDoc}`;
export type GetAgentsReportsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAgentsReportsQuery, GetAgentsReportsQueryVariables>, 'query'> & ({ variables: GetAgentsReportsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAgentsReportsComponent = (props: GetAgentsReportsComponentProps) => (
      <ApolloReactComponents.Query<GetAgentsReportsQuery, GetAgentsReportsQueryVariables> query={GetAgentsReportsDocument} {...props} />
    );
    

/**
 * __useGetAgentsReportsQuery__
 *
 * To run a query within a React component, call `useGetAgentsReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentsReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentsReportsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      teamIds: // value for 'teamIds'
 *      agentIds: // value for 'agentIds'
 *   },
 * });
 */
export function useGetAgentsReportsQuery(baseOptions: Apollo.QueryHookOptions<GetAgentsReportsQuery, GetAgentsReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentsReportsQuery, GetAgentsReportsQueryVariables>(GetAgentsReportsDocument, options);
      }
export function useGetAgentsReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentsReportsQuery, GetAgentsReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentsReportsQuery, GetAgentsReportsQueryVariables>(GetAgentsReportsDocument, options);
        }
export type GetAgentsReportsQueryHookResult = ReturnType<typeof useGetAgentsReportsQuery>;
export type GetAgentsReportsLazyQueryHookResult = ReturnType<typeof useGetAgentsReportsLazyQuery>;
export type GetAgentsReportsQueryResult = Apollo.QueryResult<GetAgentsReportsQuery, GetAgentsReportsQueryVariables>;
export const GetTeamsReportsDocument = gql`
    query getTeamsReports($from: String!, $to: String!, $page: Int!, $pageSize: Int, $teamIds: String) {
  teamsReports(
    from: $from
    to: $to
    page: $page
    pageSize: $pageSize
    teamIds: $teamIds
  ) @rest(type: "TeamsReportsResult", path: "wfo-analytics-core/wfm/teams/statistics?{args}") {
    ...TeamsReportsResultFields
  }
}
    ${TeamsReportsResultFieldsFragmentDoc}`;
export type GetTeamsReportsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTeamsReportsQuery, GetTeamsReportsQueryVariables>, 'query'> & ({ variables: GetTeamsReportsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetTeamsReportsComponent = (props: GetTeamsReportsComponentProps) => (
      <ApolloReactComponents.Query<GetTeamsReportsQuery, GetTeamsReportsQueryVariables> query={GetTeamsReportsDocument} {...props} />
    );
    

/**
 * __useGetTeamsReportsQuery__
 *
 * To run a query within a React component, call `useGetTeamsReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamsReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamsReportsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      teamIds: // value for 'teamIds'
 *   },
 * });
 */
export function useGetTeamsReportsQuery(baseOptions: Apollo.QueryHookOptions<GetTeamsReportsQuery, GetTeamsReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamsReportsQuery, GetTeamsReportsQueryVariables>(GetTeamsReportsDocument, options);
      }
export function useGetTeamsReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamsReportsQuery, GetTeamsReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamsReportsQuery, GetTeamsReportsQueryVariables>(GetTeamsReportsDocument, options);
        }
export type GetTeamsReportsQueryHookResult = ReturnType<typeof useGetTeamsReportsQuery>;
export type GetTeamsReportsLazyQueryHookResult = ReturnType<typeof useGetTeamsReportsLazyQuery>;
export type GetTeamsReportsQueryResult = Apollo.QueryResult<GetTeamsReportsQuery, GetTeamsReportsQueryVariables>;
export const GetAdherenceHistoryBarChartDataDocument = gql`
    query GetAdherenceHistoryBarChartData($agentId: ID!, $startDateTime: String!, $endDateTime: String!, $timezone: String!) {
  adherenceHistoryBarChartData(
    agentId: $agentId
    startDateTime: $startDateTime
    endDateTime: $endDateTime
    timezone: $timezone
  ) @rest(type: "AdherenceHistoryBarChart", path: "scheduling/schedules/adherence/history/per-day/agent/{args.agentId}?{args}", method: "GET") {
    ...GetAdherenceHistoryBarChartFields
  }
}
    ${GetAdherenceHistoryBarChartFieldsFragmentDoc}`;
export type GetAdherenceHistoryBarChartDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAdherenceHistoryBarChartDataQuery, GetAdherenceHistoryBarChartDataQueryVariables>, 'query'> & ({ variables: GetAdherenceHistoryBarChartDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAdherenceHistoryBarChartDataComponent = (props: GetAdherenceHistoryBarChartDataComponentProps) => (
      <ApolloReactComponents.Query<GetAdherenceHistoryBarChartDataQuery, GetAdherenceHistoryBarChartDataQueryVariables> query={GetAdherenceHistoryBarChartDataDocument} {...props} />
    );
    

/**
 * __useGetAdherenceHistoryBarChartDataQuery__
 *
 * To run a query within a React component, call `useGetAdherenceHistoryBarChartDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdherenceHistoryBarChartDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdherenceHistoryBarChartDataQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useGetAdherenceHistoryBarChartDataQuery(baseOptions: Apollo.QueryHookOptions<GetAdherenceHistoryBarChartDataQuery, GetAdherenceHistoryBarChartDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdherenceHistoryBarChartDataQuery, GetAdherenceHistoryBarChartDataQueryVariables>(GetAdherenceHistoryBarChartDataDocument, options);
      }
export function useGetAdherenceHistoryBarChartDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdherenceHistoryBarChartDataQuery, GetAdherenceHistoryBarChartDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdherenceHistoryBarChartDataQuery, GetAdherenceHistoryBarChartDataQueryVariables>(GetAdherenceHistoryBarChartDataDocument, options);
        }
export type GetAdherenceHistoryBarChartDataQueryHookResult = ReturnType<typeof useGetAdherenceHistoryBarChartDataQuery>;
export type GetAdherenceHistoryBarChartDataLazyQueryHookResult = ReturnType<typeof useGetAdherenceHistoryBarChartDataLazyQuery>;
export type GetAdherenceHistoryBarChartDataQueryResult = Apollo.QueryResult<GetAdherenceHistoryBarChartDataQuery, GetAdherenceHistoryBarChartDataQueryVariables>;
export const GetAdherenceHistoryGanttChartDataDocument = gql`
    query GetAdherenceHistoryGanttChartData($agentId: ID!, $endDateTime: String!, $startDateTime: String!, $timezone: String!) {
  adherenceHistoryGanttChartData(
    agentId: $agentId
    endDateTime: $endDateTime
    startDateTime: $startDateTime
    timezone: $timezone
  ) @rest(type: "AdherenceHistoryGanttChart", path: "scheduling/schedules/adherence/history/day-details/agent/{args.agentId}?{args}", method: "GET") {
    ...GetAdherenceHistoryGanttChartFields
  }
}
    ${GetAdherenceHistoryGanttChartFieldsFragmentDoc}`;
export type GetAdherenceHistoryGanttChartDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAdherenceHistoryGanttChartDataQuery, GetAdherenceHistoryGanttChartDataQueryVariables>, 'query'> & ({ variables: GetAdherenceHistoryGanttChartDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAdherenceHistoryGanttChartDataComponent = (props: GetAdherenceHistoryGanttChartDataComponentProps) => (
      <ApolloReactComponents.Query<GetAdherenceHistoryGanttChartDataQuery, GetAdherenceHistoryGanttChartDataQueryVariables> query={GetAdherenceHistoryGanttChartDataDocument} {...props} />
    );
    

/**
 * __useGetAdherenceHistoryGanttChartDataQuery__
 *
 * To run a query within a React component, call `useGetAdherenceHistoryGanttChartDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdherenceHistoryGanttChartDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdherenceHistoryGanttChartDataQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      endDateTime: // value for 'endDateTime'
 *      startDateTime: // value for 'startDateTime'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useGetAdherenceHistoryGanttChartDataQuery(baseOptions: Apollo.QueryHookOptions<GetAdherenceHistoryGanttChartDataQuery, GetAdherenceHistoryGanttChartDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdherenceHistoryGanttChartDataQuery, GetAdherenceHistoryGanttChartDataQueryVariables>(GetAdherenceHistoryGanttChartDataDocument, options);
      }
export function useGetAdherenceHistoryGanttChartDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdherenceHistoryGanttChartDataQuery, GetAdherenceHistoryGanttChartDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdherenceHistoryGanttChartDataQuery, GetAdherenceHistoryGanttChartDataQueryVariables>(GetAdherenceHistoryGanttChartDataDocument, options);
        }
export type GetAdherenceHistoryGanttChartDataQueryHookResult = ReturnType<typeof useGetAdherenceHistoryGanttChartDataQuery>;
export type GetAdherenceHistoryGanttChartDataLazyQueryHookResult = ReturnType<typeof useGetAdherenceHistoryGanttChartDataLazyQuery>;
export type GetAdherenceHistoryGanttChartDataQueryResult = Apollo.QueryResult<GetAdherenceHistoryGanttChartDataQuery, GetAdherenceHistoryGanttChartDataQueryVariables>;
export const GetAdherenceLastImportDocument = gql`
    query GetAdherenceLastImport($status: Int) {
  adherenceLastImport(status: $status) @rest(type: "AdherenceLastImport", path: "scheduling/adherence/last-processing?{args}", method: "GET") {
    dateTime
  }
}
    `;
export type GetAdherenceLastImportComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAdherenceLastImportQuery, GetAdherenceLastImportQueryVariables>, 'query'>;

    export const GetAdherenceLastImportComponent = (props: GetAdherenceLastImportComponentProps) => (
      <ApolloReactComponents.Query<GetAdherenceLastImportQuery, GetAdherenceLastImportQueryVariables> query={GetAdherenceLastImportDocument} {...props} />
    );
    

/**
 * __useGetAdherenceLastImportQuery__
 *
 * To run a query within a React component, call `useGetAdherenceLastImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdherenceLastImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdherenceLastImportQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetAdherenceLastImportQuery(baseOptions?: Apollo.QueryHookOptions<GetAdherenceLastImportQuery, GetAdherenceLastImportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdherenceLastImportQuery, GetAdherenceLastImportQueryVariables>(GetAdherenceLastImportDocument, options);
      }
export function useGetAdherenceLastImportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdherenceLastImportQuery, GetAdherenceLastImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdherenceLastImportQuery, GetAdherenceLastImportQueryVariables>(GetAdherenceLastImportDocument, options);
        }
export type GetAdherenceLastImportQueryHookResult = ReturnType<typeof useGetAdherenceLastImportQuery>;
export type GetAdherenceLastImportLazyQueryHookResult = ReturnType<typeof useGetAdherenceLastImportLazyQuery>;
export type GetAdherenceLastImportQueryResult = Apollo.QueryResult<GetAdherenceLastImportQuery, GetAdherenceLastImportQueryVariables>;
export const GetAdherenceNotificationSetupDocument = gql`
    query getAdherenceNotificationSetup {
  adherenceNotificationSetup @rest(type: "AdherenceNotificationType", path: "rta-calculator/v1/delayed-notifications/thresholds") {
    ...AdherenceNotificationFields
  }
}
    ${AdherenceNotificationFieldsFragmentDoc}`;
export type GetAdherenceNotificationSetupComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAdherenceNotificationSetupQuery, GetAdherenceNotificationSetupQueryVariables>, 'query'>;

    export const GetAdherenceNotificationSetupComponent = (props: GetAdherenceNotificationSetupComponentProps) => (
      <ApolloReactComponents.Query<GetAdherenceNotificationSetupQuery, GetAdherenceNotificationSetupQueryVariables> query={GetAdherenceNotificationSetupDocument} {...props} />
    );
    

/**
 * __useGetAdherenceNotificationSetupQuery__
 *
 * To run a query within a React component, call `useGetAdherenceNotificationSetupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdherenceNotificationSetupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdherenceNotificationSetupQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdherenceNotificationSetupQuery(baseOptions?: Apollo.QueryHookOptions<GetAdherenceNotificationSetupQuery, GetAdherenceNotificationSetupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdherenceNotificationSetupQuery, GetAdherenceNotificationSetupQueryVariables>(GetAdherenceNotificationSetupDocument, options);
      }
export function useGetAdherenceNotificationSetupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdherenceNotificationSetupQuery, GetAdherenceNotificationSetupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdherenceNotificationSetupQuery, GetAdherenceNotificationSetupQueryVariables>(GetAdherenceNotificationSetupDocument, options);
        }
export type GetAdherenceNotificationSetupQueryHookResult = ReturnType<typeof useGetAdherenceNotificationSetupQuery>;
export type GetAdherenceNotificationSetupLazyQueryHookResult = ReturnType<typeof useGetAdherenceNotificationSetupLazyQuery>;
export type GetAdherenceNotificationSetupQueryResult = Apollo.QueryResult<GetAdherenceNotificationSetupQuery, GetAdherenceNotificationSetupQueryVariables>;
export const CreateAdherenceNotificationDocument = gql`
    mutation createAdherenceNotification($notificationSetup: AdherenceNotificationInput!) {
  createAdherenceNotification(notificationSetup: $notificationSetup) @rest(type: "CreateAdherenceNotification", path: "rta-calculator/v1/delayed-notifications/thresholds", method: "POST", bodyKey: "notificationSetup") {
    ...AdherenceNotificationFields
  }
}
    ${AdherenceNotificationFieldsFragmentDoc}`;
export type CreateAdherenceNotificationMutationFn = Apollo.MutationFunction<CreateAdherenceNotificationMutation, CreateAdherenceNotificationMutationVariables>;
export type CreateAdherenceNotificationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateAdherenceNotificationMutation, CreateAdherenceNotificationMutationVariables>, 'mutation'>;

    export const CreateAdherenceNotificationComponent = (props: CreateAdherenceNotificationComponentProps) => (
      <ApolloReactComponents.Mutation<CreateAdherenceNotificationMutation, CreateAdherenceNotificationMutationVariables> mutation={CreateAdherenceNotificationDocument} {...props} />
    );
    

/**
 * __useCreateAdherenceNotificationMutation__
 *
 * To run a mutation, you first call `useCreateAdherenceNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdherenceNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdherenceNotificationMutation, { data, loading, error }] = useCreateAdherenceNotificationMutation({
 *   variables: {
 *      notificationSetup: // value for 'notificationSetup'
 *   },
 * });
 */
export function useCreateAdherenceNotificationMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdherenceNotificationMutation, CreateAdherenceNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdherenceNotificationMutation, CreateAdherenceNotificationMutationVariables>(CreateAdherenceNotificationDocument, options);
      }
export type CreateAdherenceNotificationMutationHookResult = ReturnType<typeof useCreateAdherenceNotificationMutation>;
export type CreateAdherenceNotificationMutationResult = Apollo.MutationResult<CreateAdherenceNotificationMutation>;
export type CreateAdherenceNotificationMutationOptions = Apollo.BaseMutationOptions<CreateAdherenceNotificationMutation, CreateAdherenceNotificationMutationVariables>;
export const UpdateAdherenceNotificationDocument = gql`
    mutation updateAdherenceNotification($notificationSetup: AdherenceNotificationInput!) {
  updateAdherenceNotification(notificationSetup: $notificationSetup) @rest(type: "UpdateAdherenceNotification", path: "rta-calculator/v1/delayed-notifications/thresholds", method: "PUT", bodyKey: "notificationSetup") {
    ...AdherenceNotificationFields
  }
}
    ${AdherenceNotificationFieldsFragmentDoc}`;
export type UpdateAdherenceNotificationMutationFn = Apollo.MutationFunction<UpdateAdherenceNotificationMutation, UpdateAdherenceNotificationMutationVariables>;
export type UpdateAdherenceNotificationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateAdherenceNotificationMutation, UpdateAdherenceNotificationMutationVariables>, 'mutation'>;

    export const UpdateAdherenceNotificationComponent = (props: UpdateAdherenceNotificationComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateAdherenceNotificationMutation, UpdateAdherenceNotificationMutationVariables> mutation={UpdateAdherenceNotificationDocument} {...props} />
    );
    

/**
 * __useUpdateAdherenceNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateAdherenceNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdherenceNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdherenceNotificationMutation, { data, loading, error }] = useUpdateAdherenceNotificationMutation({
 *   variables: {
 *      notificationSetup: // value for 'notificationSetup'
 *   },
 * });
 */
export function useUpdateAdherenceNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdherenceNotificationMutation, UpdateAdherenceNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdherenceNotificationMutation, UpdateAdherenceNotificationMutationVariables>(UpdateAdherenceNotificationDocument, options);
      }
export type UpdateAdherenceNotificationMutationHookResult = ReturnType<typeof useUpdateAdherenceNotificationMutation>;
export type UpdateAdherenceNotificationMutationResult = Apollo.MutationResult<UpdateAdherenceNotificationMutation>;
export type UpdateAdherenceNotificationMutationOptions = Apollo.BaseMutationOptions<UpdateAdherenceNotificationMutation, UpdateAdherenceNotificationMutationVariables>;
export const DeleteAdherenceNotificationDocument = gql`
    mutation deleteAdherenceNotification {
  deleteAdherenceNotification @rest(type: "DeleteAdherenceNotification", path: "rta-calculator/v1/delayed-notifications/thresholds", method: "DELETE") {
    id
  }
}
    `;
export type DeleteAdherenceNotificationMutationFn = Apollo.MutationFunction<DeleteAdherenceNotificationMutation, DeleteAdherenceNotificationMutationVariables>;
export type DeleteAdherenceNotificationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteAdherenceNotificationMutation, DeleteAdherenceNotificationMutationVariables>, 'mutation'>;

    export const DeleteAdherenceNotificationComponent = (props: DeleteAdherenceNotificationComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteAdherenceNotificationMutation, DeleteAdherenceNotificationMutationVariables> mutation={DeleteAdherenceNotificationDocument} {...props} />
    );
    

/**
 * __useDeleteAdherenceNotificationMutation__
 *
 * To run a mutation, you first call `useDeleteAdherenceNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdherenceNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdherenceNotificationMutation, { data, loading, error }] = useDeleteAdherenceNotificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteAdherenceNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdherenceNotificationMutation, DeleteAdherenceNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdherenceNotificationMutation, DeleteAdherenceNotificationMutationVariables>(DeleteAdherenceNotificationDocument, options);
      }
export type DeleteAdherenceNotificationMutationHookResult = ReturnType<typeof useDeleteAdherenceNotificationMutation>;
export type DeleteAdherenceNotificationMutationResult = Apollo.MutationResult<DeleteAdherenceNotificationMutation>;
export type DeleteAdherenceNotificationMutationOptions = Apollo.BaseMutationOptions<DeleteAdherenceNotificationMutation, DeleteAdherenceNotificationMutationVariables>;
export const GetAdherenceSettingsDataDocument = gql`
    query getAdherenceSettingsData {
  scheduleElements @rest(type: "ScheduleElement", path: "scheduling/schedule-elements") {
    ...ScheduleElementFields
  }
  adherenceEventTypes @rest(type: "AdherenceEventType", path: "scheduling/adherence/event-types") {
    ...AdherenceEventTypeFields
  }
  adherenceReasonCodes @rest(type: "AdherenceReasonCode", path: "scheduling/adherence/reason-codes") {
    ...AdherenceReasonCodeFields
  }
}
    ${ScheduleElementFieldsFragmentDoc}
${AdherenceEventTypeFieldsFragmentDoc}
${AdherenceReasonCodeFieldsFragmentDoc}`;
export type GetAdherenceSettingsDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAdherenceSettingsDataQuery, GetAdherenceSettingsDataQueryVariables>, 'query'>;

    export const GetAdherenceSettingsDataComponent = (props: GetAdherenceSettingsDataComponentProps) => (
      <ApolloReactComponents.Query<GetAdherenceSettingsDataQuery, GetAdherenceSettingsDataQueryVariables> query={GetAdherenceSettingsDataDocument} {...props} />
    );
    

/**
 * __useGetAdherenceSettingsDataQuery__
 *
 * To run a query within a React component, call `useGetAdherenceSettingsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdherenceSettingsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdherenceSettingsDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdherenceSettingsDataQuery(baseOptions?: Apollo.QueryHookOptions<GetAdherenceSettingsDataQuery, GetAdherenceSettingsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdherenceSettingsDataQuery, GetAdherenceSettingsDataQueryVariables>(GetAdherenceSettingsDataDocument, options);
      }
export function useGetAdherenceSettingsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdherenceSettingsDataQuery, GetAdherenceSettingsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdherenceSettingsDataQuery, GetAdherenceSettingsDataQueryVariables>(GetAdherenceSettingsDataDocument, options);
        }
export type GetAdherenceSettingsDataQueryHookResult = ReturnType<typeof useGetAdherenceSettingsDataQuery>;
export type GetAdherenceSettingsDataLazyQueryHookResult = ReturnType<typeof useGetAdherenceSettingsDataLazyQuery>;
export type GetAdherenceSettingsDataQueryResult = Apollo.QueryResult<GetAdherenceSettingsDataQuery, GetAdherenceSettingsDataQueryVariables>;
export const GetAdherenceSettingsDocument = gql`
    query getAdherenceSettings($searchCriteria: AdherenceSettingsSearchCriteria!) {
  adherenceSettings(searchCriteria: $searchCriteria) @rest(type: "AdherenceSettings", path: "scheduling/schedules/adherence/settings/search", method: "POST", bodyKey: "searchCriteria") {
    adherenceSettings @type(name: "AdherenceSetting") {
      ...AdherenceSettingFields
    }
    totalCount
  }
}
    ${AdherenceSettingFieldsFragmentDoc}`;
export type GetAdherenceSettingsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAdherenceSettingsQuery, GetAdherenceSettingsQueryVariables>, 'query'> & ({ variables: GetAdherenceSettingsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAdherenceSettingsComponent = (props: GetAdherenceSettingsComponentProps) => (
      <ApolloReactComponents.Query<GetAdherenceSettingsQuery, GetAdherenceSettingsQueryVariables> query={GetAdherenceSettingsDocument} {...props} />
    );
    

/**
 * __useGetAdherenceSettingsQuery__
 *
 * To run a query within a React component, call `useGetAdherenceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdherenceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdherenceSettingsQuery({
 *   variables: {
 *      searchCriteria: // value for 'searchCriteria'
 *   },
 * });
 */
export function useGetAdherenceSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetAdherenceSettingsQuery, GetAdherenceSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdherenceSettingsQuery, GetAdherenceSettingsQueryVariables>(GetAdherenceSettingsDocument, options);
      }
export function useGetAdherenceSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdherenceSettingsQuery, GetAdherenceSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdherenceSettingsQuery, GetAdherenceSettingsQueryVariables>(GetAdherenceSettingsDocument, options);
        }
export type GetAdherenceSettingsQueryHookResult = ReturnType<typeof useGetAdherenceSettingsQuery>;
export type GetAdherenceSettingsLazyQueryHookResult = ReturnType<typeof useGetAdherenceSettingsLazyQuery>;
export type GetAdherenceSettingsQueryResult = Apollo.QueryResult<GetAdherenceSettingsQuery, GetAdherenceSettingsQueryVariables>;
export const CreateAdherenceSettingDocument = gql`
    mutation createAdherenceSetting($setting: AdherenceSettingInput!) {
  createAdherenceSetting(setting: $setting) @rest(type: "CreateAdherenceSetting", path: "scheduling/schedules/adherence/settings", method: "POST", bodyKey: "setting") {
    id
  }
}
    `;
export type CreateAdherenceSettingMutationFn = Apollo.MutationFunction<CreateAdherenceSettingMutation, CreateAdherenceSettingMutationVariables>;
export type CreateAdherenceSettingComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateAdherenceSettingMutation, CreateAdherenceSettingMutationVariables>, 'mutation'>;

    export const CreateAdherenceSettingComponent = (props: CreateAdherenceSettingComponentProps) => (
      <ApolloReactComponents.Mutation<CreateAdherenceSettingMutation, CreateAdherenceSettingMutationVariables> mutation={CreateAdherenceSettingDocument} {...props} />
    );
    

/**
 * __useCreateAdherenceSettingMutation__
 *
 * To run a mutation, you first call `useCreateAdherenceSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdherenceSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdherenceSettingMutation, { data, loading, error }] = useCreateAdherenceSettingMutation({
 *   variables: {
 *      setting: // value for 'setting'
 *   },
 * });
 */
export function useCreateAdherenceSettingMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdherenceSettingMutation, CreateAdherenceSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdherenceSettingMutation, CreateAdherenceSettingMutationVariables>(CreateAdherenceSettingDocument, options);
      }
export type CreateAdherenceSettingMutationHookResult = ReturnType<typeof useCreateAdherenceSettingMutation>;
export type CreateAdherenceSettingMutationResult = Apollo.MutationResult<CreateAdherenceSettingMutation>;
export type CreateAdherenceSettingMutationOptions = Apollo.BaseMutationOptions<CreateAdherenceSettingMutation, CreateAdherenceSettingMutationVariables>;
export const UpdateAdherenceSettingDocument = gql`
    mutation updateAdherenceSetting($id: ID!, $setting: AdherenceSettingInput!) {
  updateAdherenceSetting(id: $id, setting: $setting) @rest(type: "UpdateAdherenceSetting", path: "scheduling/schedules/adherence/settings/{args.id}", method: "PUT", bodyKey: "setting") {
    id
  }
}
    `;
export type UpdateAdherenceSettingMutationFn = Apollo.MutationFunction<UpdateAdherenceSettingMutation, UpdateAdherenceSettingMutationVariables>;
export type UpdateAdherenceSettingComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateAdherenceSettingMutation, UpdateAdherenceSettingMutationVariables>, 'mutation'>;

    export const UpdateAdherenceSettingComponent = (props: UpdateAdherenceSettingComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateAdherenceSettingMutation, UpdateAdherenceSettingMutationVariables> mutation={UpdateAdherenceSettingDocument} {...props} />
    );
    

/**
 * __useUpdateAdherenceSettingMutation__
 *
 * To run a mutation, you first call `useUpdateAdherenceSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdherenceSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdherenceSettingMutation, { data, loading, error }] = useUpdateAdherenceSettingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      setting: // value for 'setting'
 *   },
 * });
 */
export function useUpdateAdherenceSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdherenceSettingMutation, UpdateAdherenceSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdherenceSettingMutation, UpdateAdherenceSettingMutationVariables>(UpdateAdherenceSettingDocument, options);
      }
export type UpdateAdherenceSettingMutationHookResult = ReturnType<typeof useUpdateAdherenceSettingMutation>;
export type UpdateAdherenceSettingMutationResult = Apollo.MutationResult<UpdateAdherenceSettingMutation>;
export type UpdateAdherenceSettingMutationOptions = Apollo.BaseMutationOptions<UpdateAdherenceSettingMutation, UpdateAdherenceSettingMutationVariables>;
export const DeleteAdherenceSettingDocument = gql`
    mutation deleteAdherenceSetting($id: ID!) {
  deleteAdherenceSetting(id: $id) @rest(type: "AdherenceSettingDelete", path: "scheduling/schedules/adherence/settings/{args.id}", method: "DELETE") {
    id
  }
}
    `;
export type DeleteAdherenceSettingMutationFn = Apollo.MutationFunction<DeleteAdherenceSettingMutation, DeleteAdherenceSettingMutationVariables>;
export type DeleteAdherenceSettingComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteAdherenceSettingMutation, DeleteAdherenceSettingMutationVariables>, 'mutation'>;

    export const DeleteAdherenceSettingComponent = (props: DeleteAdherenceSettingComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteAdherenceSettingMutation, DeleteAdherenceSettingMutationVariables> mutation={DeleteAdherenceSettingDocument} {...props} />
    );
    

/**
 * __useDeleteAdherenceSettingMutation__
 *
 * To run a mutation, you first call `useDeleteAdherenceSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdherenceSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdherenceSettingMutation, { data, loading, error }] = useDeleteAdherenceSettingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAdherenceSettingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdherenceSettingMutation, DeleteAdherenceSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdherenceSettingMutation, DeleteAdherenceSettingMutationVariables>(DeleteAdherenceSettingDocument, options);
      }
export type DeleteAdherenceSettingMutationHookResult = ReturnType<typeof useDeleteAdherenceSettingMutation>;
export type DeleteAdherenceSettingMutationResult = Apollo.MutationResult<DeleteAdherenceSettingMutation>;
export type DeleteAdherenceSettingMutationOptions = Apollo.BaseMutationOptions<DeleteAdherenceSettingMutation, DeleteAdherenceSettingMutationVariables>;
export const GetAdherenceEventTypesDocument = gql`
    query getAdherenceEventTypes {
  adherenceEventTypes @rest(type: "AdherenceEventType", path: "scheduling/adherence/event-types") {
    ...AdherenceEventTypeFields
  }
}
    ${AdherenceEventTypeFieldsFragmentDoc}`;
export type GetAdherenceEventTypesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAdherenceEventTypesQuery, GetAdherenceEventTypesQueryVariables>, 'query'>;

    export const GetAdherenceEventTypesComponent = (props: GetAdherenceEventTypesComponentProps) => (
      <ApolloReactComponents.Query<GetAdherenceEventTypesQuery, GetAdherenceEventTypesQueryVariables> query={GetAdherenceEventTypesDocument} {...props} />
    );
    

/**
 * __useGetAdherenceEventTypesQuery__
 *
 * To run a query within a React component, call `useGetAdherenceEventTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdherenceEventTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdherenceEventTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdherenceEventTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetAdherenceEventTypesQuery, GetAdherenceEventTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdherenceEventTypesQuery, GetAdherenceEventTypesQueryVariables>(GetAdherenceEventTypesDocument, options);
      }
export function useGetAdherenceEventTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdherenceEventTypesQuery, GetAdherenceEventTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdherenceEventTypesQuery, GetAdherenceEventTypesQueryVariables>(GetAdherenceEventTypesDocument, options);
        }
export type GetAdherenceEventTypesQueryHookResult = ReturnType<typeof useGetAdherenceEventTypesQuery>;
export type GetAdherenceEventTypesLazyQueryHookResult = ReturnType<typeof useGetAdherenceEventTypesLazyQuery>;
export type GetAdherenceEventTypesQueryResult = Apollo.QueryResult<GetAdherenceEventTypesQuery, GetAdherenceEventTypesQueryVariables>;
export const GetAdherenceReasonCodesDocument = gql`
    query getAdherenceReasonCodes {
  adherenceReasonCodes @rest(type: "AdherenceReasonCode", path: "scheduling/adherence/reason-codes") {
    ...AdherenceReasonCodeFields
  }
}
    ${AdherenceReasonCodeFieldsFragmentDoc}`;
export type GetAdherenceReasonCodesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAdherenceReasonCodesQuery, GetAdherenceReasonCodesQueryVariables>, 'query'>;

    export const GetAdherenceReasonCodesComponent = (props: GetAdherenceReasonCodesComponentProps) => (
      <ApolloReactComponents.Query<GetAdherenceReasonCodesQuery, GetAdherenceReasonCodesQueryVariables> query={GetAdherenceReasonCodesDocument} {...props} />
    );
    

/**
 * __useGetAdherenceReasonCodesQuery__
 *
 * To run a query within a React component, call `useGetAdherenceReasonCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdherenceReasonCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdherenceReasonCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdherenceReasonCodesQuery(baseOptions?: Apollo.QueryHookOptions<GetAdherenceReasonCodesQuery, GetAdherenceReasonCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdherenceReasonCodesQuery, GetAdherenceReasonCodesQueryVariables>(GetAdherenceReasonCodesDocument, options);
      }
export function useGetAdherenceReasonCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdherenceReasonCodesQuery, GetAdherenceReasonCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdherenceReasonCodesQuery, GetAdherenceReasonCodesQueryVariables>(GetAdherenceReasonCodesDocument, options);
        }
export type GetAdherenceReasonCodesQueryHookResult = ReturnType<typeof useGetAdherenceReasonCodesQuery>;
export type GetAdherenceReasonCodesLazyQueryHookResult = ReturnType<typeof useGetAdherenceReasonCodesLazyQuery>;
export type GetAdherenceReasonCodesQueryResult = Apollo.QueryResult<GetAdherenceReasonCodesQuery, GetAdherenceReasonCodesQueryVariables>;
export const GetUsedAdherenceAcdStatusesDocument = gql`
    query getUsedAdherenceAcdStatuses {
  adherenceAcdStatuses @rest(type: "AdherenceACDStatuses", path: "scheduling/schedules/adherence/settings/acd-statuses") {
    ...AdherenceSettingACDStatusFields
  }
}
    ${AdherenceSettingAcdStatusFieldsFragmentDoc}`;
export type GetUsedAdherenceAcdStatusesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUsedAdherenceAcdStatusesQuery, GetUsedAdherenceAcdStatusesQueryVariables>, 'query'>;

    export const GetUsedAdherenceAcdStatusesComponent = (props: GetUsedAdherenceAcdStatusesComponentProps) => (
      <ApolloReactComponents.Query<GetUsedAdherenceAcdStatusesQuery, GetUsedAdherenceAcdStatusesQueryVariables> query={GetUsedAdherenceAcdStatusesDocument} {...props} />
    );
    

/**
 * __useGetUsedAdherenceAcdStatusesQuery__
 *
 * To run a query within a React component, call `useGetUsedAdherenceAcdStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsedAdherenceAcdStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsedAdherenceAcdStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsedAdherenceAcdStatusesQuery(baseOptions?: Apollo.QueryHookOptions<GetUsedAdherenceAcdStatusesQuery, GetUsedAdherenceAcdStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsedAdherenceAcdStatusesQuery, GetUsedAdherenceAcdStatusesQueryVariables>(GetUsedAdherenceAcdStatusesDocument, options);
      }
export function useGetUsedAdherenceAcdStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsedAdherenceAcdStatusesQuery, GetUsedAdherenceAcdStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsedAdherenceAcdStatusesQuery, GetUsedAdherenceAcdStatusesQueryVariables>(GetUsedAdherenceAcdStatusesDocument, options);
        }
export type GetUsedAdherenceAcdStatusesQueryHookResult = ReturnType<typeof useGetUsedAdherenceAcdStatusesQuery>;
export type GetUsedAdherenceAcdStatusesLazyQueryHookResult = ReturnType<typeof useGetUsedAdherenceAcdStatusesLazyQuery>;
export type GetUsedAdherenceAcdStatusesQueryResult = Apollo.QueryResult<GetUsedAdherenceAcdStatusesQuery, GetUsedAdherenceAcdStatusesQueryVariables>;
export const GetUserRequestsDocument = gql`
    query GetUserRequests($agentId: ID!, $createdAtFrom: String, $createdAtTo: String, $requestedFrom: String, $requestedTo: String, $states: String, $subtypes: String, $types: String) {
  userRequests(
    agentId: $agentId
    createdAtFrom: $createdAtFrom
    createdAtTo: $createdAtTo
    requestedFrom: $requestedFrom
    requestedTo: $requestedTo
    states: $states
    subtypes: $subtypes
    types: $types
  ) @rest(type: "[RequestPreview]", path: "scheduling/bff/self-service/v1/agents/{args.agentId}/requests?{args}") {
    ...RequestPreviewFields
  }
}
    ${RequestPreviewFieldsFragmentDoc}`;
export type GetUserRequestsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUserRequestsQuery, GetUserRequestsQueryVariables>, 'query'> & ({ variables: GetUserRequestsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetUserRequestsComponent = (props: GetUserRequestsComponentProps) => (
      <ApolloReactComponents.Query<GetUserRequestsQuery, GetUserRequestsQueryVariables> query={GetUserRequestsDocument} {...props} />
    );
    

/**
 * __useGetUserRequestsQuery__
 *
 * To run a query within a React component, call `useGetUserRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRequestsQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      createdAtFrom: // value for 'createdAtFrom'
 *      createdAtTo: // value for 'createdAtTo'
 *      requestedFrom: // value for 'requestedFrom'
 *      requestedTo: // value for 'requestedTo'
 *      states: // value for 'states'
 *      subtypes: // value for 'subtypes'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useGetUserRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetUserRequestsQuery, GetUserRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserRequestsQuery, GetUserRequestsQueryVariables>(GetUserRequestsDocument, options);
      }
export function useGetUserRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserRequestsQuery, GetUserRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserRequestsQuery, GetUserRequestsQueryVariables>(GetUserRequestsDocument, options);
        }
export type GetUserRequestsQueryHookResult = ReturnType<typeof useGetUserRequestsQuery>;
export type GetUserRequestsLazyQueryHookResult = ReturnType<typeof useGetUserRequestsLazyQuery>;
export type GetUserRequestsQueryResult = Apollo.QueryResult<GetUserRequestsQuery, GetUserRequestsQueryVariables>;
export const GetAgentPtoRequestDocument = gql`
    query GetAgentPTORequest($agentId: ID!, $ptoRequestId: ID!) {
  agentPTORequest(agentId: $agentId, ptoRequestId: $ptoRequestId) @rest(type: "PTORequest", path: "scheduling/pto/v1/agents/{args.agentId}/pto-requests/{args.ptoRequestId}") {
    ...PTORequestFields
  }
}
    ${PtoRequestFieldsFragmentDoc}`;
export type GetAgentPtoRequestComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAgentPtoRequestQuery, GetAgentPtoRequestQueryVariables>, 'query'> & ({ variables: GetAgentPtoRequestQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAgentPtoRequestComponent = (props: GetAgentPtoRequestComponentProps) => (
      <ApolloReactComponents.Query<GetAgentPtoRequestQuery, GetAgentPtoRequestQueryVariables> query={GetAgentPtoRequestDocument} {...props} />
    );
    

/**
 * __useGetAgentPtoRequestQuery__
 *
 * To run a query within a React component, call `useGetAgentPtoRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentPtoRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentPtoRequestQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      ptoRequestId: // value for 'ptoRequestId'
 *   },
 * });
 */
export function useGetAgentPtoRequestQuery(baseOptions: Apollo.QueryHookOptions<GetAgentPtoRequestQuery, GetAgentPtoRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentPtoRequestQuery, GetAgentPtoRequestQueryVariables>(GetAgentPtoRequestDocument, options);
      }
export function useGetAgentPtoRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentPtoRequestQuery, GetAgentPtoRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentPtoRequestQuery, GetAgentPtoRequestQueryVariables>(GetAgentPtoRequestDocument, options);
        }
export type GetAgentPtoRequestQueryHookResult = ReturnType<typeof useGetAgentPtoRequestQuery>;
export type GetAgentPtoRequestLazyQueryHookResult = ReturnType<typeof useGetAgentPtoRequestLazyQuery>;
export type GetAgentPtoRequestQueryResult = Apollo.QueryResult<GetAgentPtoRequestQuery, GetAgentPtoRequestQueryVariables>;
export const CreatePtoRequestDocument = gql`
    mutation CreatePTORequest($agentId: ID!, $parameters: PTORequestInput!) {
  createPTORequest(agentId: $agentId, parameters: $parameters) @rest(type: "PTORequest", path: "scheduling/pto/v1/agents/{args.agentId}/pto-requests", method: "POST", bodyKey: "parameters") {
    ...PTORequestFields
  }
}
    ${PtoRequestFieldsFragmentDoc}`;
export type CreatePtoRequestMutationFn = Apollo.MutationFunction<CreatePtoRequestMutation, CreatePtoRequestMutationVariables>;
export type CreatePtoRequestComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreatePtoRequestMutation, CreatePtoRequestMutationVariables>, 'mutation'>;

    export const CreatePtoRequestComponent = (props: CreatePtoRequestComponentProps) => (
      <ApolloReactComponents.Mutation<CreatePtoRequestMutation, CreatePtoRequestMutationVariables> mutation={CreatePtoRequestDocument} {...props} />
    );
    

/**
 * __useCreatePtoRequestMutation__
 *
 * To run a mutation, you first call `useCreatePtoRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePtoRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPtoRequestMutation, { data, loading, error }] = useCreatePtoRequestMutation({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      parameters: // value for 'parameters'
 *   },
 * });
 */
export function useCreatePtoRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreatePtoRequestMutation, CreatePtoRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePtoRequestMutation, CreatePtoRequestMutationVariables>(CreatePtoRequestDocument, options);
      }
export type CreatePtoRequestMutationHookResult = ReturnType<typeof useCreatePtoRequestMutation>;
export type CreatePtoRequestMutationResult = Apollo.MutationResult<CreatePtoRequestMutation>;
export type CreatePtoRequestMutationOptions = Apollo.BaseMutationOptions<CreatePtoRequestMutation, CreatePtoRequestMutationVariables>;
export const UpdateStateOfPtoRequestDocument = gql`
    mutation updateStateOfPTORequest($agentId: ID!, $ptoRequestId: ID!, $parameters: PTORequestUpdateInput!) {
  updateStateOfPTORequest(
    agentId: $agentId
    ptoRequestId: $ptoRequestId
    parameters: $parameters
  ) @rest(type: "PTORequest", path: "scheduling/pto/v1/agents/{args.agentId}/pto-requests/{args.ptoRequestId}/state", method: "PUT", bodyKey: "parameters") {
    ...PTORequestFields
  }
}
    ${PtoRequestFieldsFragmentDoc}`;
export type UpdateStateOfPtoRequestMutationFn = Apollo.MutationFunction<UpdateStateOfPtoRequestMutation, UpdateStateOfPtoRequestMutationVariables>;
export type UpdateStateOfPtoRequestComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateStateOfPtoRequestMutation, UpdateStateOfPtoRequestMutationVariables>, 'mutation'>;

    export const UpdateStateOfPtoRequestComponent = (props: UpdateStateOfPtoRequestComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateStateOfPtoRequestMutation, UpdateStateOfPtoRequestMutationVariables> mutation={UpdateStateOfPtoRequestDocument} {...props} />
    );
    

/**
 * __useUpdateStateOfPtoRequestMutation__
 *
 * To run a mutation, you first call `useUpdateStateOfPtoRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStateOfPtoRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStateOfPtoRequestMutation, { data, loading, error }] = useUpdateStateOfPtoRequestMutation({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      ptoRequestId: // value for 'ptoRequestId'
 *      parameters: // value for 'parameters'
 *   },
 * });
 */
export function useUpdateStateOfPtoRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStateOfPtoRequestMutation, UpdateStateOfPtoRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStateOfPtoRequestMutation, UpdateStateOfPtoRequestMutationVariables>(UpdateStateOfPtoRequestDocument, options);
      }
export type UpdateStateOfPtoRequestMutationHookResult = ReturnType<typeof useUpdateStateOfPtoRequestMutation>;
export type UpdateStateOfPtoRequestMutationResult = Apollo.MutationResult<UpdateStateOfPtoRequestMutation>;
export type UpdateStateOfPtoRequestMutationOptions = Apollo.BaseMutationOptions<UpdateStateOfPtoRequestMutation, UpdateStateOfPtoRequestMutationVariables>;
export const GetSuitableShiftsForSwapDocument = gql`
    query GetSuitableShiftsForSwap($requesterId: ID!, $shiftDate: String!, $recipientGroup: ShiftSwapRecipientGroup!, $recipients: String, $shiftsFrom: String, $shiftsTo: String) {
  suitableShiftsForSwap(
    requesterId: $requesterId
    shiftDate: $shiftDate
    recipientGroup: $recipientGroup
    recipients: $recipients
    shiftsFrom: $shiftsFrom
    shiftsTo: $shiftsTo
  ) @rest(type: "[AgentShift]", path: "scheduling/shift-swap/v1/requesters/{args.requesterId}/recipients/shifts/{args.shiftDate}?{args}") {
    ...AgentShiftFields
  }
}
    ${AgentShiftFieldsFragmentDoc}`;
export type GetSuitableShiftsForSwapComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSuitableShiftsForSwapQuery, GetSuitableShiftsForSwapQueryVariables>, 'query'> & ({ variables: GetSuitableShiftsForSwapQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSuitableShiftsForSwapComponent = (props: GetSuitableShiftsForSwapComponentProps) => (
      <ApolloReactComponents.Query<GetSuitableShiftsForSwapQuery, GetSuitableShiftsForSwapQueryVariables> query={GetSuitableShiftsForSwapDocument} {...props} />
    );
    

/**
 * __useGetSuitableShiftsForSwapQuery__
 *
 * To run a query within a React component, call `useGetSuitableShiftsForSwapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuitableShiftsForSwapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuitableShiftsForSwapQuery({
 *   variables: {
 *      requesterId: // value for 'requesterId'
 *      shiftDate: // value for 'shiftDate'
 *      recipientGroup: // value for 'recipientGroup'
 *      recipients: // value for 'recipients'
 *      shiftsFrom: // value for 'shiftsFrom'
 *      shiftsTo: // value for 'shiftsTo'
 *   },
 * });
 */
export function useGetSuitableShiftsForSwapQuery(baseOptions: Apollo.QueryHookOptions<GetSuitableShiftsForSwapQuery, GetSuitableShiftsForSwapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuitableShiftsForSwapQuery, GetSuitableShiftsForSwapQueryVariables>(GetSuitableShiftsForSwapDocument, options);
      }
export function useGetSuitableShiftsForSwapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuitableShiftsForSwapQuery, GetSuitableShiftsForSwapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuitableShiftsForSwapQuery, GetSuitableShiftsForSwapQueryVariables>(GetSuitableShiftsForSwapDocument, options);
        }
export type GetSuitableShiftsForSwapQueryHookResult = ReturnType<typeof useGetSuitableShiftsForSwapQuery>;
export type GetSuitableShiftsForSwapLazyQueryHookResult = ReturnType<typeof useGetSuitableShiftsForSwapLazyQuery>;
export type GetSuitableShiftsForSwapQueryResult = Apollo.QueryResult<GetSuitableShiftsForSwapQuery, GetSuitableShiftsForSwapQueryVariables>;
export const GetShiftOverviewsForRequesterDocument = gql`
    query GetShiftOverviewsForRequester($requesterId: ID!, $from: String!, $to: String!) {
  shiftOverviewsForRequester(requesterId: $requesterId, from: $from, to: $to) @rest(type: "AgentShiftOverviews", path: "scheduling/shift-swap/v1/requesters/{args.requesterId}/shifts/overview?from={args.from}&to={args.to}") {
    ...AgentShiftOverviewsFields
  }
}
    ${AgentShiftOverviewsFieldsFragmentDoc}`;
export type GetShiftOverviewsForRequesterComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetShiftOverviewsForRequesterQuery, GetShiftOverviewsForRequesterQueryVariables>, 'query'> & ({ variables: GetShiftOverviewsForRequesterQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetShiftOverviewsForRequesterComponent = (props: GetShiftOverviewsForRequesterComponentProps) => (
      <ApolloReactComponents.Query<GetShiftOverviewsForRequesterQuery, GetShiftOverviewsForRequesterQueryVariables> query={GetShiftOverviewsForRequesterDocument} {...props} />
    );
    

/**
 * __useGetShiftOverviewsForRequesterQuery__
 *
 * To run a query within a React component, call `useGetShiftOverviewsForRequesterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShiftOverviewsForRequesterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShiftOverviewsForRequesterQuery({
 *   variables: {
 *      requesterId: // value for 'requesterId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetShiftOverviewsForRequesterQuery(baseOptions: Apollo.QueryHookOptions<GetShiftOverviewsForRequesterQuery, GetShiftOverviewsForRequesterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShiftOverviewsForRequesterQuery, GetShiftOverviewsForRequesterQueryVariables>(GetShiftOverviewsForRequesterDocument, options);
      }
export function useGetShiftOverviewsForRequesterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShiftOverviewsForRequesterQuery, GetShiftOverviewsForRequesterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShiftOverviewsForRequesterQuery, GetShiftOverviewsForRequesterQueryVariables>(GetShiftOverviewsForRequesterDocument, options);
        }
export type GetShiftOverviewsForRequesterQueryHookResult = ReturnType<typeof useGetShiftOverviewsForRequesterQuery>;
export type GetShiftOverviewsForRequesterLazyQueryHookResult = ReturnType<typeof useGetShiftOverviewsForRequesterLazyQuery>;
export type GetShiftOverviewsForRequesterQueryResult = Apollo.QueryResult<GetShiftOverviewsForRequesterQuery, GetShiftOverviewsForRequesterQueryVariables>;
export const GetSuitableRecipientsDocument = gql`
    query GetSuitableRecipients($requesterId: ID!) {
  suitableRecipients(requesterId: $requesterId) @rest(type: "[AgentInRequestWithQueues]", path: "scheduling/shift-swap/v1/requesters/{args.requesterId}/recipients") {
    ...AgentInRequestWithQueuesFields
  }
}
    ${AgentInRequestWithQueuesFieldsFragmentDoc}`;
export type GetSuitableRecipientsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSuitableRecipientsQuery, GetSuitableRecipientsQueryVariables>, 'query'> & ({ variables: GetSuitableRecipientsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSuitableRecipientsComponent = (props: GetSuitableRecipientsComponentProps) => (
      <ApolloReactComponents.Query<GetSuitableRecipientsQuery, GetSuitableRecipientsQueryVariables> query={GetSuitableRecipientsDocument} {...props} />
    );
    

/**
 * __useGetSuitableRecipientsQuery__
 *
 * To run a query within a React component, call `useGetSuitableRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuitableRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuitableRecipientsQuery({
 *   variables: {
 *      requesterId: // value for 'requesterId'
 *   },
 * });
 */
export function useGetSuitableRecipientsQuery(baseOptions: Apollo.QueryHookOptions<GetSuitableRecipientsQuery, GetSuitableRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSuitableRecipientsQuery, GetSuitableRecipientsQueryVariables>(GetSuitableRecipientsDocument, options);
      }
export function useGetSuitableRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSuitableRecipientsQuery, GetSuitableRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSuitableRecipientsQuery, GetSuitableRecipientsQueryVariables>(GetSuitableRecipientsDocument, options);
        }
export type GetSuitableRecipientsQueryHookResult = ReturnType<typeof useGetSuitableRecipientsQuery>;
export type GetSuitableRecipientsLazyQueryHookResult = ReturnType<typeof useGetSuitableRecipientsLazyQuery>;
export type GetSuitableRecipientsQueryResult = Apollo.QueryResult<GetSuitableRecipientsQuery, GetSuitableRecipientsQueryVariables>;
export const CreateShiftSwapRequestDocument = gql`
    mutation CreateShiftSwapRequest($requesterId: ID!, $parameters: ShiftSwapRequestInput!) {
  createShiftSwapRequest(requesterId: $requesterId, parameters: $parameters) @rest(type: "ShiftSwapRequest", path: "scheduling/shift-swap/v1/requesters/{args.requesterId}/shift-swap-requests", method: "POST", bodyKey: "parameters") {
    ...ShiftSwapRequestFields
  }
}
    ${ShiftSwapRequestFieldsFragmentDoc}`;
export type CreateShiftSwapRequestMutationFn = Apollo.MutationFunction<CreateShiftSwapRequestMutation, CreateShiftSwapRequestMutationVariables>;
export type CreateShiftSwapRequestComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateShiftSwapRequestMutation, CreateShiftSwapRequestMutationVariables>, 'mutation'>;

    export const CreateShiftSwapRequestComponent = (props: CreateShiftSwapRequestComponentProps) => (
      <ApolloReactComponents.Mutation<CreateShiftSwapRequestMutation, CreateShiftSwapRequestMutationVariables> mutation={CreateShiftSwapRequestDocument} {...props} />
    );
    

/**
 * __useCreateShiftSwapRequestMutation__
 *
 * To run a mutation, you first call `useCreateShiftSwapRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShiftSwapRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShiftSwapRequestMutation, { data, loading, error }] = useCreateShiftSwapRequestMutation({
 *   variables: {
 *      requesterId: // value for 'requesterId'
 *      parameters: // value for 'parameters'
 *   },
 * });
 */
export function useCreateShiftSwapRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateShiftSwapRequestMutation, CreateShiftSwapRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShiftSwapRequestMutation, CreateShiftSwapRequestMutationVariables>(CreateShiftSwapRequestDocument, options);
      }
export type CreateShiftSwapRequestMutationHookResult = ReturnType<typeof useCreateShiftSwapRequestMutation>;
export type CreateShiftSwapRequestMutationResult = Apollo.MutationResult<CreateShiftSwapRequestMutation>;
export type CreateShiftSwapRequestMutationOptions = Apollo.BaseMutationOptions<CreateShiftSwapRequestMutation, CreateShiftSwapRequestMutationVariables>;
export const GetRecipientShiftSwapRequestDocument = gql`
    query GetRecipientShiftSwapRequest($recipientId: ID!, $shiftSwapRequestId: ID!) {
  recipientShiftSwapRequest(
    recipientId: $recipientId
    shiftSwapRequestId: $shiftSwapRequestId
  ) @rest(type: "ShiftSwapRequest", path: "scheduling/shift-swap/v1/recipients/{args.recipientId}/shift-swap-requests/{args.shiftSwapRequestId}") {
    ...ShiftSwapRequestFields
  }
}
    ${ShiftSwapRequestFieldsFragmentDoc}`;
export type GetRecipientShiftSwapRequestComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetRecipientShiftSwapRequestQuery, GetRecipientShiftSwapRequestQueryVariables>, 'query'> & ({ variables: GetRecipientShiftSwapRequestQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetRecipientShiftSwapRequestComponent = (props: GetRecipientShiftSwapRequestComponentProps) => (
      <ApolloReactComponents.Query<GetRecipientShiftSwapRequestQuery, GetRecipientShiftSwapRequestQueryVariables> query={GetRecipientShiftSwapRequestDocument} {...props} />
    );
    

/**
 * __useGetRecipientShiftSwapRequestQuery__
 *
 * To run a query within a React component, call `useGetRecipientShiftSwapRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecipientShiftSwapRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecipientShiftSwapRequestQuery({
 *   variables: {
 *      recipientId: // value for 'recipientId'
 *      shiftSwapRequestId: // value for 'shiftSwapRequestId'
 *   },
 * });
 */
export function useGetRecipientShiftSwapRequestQuery(baseOptions: Apollo.QueryHookOptions<GetRecipientShiftSwapRequestQuery, GetRecipientShiftSwapRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecipientShiftSwapRequestQuery, GetRecipientShiftSwapRequestQueryVariables>(GetRecipientShiftSwapRequestDocument, options);
      }
export function useGetRecipientShiftSwapRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecipientShiftSwapRequestQuery, GetRecipientShiftSwapRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecipientShiftSwapRequestQuery, GetRecipientShiftSwapRequestQueryVariables>(GetRecipientShiftSwapRequestDocument, options);
        }
export type GetRecipientShiftSwapRequestQueryHookResult = ReturnType<typeof useGetRecipientShiftSwapRequestQuery>;
export type GetRecipientShiftSwapRequestLazyQueryHookResult = ReturnType<typeof useGetRecipientShiftSwapRequestLazyQuery>;
export type GetRecipientShiftSwapRequestQueryResult = Apollo.QueryResult<GetRecipientShiftSwapRequestQuery, GetRecipientShiftSwapRequestQueryVariables>;
export const GetRequesterShiftSwapRequestDocument = gql`
    query GetRequesterShiftSwapRequest($requesterId: ID!, $shiftSwapRequestId: ID!) {
  requesterShiftSwapRequest(
    requesterId: $requesterId
    shiftSwapRequestId: $shiftSwapRequestId
  ) @rest(type: "ShiftSwapRequest", path: "scheduling/shift-swap/v1/requesters/{args.requesterId}/shift-swap-requests/{args.shiftSwapRequestId}") {
    ...ShiftSwapRequestFields
  }
}
    ${ShiftSwapRequestFieldsFragmentDoc}`;
export type GetRequesterShiftSwapRequestComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetRequesterShiftSwapRequestQuery, GetRequesterShiftSwapRequestQueryVariables>, 'query'> & ({ variables: GetRequesterShiftSwapRequestQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetRequesterShiftSwapRequestComponent = (props: GetRequesterShiftSwapRequestComponentProps) => (
      <ApolloReactComponents.Query<GetRequesterShiftSwapRequestQuery, GetRequesterShiftSwapRequestQueryVariables> query={GetRequesterShiftSwapRequestDocument} {...props} />
    );
    

/**
 * __useGetRequesterShiftSwapRequestQuery__
 *
 * To run a query within a React component, call `useGetRequesterShiftSwapRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequesterShiftSwapRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequesterShiftSwapRequestQuery({
 *   variables: {
 *      requesterId: // value for 'requesterId'
 *      shiftSwapRequestId: // value for 'shiftSwapRequestId'
 *   },
 * });
 */
export function useGetRequesterShiftSwapRequestQuery(baseOptions: Apollo.QueryHookOptions<GetRequesterShiftSwapRequestQuery, GetRequesterShiftSwapRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequesterShiftSwapRequestQuery, GetRequesterShiftSwapRequestQueryVariables>(GetRequesterShiftSwapRequestDocument, options);
      }
export function useGetRequesterShiftSwapRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequesterShiftSwapRequestQuery, GetRequesterShiftSwapRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequesterShiftSwapRequestQuery, GetRequesterShiftSwapRequestQueryVariables>(GetRequesterShiftSwapRequestDocument, options);
        }
export type GetRequesterShiftSwapRequestQueryHookResult = ReturnType<typeof useGetRequesterShiftSwapRequestQuery>;
export type GetRequesterShiftSwapRequestLazyQueryHookResult = ReturnType<typeof useGetRequesterShiftSwapRequestLazyQuery>;
export type GetRequesterShiftSwapRequestQueryResult = Apollo.QueryResult<GetRequesterShiftSwapRequestQuery, GetRequesterShiftSwapRequestQueryVariables>;
export const GetShiftOverviewForShiftOfShiftSwapRequestDocument = gql`
    query GetShiftOverviewForShiftOfShiftSwapRequest($controller: ShiftSwapRequestController!, $shiftSwapRequestId: ID!, $userId: ID!) {
  shiftOverviewForShiftFromShiftSwapRequest(
    controller: $controller
    shiftSwapRequestId: $shiftSwapRequestId
    userId: $userId
  ) @rest(type: "AgentShift", path: "scheduling/shift-swap/v1/{args.controller}/{args.userId}/shift-swap-requests/{args.shiftSwapRequestId}/shift") {
    ...AgentShiftFields
  }
}
    ${AgentShiftFieldsFragmentDoc}`;
export type GetShiftOverviewForShiftOfShiftSwapRequestComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetShiftOverviewForShiftOfShiftSwapRequestQuery, GetShiftOverviewForShiftOfShiftSwapRequestQueryVariables>, 'query'> & ({ variables: GetShiftOverviewForShiftOfShiftSwapRequestQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetShiftOverviewForShiftOfShiftSwapRequestComponent = (props: GetShiftOverviewForShiftOfShiftSwapRequestComponentProps) => (
      <ApolloReactComponents.Query<GetShiftOverviewForShiftOfShiftSwapRequestQuery, GetShiftOverviewForShiftOfShiftSwapRequestQueryVariables> query={GetShiftOverviewForShiftOfShiftSwapRequestDocument} {...props} />
    );
    

/**
 * __useGetShiftOverviewForShiftOfShiftSwapRequestQuery__
 *
 * To run a query within a React component, call `useGetShiftOverviewForShiftOfShiftSwapRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShiftOverviewForShiftOfShiftSwapRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShiftOverviewForShiftOfShiftSwapRequestQuery({
 *   variables: {
 *      controller: // value for 'controller'
 *      shiftSwapRequestId: // value for 'shiftSwapRequestId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetShiftOverviewForShiftOfShiftSwapRequestQuery(baseOptions: Apollo.QueryHookOptions<GetShiftOverviewForShiftOfShiftSwapRequestQuery, GetShiftOverviewForShiftOfShiftSwapRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShiftOverviewForShiftOfShiftSwapRequestQuery, GetShiftOverviewForShiftOfShiftSwapRequestQueryVariables>(GetShiftOverviewForShiftOfShiftSwapRequestDocument, options);
      }
export function useGetShiftOverviewForShiftOfShiftSwapRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShiftOverviewForShiftOfShiftSwapRequestQuery, GetShiftOverviewForShiftOfShiftSwapRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShiftOverviewForShiftOfShiftSwapRequestQuery, GetShiftOverviewForShiftOfShiftSwapRequestQueryVariables>(GetShiftOverviewForShiftOfShiftSwapRequestDocument, options);
        }
export type GetShiftOverviewForShiftOfShiftSwapRequestQueryHookResult = ReturnType<typeof useGetShiftOverviewForShiftOfShiftSwapRequestQuery>;
export type GetShiftOverviewForShiftOfShiftSwapRequestLazyQueryHookResult = ReturnType<typeof useGetShiftOverviewForShiftOfShiftSwapRequestLazyQuery>;
export type GetShiftOverviewForShiftOfShiftSwapRequestQueryResult = Apollo.QueryResult<GetShiftOverviewForShiftOfShiftSwapRequestQuery, GetShiftOverviewForShiftOfShiftSwapRequestQueryVariables>;
export const UpdateStateOfShiftSwapRequestDocument = gql`
    mutation updateStateOfShiftSwapRequest($agentId: ID!, $requestId: ID!, $action: ShiftSwapRequestAction!, $controller: ShiftSwapRequestController!, $parameters: ShiftSwapRequestUpdateInput!) {
  updateStateOfShiftSwapRequest(
    agentId: $agentId
    requestId: $requestId
    action: $action
    controller: $controller
    parameters: $parameters
  ) @rest(type: "ShiftSwapRequest", path: "scheduling/shift-swap/v1/{args.controller}/{args.agentId}/shift-swap-requests/{args.requestId}/{args.action}", method: "PUT", bodyKey: "parameters") {
    ...ShiftSwapRequestFields
  }
}
    ${ShiftSwapRequestFieldsFragmentDoc}`;
export type UpdateStateOfShiftSwapRequestMutationFn = Apollo.MutationFunction<UpdateStateOfShiftSwapRequestMutation, UpdateStateOfShiftSwapRequestMutationVariables>;
export type UpdateStateOfShiftSwapRequestComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateStateOfShiftSwapRequestMutation, UpdateStateOfShiftSwapRequestMutationVariables>, 'mutation'>;

    export const UpdateStateOfShiftSwapRequestComponent = (props: UpdateStateOfShiftSwapRequestComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateStateOfShiftSwapRequestMutation, UpdateStateOfShiftSwapRequestMutationVariables> mutation={UpdateStateOfShiftSwapRequestDocument} {...props} />
    );
    

/**
 * __useUpdateStateOfShiftSwapRequestMutation__
 *
 * To run a mutation, you first call `useUpdateStateOfShiftSwapRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStateOfShiftSwapRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStateOfShiftSwapRequestMutation, { data, loading, error }] = useUpdateStateOfShiftSwapRequestMutation({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      requestId: // value for 'requestId'
 *      action: // value for 'action'
 *      controller: // value for 'controller'
 *      parameters: // value for 'parameters'
 *   },
 * });
 */
export function useUpdateStateOfShiftSwapRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStateOfShiftSwapRequestMutation, UpdateStateOfShiftSwapRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStateOfShiftSwapRequestMutation, UpdateStateOfShiftSwapRequestMutationVariables>(UpdateStateOfShiftSwapRequestDocument, options);
      }
export type UpdateStateOfShiftSwapRequestMutationHookResult = ReturnType<typeof useUpdateStateOfShiftSwapRequestMutation>;
export type UpdateStateOfShiftSwapRequestMutationResult = Apollo.MutationResult<UpdateStateOfShiftSwapRequestMutation>;
export type UpdateStateOfShiftSwapRequestMutationOptions = Apollo.BaseMutationOptions<UpdateStateOfShiftSwapRequestMutation, UpdateStateOfShiftSwapRequestMutationVariables>;
export const CalculateWorkContributionDocument = gql`
    query calculateWorkContribution($parameters: CalculateWorkContributionInput!) {
  calculatedWorkContribution(parameters: $parameters) @rest(type: "CalculateWorkContributionData", path: "scheduling/work-contribution/production/calculate", method: "POST", bodyKey: "parameters") {
    ...CalculatedWorkContributionFields
  }
}
    ${CalculatedWorkContributionFieldsFragmentDoc}`;
export type CalculateWorkContributionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CalculateWorkContributionQuery, CalculateWorkContributionQueryVariables>, 'query'> & ({ variables: CalculateWorkContributionQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CalculateWorkContributionComponent = (props: CalculateWorkContributionComponentProps) => (
      <ApolloReactComponents.Query<CalculateWorkContributionQuery, CalculateWorkContributionQueryVariables> query={CalculateWorkContributionDocument} {...props} />
    );
    

/**
 * __useCalculateWorkContributionQuery__
 *
 * To run a query within a React component, call `useCalculateWorkContributionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateWorkContributionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateWorkContributionQuery({
 *   variables: {
 *      parameters: // value for 'parameters'
 *   },
 * });
 */
export function useCalculateWorkContributionQuery(baseOptions: Apollo.QueryHookOptions<CalculateWorkContributionQuery, CalculateWorkContributionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateWorkContributionQuery, CalculateWorkContributionQueryVariables>(CalculateWorkContributionDocument, options);
      }
export function useCalculateWorkContributionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateWorkContributionQuery, CalculateWorkContributionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateWorkContributionQuery, CalculateWorkContributionQueryVariables>(CalculateWorkContributionDocument, options);
        }
export type CalculateWorkContributionQueryHookResult = ReturnType<typeof useCalculateWorkContributionQuery>;
export type CalculateWorkContributionLazyQueryHookResult = ReturnType<typeof useCalculateWorkContributionLazyQuery>;
export type CalculateWorkContributionQueryResult = Apollo.QueryResult<CalculateWorkContributionQuery, CalculateWorkContributionQueryVariables>;
export const CalculateIntradayWorkContributionDocument = gql`
    query calculateIntradayWorkContribution($parameters: CalculateWorkContributionInput!) {
  calculatedIntradayWorkContribution(parameters: $parameters) @rest(type: "CalculateWorkContributionData", path: "scheduling/work-contribution/intraday/calculate", method: "POST", bodyKey: "parameters") {
    ...CalculatedWorkContributionFields
  }
}
    ${CalculatedWorkContributionFieldsFragmentDoc}`;
export type CalculateIntradayWorkContributionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CalculateIntradayWorkContributionQuery, CalculateIntradayWorkContributionQueryVariables>, 'query'> & ({ variables: CalculateIntradayWorkContributionQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CalculateIntradayWorkContributionComponent = (props: CalculateIntradayWorkContributionComponentProps) => (
      <ApolloReactComponents.Query<CalculateIntradayWorkContributionQuery, CalculateIntradayWorkContributionQueryVariables> query={CalculateIntradayWorkContributionDocument} {...props} />
    );
    

/**
 * __useCalculateIntradayWorkContributionQuery__
 *
 * To run a query within a React component, call `useCalculateIntradayWorkContributionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateIntradayWorkContributionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateIntradayWorkContributionQuery({
 *   variables: {
 *      parameters: // value for 'parameters'
 *   },
 * });
 */
export function useCalculateIntradayWorkContributionQuery(baseOptions: Apollo.QueryHookOptions<CalculateIntradayWorkContributionQuery, CalculateIntradayWorkContributionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateIntradayWorkContributionQuery, CalculateIntradayWorkContributionQueryVariables>(CalculateIntradayWorkContributionDocument, options);
      }
export function useCalculateIntradayWorkContributionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateIntradayWorkContributionQuery, CalculateIntradayWorkContributionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateIntradayWorkContributionQuery, CalculateIntradayWorkContributionQueryVariables>(CalculateIntradayWorkContributionDocument, options);
        }
export type CalculateIntradayWorkContributionQueryHookResult = ReturnType<typeof useCalculateIntradayWorkContributionQuery>;
export type CalculateIntradayWorkContributionLazyQueryHookResult = ReturnType<typeof useCalculateIntradayWorkContributionLazyQuery>;
export type CalculateIntradayWorkContributionQueryResult = Apollo.QueryResult<CalculateIntradayWorkContributionQuery, CalculateIntradayWorkContributionQueryVariables>;
export const CloneScheduleDocument = gql`
    mutation CloneSchedule($id: ID!) {
  cloneSchedule(id: $id) @rest(type: "CloneSchedule", path: "scheduling/schedules/clone", method: "POST") {
    id
  }
}
    `;
export type CloneScheduleMutationFn = Apollo.MutationFunction<CloneScheduleMutation, CloneScheduleMutationVariables>;
export type CloneScheduleComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CloneScheduleMutation, CloneScheduleMutationVariables>, 'mutation'>;

    export const CloneScheduleComponent = (props: CloneScheduleComponentProps) => (
      <ApolloReactComponents.Mutation<CloneScheduleMutation, CloneScheduleMutationVariables> mutation={CloneScheduleDocument} {...props} />
    );
    

/**
 * __useCloneScheduleMutation__
 *
 * To run a mutation, you first call `useCloneScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneScheduleMutation, { data, loading, error }] = useCloneScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloneScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CloneScheduleMutation, CloneScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneScheduleMutation, CloneScheduleMutationVariables>(CloneScheduleDocument, options);
      }
export type CloneScheduleMutationHookResult = ReturnType<typeof useCloneScheduleMutation>;
export type CloneScheduleMutationResult = Apollo.MutationResult<CloneScheduleMutation>;
export type CloneScheduleMutationOptions = Apollo.BaseMutationOptions<CloneScheduleMutation, CloneScheduleMutationVariables>;
export const CreateScheduleDocument = gql`
    mutation CreateSchedule($schedule: ScheduleInput!, $allowInactiveAgents: Boolean) {
  createSchedule(schedule: $schedule, allowInactiveAgents: $allowInactiveAgents) @rest(type: "CreateSchedule", path: "scheduling/schedules?allowInactiveAgents={args.allowInactiveAgents}", method: "POST", bodyKey: "schedule") {
    id
  }
}
    `;
export type CreateScheduleMutationFn = Apollo.MutationFunction<CreateScheduleMutation, CreateScheduleMutationVariables>;
export type CreateScheduleComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateScheduleMutation, CreateScheduleMutationVariables>, 'mutation'>;

    export const CreateScheduleComponent = (props: CreateScheduleComponentProps) => (
      <ApolloReactComponents.Mutation<CreateScheduleMutation, CreateScheduleMutationVariables> mutation={CreateScheduleDocument} {...props} />
    );
    

/**
 * __useCreateScheduleMutation__
 *
 * To run a mutation, you first call `useCreateScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduleMutation, { data, loading, error }] = useCreateScheduleMutation({
 *   variables: {
 *      schedule: // value for 'schedule'
 *      allowInactiveAgents: // value for 'allowInactiveAgents'
 *   },
 * });
 */
export function useCreateScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduleMutation, CreateScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduleMutation, CreateScheduleMutationVariables>(CreateScheduleDocument, options);
      }
export type CreateScheduleMutationHookResult = ReturnType<typeof useCreateScheduleMutation>;
export type CreateScheduleMutationResult = Apollo.MutationResult<CreateScheduleMutation>;
export type CreateScheduleMutationOptions = Apollo.BaseMutationOptions<CreateScheduleMutation, CreateScheduleMutationVariables>;
export const CreateScheduleElementDocument = gql`
    mutation CreateScheduleElement($scheduleElement: ScheduleElementInput!) {
  createScheduleElement(scheduleElement: $scheduleElement) @rest(type: "CreateScheduleElement", path: "scheduling/schedule-elements", method: "POST", bodyKey: "scheduleElement") {
    id
  }
}
    `;
export type CreateScheduleElementMutationFn = Apollo.MutationFunction<CreateScheduleElementMutation, CreateScheduleElementMutationVariables>;
export type CreateScheduleElementComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateScheduleElementMutation, CreateScheduleElementMutationVariables>, 'mutation'>;

    export const CreateScheduleElementComponent = (props: CreateScheduleElementComponentProps) => (
      <ApolloReactComponents.Mutation<CreateScheduleElementMutation, CreateScheduleElementMutationVariables> mutation={CreateScheduleElementDocument} {...props} />
    );
    

/**
 * __useCreateScheduleElementMutation__
 *
 * To run a mutation, you first call `useCreateScheduleElementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduleElementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduleElementMutation, { data, loading, error }] = useCreateScheduleElementMutation({
 *   variables: {
 *      scheduleElement: // value for 'scheduleElement'
 *   },
 * });
 */
export function useCreateScheduleElementMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduleElementMutation, CreateScheduleElementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduleElementMutation, CreateScheduleElementMutationVariables>(CreateScheduleElementDocument, options);
      }
export type CreateScheduleElementMutationHookResult = ReturnType<typeof useCreateScheduleElementMutation>;
export type CreateScheduleElementMutationResult = Apollo.MutationResult<CreateScheduleElementMutation>;
export type CreateScheduleElementMutationOptions = Apollo.BaseMutationOptions<CreateScheduleElementMutation, CreateScheduleElementMutationVariables>;
export const DeleteScheduleDocument = gql`
    mutation DeleteSchedule($id: ID!) {
  deleteSchedule(id: $id) @rest(type: "DeleteSchedule", path: "scheduling/schedules/{args.id}", method: "DELETE") {
    id
  }
}
    `;
export type DeleteScheduleMutationFn = Apollo.MutationFunction<DeleteScheduleMutation, DeleteScheduleMutationVariables>;
export type DeleteScheduleComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteScheduleMutation, DeleteScheduleMutationVariables>, 'mutation'>;

    export const DeleteScheduleComponent = (props: DeleteScheduleComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteScheduleMutation, DeleteScheduleMutationVariables> mutation={DeleteScheduleDocument} {...props} />
    );
    

/**
 * __useDeleteScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduleMutation, { data, loading, error }] = useDeleteScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScheduleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScheduleMutation, DeleteScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScheduleMutation, DeleteScheduleMutationVariables>(DeleteScheduleDocument, options);
      }
export type DeleteScheduleMutationHookResult = ReturnType<typeof useDeleteScheduleMutation>;
export type DeleteScheduleMutationResult = Apollo.MutationResult<DeleteScheduleMutation>;
export type DeleteScheduleMutationOptions = Apollo.BaseMutationOptions<DeleteScheduleMutation, DeleteScheduleMutationVariables>;
export const DeleteScheduleElementDocument = gql`
    mutation DeleteScheduleElement($id: ID!) {
  deleteScheduleElement(id: $id) @rest(type: "DeleteScheduleElement", path: "scheduling/schedule-elements/{args.id}", method: "DELETE") {
    id
  }
}
    `;
export type DeleteScheduleElementMutationFn = Apollo.MutationFunction<DeleteScheduleElementMutation, DeleteScheduleElementMutationVariables>;
export type DeleteScheduleElementComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteScheduleElementMutation, DeleteScheduleElementMutationVariables>, 'mutation'>;

    export const DeleteScheduleElementComponent = (props: DeleteScheduleElementComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteScheduleElementMutation, DeleteScheduleElementMutationVariables> mutation={DeleteScheduleElementDocument} {...props} />
    );
    

/**
 * __useDeleteScheduleElementMutation__
 *
 * To run a mutation, you first call `useDeleteScheduleElementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduleElementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduleElementMutation, { data, loading, error }] = useDeleteScheduleElementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScheduleElementMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScheduleElementMutation, DeleteScheduleElementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScheduleElementMutation, DeleteScheduleElementMutationVariables>(DeleteScheduleElementDocument, options);
      }
export type DeleteScheduleElementMutationHookResult = ReturnType<typeof useDeleteScheduleElementMutation>;
export type DeleteScheduleElementMutationResult = Apollo.MutationResult<DeleteScheduleElementMutation>;
export type DeleteScheduleElementMutationOptions = Apollo.BaseMutationOptions<DeleteScheduleElementMutation, DeleteScheduleElementMutationVariables>;
export const CalculateEstimatedServiceLevelPerQueueDocument = gql`
    query calculateEstimatedServiceLevelPerQueue($startDateTime: String!, $endDateTime: String!, $scheduledStaffingPerQueue: [ESLStaffingPerQueueInput!]!) {
  estimatedServiceLevelPerQueue(
    startDateTime: $startDateTime
    endDateTime: $endDateTime
    scheduledStaffingPerQueue: $scheduledStaffingPerQueue
  ) @rest(type: "EstimatedServiceLevelPerQueueResponse", path: "forecasting/esl/v1/calculate/highcharts?startDateTime={args.startDateTime}&endDateTime={args.endDateTime}", method: "POST", bodyKey: "scheduledStaffingPerQueue") {
    eslQueues @type(name: [EstimatedServiceLevelPerQueue]) {
      ...EstimatedServiceLevelPerQueueFields
    }
  }
}
    ${EstimatedServiceLevelPerQueueFieldsFragmentDoc}`;
export type CalculateEstimatedServiceLevelPerQueueComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CalculateEstimatedServiceLevelPerQueueQuery, CalculateEstimatedServiceLevelPerQueueQueryVariables>, 'query'> & ({ variables: CalculateEstimatedServiceLevelPerQueueQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CalculateEstimatedServiceLevelPerQueueComponent = (props: CalculateEstimatedServiceLevelPerQueueComponentProps) => (
      <ApolloReactComponents.Query<CalculateEstimatedServiceLevelPerQueueQuery, CalculateEstimatedServiceLevelPerQueueQueryVariables> query={CalculateEstimatedServiceLevelPerQueueDocument} {...props} />
    );
    

/**
 * __useCalculateEstimatedServiceLevelPerQueueQuery__
 *
 * To run a query within a React component, call `useCalculateEstimatedServiceLevelPerQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateEstimatedServiceLevelPerQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateEstimatedServiceLevelPerQueueQuery({
 *   variables: {
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      scheduledStaffingPerQueue: // value for 'scheduledStaffingPerQueue'
 *   },
 * });
 */
export function useCalculateEstimatedServiceLevelPerQueueQuery(baseOptions: Apollo.QueryHookOptions<CalculateEstimatedServiceLevelPerQueueQuery, CalculateEstimatedServiceLevelPerQueueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateEstimatedServiceLevelPerQueueQuery, CalculateEstimatedServiceLevelPerQueueQueryVariables>(CalculateEstimatedServiceLevelPerQueueDocument, options);
      }
export function useCalculateEstimatedServiceLevelPerQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateEstimatedServiceLevelPerQueueQuery, CalculateEstimatedServiceLevelPerQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateEstimatedServiceLevelPerQueueQuery, CalculateEstimatedServiceLevelPerQueueQueryVariables>(CalculateEstimatedServiceLevelPerQueueDocument, options);
        }
export type CalculateEstimatedServiceLevelPerQueueQueryHookResult = ReturnType<typeof useCalculateEstimatedServiceLevelPerQueueQuery>;
export type CalculateEstimatedServiceLevelPerQueueLazyQueryHookResult = ReturnType<typeof useCalculateEstimatedServiceLevelPerQueueLazyQuery>;
export type CalculateEstimatedServiceLevelPerQueueQueryResult = Apollo.QueryResult<CalculateEstimatedServiceLevelPerQueueQuery, CalculateEstimatedServiceLevelPerQueueQueryVariables>;
export const GetAdherenceHistoryStartDateDocument = gql`
    query getAdherenceHistoryStartDate {
  adherenceHistoryStartDate @rest(type: "AdherenceHistoryStartDate", path: "scheduling/schedules/adherence/history/start-date") {
    ...AdherenceHistoryStartDateFields
  }
}
    ${AdherenceHistoryStartDateFieldsFragmentDoc}`;
export type GetAdherenceHistoryStartDateComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAdherenceHistoryStartDateQuery, GetAdherenceHistoryStartDateQueryVariables>, 'query'>;

    export const GetAdherenceHistoryStartDateComponent = (props: GetAdherenceHistoryStartDateComponentProps) => (
      <ApolloReactComponents.Query<GetAdherenceHistoryStartDateQuery, GetAdherenceHistoryStartDateQueryVariables> query={GetAdherenceHistoryStartDateDocument} {...props} />
    );
    

/**
 * __useGetAdherenceHistoryStartDateQuery__
 *
 * To run a query within a React component, call `useGetAdherenceHistoryStartDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdherenceHistoryStartDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdherenceHistoryStartDateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdherenceHistoryStartDateQuery(baseOptions?: Apollo.QueryHookOptions<GetAdherenceHistoryStartDateQuery, GetAdherenceHistoryStartDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdherenceHistoryStartDateQuery, GetAdherenceHistoryStartDateQueryVariables>(GetAdherenceHistoryStartDateDocument, options);
      }
export function useGetAdherenceHistoryStartDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdherenceHistoryStartDateQuery, GetAdherenceHistoryStartDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdherenceHistoryStartDateQuery, GetAdherenceHistoryStartDateQueryVariables>(GetAdherenceHistoryStartDateDocument, options);
        }
export type GetAdherenceHistoryStartDateQueryHookResult = ReturnType<typeof useGetAdherenceHistoryStartDateQuery>;
export type GetAdherenceHistoryStartDateLazyQueryHookResult = ReturnType<typeof useGetAdherenceHistoryStartDateLazyQuery>;
export type GetAdherenceHistoryStartDateQueryResult = Apollo.QueryResult<GetAdherenceHistoryStartDateQuery, GetAdherenceHistoryStartDateQueryVariables>;
export const GetAgentProductionOverviewScheduleDocument = gql`
    query getAgentProductionOverviewSchedule($agentId: ID!, $startDateTime: String!, $endDateTime: String!, $startDateTimeStats: String, $endDateTimeStats: String, $timezone: String!) {
  agentProductionOverviewSchedule(
    agentId: $agentId
    startDateTime: $startDateTime
    startDateTimeStats: $startDateTimeStats
    endDateTime: $endDateTime
    endDateTimeStats: $endDateTimeStats
    timezone: $timezone
  ) @rest(type: "AgentProductionOverviewSchedule", path: "scheduling/schedules/production/overview/agent/{args.agentId}?{args}") {
    agentId
    scheduleDailyOverview @type(name: ScheduleDailyOverview) {
      ...AgentScheduleOverviewFields
    }
    stats @type(name: AgentScheduleStats) {
      ...AgentScheduleStatsFields
    }
  }
}
    ${AgentScheduleOverviewFieldsFragmentDoc}
${AgentScheduleStatsFieldsFragmentDoc}`;
export type GetAgentProductionOverviewScheduleComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAgentProductionOverviewScheduleQuery, GetAgentProductionOverviewScheduleQueryVariables>, 'query'> & ({ variables: GetAgentProductionOverviewScheduleQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAgentProductionOverviewScheduleComponent = (props: GetAgentProductionOverviewScheduleComponentProps) => (
      <ApolloReactComponents.Query<GetAgentProductionOverviewScheduleQuery, GetAgentProductionOverviewScheduleQueryVariables> query={GetAgentProductionOverviewScheduleDocument} {...props} />
    );
    

/**
 * __useGetAgentProductionOverviewScheduleQuery__
 *
 * To run a query within a React component, call `useGetAgentProductionOverviewScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentProductionOverviewScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentProductionOverviewScheduleQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      startDateTimeStats: // value for 'startDateTimeStats'
 *      endDateTimeStats: // value for 'endDateTimeStats'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useGetAgentProductionOverviewScheduleQuery(baseOptions: Apollo.QueryHookOptions<GetAgentProductionOverviewScheduleQuery, GetAgentProductionOverviewScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentProductionOverviewScheduleQuery, GetAgentProductionOverviewScheduleQueryVariables>(GetAgentProductionOverviewScheduleDocument, options);
      }
export function useGetAgentProductionOverviewScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentProductionOverviewScheduleQuery, GetAgentProductionOverviewScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentProductionOverviewScheduleQuery, GetAgentProductionOverviewScheduleQueryVariables>(GetAgentProductionOverviewScheduleDocument, options);
        }
export type GetAgentProductionOverviewScheduleQueryHookResult = ReturnType<typeof useGetAgentProductionOverviewScheduleQuery>;
export type GetAgentProductionOverviewScheduleLazyQueryHookResult = ReturnType<typeof useGetAgentProductionOverviewScheduleLazyQuery>;
export type GetAgentProductionOverviewScheduleQueryResult = Apollo.QueryResult<GetAgentProductionOverviewScheduleQuery, GetAgentProductionOverviewScheduleQueryVariables>;
export const GetAgentProductionScheduleDocument = gql`
    query getAgentProductionSchedule($agentId: ID!, $startDateTime: String!, $endDateTime: String!, $timezone: String!) {
  agentProductionSchedule(
    agentId: $agentId
    startDateTime: $startDateTime
    endDateTime: $endDateTime
    timezone: $timezone
  ) @rest(type: "AgentProductionSchedule", path: "scheduling/schedules/production/agent/{args.agentId}?{args}") {
    agentId
    dailyShifts @type(name: AgentScheduleDailyShift) {
      ...AgentScheduleDailyShiftFields
    }
    scheduleItems @type(name: ScheduleItem) {
      ...AgentScheduleItemFields
    }
    stats @type(name: AgentScheduleStats) {
      ...AgentScheduleStatsFields
    }
  }
}
    ${AgentScheduleDailyShiftFieldsFragmentDoc}
${AgentScheduleItemFieldsFragmentDoc}
${AgentScheduleStatsFieldsFragmentDoc}`;
export type GetAgentProductionScheduleComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAgentProductionScheduleQuery, GetAgentProductionScheduleQueryVariables>, 'query'> & ({ variables: GetAgentProductionScheduleQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAgentProductionScheduleComponent = (props: GetAgentProductionScheduleComponentProps) => (
      <ApolloReactComponents.Query<GetAgentProductionScheduleQuery, GetAgentProductionScheduleQueryVariables> query={GetAgentProductionScheduleDocument} {...props} />
    );
    

/**
 * __useGetAgentProductionScheduleQuery__
 *
 * To run a query within a React component, call `useGetAgentProductionScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentProductionScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentProductionScheduleQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useGetAgentProductionScheduleQuery(baseOptions: Apollo.QueryHookOptions<GetAgentProductionScheduleQuery, GetAgentProductionScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentProductionScheduleQuery, GetAgentProductionScheduleQueryVariables>(GetAgentProductionScheduleDocument, options);
      }
export function useGetAgentProductionScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentProductionScheduleQuery, GetAgentProductionScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentProductionScheduleQuery, GetAgentProductionScheduleQueryVariables>(GetAgentProductionScheduleDocument, options);
        }
export type GetAgentProductionScheduleQueryHookResult = ReturnType<typeof useGetAgentProductionScheduleQuery>;
export type GetAgentProductionScheduleLazyQueryHookResult = ReturnType<typeof useGetAgentProductionScheduleLazyQuery>;
export type GetAgentProductionScheduleQueryResult = Apollo.QueryResult<GetAgentProductionScheduleQuery, GetAgentProductionScheduleQueryVariables>;
export const GetAgentProductionScheduleWithoutStatsDocument = gql`
    query getAgentProductionScheduleWithoutStats($parameters: AgentProductionScheduleWithoutStatsInput!) {
  agentProductionScheduleWithoutStats(parameters: $parameters) @rest(type: "AgentProductionScheduleWithoutStats", path: "scheduling/schedules/production/agent", method: "POST", bodyKey: "parameters") {
    scheduleItems @type(name: ScheduleItem) {
      ...AgentScheduleItemFields
    }
  }
}
    ${AgentScheduleItemFieldsFragmentDoc}`;
export type GetAgentProductionScheduleWithoutStatsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAgentProductionScheduleWithoutStatsQuery, GetAgentProductionScheduleWithoutStatsQueryVariables>, 'query'> & ({ variables: GetAgentProductionScheduleWithoutStatsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAgentProductionScheduleWithoutStatsComponent = (props: GetAgentProductionScheduleWithoutStatsComponentProps) => (
      <ApolloReactComponents.Query<GetAgentProductionScheduleWithoutStatsQuery, GetAgentProductionScheduleWithoutStatsQueryVariables> query={GetAgentProductionScheduleWithoutStatsDocument} {...props} />
    );
    

/**
 * __useGetAgentProductionScheduleWithoutStatsQuery__
 *
 * To run a query within a React component, call `useGetAgentProductionScheduleWithoutStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentProductionScheduleWithoutStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentProductionScheduleWithoutStatsQuery({
 *   variables: {
 *      parameters: // value for 'parameters'
 *   },
 * });
 */
export function useGetAgentProductionScheduleWithoutStatsQuery(baseOptions: Apollo.QueryHookOptions<GetAgentProductionScheduleWithoutStatsQuery, GetAgentProductionScheduleWithoutStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentProductionScheduleWithoutStatsQuery, GetAgentProductionScheduleWithoutStatsQueryVariables>(GetAgentProductionScheduleWithoutStatsDocument, options);
      }
export function useGetAgentProductionScheduleWithoutStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentProductionScheduleWithoutStatsQuery, GetAgentProductionScheduleWithoutStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentProductionScheduleWithoutStatsQuery, GetAgentProductionScheduleWithoutStatsQueryVariables>(GetAgentProductionScheduleWithoutStatsDocument, options);
        }
export type GetAgentProductionScheduleWithoutStatsQueryHookResult = ReturnType<typeof useGetAgentProductionScheduleWithoutStatsQuery>;
export type GetAgentProductionScheduleWithoutStatsLazyQueryHookResult = ReturnType<typeof useGetAgentProductionScheduleWithoutStatsLazyQuery>;
export type GetAgentProductionScheduleWithoutStatsQueryResult = Apollo.QueryResult<GetAgentProductionScheduleWithoutStatsQuery, GetAgentProductionScheduleWithoutStatsQueryVariables>;
export const GetAgentsProductionSchedulesDocument = gql`
    query getAgentsProductionSchedules($parameters: AgentsProductionSchedulesInput!) {
  agentsProductionSchedules(parameters: $parameters) @rest(type: "AgentsProductionSchedulesData", path: "scheduling/schedules/production/agent/queue-schedules", method: "POST", bodyKey: "parameters") {
    agent @type(name: Agent) {
      ...AgentFields
    }
    productionSchedules @type(name: ScheduleInfo) {
      ...ScheduleInfoFields
    }
  }
}
    ${AgentFieldsFragmentDoc}
${ScheduleInfoFieldsFragmentDoc}`;
export type GetAgentsProductionSchedulesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAgentsProductionSchedulesQuery, GetAgentsProductionSchedulesQueryVariables>, 'query'> & ({ variables: GetAgentsProductionSchedulesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAgentsProductionSchedulesComponent = (props: GetAgentsProductionSchedulesComponentProps) => (
      <ApolloReactComponents.Query<GetAgentsProductionSchedulesQuery, GetAgentsProductionSchedulesQueryVariables> query={GetAgentsProductionSchedulesDocument} {...props} />
    );
    

/**
 * __useGetAgentsProductionSchedulesQuery__
 *
 * To run a query within a React component, call `useGetAgentsProductionSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentsProductionSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentsProductionSchedulesQuery({
 *   variables: {
 *      parameters: // value for 'parameters'
 *   },
 * });
 */
export function useGetAgentsProductionSchedulesQuery(baseOptions: Apollo.QueryHookOptions<GetAgentsProductionSchedulesQuery, GetAgentsProductionSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentsProductionSchedulesQuery, GetAgentsProductionSchedulesQueryVariables>(GetAgentsProductionSchedulesDocument, options);
      }
export function useGetAgentsProductionSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentsProductionSchedulesQuery, GetAgentsProductionSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentsProductionSchedulesQuery, GetAgentsProductionSchedulesQueryVariables>(GetAgentsProductionSchedulesDocument, options);
        }
export type GetAgentsProductionSchedulesQueryHookResult = ReturnType<typeof useGetAgentsProductionSchedulesQuery>;
export type GetAgentsProductionSchedulesLazyQueryHookResult = ReturnType<typeof useGetAgentsProductionSchedulesLazyQuery>;
export type GetAgentsProductionSchedulesQueryResult = Apollo.QueryResult<GetAgentsProductionSchedulesQuery, GetAgentsProductionSchedulesQueryVariables>;
export const GetCalendarExportUrlDocument = gql`
    query getCalendarExportURL($agentId: ID!) {
  getCalendarExportURL(agentId: $agentId) @rest(type: "GetCalendarExportURL", path: "scheduling/schedule-export/info/production/agent/{args.agentId}", method: "GET") {
    url
  }
}
    `;
export type GetCalendarExportUrlComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCalendarExportUrlQuery, GetCalendarExportUrlQueryVariables>, 'query'> & ({ variables: GetCalendarExportUrlQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetCalendarExportUrlComponent = (props: GetCalendarExportUrlComponentProps) => (
      <ApolloReactComponents.Query<GetCalendarExportUrlQuery, GetCalendarExportUrlQueryVariables> query={GetCalendarExportUrlDocument} {...props} />
    );
    

/**
 * __useGetCalendarExportUrlQuery__
 *
 * To run a query within a React component, call `useGetCalendarExportUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarExportUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarExportUrlQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useGetCalendarExportUrlQuery(baseOptions: Apollo.QueryHookOptions<GetCalendarExportUrlQuery, GetCalendarExportUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalendarExportUrlQuery, GetCalendarExportUrlQueryVariables>(GetCalendarExportUrlDocument, options);
      }
export function useGetCalendarExportUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalendarExportUrlQuery, GetCalendarExportUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalendarExportUrlQuery, GetCalendarExportUrlQueryVariables>(GetCalendarExportUrlDocument, options);
        }
export type GetCalendarExportUrlQueryHookResult = ReturnType<typeof useGetCalendarExportUrlQuery>;
export type GetCalendarExportUrlLazyQueryHookResult = ReturnType<typeof useGetCalendarExportUrlLazyQuery>;
export type GetCalendarExportUrlQueryResult = Apollo.QueryResult<GetCalendarExportUrlQuery, GetCalendarExportUrlQueryVariables>;
export const GetProductionScheduleElementsFromOtherSchedulesDocument = gql`
    query getProductionScheduleElementsFromOtherSchedules($parameters: ProductionScheduleElementsFromOtherSchedulesInput!) {
  productionScheduleElementsFromOtherSchedules(parameters: $parameters) @rest(type: "ProductionScheduleItemsExtended", path: "scheduling/schedules/production/agent/studio", method: "POST", bodyKey: "parameters") {
    queueIntervals @type(name: ProductionScheduleRangeIntervals) {
      ...ProductionScheduleRangeIntervalsFields
    }
    queuesDetails @type(name: ProductionScheduleQueuesDetails) {
      ...ProductionScheduleQueuesDetailsFields
    }
    scheduleItems @type(name: ScheduleItemExtended) {
      ...ScheduleItemExtendedFields
    }
  }
}
    ${ProductionScheduleRangeIntervalsFieldsFragmentDoc}
${ProductionScheduleQueuesDetailsFieldsFragmentDoc}
${ScheduleItemExtendedFieldsFragmentDoc}`;
export type GetProductionScheduleElementsFromOtherSchedulesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProductionScheduleElementsFromOtherSchedulesQuery, GetProductionScheduleElementsFromOtherSchedulesQueryVariables>, 'query'> & ({ variables: GetProductionScheduleElementsFromOtherSchedulesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetProductionScheduleElementsFromOtherSchedulesComponent = (props: GetProductionScheduleElementsFromOtherSchedulesComponentProps) => (
      <ApolloReactComponents.Query<GetProductionScheduleElementsFromOtherSchedulesQuery, GetProductionScheduleElementsFromOtherSchedulesQueryVariables> query={GetProductionScheduleElementsFromOtherSchedulesDocument} {...props} />
    );
    

/**
 * __useGetProductionScheduleElementsFromOtherSchedulesQuery__
 *
 * To run a query within a React component, call `useGetProductionScheduleElementsFromOtherSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductionScheduleElementsFromOtherSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductionScheduleElementsFromOtherSchedulesQuery({
 *   variables: {
 *      parameters: // value for 'parameters'
 *   },
 * });
 */
export function useGetProductionScheduleElementsFromOtherSchedulesQuery(baseOptions: Apollo.QueryHookOptions<GetProductionScheduleElementsFromOtherSchedulesQuery, GetProductionScheduleElementsFromOtherSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductionScheduleElementsFromOtherSchedulesQuery, GetProductionScheduleElementsFromOtherSchedulesQueryVariables>(GetProductionScheduleElementsFromOtherSchedulesDocument, options);
      }
export function useGetProductionScheduleElementsFromOtherSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductionScheduleElementsFromOtherSchedulesQuery, GetProductionScheduleElementsFromOtherSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductionScheduleElementsFromOtherSchedulesQuery, GetProductionScheduleElementsFromOtherSchedulesQueryVariables>(GetProductionScheduleElementsFromOtherSchedulesDocument, options);
        }
export type GetProductionScheduleElementsFromOtherSchedulesQueryHookResult = ReturnType<typeof useGetProductionScheduleElementsFromOtherSchedulesQuery>;
export type GetProductionScheduleElementsFromOtherSchedulesLazyQueryHookResult = ReturnType<typeof useGetProductionScheduleElementsFromOtherSchedulesLazyQuery>;
export type GetProductionScheduleElementsFromOtherSchedulesQueryResult = Apollo.QueryResult<GetProductionScheduleElementsFromOtherSchedulesQuery, GetProductionScheduleElementsFromOtherSchedulesQueryVariables>;
export const GetProductionScheduleReportDocument = gql`
    query getProductionScheduleReport($docType: DocTypeEnum!, $queueId: ID!, $startDateTime: String!, $endDateTime: String!) {
  productionScheduleReport(
    docType: $docType
    queueId: $queueId
    startDateTime: $startDateTime
    endDateTime: $endDateTime
  ) @rest(type: "ProductionScheduleReport", path: "scheduling/schedules/production/report/{args.queueId}?{args}")
}
    `;
export type GetProductionScheduleReportComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProductionScheduleReportQuery, GetProductionScheduleReportQueryVariables>, 'query'> & ({ variables: GetProductionScheduleReportQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetProductionScheduleReportComponent = (props: GetProductionScheduleReportComponentProps) => (
      <ApolloReactComponents.Query<GetProductionScheduleReportQuery, GetProductionScheduleReportQueryVariables> query={GetProductionScheduleReportDocument} {...props} />
    );
    

/**
 * __useGetProductionScheduleReportQuery__
 *
 * To run a query within a React component, call `useGetProductionScheduleReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductionScheduleReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductionScheduleReportQuery({
 *   variables: {
 *      docType: // value for 'docType'
 *      queueId: // value for 'queueId'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useGetProductionScheduleReportQuery(baseOptions: Apollo.QueryHookOptions<GetProductionScheduleReportQuery, GetProductionScheduleReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductionScheduleReportQuery, GetProductionScheduleReportQueryVariables>(GetProductionScheduleReportDocument, options);
      }
export function useGetProductionScheduleReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductionScheduleReportQuery, GetProductionScheduleReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductionScheduleReportQuery, GetProductionScheduleReportQueryVariables>(GetProductionScheduleReportDocument, options);
        }
export type GetProductionScheduleReportQueryHookResult = ReturnType<typeof useGetProductionScheduleReportQuery>;
export type GetProductionScheduleReportLazyQueryHookResult = ReturnType<typeof useGetProductionScheduleReportLazyQuery>;
export type GetProductionScheduleReportQueryResult = Apollo.QueryResult<GetProductionScheduleReportQuery, GetProductionScheduleReportQueryVariables>;
export const GetProductionSchedulesPerQueuesDocument = gql`
    query GetProductionSchedulesPerQueues($queueIds: [ID!]!, $startDateTime: String!, $endDateTime: String!) {
  productionSchedulesPerQueues(
    queueIds: $queueIds
    startDateTime: $startDateTime
    endDateTime: $endDateTime
  ) @rest(type: "ProductionSchedule", path: "scheduling/schedules/production/info?{args}") {
    ...ProductionScheduleFields
  }
}
    ${ProductionScheduleFieldsFragmentDoc}`;
export type GetProductionSchedulesPerQueuesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetProductionSchedulesPerQueuesQuery, GetProductionSchedulesPerQueuesQueryVariables>, 'query'> & ({ variables: GetProductionSchedulesPerQueuesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetProductionSchedulesPerQueuesComponent = (props: GetProductionSchedulesPerQueuesComponentProps) => (
      <ApolloReactComponents.Query<GetProductionSchedulesPerQueuesQuery, GetProductionSchedulesPerQueuesQueryVariables> query={GetProductionSchedulesPerQueuesDocument} {...props} />
    );
    

/**
 * __useGetProductionSchedulesPerQueuesQuery__
 *
 * To run a query within a React component, call `useGetProductionSchedulesPerQueuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductionSchedulesPerQueuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductionSchedulesPerQueuesQuery({
 *   variables: {
 *      queueIds: // value for 'queueIds'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useGetProductionSchedulesPerQueuesQuery(baseOptions: Apollo.QueryHookOptions<GetProductionSchedulesPerQueuesQuery, GetProductionSchedulesPerQueuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductionSchedulesPerQueuesQuery, GetProductionSchedulesPerQueuesQueryVariables>(GetProductionSchedulesPerQueuesDocument, options);
      }
export function useGetProductionSchedulesPerQueuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductionSchedulesPerQueuesQuery, GetProductionSchedulesPerQueuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductionSchedulesPerQueuesQuery, GetProductionSchedulesPerQueuesQueryVariables>(GetProductionSchedulesPerQueuesDocument, options);
        }
export type GetProductionSchedulesPerQueuesQueryHookResult = ReturnType<typeof useGetProductionSchedulesPerQueuesQuery>;
export type GetProductionSchedulesPerQueuesLazyQueryHookResult = ReturnType<typeof useGetProductionSchedulesPerQueuesLazyQuery>;
export type GetProductionSchedulesPerQueuesQueryResult = Apollo.QueryResult<GetProductionSchedulesPerQueuesQuery, GetProductionSchedulesPerQueuesQueryVariables>;
export const GetQueuesStaffingFromOtherProductionSchedulesDocument = gql`
    query getQueuesStaffingFromOtherProductionSchedules($parameters: GetQueuesStaffingFromOtherProductionSchedulesInput!) {
  queuesStaffingFromOtherProductionSchedules(parameters: $parameters) @rest(type: "StaffingPerQueue", path: "scheduling/schedules/production/queue-staffing?{args.parameters}") {
    ...StaffingPerQueueFields
  }
}
    ${StaffingPerQueueFieldsFragmentDoc}`;
export type GetQueuesStaffingFromOtherProductionSchedulesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetQueuesStaffingFromOtherProductionSchedulesQuery, GetQueuesStaffingFromOtherProductionSchedulesQueryVariables>, 'query'> & ({ variables: GetQueuesStaffingFromOtherProductionSchedulesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetQueuesStaffingFromOtherProductionSchedulesComponent = (props: GetQueuesStaffingFromOtherProductionSchedulesComponentProps) => (
      <ApolloReactComponents.Query<GetQueuesStaffingFromOtherProductionSchedulesQuery, GetQueuesStaffingFromOtherProductionSchedulesQueryVariables> query={GetQueuesStaffingFromOtherProductionSchedulesDocument} {...props} />
    );
    

/**
 * __useGetQueuesStaffingFromOtherProductionSchedulesQuery__
 *
 * To run a query within a React component, call `useGetQueuesStaffingFromOtherProductionSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQueuesStaffingFromOtherProductionSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQueuesStaffingFromOtherProductionSchedulesQuery({
 *   variables: {
 *      parameters: // value for 'parameters'
 *   },
 * });
 */
export function useGetQueuesStaffingFromOtherProductionSchedulesQuery(baseOptions: Apollo.QueryHookOptions<GetQueuesStaffingFromOtherProductionSchedulesQuery, GetQueuesStaffingFromOtherProductionSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQueuesStaffingFromOtherProductionSchedulesQuery, GetQueuesStaffingFromOtherProductionSchedulesQueryVariables>(GetQueuesStaffingFromOtherProductionSchedulesDocument, options);
      }
export function useGetQueuesStaffingFromOtherProductionSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQueuesStaffingFromOtherProductionSchedulesQuery, GetQueuesStaffingFromOtherProductionSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQueuesStaffingFromOtherProductionSchedulesQuery, GetQueuesStaffingFromOtherProductionSchedulesQueryVariables>(GetQueuesStaffingFromOtherProductionSchedulesDocument, options);
        }
export type GetQueuesStaffingFromOtherProductionSchedulesQueryHookResult = ReturnType<typeof useGetQueuesStaffingFromOtherProductionSchedulesQuery>;
export type GetQueuesStaffingFromOtherProductionSchedulesLazyQueryHookResult = ReturnType<typeof useGetQueuesStaffingFromOtherProductionSchedulesLazyQuery>;
export type GetQueuesStaffingFromOtherProductionSchedulesQueryResult = Apollo.QueryResult<GetQueuesStaffingFromOtherProductionSchedulesQuery, GetQueuesStaffingFromOtherProductionSchedulesQueryVariables>;
export const GetScheduleDocument = gql`
    query getSchedule($id: ID!) {
  schedule(id: $id) @rest(type: "Schedule", path: "scheduling/schedules/{args.id}?includePtoItems=false") {
    info @type(name: ScheduleInfo) {
      ...ScheduleInfoFields
    }
    scheduleItems @type(name: ScheduleItem) {
      ...ScheduleItemFields
    }
    scheduledAgents @type(name: ScheduledAgent) {
      ...ScheduledAgentFields
    }
    scheduleQueues @type(name: StaffingPerQueue) {
      ...StaffingPerQueueFields
    }
    daysSettings @type(name: ScheduleDaySettings) {
      ...ScheduleDaySettingsFields
    }
  }
}
    ${ScheduleInfoFieldsFragmentDoc}
${ScheduleItemFieldsFragmentDoc}
${ScheduledAgentFieldsFragmentDoc}
${StaffingPerQueueFieldsFragmentDoc}
${ScheduleDaySettingsFieldsFragmentDoc}`;
export type GetScheduleComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetScheduleQuery, GetScheduleQueryVariables>, 'query'> & ({ variables: GetScheduleQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetScheduleComponent = (props: GetScheduleComponentProps) => (
      <ApolloReactComponents.Query<GetScheduleQuery, GetScheduleQueryVariables> query={GetScheduleDocument} {...props} />
    );
    

/**
 * __useGetScheduleQuery__
 *
 * To run a query within a React component, call `useGetScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetScheduleQuery(baseOptions: Apollo.QueryHookOptions<GetScheduleQuery, GetScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduleQuery, GetScheduleQueryVariables>(GetScheduleDocument, options);
      }
export function useGetScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduleQuery, GetScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduleQuery, GetScheduleQueryVariables>(GetScheduleDocument, options);
        }
export type GetScheduleQueryHookResult = ReturnType<typeof useGetScheduleQuery>;
export type GetScheduleLazyQueryHookResult = ReturnType<typeof useGetScheduleLazyQuery>;
export type GetScheduleQueryResult = Apollo.QueryResult<GetScheduleQuery, GetScheduleQueryVariables>;
export const GetScheduleElementDocument = gql`
    query getScheduleElement($id: ID!) {
  scheduleElement(id: $id) @rest(type: "ScheduleElement", path: "scheduling/schedule-elements/{args.id}") {
    ...ScheduleElementFields
  }
}
    ${ScheduleElementFieldsFragmentDoc}`;
export type GetScheduleElementComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetScheduleElementQuery, GetScheduleElementQueryVariables>, 'query'> & ({ variables: GetScheduleElementQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetScheduleElementComponent = (props: GetScheduleElementComponentProps) => (
      <ApolloReactComponents.Query<GetScheduleElementQuery, GetScheduleElementQueryVariables> query={GetScheduleElementDocument} {...props} />
    );
    

/**
 * __useGetScheduleElementQuery__
 *
 * To run a query within a React component, call `useGetScheduleElementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleElementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleElementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetScheduleElementQuery(baseOptions: Apollo.QueryHookOptions<GetScheduleElementQuery, GetScheduleElementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduleElementQuery, GetScheduleElementQueryVariables>(GetScheduleElementDocument, options);
      }
export function useGetScheduleElementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduleElementQuery, GetScheduleElementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduleElementQuery, GetScheduleElementQueryVariables>(GetScheduleElementDocument, options);
        }
export type GetScheduleElementQueryHookResult = ReturnType<typeof useGetScheduleElementQuery>;
export type GetScheduleElementLazyQueryHookResult = ReturnType<typeof useGetScheduleElementLazyQuery>;
export type GetScheduleElementQueryResult = Apollo.QueryResult<GetScheduleElementQuery, GetScheduleElementQueryVariables>;
export const GetScheduleElementsDocument = gql`
    query getScheduleElements {
  scheduleElements @rest(type: "ScheduleElement", path: "scheduling/schedule-elements") {
    ...ScheduleElementFields
  }
}
    ${ScheduleElementFieldsFragmentDoc}`;
export type GetScheduleElementsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetScheduleElementsQuery, GetScheduleElementsQueryVariables>, 'query'>;

    export const GetScheduleElementsComponent = (props: GetScheduleElementsComponentProps) => (
      <ApolloReactComponents.Query<GetScheduleElementsQuery, GetScheduleElementsQueryVariables> query={GetScheduleElementsDocument} {...props} />
    );
    

/**
 * __useGetScheduleElementsQuery__
 *
 * To run a query within a React component, call `useGetScheduleElementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleElementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleElementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetScheduleElementsQuery(baseOptions?: Apollo.QueryHookOptions<GetScheduleElementsQuery, GetScheduleElementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduleElementsQuery, GetScheduleElementsQueryVariables>(GetScheduleElementsDocument, options);
      }
export function useGetScheduleElementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduleElementsQuery, GetScheduleElementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduleElementsQuery, GetScheduleElementsQueryVariables>(GetScheduleElementsDocument, options);
        }
export type GetScheduleElementsQueryHookResult = ReturnType<typeof useGetScheduleElementsQuery>;
export type GetScheduleElementsLazyQueryHookResult = ReturnType<typeof useGetScheduleElementsLazyQuery>;
export type GetScheduleElementsQueryResult = Apollo.QueryResult<GetScheduleElementsQuery, GetScheduleElementsQueryVariables>;
export const GetSchedulesDocument = gql`
    query getSchedules($queueIds: ID, $scheduleName: String, $scheduleStartDateTime: String, $scheduleEndDateTime: String) {
  schedules(
    queueIds: $queueIds
    scheduleName: $scheduleName
    scheduleStartDateTime: $scheduleStartDateTime
    scheduleEndDateTime: $scheduleEndDateTime
  ) @rest(type: "ScheduleInfo", path: "scheduling/schedules?{args}") {
    ...ScheduleInfoFields
  }
  queues @rest(type: "Queue", path: "queue-management/queues") {
    id
    name
  }
}
    ${ScheduleInfoFieldsFragmentDoc}`;
export type GetSchedulesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSchedulesQuery, GetSchedulesQueryVariables>, 'query'>;

    export const GetSchedulesComponent = (props: GetSchedulesComponentProps) => (
      <ApolloReactComponents.Query<GetSchedulesQuery, GetSchedulesQueryVariables> query={GetSchedulesDocument} {...props} />
    );
    

/**
 * __useGetSchedulesQuery__
 *
 * To run a query within a React component, call `useGetSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchedulesQuery({
 *   variables: {
 *      queueIds: // value for 'queueIds'
 *      scheduleName: // value for 'scheduleName'
 *      scheduleStartDateTime: // value for 'scheduleStartDateTime'
 *      scheduleEndDateTime: // value for 'scheduleEndDateTime'
 *   },
 * });
 */
export function useGetSchedulesQuery(baseOptions?: Apollo.QueryHookOptions<GetSchedulesQuery, GetSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchedulesQuery, GetSchedulesQueryVariables>(GetSchedulesDocument, options);
      }
export function useGetSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchedulesQuery, GetSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchedulesQuery, GetSchedulesQueryVariables>(GetSchedulesDocument, options);
        }
export type GetSchedulesQueryHookResult = ReturnType<typeof useGetSchedulesQuery>;
export type GetSchedulesLazyQueryHookResult = ReturnType<typeof useGetSchedulesLazyQuery>;
export type GetSchedulesQueryResult = Apollo.QueryResult<GetSchedulesQuery, GetSchedulesQueryVariables>;
export const GetSchedulesInfoDocument = gql`
    query getSchedulesInfo($scheduleIds: ID!) {
  schedulesInfo(scheduleIds: $scheduleIds) @rest(type: "ScheduleInfo", path: "scheduling/schedules/info?{args}") {
    ...ScheduleInfoFields
  }
}
    ${ScheduleInfoFieldsFragmentDoc}`;
export type GetSchedulesInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSchedulesInfoQuery, GetSchedulesInfoQueryVariables>, 'query'> & ({ variables: GetSchedulesInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSchedulesInfoComponent = (props: GetSchedulesInfoComponentProps) => (
      <ApolloReactComponents.Query<GetSchedulesInfoQuery, GetSchedulesInfoQueryVariables> query={GetSchedulesInfoDocument} {...props} />
    );
    

/**
 * __useGetSchedulesInfoQuery__
 *
 * To run a query within a React component, call `useGetSchedulesInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchedulesInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchedulesInfoQuery({
 *   variables: {
 *      scheduleIds: // value for 'scheduleIds'
 *   },
 * });
 */
export function useGetSchedulesInfoQuery(baseOptions: Apollo.QueryHookOptions<GetSchedulesInfoQuery, GetSchedulesInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchedulesInfoQuery, GetSchedulesInfoQueryVariables>(GetSchedulesInfoDocument, options);
      }
export function useGetSchedulesInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchedulesInfoQuery, GetSchedulesInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchedulesInfoQuery, GetSchedulesInfoQueryVariables>(GetSchedulesInfoDocument, options);
        }
export type GetSchedulesInfoQueryHookResult = ReturnType<typeof useGetSchedulesInfoQuery>;
export type GetSchedulesInfoLazyQueryHookResult = ReturnType<typeof useGetSchedulesInfoLazyQuery>;
export type GetSchedulesInfoQueryResult = Apollo.QueryResult<GetSchedulesInfoQuery, GetSchedulesInfoQueryVariables>;
export const GetAgentSchedulesInfoDocument = gql`
    query getAgentSchedulesInfo($agentId: ID!, $startDateTime: String, $endDateTime: String) {
  agentSchedulesInfo(
    agentId: $agentId
    fromDate: $startDateTime
    endDate: $endDateTime
  ) @rest(type: "ScheduleInfo", path: "scheduling/schedules/info/agent/{args.agentId}?{args}") {
    ...ScheduleInfoFields
  }
}
    ${ScheduleInfoFieldsFragmentDoc}`;
export type GetAgentSchedulesInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAgentSchedulesInfoQuery, GetAgentSchedulesInfoQueryVariables>, 'query'> & ({ variables: GetAgentSchedulesInfoQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAgentSchedulesInfoComponent = (props: GetAgentSchedulesInfoComponentProps) => (
      <ApolloReactComponents.Query<GetAgentSchedulesInfoQuery, GetAgentSchedulesInfoQueryVariables> query={GetAgentSchedulesInfoDocument} {...props} />
    );
    

/**
 * __useGetAgentSchedulesInfoQuery__
 *
 * To run a query within a React component, call `useGetAgentSchedulesInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentSchedulesInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentSchedulesInfoQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      startDateTime: // value for 'startDateTime'
 *      endDateTime: // value for 'endDateTime'
 *   },
 * });
 */
export function useGetAgentSchedulesInfoQuery(baseOptions: Apollo.QueryHookOptions<GetAgentSchedulesInfoQuery, GetAgentSchedulesInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentSchedulesInfoQuery, GetAgentSchedulesInfoQueryVariables>(GetAgentSchedulesInfoDocument, options);
      }
export function useGetAgentSchedulesInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentSchedulesInfoQuery, GetAgentSchedulesInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentSchedulesInfoQuery, GetAgentSchedulesInfoQueryVariables>(GetAgentSchedulesInfoDocument, options);
        }
export type GetAgentSchedulesInfoQueryHookResult = ReturnType<typeof useGetAgentSchedulesInfoQuery>;
export type GetAgentSchedulesInfoLazyQueryHookResult = ReturnType<typeof useGetAgentSchedulesInfoLazyQuery>;
export type GetAgentSchedulesInfoQueryResult = Apollo.QueryResult<GetAgentSchedulesInfoQuery, GetAgentSchedulesInfoQueryVariables>;
export const GetSupervisedAdherenceHistoryDocument = gql`
    query getSupervisedAdherenceHistory($supervisorId: ID!, $adherenceHistorySearchCriteria: AdherenceHistorySearchCriteriaInput!) {
  supervisedAdherenceHistory(
    supervisorId: $supervisorId
    adherenceHistorySearchCriteria: $adherenceHistorySearchCriteria
  ) @rest(bodyKey: "adherenceHistorySearchCriteria", method: "POST", path: "scheduling/supervisors/{args.supervisorId}/schedules/adherence/history/search", type: "AdherenceHistory") {
    adherenceHistoryList @type(name: AdherenceHistoryItem) {
      ...AdherenceHistoryItemFields
    }
    totalCount
  }
}
    ${AdherenceHistoryItemFieldsFragmentDoc}`;
export type GetSupervisedAdherenceHistoryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSupervisedAdherenceHistoryQuery, GetSupervisedAdherenceHistoryQueryVariables>, 'query'> & ({ variables: GetSupervisedAdherenceHistoryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSupervisedAdherenceHistoryComponent = (props: GetSupervisedAdherenceHistoryComponentProps) => (
      <ApolloReactComponents.Query<GetSupervisedAdherenceHistoryQuery, GetSupervisedAdherenceHistoryQueryVariables> query={GetSupervisedAdherenceHistoryDocument} {...props} />
    );
    

/**
 * __useGetSupervisedAdherenceHistoryQuery__
 *
 * To run a query within a React component, call `useGetSupervisedAdherenceHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupervisedAdherenceHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupervisedAdherenceHistoryQuery({
 *   variables: {
 *      supervisorId: // value for 'supervisorId'
 *      adherenceHistorySearchCriteria: // value for 'adherenceHistorySearchCriteria'
 *   },
 * });
 */
export function useGetSupervisedAdherenceHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetSupervisedAdherenceHistoryQuery, GetSupervisedAdherenceHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupervisedAdherenceHistoryQuery, GetSupervisedAdherenceHistoryQueryVariables>(GetSupervisedAdherenceHistoryDocument, options);
      }
export function useGetSupervisedAdherenceHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupervisedAdherenceHistoryQuery, GetSupervisedAdherenceHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupervisedAdherenceHistoryQuery, GetSupervisedAdherenceHistoryQueryVariables>(GetSupervisedAdherenceHistoryDocument, options);
        }
export type GetSupervisedAdherenceHistoryQueryHookResult = ReturnType<typeof useGetSupervisedAdherenceHistoryQuery>;
export type GetSupervisedAdherenceHistoryLazyQueryHookResult = ReturnType<typeof useGetSupervisedAdherenceHistoryLazyQuery>;
export type GetSupervisedAdherenceHistoryQueryResult = Apollo.QueryResult<GetSupervisedAdherenceHistoryQuery, GetSupervisedAdherenceHistoryQueryVariables>;
export const GetSupervisorRequestsDocument = gql`
    query GetSupervisorRequests($agentName: String, $agentSurname: String, $createdAtFrom: String, $createdAtTo: String, $first: Int!, $max: Int!, $requestedFrom: String, $requestedTo: String, $queueIds: ID, $states: String, $subtypes: String, $supervisorId: ID!, $types: String) {
  supervisorRequests(
    agentName: $agentName
    agentSurname: $agentSurname
    createdAtFrom: $createdAtFrom
    createdAtTo: $createdAtTo
    first: $first
    max: $max
    requestedFrom: $requestedFrom
    requestedTo: $requestedTo
    queueIds: $queueIds
    states: $states
    subtypes: $subtypes
    supervisorId: $supervisorId
    types: $types
  ) @rest(type: "SupervisorRequests", path: "scheduling/bff/self-service/v1/supervisors/{args.supervisorId}/agents/requests?{args}") {
    requests @type(name: SupervisorRequestPreview) {
      ...SupervisorRequestPreviewFields
    }
    totalCount
  }
}
    ${SupervisorRequestPreviewFieldsFragmentDoc}`;
export type GetSupervisorRequestsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSupervisorRequestsQuery, GetSupervisorRequestsQueryVariables>, 'query'> & ({ variables: GetSupervisorRequestsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSupervisorRequestsComponent = (props: GetSupervisorRequestsComponentProps) => (
      <ApolloReactComponents.Query<GetSupervisorRequestsQuery, GetSupervisorRequestsQueryVariables> query={GetSupervisorRequestsDocument} {...props} />
    );
    

/**
 * __useGetSupervisorRequestsQuery__
 *
 * To run a query within a React component, call `useGetSupervisorRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupervisorRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupervisorRequestsQuery({
 *   variables: {
 *      agentName: // value for 'agentName'
 *      agentSurname: // value for 'agentSurname'
 *      createdAtFrom: // value for 'createdAtFrom'
 *      createdAtTo: // value for 'createdAtTo'
 *      first: // value for 'first'
 *      max: // value for 'max'
 *      requestedFrom: // value for 'requestedFrom'
 *      requestedTo: // value for 'requestedTo'
 *      queueIds: // value for 'queueIds'
 *      states: // value for 'states'
 *      subtypes: // value for 'subtypes'
 *      supervisorId: // value for 'supervisorId'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useGetSupervisorRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetSupervisorRequestsQuery, GetSupervisorRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupervisorRequestsQuery, GetSupervisorRequestsQueryVariables>(GetSupervisorRequestsDocument, options);
      }
export function useGetSupervisorRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupervisorRequestsQuery, GetSupervisorRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupervisorRequestsQuery, GetSupervisorRequestsQueryVariables>(GetSupervisorRequestsDocument, options);
        }
export type GetSupervisorRequestsQueryHookResult = ReturnType<typeof useGetSupervisorRequestsQuery>;
export type GetSupervisorRequestsLazyQueryHookResult = ReturnType<typeof useGetSupervisorRequestsLazyQuery>;
export type GetSupervisorRequestsQueryResult = Apollo.QueryResult<GetSupervisorRequestsQuery, GetSupervisorRequestsQueryVariables>;
export const GetSupervisorPtoRequestDocument = gql`
    query GetSupervisorPtoRequest($supervisorId: ID!, $ptoRequestId: ID!) {
  supervisorPtoRequest(supervisorId: $supervisorId, ptoRequestId: $ptoRequestId) @rest(type: "PTORequest", path: "scheduling/pto/v1/supervisors/{args.supervisorId}/agents/pto-requests/{args.ptoRequestId}") {
    ...PTORequestFields
  }
}
    ${PtoRequestFieldsFragmentDoc}`;
export type GetSupervisorPtoRequestComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSupervisorPtoRequestQuery, GetSupervisorPtoRequestQueryVariables>, 'query'> & ({ variables: GetSupervisorPtoRequestQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSupervisorPtoRequestComponent = (props: GetSupervisorPtoRequestComponentProps) => (
      <ApolloReactComponents.Query<GetSupervisorPtoRequestQuery, GetSupervisorPtoRequestQueryVariables> query={GetSupervisorPtoRequestDocument} {...props} />
    );
    

/**
 * __useGetSupervisorPtoRequestQuery__
 *
 * To run a query within a React component, call `useGetSupervisorPtoRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupervisorPtoRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupervisorPtoRequestQuery({
 *   variables: {
 *      supervisorId: // value for 'supervisorId'
 *      ptoRequestId: // value for 'ptoRequestId'
 *   },
 * });
 */
export function useGetSupervisorPtoRequestQuery(baseOptions: Apollo.QueryHookOptions<GetSupervisorPtoRequestQuery, GetSupervisorPtoRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupervisorPtoRequestQuery, GetSupervisorPtoRequestQueryVariables>(GetSupervisorPtoRequestDocument, options);
      }
export function useGetSupervisorPtoRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupervisorPtoRequestQuery, GetSupervisorPtoRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupervisorPtoRequestQuery, GetSupervisorPtoRequestQueryVariables>(GetSupervisorPtoRequestDocument, options);
        }
export type GetSupervisorPtoRequestQueryHookResult = ReturnType<typeof useGetSupervisorPtoRequestQuery>;
export type GetSupervisorPtoRequestLazyQueryHookResult = ReturnType<typeof useGetSupervisorPtoRequestLazyQuery>;
export type GetSupervisorPtoRequestQueryResult = Apollo.QueryResult<GetSupervisorPtoRequestQuery, GetSupervisorPtoRequestQueryVariables>;
export const GetSupervisorShiftSwapRequestDocument = gql`
    query GetSupervisorShiftSwapRequest($supervisorId: ID!, $shiftSwapRequestId: ID!) {
  supervisorShiftSwapRequest(
    supervisorId: $supervisorId
    shiftSwapRequestId: $shiftSwapRequestId
  ) @rest(type: "ShiftSwapRequest", path: "scheduling/shift-swap/v1/supervisors/{args.supervisorId}/shift-swap-requests/{args.shiftSwapRequestId}") {
    ...ShiftSwapRequestFields
  }
}
    ${ShiftSwapRequestFieldsFragmentDoc}`;
export type GetSupervisorShiftSwapRequestComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSupervisorShiftSwapRequestQuery, GetSupervisorShiftSwapRequestQueryVariables>, 'query'> & ({ variables: GetSupervisorShiftSwapRequestQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSupervisorShiftSwapRequestComponent = (props: GetSupervisorShiftSwapRequestComponentProps) => (
      <ApolloReactComponents.Query<GetSupervisorShiftSwapRequestQuery, GetSupervisorShiftSwapRequestQueryVariables> query={GetSupervisorShiftSwapRequestDocument} {...props} />
    );
    

/**
 * __useGetSupervisorShiftSwapRequestQuery__
 *
 * To run a query within a React component, call `useGetSupervisorShiftSwapRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupervisorShiftSwapRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupervisorShiftSwapRequestQuery({
 *   variables: {
 *      supervisorId: // value for 'supervisorId'
 *      shiftSwapRequestId: // value for 'shiftSwapRequestId'
 *   },
 * });
 */
export function useGetSupervisorShiftSwapRequestQuery(baseOptions: Apollo.QueryHookOptions<GetSupervisorShiftSwapRequestQuery, GetSupervisorShiftSwapRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupervisorShiftSwapRequestQuery, GetSupervisorShiftSwapRequestQueryVariables>(GetSupervisorShiftSwapRequestDocument, options);
      }
export function useGetSupervisorShiftSwapRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupervisorShiftSwapRequestQuery, GetSupervisorShiftSwapRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupervisorShiftSwapRequestQuery, GetSupervisorShiftSwapRequestQueryVariables>(GetSupervisorShiftSwapRequestDocument, options);
        }
export type GetSupervisorShiftSwapRequestQueryHookResult = ReturnType<typeof useGetSupervisorShiftSwapRequestQuery>;
export type GetSupervisorShiftSwapRequestLazyQueryHookResult = ReturnType<typeof useGetSupervisorShiftSwapRequestLazyQuery>;
export type GetSupervisorShiftSwapRequestQueryResult = Apollo.QueryResult<GetSupervisorShiftSwapRequestQuery, GetSupervisorShiftSwapRequestQueryVariables>;
export const GetSupervisorShiftOverviewForShiftSwapRequestDocument = gql`
    query GetSupervisorShiftOverviewForShiftSwapRequest($controller: ShiftSwapRequestController!, $shiftSwapRequestId: ID!, $supervisorId: ID!, $userId: ID!) {
  supervisorShiftOverviewForShiftSwapRequest(
    controller: $controller
    shiftSwapRequestId: $shiftSwapRequestId
    supervisorId: $supervisorId
    userId: $userId
  ) @rest(type: "AgentShift", path: "scheduling/shift-swap/v1/supervisors/{args.supervisorId}/shift-swap-requests/{args.shiftSwapRequestId}/{args.controller}/{args.userId}/shift") {
    ...AgentShiftFields
  }
}
    ${AgentShiftFieldsFragmentDoc}`;
export type GetSupervisorShiftOverviewForShiftSwapRequestComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSupervisorShiftOverviewForShiftSwapRequestQuery, GetSupervisorShiftOverviewForShiftSwapRequestQueryVariables>, 'query'> & ({ variables: GetSupervisorShiftOverviewForShiftSwapRequestQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSupervisorShiftOverviewForShiftSwapRequestComponent = (props: GetSupervisorShiftOverviewForShiftSwapRequestComponentProps) => (
      <ApolloReactComponents.Query<GetSupervisorShiftOverviewForShiftSwapRequestQuery, GetSupervisorShiftOverviewForShiftSwapRequestQueryVariables> query={GetSupervisorShiftOverviewForShiftSwapRequestDocument} {...props} />
    );
    

/**
 * __useGetSupervisorShiftOverviewForShiftSwapRequestQuery__
 *
 * To run a query within a React component, call `useGetSupervisorShiftOverviewForShiftSwapRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupervisorShiftOverviewForShiftSwapRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupervisorShiftOverviewForShiftSwapRequestQuery({
 *   variables: {
 *      controller: // value for 'controller'
 *      shiftSwapRequestId: // value for 'shiftSwapRequestId'
 *      supervisorId: // value for 'supervisorId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetSupervisorShiftOverviewForShiftSwapRequestQuery(baseOptions: Apollo.QueryHookOptions<GetSupervisorShiftOverviewForShiftSwapRequestQuery, GetSupervisorShiftOverviewForShiftSwapRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupervisorShiftOverviewForShiftSwapRequestQuery, GetSupervisorShiftOverviewForShiftSwapRequestQueryVariables>(GetSupervisorShiftOverviewForShiftSwapRequestDocument, options);
      }
export function useGetSupervisorShiftOverviewForShiftSwapRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupervisorShiftOverviewForShiftSwapRequestQuery, GetSupervisorShiftOverviewForShiftSwapRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupervisorShiftOverviewForShiftSwapRequestQuery, GetSupervisorShiftOverviewForShiftSwapRequestQueryVariables>(GetSupervisorShiftOverviewForShiftSwapRequestDocument, options);
        }
export type GetSupervisorShiftOverviewForShiftSwapRequestQueryHookResult = ReturnType<typeof useGetSupervisorShiftOverviewForShiftSwapRequestQuery>;
export type GetSupervisorShiftOverviewForShiftSwapRequestLazyQueryHookResult = ReturnType<typeof useGetSupervisorShiftOverviewForShiftSwapRequestLazyQuery>;
export type GetSupervisorShiftOverviewForShiftSwapRequestQueryResult = Apollo.QueryResult<GetSupervisorShiftOverviewForShiftSwapRequestQuery, GetSupervisorShiftOverviewForShiftSwapRequestQueryVariables>;
export const UpdateStateOfSupervisorPtoRequestDocument = gql`
    mutation updateStateOfSupervisorPtoRequest($supervisorId: ID!, $ptoRequestId: ID!, $fromState: RequestState!, $parameters: PTORequestUpdateInput!) {
  updateStateOfSupervisorPTORequest(
    supervisorId: $supervisorId
    ptoRequestId: $ptoRequestId
    fromState: $fromState
    parameters: $parameters
  ) @rest(type: "PTORequest", path: "scheduling/pto/v1/supervisors/{args.supervisorId}/agents/pto-requests/{args.ptoRequestId}/state?fromState={args.fromState}", method: "PUT", bodyKey: "parameters") {
    ...PTORequestFields
  }
}
    ${PtoRequestFieldsFragmentDoc}`;
export type UpdateStateOfSupervisorPtoRequestMutationFn = Apollo.MutationFunction<UpdateStateOfSupervisorPtoRequestMutation, UpdateStateOfSupervisorPtoRequestMutationVariables>;
export type UpdateStateOfSupervisorPtoRequestComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateStateOfSupervisorPtoRequestMutation, UpdateStateOfSupervisorPtoRequestMutationVariables>, 'mutation'>;

    export const UpdateStateOfSupervisorPtoRequestComponent = (props: UpdateStateOfSupervisorPtoRequestComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateStateOfSupervisorPtoRequestMutation, UpdateStateOfSupervisorPtoRequestMutationVariables> mutation={UpdateStateOfSupervisorPtoRequestDocument} {...props} />
    );
    

/**
 * __useUpdateStateOfSupervisorPtoRequestMutation__
 *
 * To run a mutation, you first call `useUpdateStateOfSupervisorPtoRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStateOfSupervisorPtoRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStateOfSupervisorPtoRequestMutation, { data, loading, error }] = useUpdateStateOfSupervisorPtoRequestMutation({
 *   variables: {
 *      supervisorId: // value for 'supervisorId'
 *      ptoRequestId: // value for 'ptoRequestId'
 *      fromState: // value for 'fromState'
 *      parameters: // value for 'parameters'
 *   },
 * });
 */
export function useUpdateStateOfSupervisorPtoRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStateOfSupervisorPtoRequestMutation, UpdateStateOfSupervisorPtoRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStateOfSupervisorPtoRequestMutation, UpdateStateOfSupervisorPtoRequestMutationVariables>(UpdateStateOfSupervisorPtoRequestDocument, options);
      }
export type UpdateStateOfSupervisorPtoRequestMutationHookResult = ReturnType<typeof useUpdateStateOfSupervisorPtoRequestMutation>;
export type UpdateStateOfSupervisorPtoRequestMutationResult = Apollo.MutationResult<UpdateStateOfSupervisorPtoRequestMutation>;
export type UpdateStateOfSupervisorPtoRequestMutationOptions = Apollo.BaseMutationOptions<UpdateStateOfSupervisorPtoRequestMutation, UpdateStateOfSupervisorPtoRequestMutationVariables>;
export const PutScheduleToProductionDocument = gql`
    mutation PutScheduleToProduction($scheduleId: ID!) {
  putScheduleToProduction(scheduleId: $scheduleId, input: {}) @rest(type: "PutScheduleToProduction", path: "scheduling/schedules/production/{args.scheduleId}", method: "PUT") {
    id
  }
}
    `;
export type PutScheduleToProductionMutationFn = Apollo.MutationFunction<PutScheduleToProductionMutation, PutScheduleToProductionMutationVariables>;
export type PutScheduleToProductionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<PutScheduleToProductionMutation, PutScheduleToProductionMutationVariables>, 'mutation'>;

    export const PutScheduleToProductionComponent = (props: PutScheduleToProductionComponentProps) => (
      <ApolloReactComponents.Mutation<PutScheduleToProductionMutation, PutScheduleToProductionMutationVariables> mutation={PutScheduleToProductionDocument} {...props} />
    );
    

/**
 * __usePutScheduleToProductionMutation__
 *
 * To run a mutation, you first call `usePutScheduleToProductionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePutScheduleToProductionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [putScheduleToProductionMutation, { data, loading, error }] = usePutScheduleToProductionMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function usePutScheduleToProductionMutation(baseOptions?: Apollo.MutationHookOptions<PutScheduleToProductionMutation, PutScheduleToProductionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PutScheduleToProductionMutation, PutScheduleToProductionMutationVariables>(PutScheduleToProductionDocument, options);
      }
export type PutScheduleToProductionMutationHookResult = ReturnType<typeof usePutScheduleToProductionMutation>;
export type PutScheduleToProductionMutationResult = Apollo.MutationResult<PutScheduleToProductionMutation>;
export type PutScheduleToProductionMutationOptions = Apollo.BaseMutationOptions<PutScheduleToProductionMutation, PutScheduleToProductionMutationVariables>;
export const GetRealTimeAdherenceAgentOverviewsDocument = gql`
    query getRealTimeAdherenceAgentOverviews($teamIds: String) {
  agentOverviews(teamIds: $teamIds) @rest(type: "AgentOverviewWithTeams", path: "rta-query-service/rta/overview/agent?{args}") {
    ...AgentOverviewWithTeamsFields
  }
}
    ${AgentOverviewWithTeamsFieldsFragmentDoc}`;
export type GetRealTimeAdherenceAgentOverviewsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetRealTimeAdherenceAgentOverviewsQuery, GetRealTimeAdherenceAgentOverviewsQueryVariables>, 'query'>;

    export const GetRealTimeAdherenceAgentOverviewsComponent = (props: GetRealTimeAdherenceAgentOverviewsComponentProps) => (
      <ApolloReactComponents.Query<GetRealTimeAdherenceAgentOverviewsQuery, GetRealTimeAdherenceAgentOverviewsQueryVariables> query={GetRealTimeAdherenceAgentOverviewsDocument} {...props} />
    );
    

/**
 * __useGetRealTimeAdherenceAgentOverviewsQuery__
 *
 * To run a query within a React component, call `useGetRealTimeAdherenceAgentOverviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRealTimeAdherenceAgentOverviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRealTimeAdherenceAgentOverviewsQuery({
 *   variables: {
 *      teamIds: // value for 'teamIds'
 *   },
 * });
 */
export function useGetRealTimeAdherenceAgentOverviewsQuery(baseOptions?: Apollo.QueryHookOptions<GetRealTimeAdherenceAgentOverviewsQuery, GetRealTimeAdherenceAgentOverviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRealTimeAdherenceAgentOverviewsQuery, GetRealTimeAdherenceAgentOverviewsQueryVariables>(GetRealTimeAdherenceAgentOverviewsDocument, options);
      }
export function useGetRealTimeAdherenceAgentOverviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRealTimeAdherenceAgentOverviewsQuery, GetRealTimeAdherenceAgentOverviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRealTimeAdherenceAgentOverviewsQuery, GetRealTimeAdherenceAgentOverviewsQueryVariables>(GetRealTimeAdherenceAgentOverviewsDocument, options);
        }
export type GetRealTimeAdherenceAgentOverviewsQueryHookResult = ReturnType<typeof useGetRealTimeAdherenceAgentOverviewsQuery>;
export type GetRealTimeAdherenceAgentOverviewsLazyQueryHookResult = ReturnType<typeof useGetRealTimeAdherenceAgentOverviewsLazyQuery>;
export type GetRealTimeAdherenceAgentOverviewsQueryResult = Apollo.QueryResult<GetRealTimeAdherenceAgentOverviewsQuery, GetRealTimeAdherenceAgentOverviewsQueryVariables>;
export const GetRealTimeAdherenceGanttChartInitialDataDocument = gql`
    query GetRealTimeAdherenceGanttChartInitialData($agentId: ID!) {
  realTimeAdherenceGanttChartInitialData(agentId: $agentId) @rest(type: "RealTimeAdherenceGanttChartInitial", path: "rta-query-service/rta/detail/agent/{args.agentId}", method: "GET") {
    ...GetRealTimeAdherenceGanttChartInitialDataFields
  }
}
    ${GetRealTimeAdherenceGanttChartInitialDataFieldsFragmentDoc}`;
export type GetRealTimeAdherenceGanttChartInitialDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetRealTimeAdherenceGanttChartInitialDataQuery, GetRealTimeAdherenceGanttChartInitialDataQueryVariables>, 'query'> & ({ variables: GetRealTimeAdherenceGanttChartInitialDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetRealTimeAdherenceGanttChartInitialDataComponent = (props: GetRealTimeAdherenceGanttChartInitialDataComponentProps) => (
      <ApolloReactComponents.Query<GetRealTimeAdherenceGanttChartInitialDataQuery, GetRealTimeAdherenceGanttChartInitialDataQueryVariables> query={GetRealTimeAdherenceGanttChartInitialDataDocument} {...props} />
    );
    

/**
 * __useGetRealTimeAdherenceGanttChartInitialDataQuery__
 *
 * To run a query within a React component, call `useGetRealTimeAdherenceGanttChartInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRealTimeAdherenceGanttChartInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRealTimeAdherenceGanttChartInitialDataQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useGetRealTimeAdherenceGanttChartInitialDataQuery(baseOptions: Apollo.QueryHookOptions<GetRealTimeAdherenceGanttChartInitialDataQuery, GetRealTimeAdherenceGanttChartInitialDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRealTimeAdherenceGanttChartInitialDataQuery, GetRealTimeAdherenceGanttChartInitialDataQueryVariables>(GetRealTimeAdherenceGanttChartInitialDataDocument, options);
      }
export function useGetRealTimeAdherenceGanttChartInitialDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRealTimeAdherenceGanttChartInitialDataQuery, GetRealTimeAdherenceGanttChartInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRealTimeAdherenceGanttChartInitialDataQuery, GetRealTimeAdherenceGanttChartInitialDataQueryVariables>(GetRealTimeAdherenceGanttChartInitialDataDocument, options);
        }
export type GetRealTimeAdherenceGanttChartInitialDataQueryHookResult = ReturnType<typeof useGetRealTimeAdherenceGanttChartInitialDataQuery>;
export type GetRealTimeAdherenceGanttChartInitialDataLazyQueryHookResult = ReturnType<typeof useGetRealTimeAdherenceGanttChartInitialDataLazyQuery>;
export type GetRealTimeAdherenceGanttChartInitialDataQueryResult = Apollo.QueryResult<GetRealTimeAdherenceGanttChartInitialDataQuery, GetRealTimeAdherenceGanttChartInitialDataQueryVariables>;
export const RemoveScheduleFromProductionDocument = gql`
    mutation RemoveScheduleFromProduction($scheduleId: ID!) {
  removeScheduleFromProduction(scheduleId: $scheduleId) @rest(type: "RemoveScheduleFromProduction", path: "scheduling/schedules/production/{args.scheduleId}", method: "DELETE") {
    id
  }
}
    `;
export type RemoveScheduleFromProductionMutationFn = Apollo.MutationFunction<RemoveScheduleFromProductionMutation, RemoveScheduleFromProductionMutationVariables>;
export type RemoveScheduleFromProductionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RemoveScheduleFromProductionMutation, RemoveScheduleFromProductionMutationVariables>, 'mutation'>;

    export const RemoveScheduleFromProductionComponent = (props: RemoveScheduleFromProductionComponentProps) => (
      <ApolloReactComponents.Mutation<RemoveScheduleFromProductionMutation, RemoveScheduleFromProductionMutationVariables> mutation={RemoveScheduleFromProductionDocument} {...props} />
    );
    

/**
 * __useRemoveScheduleFromProductionMutation__
 *
 * To run a mutation, you first call `useRemoveScheduleFromProductionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveScheduleFromProductionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeScheduleFromProductionMutation, { data, loading, error }] = useRemoveScheduleFromProductionMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useRemoveScheduleFromProductionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveScheduleFromProductionMutation, RemoveScheduleFromProductionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveScheduleFromProductionMutation, RemoveScheduleFromProductionMutationVariables>(RemoveScheduleFromProductionDocument, options);
      }
export type RemoveScheduleFromProductionMutationHookResult = ReturnType<typeof useRemoveScheduleFromProductionMutation>;
export type RemoveScheduleFromProductionMutationResult = Apollo.MutationResult<RemoveScheduleFromProductionMutation>;
export type RemoveScheduleFromProductionMutationOptions = Apollo.BaseMutationOptions<RemoveScheduleFromProductionMutation, RemoveScheduleFromProductionMutationVariables>;
export const UpdateScheduleDocument = gql`
    mutation UpdateSchedule($id: ID!, $schedule: ScheduleInput!, $allowInactiveAgents: Boolean) {
  updateSchedule(
    id: $id
    schedule: $schedule
    allowInactiveAgents: $allowInactiveAgents
  ) @rest(type: "UpdateSchedule", path: "scheduling/schedules/{args.id}?allowInactiveAgents={args.allowInactiveAgents}", method: "PUT", bodyKey: "schedule") {
    id
  }
}
    `;
export type UpdateScheduleMutationFn = Apollo.MutationFunction<UpdateScheduleMutation, UpdateScheduleMutationVariables>;
export type UpdateScheduleComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateScheduleMutation, UpdateScheduleMutationVariables>, 'mutation'>;

    export const UpdateScheduleComponent = (props: UpdateScheduleComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateScheduleMutation, UpdateScheduleMutationVariables> mutation={UpdateScheduleDocument} {...props} />
    );
    

/**
 * __useUpdateScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleMutation, { data, loading, error }] = useUpdateScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      schedule: // value for 'schedule'
 *      allowInactiveAgents: // value for 'allowInactiveAgents'
 *   },
 * });
 */
export function useUpdateScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleMutation, UpdateScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleMutation, UpdateScheduleMutationVariables>(UpdateScheduleDocument, options);
      }
export type UpdateScheduleMutationHookResult = ReturnType<typeof useUpdateScheduleMutation>;
export type UpdateScheduleMutationResult = Apollo.MutationResult<UpdateScheduleMutation>;
export type UpdateScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleMutation, UpdateScheduleMutationVariables>;
export const UpdateScheduleElementDocument = gql`
    mutation UpdateScheduleElement($id: ID!, $scheduleElement: ScheduleElementInput!) {
  updateScheduleElement(id: $id, scheduleElement: $scheduleElement) @rest(type: "UpdateScheduleElement", path: "scheduling/schedule-elements/{args.id}", method: "PUT", bodyKey: "scheduleElement") {
    id
  }
}
    `;
export type UpdateScheduleElementMutationFn = Apollo.MutationFunction<UpdateScheduleElementMutation, UpdateScheduleElementMutationVariables>;
export type UpdateScheduleElementComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateScheduleElementMutation, UpdateScheduleElementMutationVariables>, 'mutation'>;

    export const UpdateScheduleElementComponent = (props: UpdateScheduleElementComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateScheduleElementMutation, UpdateScheduleElementMutationVariables> mutation={UpdateScheduleElementDocument} {...props} />
    );
    

/**
 * __useUpdateScheduleElementMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleElementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleElementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleElementMutation, { data, loading, error }] = useUpdateScheduleElementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      scheduleElement: // value for 'scheduleElement'
 *   },
 * });
 */
export function useUpdateScheduleElementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleElementMutation, UpdateScheduleElementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleElementMutation, UpdateScheduleElementMutationVariables>(UpdateScheduleElementDocument, options);
      }
export type UpdateScheduleElementMutationHookResult = ReturnType<typeof useUpdateScheduleElementMutation>;
export type UpdateScheduleElementMutationResult = Apollo.MutationResult<UpdateScheduleElementMutation>;
export type UpdateScheduleElementMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleElementMutation, UpdateScheduleElementMutationVariables>;
export const UpdateDisplayOrderOnScheduleElementDocument = gql`
    mutation UpdateDisplayOrderOnScheduleElement($id: ID!, $scheduleElementDisplayOrder: ScheduleElementDisplayOrderInput!) {
  updateDisplayOrderOnScheduleElement(
    id: $id
    scheduleElementDisplayOrder: $scheduleElementDisplayOrder
  ) @rest(type: "UpdateDisplayOrderOnScheduleElement", path: "scheduling/schedule-elements/{args.id}", method: "PATCH", bodyKey: "scheduleElementDisplayOrder") {
    id
  }
}
    `;
export type UpdateDisplayOrderOnScheduleElementMutationFn = Apollo.MutationFunction<UpdateDisplayOrderOnScheduleElementMutation, UpdateDisplayOrderOnScheduleElementMutationVariables>;
export type UpdateDisplayOrderOnScheduleElementComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateDisplayOrderOnScheduleElementMutation, UpdateDisplayOrderOnScheduleElementMutationVariables>, 'mutation'>;

    export const UpdateDisplayOrderOnScheduleElementComponent = (props: UpdateDisplayOrderOnScheduleElementComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateDisplayOrderOnScheduleElementMutation, UpdateDisplayOrderOnScheduleElementMutationVariables> mutation={UpdateDisplayOrderOnScheduleElementDocument} {...props} />
    );
    

/**
 * __useUpdateDisplayOrderOnScheduleElementMutation__
 *
 * To run a mutation, you first call `useUpdateDisplayOrderOnScheduleElementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDisplayOrderOnScheduleElementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDisplayOrderOnScheduleElementMutation, { data, loading, error }] = useUpdateDisplayOrderOnScheduleElementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      scheduleElementDisplayOrder: // value for 'scheduleElementDisplayOrder'
 *   },
 * });
 */
export function useUpdateDisplayOrderOnScheduleElementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDisplayOrderOnScheduleElementMutation, UpdateDisplayOrderOnScheduleElementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDisplayOrderOnScheduleElementMutation, UpdateDisplayOrderOnScheduleElementMutationVariables>(UpdateDisplayOrderOnScheduleElementDocument, options);
      }
export type UpdateDisplayOrderOnScheduleElementMutationHookResult = ReturnType<typeof useUpdateDisplayOrderOnScheduleElementMutation>;
export type UpdateDisplayOrderOnScheduleElementMutationResult = Apollo.MutationResult<UpdateDisplayOrderOnScheduleElementMutation>;
export type UpdateDisplayOrderOnScheduleElementMutationOptions = Apollo.BaseMutationOptions<UpdateDisplayOrderOnScheduleElementMutation, UpdateDisplayOrderOnScheduleElementMutationVariables>;
export const UpdateScheduleInfoDocument = gql`
    mutation UpdateScheduleInfo($id: ID!, $name: String, $notes: String, $availableSeats: String!) {
  updateScheduleInfo(
    id: $id
    name: $name
    notes: $notes
    availableSeats: $availableSeats
  ) @rest(type: "UpdateScheduleInfo", path: "scheduling/schedules/info/{args.id}?name={args.name}&availableSeats={args.availableSeats}", method: "PUT", bodyKey: "name") {
    id
  }
}
    `;
export type UpdateScheduleInfoMutationFn = Apollo.MutationFunction<UpdateScheduleInfoMutation, UpdateScheduleInfoMutationVariables>;
export type UpdateScheduleInfoComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateScheduleInfoMutation, UpdateScheduleInfoMutationVariables>, 'mutation'>;

    export const UpdateScheduleInfoComponent = (props: UpdateScheduleInfoComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateScheduleInfoMutation, UpdateScheduleInfoMutationVariables> mutation={UpdateScheduleInfoDocument} {...props} />
    );
    

/**
 * __useUpdateScheduleInfoMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleInfoMutation, { data, loading, error }] = useUpdateScheduleInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      notes: // value for 'notes'
 *      availableSeats: // value for 'availableSeats'
 *   },
 * });
 */
export function useUpdateScheduleInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleInfoMutation, UpdateScheduleInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleInfoMutation, UpdateScheduleInfoMutationVariables>(UpdateScheduleInfoDocument, options);
      }
export type UpdateScheduleInfoMutationHookResult = ReturnType<typeof useUpdateScheduleInfoMutation>;
export type UpdateScheduleInfoMutationResult = Apollo.MutationResult<UpdateScheduleInfoMutation>;
export type UpdateScheduleInfoMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleInfoMutation, UpdateScheduleInfoMutationVariables>;
export const GetShiftTemplatesDocument = gql`
    query getShiftTemplates($offset: Int, $limit: Int) {
  shiftTemplates(offset: $offset, limit: $limit) @rest(type: "ShiftTemplates", path: "auto-scheduler/shift-templates?{args}") {
    shiftTemplates @type(name: "ShiftTemplate") {
      ...ShiftTemplateFields
    }
    totalCount
  }
}
    ${ShiftTemplateFieldsFragmentDoc}`;
export type GetShiftTemplatesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetShiftTemplatesQuery, GetShiftTemplatesQueryVariables>, 'query'>;

    export const GetShiftTemplatesComponent = (props: GetShiftTemplatesComponentProps) => (
      <ApolloReactComponents.Query<GetShiftTemplatesQuery, GetShiftTemplatesQueryVariables> query={GetShiftTemplatesDocument} {...props} />
    );
    

/**
 * __useGetShiftTemplatesQuery__
 *
 * To run a query within a React component, call `useGetShiftTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShiftTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShiftTemplatesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetShiftTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetShiftTemplatesQuery, GetShiftTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShiftTemplatesQuery, GetShiftTemplatesQueryVariables>(GetShiftTemplatesDocument, options);
      }
export function useGetShiftTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShiftTemplatesQuery, GetShiftTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShiftTemplatesQuery, GetShiftTemplatesQueryVariables>(GetShiftTemplatesDocument, options);
        }
export type GetShiftTemplatesQueryHookResult = ReturnType<typeof useGetShiftTemplatesQuery>;
export type GetShiftTemplatesLazyQueryHookResult = ReturnType<typeof useGetShiftTemplatesLazyQuery>;
export type GetShiftTemplatesQueryResult = Apollo.QueryResult<GetShiftTemplatesQuery, GetShiftTemplatesQueryVariables>;
export const GetShiftTemplateDocument = gql`
    query getShiftTemplate($id: ID) {
  shiftTemplate(id: $id) @rest(type: "ShiftTemplate", path: "auto-scheduler/shift-templates/{id}") {
    ...ShiftTemplateFields
  }
}
    ${ShiftTemplateFieldsFragmentDoc}`;
export type GetShiftTemplateComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetShiftTemplateQuery, GetShiftTemplateQueryVariables>, 'query'>;

    export const GetShiftTemplateComponent = (props: GetShiftTemplateComponentProps) => (
      <ApolloReactComponents.Query<GetShiftTemplateQuery, GetShiftTemplateQueryVariables> query={GetShiftTemplateDocument} {...props} />
    );
    

/**
 * __useGetShiftTemplateQuery__
 *
 * To run a query within a React component, call `useGetShiftTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShiftTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShiftTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetShiftTemplateQuery(baseOptions?: Apollo.QueryHookOptions<GetShiftTemplateQuery, GetShiftTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShiftTemplateQuery, GetShiftTemplateQueryVariables>(GetShiftTemplateDocument, options);
      }
export function useGetShiftTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShiftTemplateQuery, GetShiftTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShiftTemplateQuery, GetShiftTemplateQueryVariables>(GetShiftTemplateDocument, options);
        }
export type GetShiftTemplateQueryHookResult = ReturnType<typeof useGetShiftTemplateQuery>;
export type GetShiftTemplateLazyQueryHookResult = ReturnType<typeof useGetShiftTemplateLazyQuery>;
export type GetShiftTemplateQueryResult = Apollo.QueryResult<GetShiftTemplateQuery, GetShiftTemplateQueryVariables>;
export const CreateShiftTemplateDocument = gql`
    mutation createShiftTemplate($shiftTemplate: ShiftTemplateInput!) {
  createShiftTemplate(shiftTemplate: $shiftTemplate) @rest(type: "ShiftTemplateCreate", bodyKey: "shiftTemplate", path: "auto-scheduler/shift-templates", method: "POST") {
    id
  }
}
    `;
export type CreateShiftTemplateMutationFn = Apollo.MutationFunction<CreateShiftTemplateMutation, CreateShiftTemplateMutationVariables>;
export type CreateShiftTemplateComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateShiftTemplateMutation, CreateShiftTemplateMutationVariables>, 'mutation'>;

    export const CreateShiftTemplateComponent = (props: CreateShiftTemplateComponentProps) => (
      <ApolloReactComponents.Mutation<CreateShiftTemplateMutation, CreateShiftTemplateMutationVariables> mutation={CreateShiftTemplateDocument} {...props} />
    );
    

/**
 * __useCreateShiftTemplateMutation__
 *
 * To run a mutation, you first call `useCreateShiftTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShiftTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShiftTemplateMutation, { data, loading, error }] = useCreateShiftTemplateMutation({
 *   variables: {
 *      shiftTemplate: // value for 'shiftTemplate'
 *   },
 * });
 */
export function useCreateShiftTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateShiftTemplateMutation, CreateShiftTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShiftTemplateMutation, CreateShiftTemplateMutationVariables>(CreateShiftTemplateDocument, options);
      }
export type CreateShiftTemplateMutationHookResult = ReturnType<typeof useCreateShiftTemplateMutation>;
export type CreateShiftTemplateMutationResult = Apollo.MutationResult<CreateShiftTemplateMutation>;
export type CreateShiftTemplateMutationOptions = Apollo.BaseMutationOptions<CreateShiftTemplateMutation, CreateShiftTemplateMutationVariables>;
export const DeleteShiftTemplateDocument = gql`
    mutation deleteShiftTemplate($id: ID!) {
  deleteShiftTemplate(id: $id) @rest(type: "ShiftTemplateDelete", path: "auto-scheduler/shift-templates/{args.id}", method: "DELETE") {
    id
  }
}
    `;
export type DeleteShiftTemplateMutationFn = Apollo.MutationFunction<DeleteShiftTemplateMutation, DeleteShiftTemplateMutationVariables>;
export type DeleteShiftTemplateComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteShiftTemplateMutation, DeleteShiftTemplateMutationVariables>, 'mutation'>;

    export const DeleteShiftTemplateComponent = (props: DeleteShiftTemplateComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteShiftTemplateMutation, DeleteShiftTemplateMutationVariables> mutation={DeleteShiftTemplateDocument} {...props} />
    );
    

/**
 * __useDeleteShiftTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteShiftTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShiftTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShiftTemplateMutation, { data, loading, error }] = useDeleteShiftTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteShiftTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteShiftTemplateMutation, DeleteShiftTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteShiftTemplateMutation, DeleteShiftTemplateMutationVariables>(DeleteShiftTemplateDocument, options);
      }
export type DeleteShiftTemplateMutationHookResult = ReturnType<typeof useDeleteShiftTemplateMutation>;
export type DeleteShiftTemplateMutationResult = Apollo.MutationResult<DeleteShiftTemplateMutation>;
export type DeleteShiftTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteShiftTemplateMutation, DeleteShiftTemplateMutationVariables>;
export const UpdateShiftTemplateDocument = gql`
    mutation updateShiftTemplate($id: ID!, $shiftTemplate: ShiftTemplateInput!) {
  updateShiftTemplate(id: $id, shiftTemplate: $shiftTemplate) @rest(type: "ShiftTemplateEdit", bodyKey: "shiftTemplate", path: "auto-scheduler/shift-templates/{args.id}", method: "PUT") {
    ...ShiftTemplateFields
  }
}
    ${ShiftTemplateFieldsFragmentDoc}`;
export type UpdateShiftTemplateMutationFn = Apollo.MutationFunction<UpdateShiftTemplateMutation, UpdateShiftTemplateMutationVariables>;
export type UpdateShiftTemplateComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateShiftTemplateMutation, UpdateShiftTemplateMutationVariables>, 'mutation'>;

    export const UpdateShiftTemplateComponent = (props: UpdateShiftTemplateComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateShiftTemplateMutation, UpdateShiftTemplateMutationVariables> mutation={UpdateShiftTemplateDocument} {...props} />
    );
    

/**
 * __useUpdateShiftTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateShiftTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShiftTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShiftTemplateMutation, { data, loading, error }] = useUpdateShiftTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      shiftTemplate: // value for 'shiftTemplate'
 *   },
 * });
 */
export function useUpdateShiftTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShiftTemplateMutation, UpdateShiftTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShiftTemplateMutation, UpdateShiftTemplateMutationVariables>(UpdateShiftTemplateDocument, options);
      }
export type UpdateShiftTemplateMutationHookResult = ReturnType<typeof useUpdateShiftTemplateMutation>;
export type UpdateShiftTemplateMutationResult = Apollo.MutationResult<UpdateShiftTemplateMutation>;
export type UpdateShiftTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateShiftTemplateMutation, UpdateShiftTemplateMutationVariables>;
export const CreateSkillDocument = gql`
    mutation CreateSkill($skill: SkillInput!) {
  createSkill(skill: $skill) @rest(type: "SkillCreate", bodyKey: "skill", path: "queue-management/skills", method: "POST") {
    id
  }
}
    `;
export type CreateSkillMutationFn = Apollo.MutationFunction<CreateSkillMutation, CreateSkillMutationVariables>;
export type CreateSkillComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateSkillMutation, CreateSkillMutationVariables>, 'mutation'>;

    export const CreateSkillComponent = (props: CreateSkillComponentProps) => (
      <ApolloReactComponents.Mutation<CreateSkillMutation, CreateSkillMutationVariables> mutation={CreateSkillDocument} {...props} />
    );
    

/**
 * __useCreateSkillMutation__
 *
 * To run a mutation, you first call `useCreateSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSkillMutation, { data, loading, error }] = useCreateSkillMutation({
 *   variables: {
 *      skill: // value for 'skill'
 *   },
 * });
 */
export function useCreateSkillMutation(baseOptions?: Apollo.MutationHookOptions<CreateSkillMutation, CreateSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSkillMutation, CreateSkillMutationVariables>(CreateSkillDocument, options);
      }
export type CreateSkillMutationHookResult = ReturnType<typeof useCreateSkillMutation>;
export type CreateSkillMutationResult = Apollo.MutationResult<CreateSkillMutation>;
export type CreateSkillMutationOptions = Apollo.BaseMutationOptions<CreateSkillMutation, CreateSkillMutationVariables>;
export const GetSkillsAllDocument = gql`
    query getSkillsAll {
  skills @rest(type: "Skill", path: "queue-management/skills") {
    ...SkillFields
  }
}
    ${SkillFieldsFragmentDoc}`;
export type GetSkillsAllComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSkillsAllQuery, GetSkillsAllQueryVariables>, 'query'>;

    export const GetSkillsAllComponent = (props: GetSkillsAllComponentProps) => (
      <ApolloReactComponents.Query<GetSkillsAllQuery, GetSkillsAllQueryVariables> query={GetSkillsAllDocument} {...props} />
    );
    

/**
 * __useGetSkillsAllQuery__
 *
 * To run a query within a React component, call `useGetSkillsAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkillsAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkillsAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSkillsAllQuery(baseOptions?: Apollo.QueryHookOptions<GetSkillsAllQuery, GetSkillsAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSkillsAllQuery, GetSkillsAllQueryVariables>(GetSkillsAllDocument, options);
      }
export function useGetSkillsAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSkillsAllQuery, GetSkillsAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSkillsAllQuery, GetSkillsAllQueryVariables>(GetSkillsAllDocument, options);
        }
export type GetSkillsAllQueryHookResult = ReturnType<typeof useGetSkillsAllQuery>;
export type GetSkillsAllLazyQueryHookResult = ReturnType<typeof useGetSkillsAllLazyQuery>;
export type GetSkillsAllQueryResult = Apollo.QueryResult<GetSkillsAllQuery, GetSkillsAllQueryVariables>;
export const GetSkillsAllWithUsedDocument = gql`
    query getSkillsAllWithUsed {
  skillsWithUsed @rest(type: "SkillWithUsed", path: "administration/skill-usage") {
    ...SkillWithUsedFields
  }
}
    ${SkillWithUsedFieldsFragmentDoc}`;
export type GetSkillsAllWithUsedComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSkillsAllWithUsedQuery, GetSkillsAllWithUsedQueryVariables>, 'query'>;

    export const GetSkillsAllWithUsedComponent = (props: GetSkillsAllWithUsedComponentProps) => (
      <ApolloReactComponents.Query<GetSkillsAllWithUsedQuery, GetSkillsAllWithUsedQueryVariables> query={GetSkillsAllWithUsedDocument} {...props} />
    );
    

/**
 * __useGetSkillsAllWithUsedQuery__
 *
 * To run a query within a React component, call `useGetSkillsAllWithUsedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkillsAllWithUsedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkillsAllWithUsedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSkillsAllWithUsedQuery(baseOptions?: Apollo.QueryHookOptions<GetSkillsAllWithUsedQuery, GetSkillsAllWithUsedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSkillsAllWithUsedQuery, GetSkillsAllWithUsedQueryVariables>(GetSkillsAllWithUsedDocument, options);
      }
export function useGetSkillsAllWithUsedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSkillsAllWithUsedQuery, GetSkillsAllWithUsedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSkillsAllWithUsedQuery, GetSkillsAllWithUsedQueryVariables>(GetSkillsAllWithUsedDocument, options);
        }
export type GetSkillsAllWithUsedQueryHookResult = ReturnType<typeof useGetSkillsAllWithUsedQuery>;
export type GetSkillsAllWithUsedLazyQueryHookResult = ReturnType<typeof useGetSkillsAllWithUsedLazyQuery>;
export type GetSkillsAllWithUsedQueryResult = Apollo.QueryResult<GetSkillsAllWithUsedQuery, GetSkillsAllWithUsedQueryVariables>;
export const GetSkillsDocument = gql`
    query getSkills($id: ID!) {
  skills(id: $id) @rest(type: "Skill", path: "queue-management/skills?{args}") {
    ...SkillFields
  }
}
    ${SkillFieldsFragmentDoc}`;
export type GetSkillsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSkillsQuery, GetSkillsQueryVariables>, 'query'> & ({ variables: GetSkillsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSkillsComponent = (props: GetSkillsComponentProps) => (
      <ApolloReactComponents.Query<GetSkillsQuery, GetSkillsQueryVariables> query={GetSkillsDocument} {...props} />
    );
    

/**
 * __useGetSkillsQuery__
 *
 * To run a query within a React component, call `useGetSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkillsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSkillsQuery(baseOptions: Apollo.QueryHookOptions<GetSkillsQuery, GetSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSkillsQuery, GetSkillsQueryVariables>(GetSkillsDocument, options);
      }
export function useGetSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSkillsQuery, GetSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSkillsQuery, GetSkillsQueryVariables>(GetSkillsDocument, options);
        }
export type GetSkillsQueryHookResult = ReturnType<typeof useGetSkillsQuery>;
export type GetSkillsLazyQueryHookResult = ReturnType<typeof useGetSkillsLazyQuery>;
export type GetSkillsQueryResult = Apollo.QueryResult<GetSkillsQuery, GetSkillsQueryVariables>;
export const UpdateSkillDocument = gql`
    mutation UpdateSkill($id: ID!, $skill: SkillInput!) {
  updateSkill(id: $id, skill: $skill) @rest(type: "SkillUpdate", bodyKey: "skill", path: "queue-management/skills/{args.id}", method: "PUT") {
    id
  }
}
    `;
export type UpdateSkillMutationFn = Apollo.MutationFunction<UpdateSkillMutation, UpdateSkillMutationVariables>;
export type UpdateSkillComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateSkillMutation, UpdateSkillMutationVariables>, 'mutation'>;

    export const UpdateSkillComponent = (props: UpdateSkillComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateSkillMutation, UpdateSkillMutationVariables> mutation={UpdateSkillDocument} {...props} />
    );
    

/**
 * __useUpdateSkillMutation__
 *
 * To run a mutation, you first call `useUpdateSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSkillMutation, { data, loading, error }] = useUpdateSkillMutation({
 *   variables: {
 *      id: // value for 'id'
 *      skill: // value for 'skill'
 *   },
 * });
 */
export function useUpdateSkillMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSkillMutation, UpdateSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSkillMutation, UpdateSkillMutationVariables>(UpdateSkillDocument, options);
      }
export type UpdateSkillMutationHookResult = ReturnType<typeof useUpdateSkillMutation>;
export type UpdateSkillMutationResult = Apollo.MutationResult<UpdateSkillMutation>;
export type UpdateSkillMutationOptions = Apollo.BaseMutationOptions<UpdateSkillMutation, UpdateSkillMutationVariables>;
export const DeleteSkillDocument = gql`
    mutation DeleteSkill($id: ID!) {
  deleteSkill(id: $id) @rest(type: "SkillDelete", path: "queue-management/skills/{args.id}", method: "DELETE") {
    id
  }
}
    `;
export type DeleteSkillMutationFn = Apollo.MutationFunction<DeleteSkillMutation, DeleteSkillMutationVariables>;
export type DeleteSkillComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteSkillMutation, DeleteSkillMutationVariables>, 'mutation'>;

    export const DeleteSkillComponent = (props: DeleteSkillComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteSkillMutation, DeleteSkillMutationVariables> mutation={DeleteSkillDocument} {...props} />
    );
    

/**
 * __useDeleteSkillMutation__
 *
 * To run a mutation, you first call `useDeleteSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSkillMutation, { data, loading, error }] = useDeleteSkillMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSkillMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSkillMutation, DeleteSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSkillMutation, DeleteSkillMutationVariables>(DeleteSkillDocument, options);
      }
export type DeleteSkillMutationHookResult = ReturnType<typeof useDeleteSkillMutation>;
export type DeleteSkillMutationResult = Apollo.MutationResult<DeleteSkillMutation>;
export type DeleteSkillMutationOptions = Apollo.BaseMutationOptions<DeleteSkillMutation, DeleteSkillMutationVariables>;
export const IntradayMeasurementsChangedDocument = gql`
    subscription IntradayMeasurementsChanged {
  intradayMeasurementsChanged {
    id
  }
}
    `;
export type IntradayMeasurementsChangedComponentProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<IntradayMeasurementsChangedSubscription, IntradayMeasurementsChangedSubscriptionVariables>, 'subscription'>;

    export const IntradayMeasurementsChangedComponent = (props: IntradayMeasurementsChangedComponentProps) => (
      <ApolloReactComponents.Subscription<IntradayMeasurementsChangedSubscription, IntradayMeasurementsChangedSubscriptionVariables> subscription={IntradayMeasurementsChangedDocument} {...props} />
    );
    

/**
 * __useIntradayMeasurementsChangedSubscription__
 *
 * To run a query within a React component, call `useIntradayMeasurementsChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIntradayMeasurementsChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntradayMeasurementsChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useIntradayMeasurementsChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<IntradayMeasurementsChangedSubscription, IntradayMeasurementsChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IntradayMeasurementsChangedSubscription, IntradayMeasurementsChangedSubscriptionVariables>(IntradayMeasurementsChangedDocument, options);
      }
export type IntradayMeasurementsChangedSubscriptionHookResult = ReturnType<typeof useIntradayMeasurementsChangedSubscription>;
export type IntradayMeasurementsChangedSubscriptionResult = Apollo.SubscriptionResult<IntradayMeasurementsChangedSubscription>;
export const RealTimeScheduleChangedDocument = gql`
    subscription RealTimeScheduleChanged($agentId: ID!) {
  realTimeScheduleChanged(agentId: $agentId) @rest(type: "ScheduleChange") {
    ...ScheduleChangeFields
  }
}
    ${ScheduleChangeFieldsFragmentDoc}`;
export type RealTimeScheduleChangedComponentProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<RealTimeScheduleChangedSubscription, RealTimeScheduleChangedSubscriptionVariables>, 'subscription'>;

    export const RealTimeScheduleChangedComponent = (props: RealTimeScheduleChangedComponentProps) => (
      <ApolloReactComponents.Subscription<RealTimeScheduleChangedSubscription, RealTimeScheduleChangedSubscriptionVariables> subscription={RealTimeScheduleChangedDocument} {...props} />
    );
    

/**
 * __useRealTimeScheduleChangedSubscription__
 *
 * To run a query within a React component, call `useRealTimeScheduleChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRealTimeScheduleChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRealTimeScheduleChangedSubscription({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useRealTimeScheduleChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<RealTimeScheduleChangedSubscription, RealTimeScheduleChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RealTimeScheduleChangedSubscription, RealTimeScheduleChangedSubscriptionVariables>(RealTimeScheduleChangedDocument, options);
      }
export type RealTimeScheduleChangedSubscriptionHookResult = ReturnType<typeof useRealTimeScheduleChangedSubscription>;
export type RealTimeScheduleChangedSubscriptionResult = Apollo.SubscriptionResult<RealTimeScheduleChangedSubscription>;
export const RealTimeAgentEventsChangedDocument = gql`
    subscription RealTimeAgentEventsChanged($agentId: ID!) {
  realTimeAgentEventsChanged(agentId: $agentId) @rest(type: "AgentEvents") {
    agentEvents @type(name: AgentEvent) {
      ...AgentEventFields
    }
  }
}
    ${AgentEventFieldsFragmentDoc}`;
export type RealTimeAgentEventsChangedComponentProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<RealTimeAgentEventsChangedSubscription, RealTimeAgentEventsChangedSubscriptionVariables>, 'subscription'>;

    export const RealTimeAgentEventsChangedComponent = (props: RealTimeAgentEventsChangedComponentProps) => (
      <ApolloReactComponents.Subscription<RealTimeAgentEventsChangedSubscription, RealTimeAgentEventsChangedSubscriptionVariables> subscription={RealTimeAgentEventsChangedDocument} {...props} />
    );
    

/**
 * __useRealTimeAgentEventsChangedSubscription__
 *
 * To run a query within a React component, call `useRealTimeAgentEventsChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRealTimeAgentEventsChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRealTimeAgentEventsChangedSubscription({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useRealTimeAgentEventsChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<RealTimeAgentEventsChangedSubscription, RealTimeAgentEventsChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RealTimeAgentEventsChangedSubscription, RealTimeAgentEventsChangedSubscriptionVariables>(RealTimeAgentEventsChangedDocument, options);
      }
export type RealTimeAgentEventsChangedSubscriptionHookResult = ReturnType<typeof useRealTimeAgentEventsChangedSubscription>;
export type RealTimeAgentEventsChangedSubscriptionResult = Apollo.SubscriptionResult<RealTimeAgentEventsChangedSubscription>;
export const RealTimeAdherenceChangedDocument = gql`
    subscription RealTimeAdherenceChanged {
  realTimeAdherenceChanged @rest(type: "AgentOverview") {
    ...AgentOverviewFields
  }
}
    ${AgentOverviewFieldsFragmentDoc}`;
export type RealTimeAdherenceChangedComponentProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<RealTimeAdherenceChangedSubscription, RealTimeAdherenceChangedSubscriptionVariables>, 'subscription'>;

    export const RealTimeAdherenceChangedComponent = (props: RealTimeAdherenceChangedComponentProps) => (
      <ApolloReactComponents.Subscription<RealTimeAdherenceChangedSubscription, RealTimeAdherenceChangedSubscriptionVariables> subscription={RealTimeAdherenceChangedDocument} {...props} />
    );
    

/**
 * __useRealTimeAdherenceChangedSubscription__
 *
 * To run a query within a React component, call `useRealTimeAdherenceChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRealTimeAdherenceChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRealTimeAdherenceChangedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useRealTimeAdherenceChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RealTimeAdherenceChangedSubscription, RealTimeAdherenceChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RealTimeAdherenceChangedSubscription, RealTimeAdherenceChangedSubscriptionVariables>(RealTimeAdherenceChangedDocument, options);
      }
export type RealTimeAdherenceChangedSubscriptionHookResult = ReturnType<typeof useRealTimeAdherenceChangedSubscription>;
export type RealTimeAdherenceChangedSubscriptionResult = Apollo.SubscriptionResult<RealTimeAdherenceChangedSubscription>;
export const RealTimeAdherenceEventsChangedDocument = gql`
    subscription RealTimeAdherenceEventsChanged($agentId: ID!) {
  realTimeAdherenceEventsChanged(agentId: $agentId) @rest(type: "AdherenceEventsChanged") {
    adherenceEvents @type(name: AdherenceEvent) {
      ...AdherenceEventFields
    }
  }
}
    ${AdherenceEventFieldsFragmentDoc}`;
export type RealTimeAdherenceEventsChangedComponentProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<RealTimeAdherenceEventsChangedSubscription, RealTimeAdherenceEventsChangedSubscriptionVariables>, 'subscription'>;

    export const RealTimeAdherenceEventsChangedComponent = (props: RealTimeAdherenceEventsChangedComponentProps) => (
      <ApolloReactComponents.Subscription<RealTimeAdherenceEventsChangedSubscription, RealTimeAdherenceEventsChangedSubscriptionVariables> subscription={RealTimeAdherenceEventsChangedDocument} {...props} />
    );
    

/**
 * __useRealTimeAdherenceEventsChangedSubscription__
 *
 * To run a query within a React component, call `useRealTimeAdherenceEventsChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRealTimeAdherenceEventsChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRealTimeAdherenceEventsChangedSubscription({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useRealTimeAdherenceEventsChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<RealTimeAdherenceEventsChangedSubscription, RealTimeAdherenceEventsChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RealTimeAdherenceEventsChangedSubscription, RealTimeAdherenceEventsChangedSubscriptionVariables>(RealTimeAdherenceEventsChangedDocument, options);
      }
export type RealTimeAdherenceEventsChangedSubscriptionHookResult = ReturnType<typeof useRealTimeAdherenceEventsChangedSubscription>;
export type RealTimeAdherenceEventsChangedSubscriptionResult = Apollo.SubscriptionResult<RealTimeAdherenceEventsChangedSubscription>;
export const WebSocketStateDocument = gql`
    subscription WebSocketState {
  webSocketState {
    state
    error {
      message
    }
  }
}
    `;
export type WebSocketStateComponentProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<WebSocketStateSubscription, WebSocketStateSubscriptionVariables>, 'subscription'>;

    export const WebSocketStateComponent = (props: WebSocketStateComponentProps) => (
      <ApolloReactComponents.Subscription<WebSocketStateSubscription, WebSocketStateSubscriptionVariables> subscription={WebSocketStateDocument} {...props} />
    );
    

/**
 * __useWebSocketStateSubscription__
 *
 * To run a query within a React component, call `useWebSocketStateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWebSocketStateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebSocketStateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useWebSocketStateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<WebSocketStateSubscription, WebSocketStateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WebSocketStateSubscription, WebSocketStateSubscriptionVariables>(WebSocketStateDocument, options);
      }
export type WebSocketStateSubscriptionHookResult = ReturnType<typeof useWebSocketStateSubscription>;
export type WebSocketStateSubscriptionResult = Apollo.SubscriptionResult<WebSocketStateSubscription>;
export const GetSupervisedAgentsAllDocument = gql`
    query getSupervisedAgentsAll($supervisorId: ID!) {
  supervisedAgents(supervisorId: $supervisorId, filters: {}) @rest(type: "Agents", path: "administration/supervisors/{args.supervisorId}/agents") {
    agents @type(name: Agent) {
      ...AgentFields
    }
    totalCount
  }
}
    ${AgentFieldsFragmentDoc}`;
export type GetSupervisedAgentsAllComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSupervisedAgentsAllQuery, GetSupervisedAgentsAllQueryVariables>, 'query'> & ({ variables: GetSupervisedAgentsAllQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSupervisedAgentsAllComponent = (props: GetSupervisedAgentsAllComponentProps) => (
      <ApolloReactComponents.Query<GetSupervisedAgentsAllQuery, GetSupervisedAgentsAllQueryVariables> query={GetSupervisedAgentsAllDocument} {...props} />
    );
    

/**
 * __useGetSupervisedAgentsAllQuery__
 *
 * To run a query within a React component, call `useGetSupervisedAgentsAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupervisedAgentsAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupervisedAgentsAllQuery({
 *   variables: {
 *      supervisorId: // value for 'supervisorId'
 *   },
 * });
 */
export function useGetSupervisedAgentsAllQuery(baseOptions: Apollo.QueryHookOptions<GetSupervisedAgentsAllQuery, GetSupervisedAgentsAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupervisedAgentsAllQuery, GetSupervisedAgentsAllQueryVariables>(GetSupervisedAgentsAllDocument, options);
      }
export function useGetSupervisedAgentsAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupervisedAgentsAllQuery, GetSupervisedAgentsAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupervisedAgentsAllQuery, GetSupervisedAgentsAllQueryVariables>(GetSupervisedAgentsAllDocument, options);
        }
export type GetSupervisedAgentsAllQueryHookResult = ReturnType<typeof useGetSupervisedAgentsAllQuery>;
export type GetSupervisedAgentsAllLazyQueryHookResult = ReturnType<typeof useGetSupervisedAgentsAllLazyQuery>;
export type GetSupervisedAgentsAllQueryResult = Apollo.QueryResult<GetSupervisedAgentsAllQuery, GetSupervisedAgentsAllQueryVariables>;
export const GetSupervisedAgentsDocument = gql`
    query getSupervisedAgents($supervisorId: ID!, $filters: SupervisedAgentsFilter!) {
  supervisedAgents(supervisorId: $supervisorId, filters: $filters) @rest(type: "Agents", path: "administration/supervisors/{args.supervisorId}/agents?{args.filters}") {
    agents @type(name: Agent) {
      ...AgentFields
    }
    totalCount
  }
}
    ${AgentFieldsFragmentDoc}`;
export type GetSupervisedAgentsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSupervisedAgentsQuery, GetSupervisedAgentsQueryVariables>, 'query'> & ({ variables: GetSupervisedAgentsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSupervisedAgentsComponent = (props: GetSupervisedAgentsComponentProps) => (
      <ApolloReactComponents.Query<GetSupervisedAgentsQuery, GetSupervisedAgentsQueryVariables> query={GetSupervisedAgentsDocument} {...props} />
    );
    

/**
 * __useGetSupervisedAgentsQuery__
 *
 * To run a query within a React component, call `useGetSupervisedAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupervisedAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupervisedAgentsQuery({
 *   variables: {
 *      supervisorId: // value for 'supervisorId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetSupervisedAgentsQuery(baseOptions: Apollo.QueryHookOptions<GetSupervisedAgentsQuery, GetSupervisedAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupervisedAgentsQuery, GetSupervisedAgentsQueryVariables>(GetSupervisedAgentsDocument, options);
      }
export function useGetSupervisedAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupervisedAgentsQuery, GetSupervisedAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupervisedAgentsQuery, GetSupervisedAgentsQueryVariables>(GetSupervisedAgentsDocument, options);
        }
export type GetSupervisedAgentsQueryHookResult = ReturnType<typeof useGetSupervisedAgentsQuery>;
export type GetSupervisedAgentsLazyQueryHookResult = ReturnType<typeof useGetSupervisedAgentsLazyQuery>;
export type GetSupervisedAgentsQueryResult = Apollo.QueryResult<GetSupervisedAgentsQuery, GetSupervisedAgentsQueryVariables>;
export const UpdateSupervisedAgentDocument = gql`
    mutation UpdateSupervisedAgent($id: ID!, $supervisorId: ID!, $agent: UpdateAgentInput!) {
  updateSupervisedAgent(id: $id, supervisorId: $supervisorId, agent: $agent) @rest(type: "AgentUpdate", bodyKey: "agent", path: "administration/supervisors/{args.supervisorId}/agents/{args.id}", method: "PUT") {
    id
  }
}
    `;
export type UpdateSupervisedAgentMutationFn = Apollo.MutationFunction<UpdateSupervisedAgentMutation, UpdateSupervisedAgentMutationVariables>;
export type UpdateSupervisedAgentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateSupervisedAgentMutation, UpdateSupervisedAgentMutationVariables>, 'mutation'>;

    export const UpdateSupervisedAgentComponent = (props: UpdateSupervisedAgentComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateSupervisedAgentMutation, UpdateSupervisedAgentMutationVariables> mutation={UpdateSupervisedAgentDocument} {...props} />
    );
    

/**
 * __useUpdateSupervisedAgentMutation__
 *
 * To run a mutation, you first call `useUpdateSupervisedAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupervisedAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupervisedAgentMutation, { data, loading, error }] = useUpdateSupervisedAgentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      supervisorId: // value for 'supervisorId'
 *      agent: // value for 'agent'
 *   },
 * });
 */
export function useUpdateSupervisedAgentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupervisedAgentMutation, UpdateSupervisedAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupervisedAgentMutation, UpdateSupervisedAgentMutationVariables>(UpdateSupervisedAgentDocument, options);
      }
export type UpdateSupervisedAgentMutationHookResult = ReturnType<typeof useUpdateSupervisedAgentMutation>;
export type UpdateSupervisedAgentMutationResult = Apollo.MutationResult<UpdateSupervisedAgentMutation>;
export type UpdateSupervisedAgentMutationOptions = Apollo.BaseMutationOptions<UpdateSupervisedAgentMutation, UpdateSupervisedAgentMutationVariables>;
export const BulkAssignSupervisedAgentsToShiftTemplateDocument = gql`
    mutation BulkAssignSupervisedAgentsToShiftTemplate($supervisorId: ID!, $data: BulkAssignSupervisedAgentsToShiftTemplateInput!) {
  bulkAssignSupervisedAgentsToShiftTemplate(
    supervisorId: $supervisorId
    data: $data
  ) @rest(type: "BulkAssignSupervisedAgentsToShiftTemplate", bodyKey: "data", path: "administration/supervisors/{args.supervisorId}/agents/shift-template-bulk-assignment", method: "PUT") {
    id
  }
}
    `;
export type BulkAssignSupervisedAgentsToShiftTemplateMutationFn = Apollo.MutationFunction<BulkAssignSupervisedAgentsToShiftTemplateMutation, BulkAssignSupervisedAgentsToShiftTemplateMutationVariables>;
export type BulkAssignSupervisedAgentsToShiftTemplateComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<BulkAssignSupervisedAgentsToShiftTemplateMutation, BulkAssignSupervisedAgentsToShiftTemplateMutationVariables>, 'mutation'>;

    export const BulkAssignSupervisedAgentsToShiftTemplateComponent = (props: BulkAssignSupervisedAgentsToShiftTemplateComponentProps) => (
      <ApolloReactComponents.Mutation<BulkAssignSupervisedAgentsToShiftTemplateMutation, BulkAssignSupervisedAgentsToShiftTemplateMutationVariables> mutation={BulkAssignSupervisedAgentsToShiftTemplateDocument} {...props} />
    );
    

/**
 * __useBulkAssignSupervisedAgentsToShiftTemplateMutation__
 *
 * To run a mutation, you first call `useBulkAssignSupervisedAgentsToShiftTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAssignSupervisedAgentsToShiftTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAssignSupervisedAgentsToShiftTemplateMutation, { data, loading, error }] = useBulkAssignSupervisedAgentsToShiftTemplateMutation({
 *   variables: {
 *      supervisorId: // value for 'supervisorId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBulkAssignSupervisedAgentsToShiftTemplateMutation(baseOptions?: Apollo.MutationHookOptions<BulkAssignSupervisedAgentsToShiftTemplateMutation, BulkAssignSupervisedAgentsToShiftTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkAssignSupervisedAgentsToShiftTemplateMutation, BulkAssignSupervisedAgentsToShiftTemplateMutationVariables>(BulkAssignSupervisedAgentsToShiftTemplateDocument, options);
      }
export type BulkAssignSupervisedAgentsToShiftTemplateMutationHookResult = ReturnType<typeof useBulkAssignSupervisedAgentsToShiftTemplateMutation>;
export type BulkAssignSupervisedAgentsToShiftTemplateMutationResult = Apollo.MutationResult<BulkAssignSupervisedAgentsToShiftTemplateMutation>;
export type BulkAssignSupervisedAgentsToShiftTemplateMutationOptions = Apollo.BaseMutationOptions<BulkAssignSupervisedAgentsToShiftTemplateMutation, BulkAssignSupervisedAgentsToShiftTemplateMutationVariables>;
export const BulkAssignSupervisedAgentsDocument = gql`
    mutation BulkAssignSupervisedAgents($supervisorId: ID!, $data: BulkAssignSupervisedAgentsInput!) {
  bulkAssignSupervisedAgents(supervisorId: $supervisorId, data: $data) @rest(type: "BulkAssignSupervisedAgents", bodyKey: "data", path: "administration/supervisors/{args.supervisorId}/agents/queue-bulk-assignment", method: "PUT") {
    id
  }
}
    `;
export type BulkAssignSupervisedAgentsMutationFn = Apollo.MutationFunction<BulkAssignSupervisedAgentsMutation, BulkAssignSupervisedAgentsMutationVariables>;
export type BulkAssignSupervisedAgentsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<BulkAssignSupervisedAgentsMutation, BulkAssignSupervisedAgentsMutationVariables>, 'mutation'>;

    export const BulkAssignSupervisedAgentsComponent = (props: BulkAssignSupervisedAgentsComponentProps) => (
      <ApolloReactComponents.Mutation<BulkAssignSupervisedAgentsMutation, BulkAssignSupervisedAgentsMutationVariables> mutation={BulkAssignSupervisedAgentsDocument} {...props} />
    );
    

/**
 * __useBulkAssignSupervisedAgentsMutation__
 *
 * To run a mutation, you first call `useBulkAssignSupervisedAgentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAssignSupervisedAgentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAssignSupervisedAgentsMutation, { data, loading, error }] = useBulkAssignSupervisedAgentsMutation({
 *   variables: {
 *      supervisorId: // value for 'supervisorId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBulkAssignSupervisedAgentsMutation(baseOptions?: Apollo.MutationHookOptions<BulkAssignSupervisedAgentsMutation, BulkAssignSupervisedAgentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkAssignSupervisedAgentsMutation, BulkAssignSupervisedAgentsMutationVariables>(BulkAssignSupervisedAgentsDocument, options);
      }
export type BulkAssignSupervisedAgentsMutationHookResult = ReturnType<typeof useBulkAssignSupervisedAgentsMutation>;
export type BulkAssignSupervisedAgentsMutationResult = Apollo.MutationResult<BulkAssignSupervisedAgentsMutation>;
export type BulkAssignSupervisedAgentsMutationOptions = Apollo.BaseMutationOptions<BulkAssignSupervisedAgentsMutation, BulkAssignSupervisedAgentsMutationVariables>;
export const GetTeamsAllDocument = gql`
    query getTeamsAll {
  teams @rest(type: "Team", path: "administration/teams") {
    ...TeamFields
  }
}
    ${TeamFieldsFragmentDoc}`;
export type GetTeamsAllComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTeamsAllQuery, GetTeamsAllQueryVariables>, 'query'>;

    export const GetTeamsAllComponent = (props: GetTeamsAllComponentProps) => (
      <ApolloReactComponents.Query<GetTeamsAllQuery, GetTeamsAllQueryVariables> query={GetTeamsAllDocument} {...props} />
    );
    

/**
 * __useGetTeamsAllQuery__
 *
 * To run a query within a React component, call `useGetTeamsAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamsAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamsAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTeamsAllQuery(baseOptions?: Apollo.QueryHookOptions<GetTeamsAllQuery, GetTeamsAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamsAllQuery, GetTeamsAllQueryVariables>(GetTeamsAllDocument, options);
      }
export function useGetTeamsAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamsAllQuery, GetTeamsAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamsAllQuery, GetTeamsAllQueryVariables>(GetTeamsAllDocument, options);
        }
export type GetTeamsAllQueryHookResult = ReturnType<typeof useGetTeamsAllQuery>;
export type GetTeamsAllLazyQueryHookResult = ReturnType<typeof useGetTeamsAllLazyQuery>;
export type GetTeamsAllQueryResult = Apollo.QueryResult<GetTeamsAllQuery, GetTeamsAllQueryVariables>;
export const GetSupervisedTeamsDocument = gql`
    query getSupervisedTeams($supervisorId: ID!) {
  supervisedTeams(supervisorId: $supervisorId) @rest(type: "Team", path: "administration/supervisors/{args.supervisorId}/teams") {
    ...TeamFields
  }
}
    ${TeamFieldsFragmentDoc}`;
export type GetSupervisedTeamsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetSupervisedTeamsQuery, GetSupervisedTeamsQueryVariables>, 'query'> & ({ variables: GetSupervisedTeamsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetSupervisedTeamsComponent = (props: GetSupervisedTeamsComponentProps) => (
      <ApolloReactComponents.Query<GetSupervisedTeamsQuery, GetSupervisedTeamsQueryVariables> query={GetSupervisedTeamsDocument} {...props} />
    );
    

/**
 * __useGetSupervisedTeamsQuery__
 *
 * To run a query within a React component, call `useGetSupervisedTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupervisedTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupervisedTeamsQuery({
 *   variables: {
 *      supervisorId: // value for 'supervisorId'
 *   },
 * });
 */
export function useGetSupervisedTeamsQuery(baseOptions: Apollo.QueryHookOptions<GetSupervisedTeamsQuery, GetSupervisedTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupervisedTeamsQuery, GetSupervisedTeamsQueryVariables>(GetSupervisedTeamsDocument, options);
      }
export function useGetSupervisedTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupervisedTeamsQuery, GetSupervisedTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupervisedTeamsQuery, GetSupervisedTeamsQueryVariables>(GetSupervisedTeamsDocument, options);
        }
export type GetSupervisedTeamsQueryHookResult = ReturnType<typeof useGetSupervisedTeamsQuery>;
export type GetSupervisedTeamsLazyQueryHookResult = ReturnType<typeof useGetSupervisedTeamsLazyQuery>;
export type GetSupervisedTeamsQueryResult = Apollo.QueryResult<GetSupervisedTeamsQuery, GetSupervisedTeamsQueryVariables>;
export const GetTimezonesAllDocument = gql`
    query getTimezonesAll {
  timezones @rest(type: "Timezone", path: "administration/timezones") {
    ...TimezoneFields
  }
}
    ${TimezoneFieldsFragmentDoc}`;
export type GetTimezonesAllComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTimezonesAllQuery, GetTimezonesAllQueryVariables>, 'query'>;

    export const GetTimezonesAllComponent = (props: GetTimezonesAllComponentProps) => (
      <ApolloReactComponents.Query<GetTimezonesAllQuery, GetTimezonesAllQueryVariables> query={GetTimezonesAllDocument} {...props} />
    );
    

/**
 * __useGetTimezonesAllQuery__
 *
 * To run a query within a React component, call `useGetTimezonesAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimezonesAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimezonesAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTimezonesAllQuery(baseOptions?: Apollo.QueryHookOptions<GetTimezonesAllQuery, GetTimezonesAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimezonesAllQuery, GetTimezonesAllQueryVariables>(GetTimezonesAllDocument, options);
      }
export function useGetTimezonesAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimezonesAllQuery, GetTimezonesAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimezonesAllQuery, GetTimezonesAllQueryVariables>(GetTimezonesAllDocument, options);
        }
export type GetTimezonesAllQueryHookResult = ReturnType<typeof useGetTimezonesAllQuery>;
export type GetTimezonesAllLazyQueryHookResult = ReturnType<typeof useGetTimezonesAllLazyQuery>;
export type GetTimezonesAllQueryResult = Apollo.QueryResult<GetTimezonesAllQuery, GetTimezonesAllQueryVariables>;
export const GetTimezonesUsedInQueuesDocument = gql`
    query getTimezonesUsedInQueues {
  queuesTimezones @rest(type: "Timezone", path: "queue-management/queues/timezones") {
    ...TimezoneFields
  }
}
    ${TimezoneFieldsFragmentDoc}`;
export type GetTimezonesUsedInQueuesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTimezonesUsedInQueuesQuery, GetTimezonesUsedInQueuesQueryVariables>, 'query'>;

    export const GetTimezonesUsedInQueuesComponent = (props: GetTimezonesUsedInQueuesComponentProps) => (
      <ApolloReactComponents.Query<GetTimezonesUsedInQueuesQuery, GetTimezonesUsedInQueuesQueryVariables> query={GetTimezonesUsedInQueuesDocument} {...props} />
    );
    

/**
 * __useGetTimezonesUsedInQueuesQuery__
 *
 * To run a query within a React component, call `useGetTimezonesUsedInQueuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimezonesUsedInQueuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimezonesUsedInQueuesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTimezonesUsedInQueuesQuery(baseOptions?: Apollo.QueryHookOptions<GetTimezonesUsedInQueuesQuery, GetTimezonesUsedInQueuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimezonesUsedInQueuesQuery, GetTimezonesUsedInQueuesQueryVariables>(GetTimezonesUsedInQueuesDocument, options);
      }
export function useGetTimezonesUsedInQueuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimezonesUsedInQueuesQuery, GetTimezonesUsedInQueuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimezonesUsedInQueuesQuery, GetTimezonesUsedInQueuesQueryVariables>(GetTimezonesUsedInQueuesDocument, options);
        }
export type GetTimezonesUsedInQueuesQueryHookResult = ReturnType<typeof useGetTimezonesUsedInQueuesQuery>;
export type GetTimezonesUsedInQueuesLazyQueryHookResult = ReturnType<typeof useGetTimezonesUsedInQueuesLazyQuery>;
export type GetTimezonesUsedInQueuesQueryResult = Apollo.QueryResult<GetTimezonesUsedInQueuesQuery, GetTimezonesUsedInQueuesQueryVariables>;